    (function FfShopifyGokwikBootstrap() {
      "use strict";
      var SHOP = "https://myfrido.com";
      var productsByHandle = {};
      var productsByName = {};
      var prefetchPromise = null;

      function ingestBootstrapCatalog() {
        var boot = window.__FF_SHOPIFY_BOOTSTRAP;
        if (!boot) return;
        for (var handle in boot) {
          if (!boot.hasOwnProperty(handle)) continue;
          ingestProduct({ product: boot[handle] });
        }
      }
      ingestBootstrapCatalog();
      var HANDLE_OVERRIDES = {
        "Ultimate Flat Feet Combo": "ultimate-flat-feet-combo"
      };
      var COLOR_ALIASES = {
        black: ["black", "charcoal"],
        brown: ["brown", "mocha", "tan", "chestnut"],
        grey: ["grey", "gray", "cloud"]
      };

      function handleFromUrl(url) {
        if (!url) return "";
        var m = String(url).match(/\/products\/([^/?#]+)/);
        return m ? m[1] : "";
      }

      function parseUk(size) {
        if (size == null || size === "") return null;
        var str = String(size).trim();
        if (/^\d+$/.test(str)) return parseInt(str, 10);
        var m = str.match(/(\d+)(?:\s*-\s*(\d+))?\s*(?:uk)?/i);
        if (m) return parseInt(m[1], 10);
        return null;
      }

      function sizeOptionIndex(product) {
        var idx = optionIndex(product, ["size", "shoe size", "shoe"]);
        if (idx >= 0) return idx;
        return -1;
      }

      function sizeMatches(selected, optionVal) {
        if (selected == null || selected === "") return true;
        if (!optionVal) return false;
        var s = String(selected).trim().toLowerCase();
        var o = String(optionVal).trim().toLowerCase();
        if (s === o) return true;
        var wantUk = parseUk(selected);
        return wantUk != null && ukMatches(wantUk, optionVal);
      }

      function normalizeFootwearUkSize(label) {
        var s = String(label || "").trim();
        var ukLead = s.match(/^UK\s?(\d+)$/i);
        if (ukLead) return ukLead[1];
        var ukTrail = s.match(/^(\d+)\s*UK$/i);
        if (ukTrail) return ukTrail[1];
        var m = s.match(/^(\d+)$/);
        return m ? m[1] : s;
      }

      function isDiscreteFootwearUkSize(label) {
        var s = String(label || "").trim();
        if (/^\d+$/.test(s)) return true;
        if (/^UK\s?\d+$/i.test(s)) return true;
        if (/^\d+\s*UK$/i.test(s)) return true;
        return false;
      }

      function buildSizesFromProduct(product) {
        if (!product || !product.options) return [];
        var sizeIdx = sizeOptionIndex(product);
        if (sizeIdx >= 0) {
          var sizeVals = (product.options[sizeIdx] && product.options[sizeIdx].values) || [];
          if (!sizeVals.length) return [];
          var isUkGrid = sizeVals.every(isDiscreteFootwearUkSize);
          if (isUkGrid) {
            return sizeVals.map(function (v) { return normalizeFootwearUkSize(v); });
          }
          return sizeVals.slice();
        }
        var genderIdx = optionIndex(product, ["gender"]);
        if (genderIdx >= 0) {
          return (product.options[genderIdx] && product.options[genderIdx].values) || [];
        }
        if (product.variants && product.variants.length <= 6) {
          var seen = {};
          var out = [];
          product.variants.forEach(function (v) {
            var label = v.option1;
            if (!label || seen[label]) return;
            seen[label] = true;
            out.push(label);
          });
          return out;
        }
        return [];
      }

      function colorMatches(want, have) {
        if (!want) return true;
        if (!have) return false;
        var w = String(want).toLowerCase().trim();
        var h = String(have).toLowerCase().trim();
        if (w === h || h.indexOf(w) >= 0 || w.indexOf(h) >= 0) return true;
        var alias = COLOR_ALIASES[w];
        if (alias) {
          for (var i = 0; i < alias.length; i++) {
            if (h.indexOf(alias[i]) >= 0) return true;
          }
        }
        return false;
      }

      function ukMatches(wantUk, optionVal) {
        if (wantUk == null) return true;
        var val = String(optionVal || "");
        var nums = val.match(/\d+(?:\.\d+)?/g);
        if (!nums || !nums.length) return false;
        if (nums.length >= 2 && val.indexOf("-") >= 0) {
          var lo = parseInt(nums[0], 10);
          var hi = parseInt(nums[1], 10);
          return wantUk >= lo && wantUk <= hi;
        }
        for (var i = 0; i < nums.length; i++) {
          if (parseInt(nums[i], 10) === wantUk) return true;
        }
        return false;
      }

      function optionIndex(product, names) {
        var opts = product.options || [];
        for (var i = 0; i < opts.length; i++) {
          var n = String(opts[i].name || "").toLowerCase();
          for (var j = 0; j < names.length; j++) {
            if (n.indexOf(names[j]) >= 0) return i;
          }
        }
        return -1;
      }

      function variantOptions(v) {
        return [v.option1, v.option2, v.option3].filter(function (x) {
          return x != null && x !== "";
        });
      }

      function variantMatches(v, product, colorName, selectedSize) {
        var colorIdx = optionIndex(product, ["color", "colour"]);
        var sizeIdx = sizeOptionIndex(product);
        var colorVal = null;
        var sizeVal = null;
        if (colorIdx === 0) colorVal = v.option1;
        else if (colorIdx === 1) colorVal = v.option2;
        else if (colorIdx === 2) colorVal = v.option3;
        if (sizeIdx === 0) sizeVal = v.option1;
        else if (sizeIdx === 1) sizeVal = v.option2;
        else if (sizeIdx === 2) sizeVal = v.option3;
        if (sizeIdx < 0) {
          var genderIdx = optionIndex(product, ["gender"]);
          if (genderIdx === 0) sizeVal = v.option1;
          else if (genderIdx === 1) sizeVal = v.option2;
          else if (genderIdx === 2) sizeVal = v.option3;
        }
        if (colorIdx < 0 && sizeIdx < 0 && optionIndex(product, ["gender"]) < 0) {
          var vals = variantOptions(v);
          if (colorName && !vals.some(function (x) { return colorMatches(colorName, x); })) return false;
          if (selectedSize && !vals.some(function (x) { return sizeMatches(selectedSize, x); })) return false;
          return true;
        }
        if (!colorMatches(colorName, colorVal)) return false;
        if (!sizeMatches(selectedSize, sizeVal)) return false;
        return true;
      }

      // Colour name → hex for the swatch dots. The quiz renders real colour circles
      // rather than tiny product photos, so every colour value in the quiz catalogue
      // is mapped explicitly; the keyword fallback below only catches unmapped names.
      var COLOR_HEX = {
        "aqua": "#4FC9C2", "aqua blue": "#4FB6D9", "army grey": "#6E7367",
        "beige": "#E0CDAF", "berry fuschia": "#B0356B", "black": "#1A1A1A",
        "black noir": "#121212", "blue": "#2B5FA8", "brown": "#7A4A25",
        "burgundy": "#6E2438", "camel brown": "#A9743F", "caramel beige": "#D2B48C",
        "charcoal black": "#2E2E2E", "chestnut brown": "#6B4226", "classic black": "#1A1A1A",
        "classic brown": "#6F4626", "cloud grey": "#C3C7CC", "cloudy grey": "#B9BDC2",
        "dark silver": "#9A9A9E", "deep mustard": "#C68A0E", "denim blue": "#3B5E86",
        "earth red": "#9B4034", "emerald green": "#2E8B62", "green": "#4A7C59",
        "grey": "#8C8C8C", "ivory": "#F2EADC", "ivory dust": "#EDE4D3",
        "lavender": "#B7A5D6", "mocca mousse": "#A47864", "mocha cream": "#D9BFA8",
        "mustard yellow": "#D4A017", "navy": "#1F3864", "navy blue": "#22375F",
        "nude sand": "#DFC9AE", "olive": "#6B7A3A", "olive green": "#6E7B4B",
        "pastel multi": "#E7C6D8", "peach": "#F0B49B", "pink": "#E8A5B8",
        "rose gold": "#E0A899", "rose pink": "#E39BAA", "satin gold": "#D4AF57",
        "slate grey": "#6E7780", "soft cream": "#F0E6D2", "soft peach": "#F5C6AE",
        "tan": "#C8A578", "taupe": "#A89684", "transparent": "#E4E7E9",
        "warm brown": "#8A5A33", "white": "#FFFFFF"
      };
      function swatchForColor(name) {
        var n = String(name || "").toLowerCase().replace(/\s+/g, " ").replace(/^ | $/g, "");
        if (COLOR_HEX[n]) return COLOR_HEX[n];
        // Fallback for names not in the map. Order matters — most specific first, so
        // e.g. a new "… Cream" reads as cream rather than falling through to brown.
        if (n.indexOf("noir") >= 0 || n.indexOf("black") >= 0 || n.indexOf("charcoal") >= 0) return "#1A1A1A";
        if (n.indexOf("cream") >= 0 || n.indexOf("ivory") >= 0) return "#F0E6D2";
        if (n.indexOf("white") >= 0) return "#FFFFFF";
        if (n.indexOf("mocca") >= 0 || n.indexOf("mocha") >= 0) return "#A47864";
        if (n.indexOf("tan") >= 0 || n.indexOf("camel") >= 0 || n.indexOf("caramel") >= 0) return "#C8A578";
        if (n.indexOf("taupe") >= 0 || n.indexOf("sand") >= 0 || n.indexOf("beige") >= 0) return "#D8C4A6";
        if (n.indexOf("brown") >= 0) return "#7A4A25";
        if (n.indexOf("burgundy") >= 0 || n.indexOf("maroon") >= 0) return "#6E2438";
        if (n.indexOf("red") >= 0) return "#9B4034";
        if (n.indexOf("olive") >= 0) return "#6B7A3A";
        if (n.indexOf("green") >= 0) return "#4A7C59";
        if (n.indexOf("navy") >= 0) return "#1F3864";
        if (n.indexOf("denim") >= 0 || n.indexOf("blue") >= 0 || n.indexOf("aqua") >= 0) return "#2B5FA8";
        if (n.indexOf("lavender") >= 0 || n.indexOf("purple") >= 0) return "#B7A5D6";
        if (n.indexOf("fuschia") >= 0 || n.indexOf("fuchsia") >= 0) return "#B0356B";
        if (n.indexOf("rose") >= 0 || n.indexOf("peach") >= 0 || n.indexOf("pink") >= 0) return "#E8A5B8";
        if (n.indexOf("gold") >= 0) return "#D4AF57";
        if (n.indexOf("yellow") >= 0 || n.indexOf("mustard") >= 0) return "#D4A017";
        if (n.indexOf("silver") >= 0 || n.indexOf("grey") >= 0 || n.indexOf("gray") >= 0 || n.indexOf("slate") >= 0) return "#8C8C8C";
        if (n.indexOf("transparent") >= 0 || n.indexOf("clear") >= 0) return "#E4E7E9";
        return "#C8C8C8";
      }

      function buildColorsFromProduct(product) {
        // Prefer the bootstrap's per-colour images (real product photos): the
        // swatch and the colour's hero image both come from the live variant image.
        if (product.colors && product.colors.length) {
          var res = [];
          for (var k = 0; k < product.colors.length; k++) {
            var c = product.colors[k];
            var img = c.img || "";
            // swatch = a real colour circle (hex), img = the colour's hero photo. These
            // are deliberately separate: the dot shows the colour, the gallery shows the shoe.
            res.push({ name: c.name, img: img, swatch: swatchForColor(c.name) });
          }
          return res;
        }
        var colorIdx = optionIndex(product, ["color", "colour"]);
        if (colorIdx < 0) return [];
        var values = (product.options[colorIdx] && product.options[colorIdx].values) || [];
        var out = [];
        for (var i = 0; i < values.length; i++) {
          out.push({ name: values[i], swatch: swatchForColor(values[i]) });
        }
        return out;
      }

      // Default variant for a product: the first in-stock one, else the first.
      function defaultVariant(product) {
        if (!product || !product.variants || !product.variants.length) return null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].available) return product.variants[i];
        }
        return product.variants[0];
      }

      function ingestProduct(raw) {
        var product = raw && raw.product ? raw.product : raw;
        if (!product || !product.handle) return;
        productsByHandle[product.handle] = product;
        if (product.title) {
          productsByName[product.title] = product;
          if (product.title.indexOf("Frido ") === 0) {
            productsByName[product.title.slice(6)] = product;
          }
        }
      }

      function fetchProduct(handle) {
        return fetch(SHOP + "/products/" + encodeURIComponent(handle) + ".js", {
          credentials: "omit",
          mode: "cors"
        })
          .then(function (res) {
            if (!res.ok) throw new Error("product fetch failed");
            return res.json();
          })
          .then(function (data) {
            ingestProduct(data);
            return data.product || data;
          })
          .catch(function () {
            return null;
          });
      }

      function prefetchProducts(productList) {
        function annotateAll() {
          for (var j = 0; j < productList.length; j++) annotateProduct(productList[j]);
        }
        annotateAll();
        if (prefetchPromise) return prefetchPromise.then(function () { annotateAll(); });
        var handles = [];
        var seen = {};
        for (var i = 0; i < productList.length; i++) {
          var p = productList[i];
          if (!p) continue;
          var handle = handleFromUrl(p.url) || HANDLE_OVERRIDES[p.name] || "";
          if (!handle || seen[handle]) continue;
          seen[handle] = true;
          handles.push(handle);
        }
        var idx = 0;
        var concurrency = 6;
        function worker() {
          if (idx >= handles.length) return Promise.resolve();
          var batch = [];
          while (idx < handles.length && batch.length < concurrency) {
            batch.push(fetchProduct(handles[idx++]));
          }
          return Promise.all(batch).then(worker);
        }
        prefetchPromise = worker().then(function () { annotateAll(); });
        return prefetchPromise;
      }

      function getProduct(p) {
        if (!p) return null;
        if (p.__shopifyHandle && productsByHandle[p.__shopifyHandle]) return productsByHandle[p.__shopifyHandle];
        var handle = handleFromUrl(p.url) || HANDLE_OVERRIDES[p.name] || "";
        if (handle && productsByHandle[handle]) return productsByHandle[handle];
        if (p.name && productsByName[p.name]) return productsByName[p.name];
        return null;
      }

      function annotateProduct(p) {
        if (!p) return;
        var handle = handleFromUrl(p.url) || HANDLE_OVERRIDES[p.name] || "";
        var shopProduct = handle ? productsByHandle[handle] : (p.name ? productsByName[p.name] : null);
        if (!shopProduct) return;
        p.__shopifyHandle = shopProduct.handle || handle;
        p.__shopifyColors = buildColorsFromProduct(shopProduct);
        p.__shopifySizes = buildSizesFromProduct(shopProduct);
        // Product imagery comes from Shopify. The hardcoded img in the catalogue entry is
        // only a pre-annotation placeholder (and a fallback for products missing from the
        // quiz collection) — once the live product resolves, Shopify's image wins.
        if (shopProduct.featured_image){
          p.__shopifyImg = shopProduct.featured_image;
          p.img = shopProduct.featured_image;
        }
        // Cards show the FIRST VARIANT's own photo, not the product's featured image.
        // featured_image is whatever sits first in the product's media — often a lifestyle
        // or PLP banner — so a listing ends up mixing banners with product shots. The
        // per-variant image is the consistent white-background, slanted-pose photo, and it
        // is the same picture the colour swatch shows, so card and swatch agree.
        var ffFirstColor = p.__shopifyColors && p.__shopifyColors[0];
        if (ffFirstColor && ffFirstColor.img){
          p.img = ffFirstColor.img;
          p.__shopifyImg = ffFirstColor.img;
        }
        // Full catalogue image list from Shopify — the sheet gallery is built from this
        // (plus per-colour variant images), so no product imagery is hardcoded.
        if (shopProduct.images && shopProduct.images.length) p.__shopifyImages = shopProduct.images;
        // Per-colour galleries resolved server-side from Shopify's variant→image links and
        // the images' own alt labels. See snippets/frido-footwear-quiz-product-json.liquid.
        if (shopProduct.gallery) p.__shopifyGallery = shopProduct.gallery;
        if (!p.vid && shopProduct.variants && shopProduct.variants[0]) {
          p.vid = String(shopProduct.variants[0].id);
        }
        // Live pricing: drive the displayed selling price + MRP from the default
        // (first in-stock) variant, so cards/cart reflect the real catalog.
        var dv = defaultVariant(shopProduct);
        if (dv) {
          var lp = parseFloat(dv.price);
          if (!isNaN(lp) && lp > 0) p.price = lp;
          var lc = parseFloat(dv.cmp);
          if (!isNaN(lc) && lc > p.price) p.mrp = lc;
          else if (!p.mrp || p.mrp <= p.price) p.mrp = p.price;
        }
      }

      function sizesForProduct(p) {
        if (p && p.__shopifySizes && p.__shopifySizes.length) return p.__shopifySizes;
        var product = getProduct(p);
        if (product) return buildSizesFromProduct(product);
        return [];
      }

      function colorsForProduct(p, productColorsMap, fallbackColors) {
        if (p && p.name && productColorsMap && productColorsMap[p.name] && productColorsMap[p.name].length) {
          return productColorsMap[p.name];
        }
        if (p && p.__shopifyColors && p.__shopifyColors.length) return p.__shopifyColors;
        return fallbackColors || [];
      }

      function resolveVariant(p, colorIdx, size, productColorsMap, fallbackColors) {
        var product = getProduct(p);
        var selectedSize = size == null ? "" : String(size);
        var cols = colorsForProduct(p, productColorsMap, fallbackColors);
        var colorName = null;
        if (cols.length && colorIdx != null && cols[colorIdx]) colorName = cols[colorIdx].name;

        if (product && product.variants && product.variants.length) {
          var needsColor = optionIndex(product, ["color", "colour"]) >= 0;
          if (!needsColor) colorName = null;

          for (var i = 0; i < product.variants.length; i++) {
            var v = product.variants[i];
            if (variantMatches(v, product, colorName, selectedSize)) return String(v.id);
          }
          if (selectedSize) {
            for (var j = 0; j < product.variants.length; j++) {
              var v2 = product.variants[j];
              if (sizeMatches(selectedSize, v2.option1) || sizeMatches(selectedSize, v2.option2) || sizeMatches(selectedSize, v2.option3)) {
                return String(v2.id);
              }
            }
          }
          if (product.variants[0]) return String(product.variants[0].id);
        }

        if (cols.length && colorIdx != null && cols[colorIdx] && cols[colorIdx].variants && size && cols[colorIdx].variants[size]) {
          return cols[colorIdx].variants[size];
        }
        return p && p.vid ? String(p.vid) : "";
      }

      function variantPriceCents(p, variantId) {
        var product = getProduct(p);
        if (!product || !product.variants) return (p && p.price ? p.price * 100 : 0);
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(variantId)) {
            return Math.round(parseFloat(product.variants[i].price) * 100);
          }
        }
        return p.price ? p.price * 100 : 0;
      }

      // Variant id → { price, cmp } in CENTS, from the bootstrap. Used by the
      // cart drawer to show the slashed MRP next to the live selling price.
      var variantIndex = null;
      function buildVariantIndex() {
        variantIndex = {};
        var boot = window.__FF_SHOPIFY_BOOTSTRAP;
        if (!boot) return;
        for (var h in boot) {
          if (!boot.hasOwnProperty(h)) continue;
          var vs = boot[h].variants || [];
          for (var i = 0; i < vs.length; i++) {
            variantIndex[String(vs[i].id)] = {
              price: Math.round(parseFloat(vs[i].price) * 100) || 0,
              cmp: Math.round(parseFloat(vs[i].cmp) * 100) || 0
            };
          }
        }
      }
      function variantPricingCents(variantId) {
        if (!variantIndex) buildVariantIndex();
        return variantIndex[String(variantId)] || null;
      }

      function getGokwikButton() {
        return document.querySelector("[data-frido-pdp-gokwik-trigger] .checkout");
      }

      function shopFetch(path, opts) {
        opts = opts || {};
        return fetch(SHOP + path, Object.assign({ credentials: "include", mode: "cors" }, opts));
      }

      function waitForCartItems(expectedCount, attempts) {
        expectedCount = expectedCount || 1;
        attempts = attempts == null ? 12 : attempts;
        return shopFetch("/cart.js")
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if ((cart.item_count || 0) >= expectedCount) return cart;
            if (attempts <= 0) throw new Error("cart timeout");
            return new Promise(function (resolve) { setTimeout(resolve, 50); }).then(function () {
              return waitForCartItems(expectedCount, attempts - 1);
            });
          });
      }

      function clearCart() {
        return shopFetch("/cart/clear.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" }
        });
      }

      function loadCartFromUrl(cartUrl, expectedCount) {
        return shopFetch(cartUrl, { method: "GET", redirect: "manual" })
          .then(function (res) {
            if (!(res.type === "opaqueredirect" || res.status === 0 || res.status === 302 || res.ok)) {
              throw new Error("cart prepare failed");
            }
            return waitForCartItems(expectedCount);
          })
          .catch(function () {
            return shopFetch(cartUrl, { method: "GET" }).then(function () {
              return waitForCartItems(expectedCount);
            });
          });
      }

      function openGokwikCheckout() {
        var btn = getGokwikButton();
        if (!btn || typeof window.onCheckoutClick !== "function") return false;
        window.onCheckoutClick(btn);
        return true;
      }

      function whenGokwikReady() {
        return new Promise(function (resolve) {
          if (typeof window.onCheckoutClick === "function") {
            resolve();
            return;
          }
          window.addEventListener("gokwikLoaded", function () { resolve(); }, { once: true });
          setTimeout(resolve, 8000);
        });
      }

      function buildCartUrl(parts, disamCents) {
        var qs = ["rfname=" + encodeURIComponent("Frido"), "tt-cart-mod=true"];
        if (disamCents > 0) qs.push("disam=" + disamCents);
        return "/cart/" + parts.join(",") + "?" + qs.join("&");
      }

      function canUseSameOriginCart() {
        try {
          var host = String(location.hostname || "").toLowerCase();
          return host === "myfrido.com" || host.slice(-12) === ".myfrido.com";
        } catch (e) {
          return false;
        }
      }

      function checkoutBundle(opts) {
        opts = opts || {};
        var uiButton = opts.uiButton;
        var lineItems = opts.lineItems || [];
        var disamCents = opts.disamCents || 0;
        var expectedCount = lineItems.length;
        var parts = lineItems.map(function (item) { return item.id + ":" + (item.qty || 1); });
        var cartPath = buildCartUrl(parts, disamCents);
        var fallbackUrl = SHOP + cartPath;

        if (!canUseSameOriginCart()) {
          window.location.href = fallbackUrl;
          return Promise.resolve();
        }

        function setLoading(on) {
          if (!uiButton) return;
          uiButton.classList.toggle("is-loading", !!on);
          uiButton.disabled = !!on;
          if (on) uiButton.setAttribute("aria-busy", "true");
          else uiButton.removeAttribute("aria-busy");
        }

        setLoading(true);
        return whenGokwikReady()
          .then(function () { return clearCart(); })
          .then(function () { return loadCartFromUrl(cartPath, expectedCount); })
          .then(function () {
            if (openGokwikCheckout()) {
              setLoading(false);
              if (opts.onComplete) opts.onComplete();
              return;
            }
            window.location.href = fallbackUrl;
          })
          .catch(function () {
            setLoading(false);
            window.location.href = fallbackUrl;
            if (opts.onError) opts.onError();
          });
      }

      // Returns an AVAILABLE variant id for a product: keeps preferredVid if it's
      // in stock, otherwise falls back to the first in-stock variant.
      function availableVariantId(p, preferredVid) {
        var product = getProduct(p);
        if (!product || !product.variants || !product.variants.length) return preferredVid || "";
        var vs = product.variants;
        if (preferredVid) {
          for (var i = 0; i < vs.length; i++) {
            if (String(vs[i].id) === String(preferredVid)) { if (vs[i].available) return String(preferredVid); break; }
          }
        }
        for (var j = 0; j < vs.length; j++) { if (vs[j].available) return String(vs[j].id); }
        return preferredVid ? String(preferredVid) : String(vs[0].id);
      }

      // ── Live stock lookups ────────────────────────────────────────────────────
      // The bootstrap carries `available` per variant straight from Shopify, so the UI
      // can grey out sold-out sizes and swap "Add to cart" for "Out of stock" instead
      // of letting the add fail silently.
      function normOpt(s){ return String(s == null ? "" : s).toLowerCase().replace(/\s+/g, ""); }
      function shopProductFor(p){
        if (!p) return null;
        var handle = p.__shopifyHandle || handleFromUrl(p.url) || HANDLE_OVERRIDES[p.name] || "";
        return handle ? productsByHandle[handle] : (p.name ? productsByName[p.name] : null);
      }
      function matchVariant(sp, colorName, sizeLabel){
        if (!sp || !sp.variants) return null;
        var ci = optionIndex(sp, ["color", "colour"]);
        // On the heel pad and the gel insole the size axis is named "Gender" (Women/Men),
        // so sizeOptionIndex alone returns -1 and this matched on colour only — handing
        // back the colour's FIRST variant and reporting its stock for both genders.
        // Beige/Men (in stock) then greyed out while Grey/Men (sold out) looked buyable.
        var si = sizeOptionIndex(sp);
        if (si < 0) si = optionIndex(sp, ["gender"]);
        for (var i = 0; i < sp.variants.length; i++){
          var v = sp.variants[i];
          var opts = [v.option1, v.option2, v.option3];
          if (colorName != null && ci >= 0 && normOpt(opts[ci]) !== normOpt(colorName)) continue;
          if (sizeLabel != null && si >= 0){
            var raw = opts[si];
            if (normOpt(raw) !== normOpt(sizeLabel) && normOpt(normalizeFootwearUkSize(raw)) !== normOpt(sizeLabel)) continue;
          }
          return v;
        }
        return null;
      }
      // Unknown product/variant → treat as in stock, so a data gap never blocks a sale.
      function sizeInStock(p, colorName, sizeLabel){
        var sp = shopProductFor(p);
        if (!sp) return true;
        var v = matchVariant(sp, colorName, sizeLabel);
        return v ? !!v.available : true;
      }
      function productInStock(p){
        var sp = shopProductFor(p);
        if (!sp || !sp.variants || !sp.variants.length) return true;
        for (var i = 0; i < sp.variants.length; i++){ if (sp.variants[i].available) return true; }
        return false;
      }

      window.FfShopify = {
        prefetchProducts: prefetchProducts,
        sizeInStock: sizeInStock,
        productInStock: productInStock,
        availableVariantId: availableVariantId,
        resolveVariant: resolveVariant,
        colorsForProduct: colorsForProduct,
        sizesForProduct: sizesForProduct,
        variantPriceCents: variantPriceCents,
        variantPricingCents: variantPricingCents,
        getProduct: getProduct,
        annotateProduct: annotateProduct,
        handleFromUrl: handleFromUrl
      };
      window.FfGokwik = {
        checkoutBundle: checkoutBundle,
        openGokwikCheckout: openGokwikCheckout,
        whenGokwikReady: whenGokwikReady
      };
    })();

    /* ═══════════════════════════════════════════════════════════
       FRIDO FOOT COMFORT FINDER — application logic
       Sections: icons/data → quiz engine → results/bundle → UI hooks
       ═══════════════════════════════════════════════════════════ */
    (function(){
      "use strict";
    
      var ffRoot = document.getElementById("ff-root");
      function ffLockScroll(on){
        var v = on ? "hidden" : "";
        if (ffRoot) ffRoot.style.overflow = v;
        document.documentElement.style.overflow = v;
      }
    
      var ICON = {
        heel: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4c-1.5 2-2 5-2 8 0 4 1 6 4 7 2 .7 4 1 6 .5 2-.5 2-3 1-5-1-1.5-1-3-1-5 0-3-1-6-4-6.5C9 2.5 8 3 7 4z"/><circle cx="9" cy="17" r="1"/></svg>',
        arch: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17c4 0 4-8 9-8s5 8 9 8"/><path d="M3 20h18"/></svg>',
        ball: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="9" r="2.2"/><circle cx="13" cy="7.5" r="1.8"/><circle cx="17" cy="9" r="1.6"/><path d="M5 14c0 4 3 6 7 6s7-2 7-6"/></svg>',
        general: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M5 19l2-2M17 7l2-2"/><circle cx="12" cy="12" r="3.5"/></svg>',
        bolt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
        ache: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C8 6 6 9 6 13a6 6 0 0 0 12 0c0-4-2-7-6-11z"/></svg>',
        fire: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2c1 3 4 5 4 9a4 4 0 0 1-8 0c0-1 .5-2 1-3 .5 2 2 2 2 2 0-2-1-5 1-8z"/></svg>',
        roll: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9"/><polyline points="3 4 3 12 11 12"/></svg>',
        flat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 16h18"/><path d="M3 16c0-1 1-2 3-2h12c2 0 3 1 3 2"/></svg>',
        normal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17c5 0 5-6 9-6s4 6 9 6"/></svg>',
        high: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18c5 0 6-12 9-12s4 12 9 12"/></svg>',
        question: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12" y2="17"/></svg>',
        work: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="12" rx="2"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
        run: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="14" cy="5" r="2"/><path d="M11 8l3 2 2 3M11 8l-3 3 1 4M14 13l-2 6M16 13l3 1"/></svg>',
        walk: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="13" cy="4" r="2"/><path d="M13 7l-2 5 3 3 1 5M11 12l-3 2-2-1"/></svg>',
        home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l9-8 9 8"/><path d="M5 10v10h14V10"/></svg>',
        ethnic: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3c2 2.5 2 5 0 7.5C10 8 10 5.5 12 3z"/><path d="M12 10.5c2.5 0 4.5 1.5 5.5 4-3 .5-5 -.5-5.5-4z"/><path d="M12 10.5c-2.5 0-4.5 1.5-5.5 4 3 .5 5-.5 5.5-4z"/><path d="M12 14v7"/><path d="M8 21h8"/></svg>',
        slipper: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 14c0-2 1.5-3 4-3h7c4 0 7 1.5 7 4 0 1.5-1 2.5-3 2.5H6c-2 0-3-1.5-3-3.5z"/><path d="M6 11c0-2 1-3 3-3"/></svg>',
        sandal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17c-1 0-2-.8-2-2 0-4 .5-8 1.5-9C5.5 5 7 5 7.5 6.5 8 8 8 11 8 14c0 2-1 3-3 3z"/><path d="M10 8h9M10 12h9M14 8v8"/></svg>',
        closedshoe: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 16c0-1 .5-2 2-2.5L9 11l2-3c.5 3 2 4 5 4.5l4 .8c1.3.3 2 1 2 2.2v.5H2z"/><path d="M2 17.5h20"/></svg>',
        anyshoe: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9 9.5a3 3 0 0 1 5.5 1.5c0 2-3 2.5-3 4"/><circle cx="11.5" cy="17.5" r="0.6" fill="currentColor"/></svg>',
        lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
        shoe: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 17h14c3 0 6-1 6-3 0-1-1-2-3-2-3 0-4-1-6-3l-2-2-2 3H2z"/><path d="M2 17v2h20v-2"/></svg>',
        wide: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="7 8 3 12 7 16"/><polyline points="17 8 21 12 17 16"/><line x1="3" y1="12" x2="21" y2="12"/></svg>',
        pinch: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 7 13 12 9 17"/><polyline points="15 7 11 12 15 17"/></svg>',
        seed: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22V12"/><path d="M12 12C12 8 9 6 5 6c0 4 3 6 7 6z"/><path d="M12 14c0-3 3-5 7-5 0 3-3 5-7 5z"/></svg>',
        cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 9h18M8 3v4M16 3v4"/></svg>',
        hourglass: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2h12M6 22h12M8 2c0 4 8 6 8 10s-8 6-8 10M16 2c0 4-8 6-8 10s8 6 8 10"/></svg>',
        cycle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7"/><polyline points="21 3 21 8 16 8"/></svg>',
        man: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="6" r="3"/><path d="M7 21v-5a5 5 0 0 1 10 0v5"/></svg>',
        woman: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="6" r="3"/><path d="M9 21l1.5-6h3L15 21M10.5 15h3"/></svg>',
        insole: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 2c-2 0-4 2-4 6 0 3 1 4 1 7s-1 4 0 6c.7 1.3 4 1.3 5 0 1-1.5 0-4 .5-7s2-4 2-8c0-3-2-4-4.5-4z"/></svg>',
        support: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"/><path d="m9 12 2 2 4-4"/></svg>',
        check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
        spark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6"/></svg>',
        target: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1.5"/></svg>',
        cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 12.3a2 2 0 0 0 2 1.7h7.7a2 2 0 0 0 2-1.6L22 7H6"/></svg>',
        redo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>',
        close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
        refresh: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>',
        chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>'
      };
    
      // ═══════════════════════════════════════════════════════════
      //  DATA CAPTURE LAYER
      //  Accumulates the full quiz session into one RECORD object.
      //  Destination is intentionally deferred - see sendData() below.
      // ═══════════════════════════════════════════════════════════
    
      function uid(){
        return "ff_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 8);
      }
    
      // The single growing record for this session.
      var RECORD = {
        sessionId: uid(),
        startedAt: null,            // ISO string, set on quiz_start
        completedAt: null,          // ISO string, set on quiz_complete
        page: (typeof location !== "undefined" ? location.pathname : ""),
        name: null,                 // optional first name (personalization)
        phone: null,                // optional +91 mobile (lead capture)
        lead: null,                 // { name, phone } once captured
        answers: {},                // { questionId: { label, value } } in plain language
        result: null,               // { condition, conditionLabel, gender, activity, width }
        recommended: null,          // { shoe, insole, support } product names
        kit: null,                  // { shoe:true, insole:true, support:false }
        bundle: null,               // { itemsKept, fullPrice, finalPrice, saved }
        events: []                  // ordered log of every event for full detail
      };
    
      // dataLayer push (GTM/GA4/Pixel listen here) - always on, harmless if nothing listens.
      function track(event, payload){
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(Object.assign({ event: event, ffSession: RECORD.sessionId }, payload || {}));
        } catch(e) {}
        // also keep an in-record log so the final payload has full per-event detail
        try { RECORD.events.push({ event: event, t: new Date().toISOString(), data: payload || {} }); } catch(e) {}
      }
    
      // ─── DISPATCH (wire a destination here LATER) ───
      // Called at key milestones with the full RECORD. Currently it only logs +
      // stashes the record on window for inspection. Pick ONE (or more) later:
      function sendData(record, trigger){
        try { window.__ffLastRecord = record; } catch(e) {}
        // Debug logging disabled (was: console.log("[FootFinder] capture (" + trigger + ")", record);)
    
        // ── OPTION A · Webhook / Google Sheet (Apps Script) / Zapier / Make ──
        // Uncomment and set ENDPOINT. keepalive lets it survive the checkout redirect.
        // var ENDPOINT = "https://YOUR-ENDPOINT-HERE";
        // try {
        //   fetch(ENDPOINT, {
        //     method: "POST",
        //     headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify(Object.assign({ trigger: trigger }, record)),
        //     keepalive: true
        //   });
        // } catch(e) {}
    
        // ── OPTION B · GA4 custom event with the full result (via gtag) ──
        // try { if (window.gtag) gtag("event", "foot_finder_" + trigger, {
        //   ff_session: record.sessionId,
        //   ff_condition: record.result && record.result.condition,
        //   ff_gender: record.result && record.result.gender,
        //   ff_bundle_value: record.bundle && record.bundle.finalPrice
        // }); } catch(e) {}
    
        // ── OPTION C · Lead capture record (after you add an email/phone step) ──
        // The contact would already be attached at record.contact - POST as in Option A.
      }
      // expose for manual testing in console
      try { window.__ffSendData = sendData; window.__ffRecord = function(){ return RECORD; }; } catch(e) {}
    
      function P(name, tag, price, mrp, vid, icon, rating, reviews, url, img){
        return { name: name, tag: tag, price: price, mrp: mrp, vid: vid || "", icon: icon, rating: rating || "4.5", reviews: reviews || "1.2k", url: url || "", img: img || "" };
      }
    
      // Footwear pool: each shoe tagged with the conditions and activities it serves.
      // c = conditions it suits, a = activities (form factor), g = gender (m/w/u)
      // pickShoe(condition, activity, gender) finds the best match, with fallback.
      var SHOES = [
        { g:"m", c:["flat","plantar","fatigue"], a:["casual"],          t:"slipper", p:P("Frido Cloud Comfort Arch Support Slippers","Arch support · all-day soft",1799,2999,"",ICON.shoe,"4.7","3.9k", "https://myfrido.com/products/frido-cloud-comfort-arch-support-slippers", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/B-CCASS-01_daacff8c-5694-47b1-81b6-3f541e8e0653.jpg?v=1770619699") },
        { g:"w", c:["flat","plantar","fatigue"], a:["casual"],          t:"slipper", p:P("Frido Cloud Comfort Arch Support Slippers","Arch support · all-day soft",1799,2999,"",ICON.shoe,"4.7","3.9k", "https://myfrido.com/products/frido-cloud-comfort-arch-support-slippers", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/B-CCASS-01_daacff8c-5694-47b1-81b6-3f541e8e0653.jpg?v=1770619699") },
        { g:"m", c:["flat","plantar","fatigue"], a:["walk"],            t:"closed",  p:P("Frido Active Casual Sneakers - Men's","Everyday sneaker · supportive",3999,4999,"52308998488345",ICON.shoe,"4.6","1.4k", "https://myfrido.com/products/frido-active-casual-sneakers-mens", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/AS-00Blue_2.png?v=1777541466") },
        { g:"w", c:["flat","plantar","fatigue"], a:["walk"],            t:"closed",  p:P("Frido Active Casual Sneakers - Women's","Everyday sneaker · supportive",3999,4999,"",ICON.shoe,"4.6","1.4k", "https://myfrido.com/products/frido-active-casual-sneakers-womens", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/AS-00B_2.png?v=1777541467") },
        { g:"m", c:["fatigue","heel"],           a:["casual","walk"],   t:"closed",  p:P("Frido Cloud Comfort Shoes - Slip Ons","Easy on · cushioned ride",2799,4499,"",ICON.shoe,"4.6","1.3k", "https://myfrido.com/products/frido-cloud-comfort-slip-on-shoes", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CS_01_1.png?v=1759842450") },
        { g:"w", c:["fatigue","heel"],           a:["casual","walk"],   t:"closed",  p:P("Frido Women's Cloud Comfort Shoes - Slip Ons","Easy on · cushioned ride",2799,4499,"",ICON.shoe,"4.6","1.3k", "https://myfrido.com/products/frido-womens-cloud-comfort-shoes-slip-ons", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/black_1_2495a50a-ddf8-4706-8068-15c2c81bbb01.png?v=1781620403") },
        { g:"m", c:["flat","plantar"],           a:["casual","walk"],   t:"closed",  p:P("Frido Cloud Comfort Shoes - Lace Ups","Stable base · firm structure",2999,4999,"",ICON.shoe,"4.6","1.5k", "https://myfrido.com/products/frido-cloud-comfort-shoes-with-lace", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/with_laces_black.png?v=1758814849") },
        { g:"w", c:["flat","plantar"],           a:["casual","walk"],   t:"closed",  p:P("Frido Women's Cloud Comfort Shoes - Lace ups","Stable base · firm structure",2999,4999,"",ICON.shoe,"4.6","1.4k", "https://myfrido.com/products/frido-womens-cloud-comfort-shoes-lace-ups", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/FWCCS-LU_Lavender_PLP_img.png?v=1769682361") },
        { g:"m", c:["fatigue","meta","heel","bunion"],    a:["casual"],          t:"sandal",  p:P("Frido Men's Comfort Dual Strap Sandals","Roomy forefoot · soft footbed",2299,3799,"",ICON.shoe,"4.5","1.1k", "https://myfrido.com/products/frido-mens-comfort-dual-strap-sandals", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/02_1.png?v=1769163520") },
        { g:"w", c:["flat","plantar"],           a:["casual"],          t:"sandal",  p:P("Frido Women's Arch Comfort Sandals","Built-in arch support",2499,3999,"",ICON.shoe,"4.6","1.9k", "https://myfrido.com/products/frido-womens-arch-comfort-sandals", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/ACS-01_941902af-1daa-4324-9ace-8720a34d2c1f.jpg?v=1762874557") },
        { g:"w", c:["fatigue","heel"],           a:["casual"],          t:"sandal",  p:P("Frido Women's Cloud Comfort Sandal","Plush cushioning · soft landing",2499,3999,"",ICON.shoe,"4.6","1.6k", "https://myfrido.com/products/frido-cloud-comfort-sandal", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/FWCCS_LI_Peach_01_88c9e880-8073-4c97-ada3-15b54667e90f.jpg?v=1771847838") },
        { g:"m", c:["fatigue","heel"],           a:["casual"],          t:"sandal",  p:P("Frido Men's Cloud Comfort Sandal","Plush cushioning · soft landing",2499,3999,"",ICON.shoe,"4.6","1.5k", "https://myfrido.com/products/frido-mens-cloud-comfort-sandal", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CCM-01_e495f429-a3c2-4cb5-b6fa-942a1f7001b5.jpg?v=1771324806") },
        { g:"w", c:["fatigue","meta","heel","bunion"],    a:["casual"],          t:"sandal",  p:P("Frido Women's Comfort Flat Sandal","Roomy forefoot · soft footbed",1999,3299,"",ICON.shoe,"4.6","2.3k", "https://myfrido.com/products/frido-womens-comfort-flat-sandal", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/ivory_dustWCF-01_94bdee33-154a-472d-81ba-9f3a3934e893.jpg?v=1765631651") },
        { g:"w", c:["fatigue","heel"],           a:["casual"],          t:"sandal",  p:P("Frido Women's Cloud Comfort Sandal - Toeless","Open comfort · soft footbed",2299,3799,"",ICON.shoe,"4.5","720", "https://myfrido.com/products/frido-womens-cloud-comfort-sandal-toeless", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/01_d485cfef-a88b-4800-ac69-667ca7c280a9.png?v=1762242239") },
        { g:"w", c:["fatigue"],                  a:["ethnic"],          t:"sandal",  p:P("Frido Women's Ethnic Comfort Flat Sandal","Festive comfort · cushioned",1999,3299,"",ICON.shoe,"4.6","1.2k", "https://myfrido.com/products/frido-womens-ethnic-comfort-flat-sandal", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/EF-01A_ffcf9389-001c-46d0-a6d9-0c867df1161d.jpg?v=1767628300") },
        { g:"m", c:["fatigue"],                  a:["ethnic","casual"], t:"sandal",  p:P("Frido Men's Puneri Arch Comfort Sandal","Arch comfort · festive ready",1799,2999,"",ICON.shoe,"4.6","960", "https://myfrido.com/products/frido-puneri-arch-comfort-sandal", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Black_1_531542e7-e6cc-470e-b038-e3478087b791.png?v=1777888037") },
        { g:"m", c:["fatigue","heel"],           a:["work"],            t:"closed",  p:P("Frido Comfort Formal Shoes","Office-ready · cushioned all day",2999,4999,"",ICON.shoe,"4.5","1.1k", "https://myfrido.com/products/frido-comfort-formal-shoes", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/black-_01_1.png?v=1773055294") },
        { g:"m", c:["plantar","flat","fatigue"], a:["active"],          t:"closed",  p:P("Frido Active Walking Shoes - Men's","Lightweight cushioning · all-day walking",3499,6000,"",ICON.shoe,"4.7","2.1k","https://myfrido.com/products/frido-active-walking-shoes-mens","https://cdn.shopify.com/s/files/1/0553/0419/2034/files/00A.jpg?v=1775223430") },
        { g:"w", c:["plantar","flat","fatigue"], a:["active"],          t:"closed",  p:P("Frido Active Walking Shoes - Women's","Lightweight cushioning · all-day walking",3499,6000,"",ICON.shoe,"4.7","1.8k","https://myfrido.com/products/frido-active-walking-shoes-womens","https://cdn.shopify.com/s/files/1/0553/0419/2034/files/00A.jpg?v=1775223430") },
        { g:"m", c:["flat","meta","bunion"],              a:["casual"],          t:"sandal",  p:P("Frido Men's Orthotics Toe Ring Sandals","Orthotic support · roomy",2299,3799,"",ICON.shoe,"4.5","680", "https://myfrido.com/products/frido-orthotics-toe-ring-sandals", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MS-01_f6649676-9d6d-4c73-a001-ea88f7445553.jpg?v=1757336652") },
        { g:"m", c:["flat","plantar"],           a:["casual"],          t:"sandal",  p:P("Frido Men's Orthotics Dual Strap Sandals","Orthotic arch support",2499,3999,"",ICON.shoe,"4.6","790", "https://myfrido.com/products/frido-orthotics-dual-strap-sandals", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MS-01.jpg?v=1756387518") },
        { g:"u", c:["flat","plantar","bunion"],           a:["casual"],          t:"sandal",  p:P("Frido Unisex Orthotics V-Strap Sandals","Orthotic arch support",2499,3999,"",ICON.shoe,"4.6","850", "https://myfrido.com/products/frido-unisex-orthotics-v-strap-sandals", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/VSS-01.jpg?v=1763465466") }
      ];
    
      function pickShoe(condition, activity, gender, pref){
        var arr = pickShoes(condition, activity, gender, pref);
        return arr.length ? arr[0] : SHOES[0].p;
      }
    
      // Returns a ranked list of products. When pref is set, the list is strictly within that category
      // (so the filter on the result page actually filters). Without pref, returns all-category matches.
      function pickShoes(condition, activity, gender, pref){
        var gKey = gender === "women" ? "w" : "m";
        function matchesGender(s){ return (s.g === "u" || s.g === gKey); }
        function matchesType(s){
          if (!pref) return true;
          // group chappal under slipper for the filter UI
          if (pref === "slipper") return (s.t === "slipper" || s.t === "chappal");
          return s.t === pref;
        }
        // Score each candidate. Higher score = better match.
        var scored = [];
        for (var i = 0; i < SHOES.length; i++){
          var s = SHOES[i];
          if (!matchesGender(s)) continue;
          if (!matchesType(s)) continue;
          var score = 0;
          if (s.c.indexOf(condition) !== -1) score += 10; // condition match
          if (s.a.indexOf(activity) !== -1) score += 4;   // activity match
          // small bias by index so original ordering breaks ties
          scored.push({ p: s.p, score: score, idx: i });
        }
        scored.sort(function(a, b){
          if (b.score !== a.score) return b.score - a.score;
          return a.idx - b.idx;
        });
        // If pref was set but yielded nothing (no products in that category for this gender), return [].
        // If no pref, ensure we always return SOMETHING — fall back to any gender-matching shoe.
        if (!scored.length && !pref){
          for (var j = 0; j < SHOES.length; j++){
            if (matchesGender(SHOES[j])) scored.push({ p: SHOES[j].p, score: 0, idx: j });
          }
        }
        return scored.map(function(o){ return o.p; });
      }
    
      // Condition → icon (for diagnostic block rows)
      var CONDITION_ICONS = {
        plantar: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/plantar_fascitis_2.png?v=1781504786" alt="" loading="lazy">',
        heel:    '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Heel_Spur_c2e924e1-f85c-4ebd-ac46-f0adc9b0015d.png?v=1781853043" alt="" loading="lazy">',
        flat:    '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Flat_Feet_f0eb8100-5f1d-4f02-8ed0-6e1883eb4ac2.png?v=1781504851" alt="" loading="lazy">',
        high:    '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/High_Arches.png?v=1781504851" alt="" loading="lazy">',
        meta:    '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Metatarsalgia_Ball_of_Foot_Pain.png?v=1781504851" alt="" loading="lazy">',
        fatigue: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Foot_fatigue_1.png?v=1781593614" alt="" loading="lazy">',
        bunion:  '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Bunions_7d3616ba-54db-44a2-a34f-11664dbb7c71.png?v=1781504851" alt="" loading="lazy">',
        general: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Foot_fatigue_1_2.png?v=1781853019" alt="" loading="lazy">'
      };

      // ── "Why this happens" root-cause icons (reusable named slots) ──
      // PASTE icon image URLs between the quotes. Empty = renders a blank tile (won't break).
      var CAUSE_ICONS = {
        footwear:   "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/narrow_footwear1.png?v=1782120208",
        standing:   "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/long_hours_on_feet.png?v=1782120208",
        cushioning: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/thin_cushioning.png?v=1782120208",
        arch:       "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/arch_issues_fallenhightight.png?v=1782120208",
        impact:     "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/high-activity.png?v=1782120207",
        pressure:   "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/pressure_forefootjoint_pressure.png?v=1782120208",
        genetic:    "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/genetic_inherited_foot_shape.png?v=1782120208",
        hardfloor:  "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/hardfloor_hard_surfaces.png?v=1782120208"
      };
      function causeIcon(slot){
        var u = CAUSE_ICONS[slot];
        return u ? '<img src="' + u + '" alt="" loading="lazy">' : '';
      }

      // ── "Why this happens" — 3 root causes per condition {icon slot, title, body} ──
      var CAUSES_BY_COND = {
        plantar: [
          { icon: "footwear", title: "Unsupportive footwear", body: "Flat soles with no arch support let the fascia overstretch with every step." },
          { icon: "standing", title: "Long hours on hard floors", body: "Sustained standing keeps the tissue band under constant strain." },
          { icon: "arch",     title: "Tight calves or high arches", body: "Pull on the fascia and raise tension at the heel." }
        ],
        heel: [
          { icon: "impact",     title: "Repeated heel impact", body: "Walking or standing on hard surfaces bruises the fatty heel pad." },
          { icon: "cushioning", title: "Worn-out cushioning", body: "Old shoes lose the padding that protects the heel bone." },
          { icon: "impact",     title: "Sudden activity increase", body: "Ramping up walking or exercise too fast overloads the heel." }
        ],
        flat: [
          { icon: "arch",     title: "Fallen arches", body: "The arch collapses inward, so the foot rolls and the whole leg compensates." },
          { icon: "footwear", title: "Unsupportive shoes", body: "Flat, soft footwear gives the arch nothing to rest on." },
          { icon: "standing", title: "Long periods standing", body: "Without support the arch fatigues and aches travel up to knees and back." }
        ],
        high: [
          { icon: "cushioning", title: "Poor shock absorption", body: "A rigid high arch can't flatten to spread impact, so pressure piles onto the heel and ball." },
          { icon: "arch",       title: "Unstable footing", body: "Weight concentrates on two points, making the foot roll outward." },
          { icon: "footwear",   title: "Hard, flat insoles", body: "Leave the arch unsupported and the gap unfilled." }
        ],
        fatigue: [
          { icon: "standing",   title: "Long hours on your feet", body: "Muscles and arches tire without a break or support." },
          { icon: "cushioning", title: "Inadequate cushioning", body: "Thin or worn soles transfer every step's shock into the foot." },
          { icon: "hardfloor",  title: "Standing on hard surfaces", body: "Concrete and tile give nothing back, so feet work harder all day." }
        ],
        meta: [
          { icon: "pressure",   title: "Pressure on the forefoot", body: "Heels and tight shoes push body weight onto the ball of the foot." },
          { icon: "cushioning", title: "Thinning fat pad", body: "Natural cushioning under the metatarsals wears down over time." },
          { icon: "impact",     title: "High-impact activity", body: "Running or long standing overloads the forefoot bones." }
        ],
        bunion: [
          { icon: "footwear", title: "Narrow or pointed footwear", body: "Squeezes the big toe inward and forces the joint outward." },
          { icon: "pressure", title: "Frequent heel wear", body: "Tips weight forward onto the toe joint, worsening the lean." },
          { icon: "genetic",  title: "Inherited foot shape", body: "Some feet are simply more prone to the joint drifting over time." }
        ],
        general: [
          { icon: "footwear",   title: "Everyday footwear strain", body: "Shoes without proper support let small aches build up." },
          { icon: "standing",   title: "Time on your feet", body: "Daily standing and walking add cumulative load." },
          { icon: "cushioning", title: "Lack of cushioning or arch support", body: "Leaves the foot working harder than it should." }
        ]
      };

      // Collect the user's selected answers as short display chips for the "What you told us" recap.
      // Skips meta questions (gender) and "not sure"-type non-answers.
      function getAnswerChips(){
        var SHOW_QS = { feel:1, diagnosed:1, arch:1, activity:1, timing:1, footwear:1, location:1 };
        var SKIP_LABELS = { "not sure": 1, "i'm not sure": 1, "i am not sure": 1 };
        var chips = [];
        for (var qi = 0; qi < QUESTIONS.length; qi++){
          var q = QUESTIONS[qi];
          if (!SHOW_QS[q.id]) continue;
          var a = answers[q.id];
          if (a === undefined || a === null) continue;
          var idxs = (Object.prototype.toString.call(a) === "[object Array]") ? a : [a];
          for (var n = 0; n < idxs.length; n++){
            var opt = q.opts[idxs[n]];
            if (!opt || !opt.label) continue;
            var ll = opt.label.toLowerCase();
            if (ll.indexOf("not sure") === 0 || ll.indexOf("i'm not sure") === 0) continue;
            chips.push(opt.label);
          }
        }
        return chips;
      }

      // Match strength: of the user's answered, signal-bearing questions, how many pointed to the
      // diagnosed condition. Real & defensible (not a fixed number). Returns {hit, total, label, pct}.
      function getMatchStrength(condKey){
        var hit = 0, total = 0;
        for (var qi = 0; qi < QUESTIONS.length; qi++){
          var q = QUESTIONS[qi];
          var a = answers[q.id];
          if (a === undefined || a === null) continue;
          var idxs = (Object.prototype.toString.call(a) === "[object Array]") ? a : [a];
          var qHasSignal = false, qHitsCond = false;
          for (var n = 0; n < idxs.length; n++){
            var opt = q.opts[idxs[n]];
            if (!opt || !opt.sig) continue;
            var keys = 0; for (var k in opt.sig){ if (opt.sig.hasOwnProperty(k)) keys++; }
            if (keys > 0) qHasSignal = true;
            if (opt.sig[condKey]) qHitsCond = true;
          }
          if (qHasSignal){ total++; if (qHitsCond) hit++; }
        }
        if (total === 0){ total = 1; hit = 1; } // safety
        var pct = Math.round((hit / total) * 100);
        var label = pct >= 75 ? "Strong match" : (pct >= 45 ? "Good match" : "Possible match");
        return { hit: hit, total: total, label: label, pct: pct };
      }
    
      var CATALOG = {
        plantar: {
          label: "Plantar Fasciitis",
          oneLine: "Inflammation of the tissue band that runs along the bottom of your foot.",
          why: "Heel pain that bites hardest on your first morning steps points to an inflamed plantar fascia. The fix is structured support that takes load off that band.",
          whyShort: { happens: "Inflamed tissue band along the foot's sole.", helps: "Structured support that takes load off the band." },
          men: {
            shoe: P("Frido Active Walking Shoes - Men's", "Lightweight cushioning · all-day walking", 3499, 6000, "", ICON.shoe, "4.7", "2.1k", "https://myfrido.com/products/frido-active-walking-shoes-mens", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/00A.jpg?v=1775223430"),
            insole: P("Frido Plantar Fasciitis Pain Relief Ortho Insoles", "Deep heel cup + firm arch support", 1499, 2799, "", ICON.insole, "4.6", "3.4k", "https://myfrido.com/products/frido-plantar-fasciitis-pain-relief-ortho-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Primary_Small_-_PLI.webp?v=1783507476"),
            support: P("Frido Orthopedic Heel Pad Pro Insole", "Gel heel cushioning for heel pain", 599, 699, "", ICON.support, "4.5", "980", "https://myfrido.com/products/frido-orthopedic-heel-pad-pro-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/HPP-01-beige.jpg?v=1745922369")
          },
          women: {
            shoe: P("Frido Active Walking Shoes - Women's", "Lightweight cushioning · all-day walking", 3499, 6000, "", ICON.shoe, "4.7", "1.8k", "https://myfrido.com/products/frido-active-walking-shoes-womens", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/00A.jpg?v=1775223430"),
            insole: P("Frido Plantar Fasciitis Pain Relief Ortho Insoles", "Deep heel cup + firm arch support", 1499, 2799, "", ICON.insole, "4.6", "3.4k", "https://myfrido.com/products/frido-plantar-fasciitis-pain-relief-ortho-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Primary_Small_-_PLI.webp?v=1783507476"),
            support: P("Frido Orthopedic Heel Pad Pro Insole", "Gel heel cushioning for heel pain", 599, 699, "", ICON.support, "4.5", "980", "https://myfrido.com/products/frido-orthopedic-heel-pad-pro-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/HPP-01-beige.jpg?v=1745922369")
          }
        },
        heel: {
          label: "Heel Pain",
          oneLine: "Persistent ache or impact pain at the back of the foot.",
          why: "A dull, constant heel ache, often worse on hard floors, points to general heel pain rather than the plantar fascia. The fix is targeted heel cushioning that absorbs impact with every step.",
          whyShort: { happens: "Repeated impact strains the heel pad.", helps: "Soft heel cushioning that absorbs impact." },
          men: {
            shoe: P("Frido Cloud Comfort Slippers", "Plush cushioning · soft heel landing", 2999, 4999, "", ICON.shoe, "4.6", "1.4k", "https://myfrido.com/products/frido-cloud-comfort-slippers", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CCS-01_5df3ddce-28c2-46e8-9ab1-7164cd5ee242.jpg?v=1758444340"),
            insole: P("Frido Dual Gel Insoles", "Gel cushioning under the heel", 1299, 1999, "", ICON.insole, "4.5", "2.1k", "https://myfrido.com/products/frido-dual-gel-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/DualGelInsole-L1-Small-2024_badb6c9e-7b37-4454-beb3-c381f9fa7d98.jpg?v=1758534908"),
            support: P("Frido Orthotics Heel Protector", "Wearable gel heel cushion", 899, 1000, "52136146960665", ICON.support, "4.6", "640", "https://myfrido.com/products/frido-orthotics-heel-protector", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/green_png_2.png?v=1774266384")
          },
          women: {
            shoe: P("Frido Women's Cloud Comfort Sandal", "Plush cushioning · soft heel landing", 2999, 4999, "", ICON.shoe, "4.6", "1.6k", "https://myfrido.com/products/frido-cloud-comfort-sandal", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/FWCCS_LI_Peach_01_88c9e880-8073-4c97-ada3-15b54667e90f.jpg?v=1771847838"),
            insole: P("Frido Dual Gel Insoles", "Gel cushioning under the heel", 1299, 1999, "", ICON.insole, "4.5", "2.1k", "https://myfrido.com/products/frido-dual-gel-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/DualGelInsole-L1-Small-2024_badb6c9e-7b37-4454-beb3-c381f9fa7d98.jpg?v=1758534908"),
            support: P("Frido Orthotics Heel Protector", "Wearable gel heel cushion", 899, 1000, "52136146960665", ICON.support, "4.6", "640", "https://myfrido.com/products/frido-orthotics-heel-protector", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/green_png_2.png?v=1774266384")
          }
        },
        flat: {
          label: "Flat Feet",
          oneLine: "Arches collapse inward, causing strain through the ankles, knees, and hips.",
          why: "When arches collapse and feet roll inward, the whole leg compensates. Firm arch support and a stable base keep you aligned and reduce strain.",
          whyShort: { happens: "Arches collapse, feet roll inward.", helps: "Firm arch support, stable base." },
          men: {
            shoe: P("Frido Cloud Comfort Shoes - Lace Ups", "Stable base · firm structure", 2999, 4999, "", ICON.shoe, "4.6", "1.5k", "https://myfrido.com/products/frido-cloud-comfort-shoes-with-lace", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/with_laces_black.png?v=1758814849"),
            insole: P("Frido Arch Support Insoles (Rigid)", "Controls arch collapse & roll", 1499, 2499, "", ICON.insole, "4.7", "2.6k", "https://myfrido.com/products/frido-arch-support-rigid-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Arch_correction_Insole_rigid.jpg?v=1724683439"),
            support: P("Ultimate Flat Feet Combo", "Complete flat-feet support set", 1999, 3499, "", ICON.support, "4.6", "740")
          },
          women: {
            shoe: P("Frido Women's Arch Comfort Sandals", "Built-in arch support", 2499, 3999, "", ICON.shoe, "4.6", "1.9k", "https://myfrido.com/products/frido-womens-arch-comfort-sandals", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/ACS-01_941902af-1daa-4324-9ace-8720a34d2c1f.jpg?v=1762874557"),
            insole: P("Frido Arch Support Insoles (Rigid)", "Controls arch collapse & roll", 1499, 2499, "", ICON.insole, "4.7", "2.6k", "https://myfrido.com/products/frido-arch-support-rigid-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Arch_correction_Insole_rigid.jpg?v=1724683439"),
            support: P("Ultimate Flat Feet Combo", "Complete flat-feet support set", 1999, 3499, "", ICON.support, "4.6", "740")
          }
        },
        high: {
          label: "High Arches",
          oneLine: "Pronounced arches that concentrate pressure on the heel and ball of the foot.",
          why: "High arches concentrate pressure on the heel and ball of the foot. You need cushioning and shock absorption that fills the arch and spreads the load.",
          whyShort: { happens: "Pressure concentrates on heel and ball.", helps: "Cushioning that fills the arch, spreads load." },
          men: {
            shoe: P("Frido Cloud Comfort Shoes - Slip Ons", "Plush cushioning · shock absorbing", 2799, 4499, "", ICON.shoe, "4.6", "1.3k", "https://myfrido.com/products/frido-cloud-comfort-slip-on-shoes", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CS_01_3e2f0b59-11f8-4980-96fd-d365ef03c925.jpg?v=1759842271"),
            insole: P("Frido Max Comfort Arch Cushion Insoles", "Fills the arch, spreads load", 1199, 1999, "", ICON.insole, "4.5", "1.6k", "https://myfrido.com/products/frido-max-comfort-arch-cushion-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MCAI_0BG.png?v=1758113507"),
            support: P("Frido Gel Max Comfort Insole", "Extra impact protection", 999, 1599, "", ICON.support, "4.5", "1.1k", "https://myfrido.com/products/frido-gel-max-comfort-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/0-GMI-LI-Small_8945baa9-c165-465b-8889-93455ffb0537.jpg?v=1744875791")
          },
          women: {
            shoe: P("Frido Women's Cloud Comfort Sandal", "Plush cushioning · shock absorbing", 2499, 3999, "", ICON.shoe, "4.6", "1.4k", "https://myfrido.com/products/frido-cloud-comfort-sandal", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/FWCCS_LI_Peach_01_88c9e880-8073-4c97-ada3-15b54667e90f.jpg?v=1771847838"),
            insole: P("Frido Max Comfort Arch Cushion Insoles", "Fills the arch, spreads load", 1199, 1999, "", ICON.insole, "4.5", "1.6k", "https://myfrido.com/products/frido-max-comfort-arch-cushion-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MCAI_0BG.png?v=1758113507"),
            support: P("Frido Gel Max Comfort Insole", "Extra impact protection", 999, 1599, "", ICON.support, "4.5", "1.1k", "https://myfrido.com/products/frido-gel-max-comfort-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/0-GMI-LI-Small_8945baa9-c165-465b-8889-93455ffb0537.jpg?v=1744875791")
          }
        },
        fatigue: {
          label: "Foot Fatigue",
          oneLine: "Tired, aching feet from long hours of standing or walking.",
          why: "Aching, tired feet from long hours standing call for maximum cushioning and a stable base that fights fatigue through the whole day.",
          whyShort: { happens: "Long hours strain feet and arches.", helps: "Maximum cushioning, all-day support." },
          men: {
            shoe: P("Frido Cloud Comfort Slippers", "Max cushioning · all-day soft", 1799, 2999, "", ICON.shoe, "4.7", "4.2k", "https://myfrido.com/products/frido-cloud-comfort-slippers", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CCS-01_5df3ddce-28c2-46e8-9ab1-7164cd5ee242.jpg?v=1758444340"),
            insole: P("Frido Max Comfort Memory Hi-Per Foam Insole", "Soft full-foot support", 1099, 1799, "", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-max-comfort-memory-hi-per-foam-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MFI-02.jpg?v=1719343958"),
            support: P("Frido Dual Gel Pro Insoles", "Shock-absorbing gel layer", 1199, 1999, "", ICON.support, "4.5", "1.7k", "https://myfrido.com/products/frido-dual-gel-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/DualGelInsole-L1-Small-2024_badb6c9e-7b37-4454-beb3-c381f9fa7d98.jpg?v=1758534908")
          },
          women: {
            shoe: P("Frido Cloud Comfort Arch Support Slippers", "Max cushioning · all-day soft", 1799, 2999, "", ICON.shoe, "4.7", "3.9k", "https://myfrido.com/products/frido-cloud-comfort-arch-support-slippers", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/B-CCASS-01_daacff8c-5694-47b1-81b6-3f541e8e0653.jpg?v=1770619699"),
            insole: P("Frido Max Comfort Memory Hi-Per Foam Insole", "Soft full-foot support", 1099, 1799, "", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-max-comfort-memory-hi-per-foam-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MFI-02.jpg?v=1719343958"),
            support: P("Frido Dual Gel Pro Insoles", "Shock-absorbing gel layer", 1199, 1999, "", ICON.support, "4.5", "1.7k", "https://myfrido.com/products/frido-dual-gel-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/DualGelInsole-L1-Small-2024_badb6c9e-7b37-4454-beb3-c381f9fa7d98.jpg?v=1758534908")
          }
        },
        meta: {
          label: "Ball-of-Foot Pain",
          oneLine: "Burning, tingling, or pressure under the toes, often worse in tight shoes.",
          why: "Burning under the toes means pressure is concentrated on the metatarsals. A roomy forefoot plus targeted padding redistributes that load.",
          whyShort: { happens: "Pressure focused on the metatarsal bones.", helps: "Roomy forefoot, targeted padding." },
          men: {
            shoe: P("Frido Men's Comfort Dual Strap Sandals", "Roomy forefoot · soft footbed", 2299, 3799, "", ICON.shoe, "4.5", "1.1k", "https://myfrido.com/products/frido-mens-comfort-dual-strap-sandals", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/02_1.png?v=1769163520"),
            insole: P("Frido Max Comfort Memory Hi-Per Foam Insole", "Plush cushioning for the ball of the foot", 649, 1799, "49177361744153", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-max-comfort-memory-hi-per-foam-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MFI-02.jpg?v=1719343958"),
            support: P("Frido Silicone Gel Insole", "Cushions every step", 899, 1499, "", ICON.support, "4.4", "1.3k", "https://myfrido.com/products/frido-silicone-gel-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/SGI-01.jpg?v=1747034940")
          },
          women: {
            shoe: P("Frido Women's Comfort Flat Sandal", "Roomy forefoot · soft footbed", 1999, 3299, "", ICON.shoe, "4.6", "2.3k", "https://myfrido.com/products/frido-womens-comfort-flat-sandal", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/ivory_dustWCF-01_94bdee33-154a-472d-81ba-9f3a3934e893.jpg?v=1765631651"),
            insole: P("Frido Max Comfort Memory Hi-Per Foam Insole", "Plush cushioning for the ball of the foot", 649, 1799, "49177361744153", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-max-comfort-memory-hi-per-foam-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MFI-02.jpg?v=1719343958"),
            support: P("Frido Silicone Gel Insole", "Cushions every step", 899, 1499, "", ICON.support, "4.4", "1.3k", "https://myfrido.com/products/frido-silicone-gel-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/SGI-01.jpg?v=1747034940")
          }
        },
        bunion: {
          label: "Bunions",
          oneLine: "A bony bump at the base of the big toe that pushes against tight footwear.",
          why: "Bunions form when the big-toe joint gets squeezed by narrow footwear over years. Relief comes from a roomy toe box that doesn't crowd the joint, plus targeted corrective support.",
          whyShort: { happens: "Narrow footwear squeezes the big-toe joint.", helps: "Roomy toe box, corrective support." },
          men: {
            shoe: P("Frido Men's Orthotics Toe Ring Sandals", "Wide toe box · orthotic support", 2299, 3799, "", ICON.shoe, "4.5", "680", "https://myfrido.com/products/frido-orthotics-toe-ring-sandals", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MS-01_f6649676-9d6d-4c73-a001-ea88f7445553.jpg?v=1757336652"),
            insole: P("Frido Max Comfort Memory Hi-Per Foam Insole", "Plush full-foot cushioning", 649, 1799, "49177361744153", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-max-comfort-memory-hi-per-foam-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MFI-02.jpg?v=1719343958"),
            support: P("Frido Orthotics Bunion Corrector", "Bunion support", 1899, 2999, "50938659438873", ICON.question, "4.5", "1.2k", "https://myfrido.com/products/frido-orthotics-bunion-corrector", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/BC-Cred_primary_image.jpg?v=1774249965")
          },
          women: {
            shoe: P("Frido Women's Comfort Flat Sandal", "Roomy forefoot · soft footbed", 1999, 3299, "", ICON.shoe, "4.6", "2.3k", "https://myfrido.com/products/frido-womens-comfort-flat-sandal", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/ivory_dustWCF-01_94bdee33-154a-472d-81ba-9f3a3934e893.jpg?v=1765631651"),
            insole: P("Frido Max Comfort Memory Hi-Per Foam Insole", "Plush full-foot cushioning", 649, 1799, "49177361744153", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-max-comfort-memory-hi-per-foam-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MFI-02.jpg?v=1719343958"),
            support: P("Frido Orthotics Bunion Corrector", "Bunion support", 1899, 2999, "50938659438873", ICON.question, "4.5", "1.2k", "https://myfrido.com/products/frido-orthotics-bunion-corrector", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/BC-Cred_primary_image.jpg?v=1774249965")
          }
        },
        general: {
          label: "General Foot Discomfort",
          oneLine: "Mild, hard-to-localize discomfort that doesn't fit a specific condition pattern.",
          why: "Your answers point to general foot discomfort rather than one specific condition. The fix is broad-spectrum comfort \u2014 soft cushioning, a supportive footbed, and a forgiving fit that handles everyday strain.",
          whyShort: { happens: "Mild, all-around discomfort from everyday strain.", helps: "Soft cushioning, supportive footbed, forgiving fit." },
          men: {
            shoe: P("Frido Cloud Comfort Shoes - Slip Ons", "Easy on · cushioned ride", 2799, 4499, "", ICON.shoe, "4.6", "1.3k", "https://myfrido.com/products/frido-cloud-comfort-slip-on-shoes", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CS_01_3e2f0b59-11f8-4980-96fd-d365ef03c925.jpg?v=1759842271"),
            insole: P("Frido Max Comfort Memory Hi-Per Foam Insole", "Soft full-foot support", 1099, 1799, "", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-max-comfort-memory-hi-per-foam-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MFI-02.jpg?v=1719343958"),
            support: P("Frido Dual Gel Pro Insoles", "Shock-absorbing gel layer", 1199, 1999, "", ICON.support, "4.5", "1.7k", "https://myfrido.com/products/frido-dual-gel-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/DualGelInsole-L1-Small-2024_badb6c9e-7b37-4454-beb3-c381f9fa7d98.jpg?v=1758534908")
          },
          women: {
            shoe: P("Frido Cloud Comfort Shoes - Slip Ons", "Easy on · cushioned ride", 2799, 4499, "", ICON.shoe, "4.6", "1.3k", "https://myfrido.com/products/frido-cloud-comfort-slip-on-shoes", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CS_01_3e2f0b59-11f8-4980-96fd-d365ef03c925.jpg?v=1759842271"),
            insole: P("Frido Max Comfort Memory Hi-Per Foam Insole", "Soft full-foot support", 1099, 1799, "", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-max-comfort-memory-hi-per-foam-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MFI-02.jpg?v=1719343958"),
            support: P("Frido Dual Gel Pro Insoles", "Shock-absorbing gel layer", 1199, 1999, "", ICON.support, "4.5", "1.7k", "https://myfrido.com/products/frido-dual-gel-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/DualGelInsole-L1-Small-2024_badb6c9e-7b37-4454-beb3-c381f9fa7d98.jpg?v=1758534908")
          }
        }
      };
    
      // Real product photos keyed by product name. Batch-assigned below so we don't
      // edit every P() call. Add more entries as product URLs are gathered.
      var PRODUCT_IMAGES = {
        "Frido Cloud Comfort Arch Support Slippers": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/O-CCASS-01_6354c4eb-5fb1-4d83-a5bc-3517376411a3.jpg?v=1779513972&width=600",
        "Frido Men's Comfort Dual Strap Sandals": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/01_19c13611-79b9-4da3-9917-b91b76d14a92.jpg?v=1770813602&width=600",
        "Frido Cloud Comfort Slippers": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CCS-01_ea2ca041-7d64-40f6-85b4-0860003d7930.jpg?v=1756912854&width=600",
        "Frido Women's Arch Comfort Sandals": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/ACS-01_941902af-1daa-4324-9ace-8720a34d2c1f.jpg?v=1762874557&width=600",
        "Frido Cloud Comfort Shoes - Slip Ons": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CS_01_d725ba08-f415-4067-a9a5-96782b1adbf3.jpg?v=1759841442&width=600",
        "Frido Cloud Comfort Shoes - Lace Ups": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/black_CS_01D_718e27cd-6c44-4328-8416-e43d3eca771d.jpg?v=1758957549&width=600",
        "Frido Women's Cloud Comfort Shoes - Lace ups": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CS_01_2_1_f945be2e-294e-452a-a5e7-87fceafdf5fc.jpg?v=1769611495&width=600",
        "Frido Women's Cloud Comfort Sandal": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/FWCCS_LI_Peach_01_88c9e880-8073-4c97-ada3-15b54667e90f.jpg?v=1771847838&width=600",
        "Frido Men's Cloud Comfort Sandal": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CCM-01_e495f429-a3c2-4cb5-b6fa-942a1f7001b5.jpg?v=1771324806&width=600",
        "Frido Women's Comfort Flat Sandal": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/WCF-01.jpg?v=1772855670&width=600",
        "Frido Women's Ethnic Comfort Flat Sandal": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/EF-01A_ffcf9389-001c-46d0-a6d9-0c867df1161d.jpg?v=1767628300&width=600",
        "Frido Women's Cloud Comfort Sandal - Toeless": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/WS-01_fce2ae3d-a39d-4a30-97c7-94fe9497610d.jpg?v=1765368061&width=600",
        "Frido Comfort Formal Shoes": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Primary_Tan_d18f27a4-5bf4-42bf-b55a-88ae0421271e.jpg?v=1778480294&width=600",
        "Frido Active Casual Sneakers - Men's": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/AS-00A_79eb6bfd-40c1-4e81-a7d2-a80981c54355.jpg?v=1777545586&width=600",
        "Frido Active Casual Sneakers - Women's": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/AS-00A_f0449355-6945-4fe5-abad-66cd6a5bc909.jpg?v=1777545761&width=600",
        "Frido Active Walking Shoes - Men's": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/00A.jpg?v=1775223430&width=600",
        "Frido Active Walking Shoes - Women's": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/00A_0bcc0d7b-fd43-4155-8535-0b6164535d6b.jpg?v=1773749227&width=600",
        "Frido Puneri Chappal - Men": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/PC-01_ef4f6100-4f33-462d-8794-fcecf6adbb5b.jpg?v=1763558270&width=600",
        "Frido Puneri Chappal - Women": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/PC-01_1b486e16-f086-49fd-b61f-b614bcb445a6.jpg?v=1760529285&width=600",
        "Frido Men's Orthotics Toe Ring Sandals": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MS-01_f6649676-9d6d-4c73-a001-ea88f7445553.jpg?v=1757336652&width=600",
        "Frido Men's Puneri Arch Comfort Sandal": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CCPC-00A.jpg?v=1777886058&width=600",
        "Frido Men's Orthotics Dual Strap Sandals": "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MS-01.jpg?v=1756387518&width=600"
      };
      function applyProductImage(p){ if (p && p.name && PRODUCT_IMAGES[p.name]) { p.img = PRODUCT_IMAGES[p.name]; } }
      (function assignImages(){
        var i;
        for (i = 0; i < SHOES.length; i++){ applyProductImage(SHOES[i].p); }
        for (var cKey in CATALOG){
          if (!CATALOG.hasOwnProperty(cKey)) continue;
          var genders = ["men","women"];
          for (var g = 0; g < genders.length; g++){
            var grp = CATALOG[cKey][genders[g]];
            if (!grp) continue;
            applyProductImage(grp.shoe); applyProductImage(grp.insole); applyProductImage(grp.support);
          }
        }
      })();

      function collectCatalogProducts(){
        var seen = {};
        var list = [];
        function add(p){
          if (!p || !p.name || seen[p.name]) return;
          seen[p.name] = true;
          list.push(p);
        }
        var i;
        for (i = 0; i < SHOES.length; i++) add(SHOES[i].p);
        for (var cKey in CATALOG){
          if (!CATALOG.hasOwnProperty(cKey)) continue;
          var genders = ["men", "women"];
          for (var g = 0; g < genders.length; g++){
            var grp = CATALOG[cKey][genders[g]];
            if (!grp) continue;
            add(grp.shoe); add(grp.insole); add(grp.support);
          }
        }
        return list;
      }
      if (window.FfShopify) window.FfShopify.prefetchProducts(collectCatalogProducts());
    
      // ── SIZE SELECTION ──────────────────────────────────────────────
      // Default size options shown per footwear type (UK sizing).
      var SIZE_OPTIONS = {
        slipper: ["3","4","5","6","7","8","9","10","11","12"],
        closed:  ["6","7","8","9","10","11","12"],
        sandal:  ["3","4","5","6","7","8","9","10","11","12"],
        chappal: ["6","7","8","9","10","11","12"]
      };
      // Per-size variant IDs, keyed by product name then UK size.
      // FILL THESE IN as variant IDs are gathered. Any product/size left out
      // simply has no variant ID yet — the picker still shows, and checkout
      // falls back to opening the product page so the user can pick there.
      // Template:
      //   "Frido Cloud Comfort Arch Support Slippers": { "7": "51352664539417", "8": "..." },
      var SIZE_VARIANTS = {
      };
      // Look up the size list for a product — prefer live Shopify options, else footwear defaults.
      function sizesFor(p){
        if (!p) return [];
        if (window.FfShopify) {
          window.FfShopify.annotateProduct(p);
          var live = window.FfShopify.sizesForProduct(p);
          if (live && live.length) return live;
        }
        if (p.sizeType && SIZE_OPTIONS[p.sizeType]) return SIZE_OPTIONS[p.sizeType];
        return [];
      }
      // A few products (Orthopedic Heel Pad Pro, Silicone Gel Insole) are sized by gender
      // rather than by UK number, so their "size" grid reads Women / Men.
      function ffIsGenderSizeAxis(p){
        var szs = sizesFor(p);
        if (szs.length < 2) return false;
        for (var i = 0; i < szs.length; i++){
          var s = String(szs[i]).trim().toLowerCase().replace(/['’]?s$/, "");
          // Every value must be a gender word, else this is a normal size grid.
          if (s !== "men" && s !== "women" && s !== "male" && s !== "female" && s !== "unisex") return false;
        }
        return true;
      }
      // The quiz already asked for gender — preselect the answer instead of making the
      // shopper state it twice. Returns "" on a numeric grid, so those are untouched.
      function ffGenderSize(p){
        if (!ffIsGenderSizeAxis(p)) return "";
        var want = String((window.__ffResult && window.__ffResult.gender) || "").toLowerCase();
        if (want !== "men" && want !== "women") return "";
        var szs = sizesFor(p), hit = "";
        for (var i = 0; i < szs.length; i++){
          var s = String(szs[i]).trim().toLowerCase().replace(/['’]?s$/, "");
          if (s === want || (want === "men" && s === "male") || (want === "women" && s === "female")) hit = szs[i];
        }
        return hit;
      }
      function variantForSize(name, size){
        var m = SIZE_VARIANTS[name];
        return (m && m[size]) ? m[size] : "";
      }
      // tag each shoe product with its type so we can show the right size list
      (function tagSizeTypes(){
        var i;
        for (i = 0; i < SHOES.length; i++){ if (SHOES[i].p) SHOES[i].p.sizeType = SHOES[i].t; }
      })();
    
      // ── COLOR SELECTION ─────────────────────────────────────────────
      // Per-product colors, keyed by product name. Each color has:
      //   name   - display name (e.g. "Olive Green")
      //   swatch - small image OR hex value for the swatch dot
      //   img    - the hero product photo for this color (swaps on select)
      //   variants - optional { "<size>": "<variantId>" } map for this color
      // FILL THESE IN per product as colors are gathered. Products left out
      // simply show no color selector. Template:
      //   "Frido Men's Comfort Dual Strap Sandals": [
      //     { name: "Olive Green", swatch: "https://.../olive.png", img: "https://.../olive-01.jpg",
      //       variants: { "7": "51990328410393", "8": "..." } },
      //     { name: "Tan", swatch: "#C8A578", img: "https://.../tan-01.jpg" }
      //   ],
      // Intentionally empty. Every product's colours now come from live Shopify data
      // (__shopifyColors: a hex `swatch` for the card circles + a variant-photo `img`
      // for the modal), so behaviour is uniform across all products. The old hardcoded
      // Lace Ups entry made that one product show image-chip swatches on the card while
      // everything else showed hex circles — the inconsistency this map caused.
      var PRODUCT_COLORS = {};
      // Per-product sheet gallery images. Value is either an array (all colors)
      // or an object keyed by color name (gallery swaps when color changes).
      // Placeholder palette shown when a product has no real colors filled in yet.
      // Replace per-product in PRODUCT_COLORS as real color data is gathered.
      var FALLBACK_COLORS = [
        { name: "Black",  swatch: "#1A1A1A" },
        { name: "Brown",  swatch: "#7A4A25" },
        { name: "Grey",   swatch: "#8C8C8C" }
      ];

      // ── Colour→gallery for products Shopify has no mapping for ─────────────────
      // A handful of products carry neither variant-attached images nor a colour in the
      // image alt text, so the bootstrap can only resolve their one hero photo. Frido's
      // own PDP on myfrido.com does show the right per-colour set, but that storefront is
      // headless and reads the mapping from a CMS this theme cannot see — so the sets below
      // were captured from those live PDPs (one fetch per colour variant, verified to have
      // zero image shared between two colours).
      // STOPGAP, and self-retiring: it is consulted ONLY when Shopify itself yields nothing
      // for a colour. Add alt text ("Olive — …") or attach the images to their variants in
      // admin and __shopifyGallery immediately wins, making the entry here dead weight.
      // Filenames carry Shopify's upload hash, so a re-upload simply stops matching and the
      // gallery falls back to the hero photo rather than showing a wrong colour.
      var FF_CDN = "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/";
      var FF_PDP_GALLERY = {
        "frido-active-casual-sneakers-mens": {
          "Aqua Blue": ["AS-00A_f753c664-4563-4429-abc1-ad99c3106b68.jpg","AS-00B_d300e1fb-360a-4649-98be-23faa47ee029.jpg","AS-00C_bc880990-2d7b-479e-81c9-f25ca81bf0f1.jpg","AS-00D_f272f788-4d80-439e-ae1b-dc0d29e98b92.jpg","AS-00E_e0e28140-f8a7-4d83-9e15-6c85a728a235.jpg","AS-01_686907b0-a261-4a47-8e0c-187eec7a96ba.jpg","AS-01B_34727574-dd58-4016-ac77-b8142f4ed3a2.jpg","AS-02_601c06fe-130d-45b9-9a20-d25ecf2ffd10.jpg"],
          "Olive Green": ["AS-00A_3372e40b-8d0f-4136-8f58-de3d23d1222d.jpg","AS-00B_21515d97-d8ce-4db2-92de-0edc944a76a2.jpg","AS-00C_70dca165-b1e5-450d-a4e1-2d4b44ae0ae3.jpg","AS-00D_2740d3e6-3285-4762-a197-9495eced15d1.jpg","AS-00E_cd5f9e50-a0b9-406b-bd78-30aa5add6365.jpg","AS-01_98402205-31cc-47b3-a9b8-a7d5baf3d5ed.jpg","AS-01B_3d5fed4d-d757-4065-8810-01b6ee3bb9ff.jpg","AS-02_dd571cf9-4be4-49e7-a78e-a89ddff3a20c.jpg"],
          "Charcoal Black": ["AS-00A_99672a4e-5a39-4e65-87e1-110c696d4b9a.jpg","AS-00B_0fb3bd30-b066-4ba9-aea0-29e3c329ba39.jpg","AS-00C_e8149ada-f97a-41ae-938b-b7730d7eb691.jpg","AS-00D_0d2200bb-7b96-4ad1-aaf9-eef24008892c.jpg","AS-00E_42bbc441-7717-4760-bd00-10c5f36ee1c4.jpg","AS-01_d335f1da-5a46-4386-b1ef-dd84aced4ffc.jpg","AS-01B_ab7be0d3-dde0-4c82-8a45-d0824e5f7a5a.jpg","AS-02_ed54e6e8-50fd-42b8-9b26-c9516c29f480.jpg"]
        },
        "frido-active-casual-sneakers-womens": {
          "Olive Green": ["AS-00A_578df658-e85d-48ca-9a5f-f7fc133c89e9.jpg","AS-00B_6855187c-6c74-422c-aee8-a033f1f84f28.jpg","AS-00C_82500f74-eb06-4261-9090-21ed637e82c5.jpg","AS-00D_560fb0a7-e29d-409a-9a82-b10394d0d09f.jpg","AS-00E_2cab4830-fc7b-4a27-8e0c-4fa34c579bf9.jpg","AS-01_77b8e87f-757d-495a-a18a-7314cea9b9c8.jpg","AS-01B_719f5247-0671-49a4-95ad-1b2d33a66756.jpg","AS-02_d0d95e65-3d55-4132-9176-c10f79d7c409.jpg"],
          "Charcoal Black": ["AS-00A_33c8a42d-53af-404c-9952-8d1b095f933c.jpg","AS-00B_6cd3c416-f6ce-48ab-8e8a-9c4cb1c868d8.jpg","AS-00C_828afebf-feab-40f5-a7dc-71194d4ad928.jpg","AS-00D_91a47c4e-e436-44f0-9caa-15ca87f0bc5d.jpg","AS-00E_fc3713e2-88bf-4e98-8367-d2af32934844.jpg","AS-01_f6e50729-fa0d-43a0-9c23-de905c42d19c.jpg","AS-01B_ed34d44a-cadb-4465-824e-e57f640c0e2b.jpg","AS-02_46cf6706-9dfc-4ee3-9e2c-d8cf7c39cdcd.jpg"]
        },
        "frido-active-walking-shoes-mens": {
          "Olive": ["AS-00A_7ca380a1-8f3f-4de9-b934-0d1af5a1fa03.jpg","AS-00B_ff04f9b6-0702-47cb-9548-0ae42ac06c29.jpg","AS-00D_640a3e0c-6590-4481-bc6a-b4674021153d.jpg","AS-00E_bb3f8515-d196-4ee1-89d9-a284059d986e.jpg","AS-01_f9bf125b-da91-428d-a251-50877f04370f.jpg","AS-01B_53cc16db-37b8-4941-ac6f-379adf507841.jpg","AS-02_2c7ee4d9-fb0a-4e49-8440-3ccd06607edb.jpg","AS-03_83b2f21f-fc8f-4fb5-bef5-805eecfffd0a.jpg"],
          "Black": ["AS-00A_950f2b32-4508-4c78-9e92-655a12c88170.jpg","AS-00B_9e84126f-1c34-443a-a5e6-7302b5a5f184.jpg","AS-00D_6a53a33a-f522-4777-b9d3-6fddc4871673.jpg","AS-00E_c69494c6-398a-4565-a84f-829f5c0b4a12.jpg","AS-01_dfb56faa-2942-421a-8603-1c2f0f382f0c.jpg","AS-01B_5a190d0c-a67b-43ac-8120-7226d9ef2958.jpg","AS-02_a03b9770-fa1c-4184-99d7-ad7b1a382853.jpg","AS-03_9771318a-d56e-47ff-bdf9-480338beae25.jpg"],
          "Blue": ["AS-00A_8d3e50b3-8c7f-4f83-bd78-2bc1434faf51.jpg","AS-00B_1729b713-726e-486a-8269-d542c2124d25.jpg","AS-00D_efdbacc9-7e04-4a65-b0ec-8435b5060fc6.jpg","AS-00E_1756ce4c-74e1-4657-95ab-6daf53fb8b37.jpg","AS-01_0bad4c27-01cb-491f-88f4-e87ebc7846c6.jpg","AS-01B_5cf87eb8-c4d1-4900-9344-d15c2daf53f0.jpg","AS-02_e34a980f-8ebd-41f7-890e-ac6fbfeffec6.jpg","AS-03_70beb693-f95e-42aa-80cb-cba3cc37d23d.jpg"],
          "White": ["AS-00A_847e434b-d728-4179-b975-69d8206ca8c2.jpg","AS-00B_c456a625-148e-46e4-be52-eb5c3dce0fce.jpg","AS-00D_32b80df3-72b4-452d-8817-63b0f475f345.jpg","AS-00E_5bed1afa-8ef3-4c15-8d96-e28bba0456a3.jpg","AS-01_03df1029-ffcf-4a70-b7f8-84b82b3d18a3.jpg","AS-01B_422ace6d-4599-4d74-b027-face26192582.jpg","AS-02_a9f71961-1c2f-438d-b86b-a8360cbbfdf2.jpg","AS-03_9a5309a4-5183-4dce-84f0-14574ac40478.jpg"]
        },
        "frido-active-walking-shoes-womens": {
          "Black": ["AS-00A_474b1d82-186d-4e1d-bdc5-8ea50f852fb0.jpg","AS-00B_4deb26a9-37bc-4790-8e72-54d6949394ab.jpg","AS-00D_f7599e28-43f0-4bc1-8424-9c5ca504a283.jpg","AS-00E_0ac3ef1a-4e2b-4688-a0a3-ed1473dc3702.jpg","AS-01_6298aee3-bef2-4acb-a148-0d9608acbd99.jpg","AS-01B_6e38b8c8-d2f0-4e8b-81a6-6353b4927e50.jpg","AS-02_1eb1d67b-df11-4c40-8b60-b8ec92b3b2a2.jpg","AS-03_a6ab8ee8-a091-4623-98da-98763e197678.jpg"],
          "Earth Red": ["AS-00A_ad7e7278-65bd-448b-a87c-8d2d1a699503.jpg","AS-00B_9a5ed78f-15f6-4e22-a5de-b195d07d55b8.jpg","AS-00D_a7b111e3-ef1e-4889-851d-3fb725529662.jpg","AS-00E_902fb1ed-6832-4be0-af88-2634ab0a8392.jpg","AS-01_bb14b0f6-f043-4ce4-aef7-9097161f8d6c.jpg","AS-01B_3e2ea2ae-528a-48f3-b1e0-a6839c9309e1.jpg","AS-02_74c027d3-6c47-45d7-8fca-b5eb111c861b.jpg","AS-03_6e8a84b0-0ebb-4ebf-8d42-18ebf2d4ca1d.jpg"],
          "Ivory": ["AS-00A_1fda4201-fddb-468d-8373-3d68c68ea195.jpg","AS-00B_84734755-a1b6-4838-ab75-418d49c33c72.jpg","AS-00D_f6390ebd-54f1-442d-a42a-77dc95d76e76.jpg","AS-00E_8d94951a-74e0-4e14-809f-b5285bd45814.jpg","AS-01_1cbebccb-7501-443e-8938-a010431960ba.jpg","AS-01B_cb7d407b-e27c-4338-baec-aa84754d96f9.jpg","AS-02_9241503d-61d3-47d5-9bf2-629c10bd002c.jpg","AS-03_f38b22ac-dbd0-4f44-9495-e51b13f01c95.jpg"],
          "Aqua": ["AS-00A_effaa19c-3e38-49da-b957-c6f61f532c40.jpg","AS-00B_b0d107dc-d42b-49dd-a94b-e99e76954763.jpg","AS-00D_7145b495-ec3a-47dc-8a52-21d8a880f680.jpg","AS-00E_6ba068a6-e98f-48de-bb52-443d3c1cc944.jpg","AS-01_8fcf3336-e3dc-4938-96aa-3c660a4fa11c.jpg","AS-01B_32672147-caaa-467e-9c7e-e376e4d62735.jpg","AS-02_53556f90-8642-41f9-a91d-96f5b3ac2e45.jpg","AS-03_c3729d58-be5f-41cb-837d-6154353a542f.jpg"]
        },
        // The alt-tagging pass here only labelled ONE photo per colour (CS_09, re-uploaded
        // once per size), so after dedupe Shopify yields a single image and the sheet showed
        // just the hero. The real per-colour sets sit untagged in positions 1-39; block →
        // colour was read off the photos themselves, NOT the upload order — the blocks run
        // Olive, Navy, Black, which is the REVERSE of the colour option order.
        "frido-cloud-comfort-slip-on-shoes": {
          "Black": ["CS_01_d725ba08-f415-4067-a9a5-96782b1adbf3.jpg","CS_01B_d27d4e51-822c-48e6-8ad8-e2ec3730d22f.jpg","CS_01C_f0e1ed12-4a3f-4606-b571-6bf5199f5ee7.jpg","CS_01E.jpg","CS_02_f05fe3fd-7d62-4605-86e0-455398858888.jpg","CS_02B_c5e12975-900b-450e-900f-ff41c7e8ff7f.jpg","CS_03_90b445b2-8452-443e-9f17-60e4c9908265.jpg","CS_04_adf20076-965f-4578-9ab9-6c18b38964c1.jpg"],
          "Navy": ["CS_01_75daece5-2c7a-43a0-9970-515d2f335e85.jpg","CS_01B_9d0880c5-3bf3-4cf5-b01a-e57acc83b1bf.jpg","CS_01C_e203d37e-ebb3-4071-a1b8-bf492dfa18d7.jpg","CS_01D_ed27ce25-f557-44e3-a532-a0e2d72eacd2.jpg","CS_02_4a98d83d-3da7-4715-a59c-6fd4e1cd7756.jpg","CS_02B_b161c1e9-83f2-4b2c-a7e4-23c00499aadc.jpg","CS_03_a9aeb030-4bd3-4184-85ba-e0e11645ccdd.jpg","CS_04_79bc2ad4-61fd-4bf4-917a-080c0a4760ef.jpg"],
          "Olive": ["CS_01_3e2f0b59-11f8-4980-96fd-d365ef03c925.jpg","CS_01B_5630718e-a798-411b-9ce7-5cf921aaf9c4.jpg","CS_01C_808b8f0d-8acd-4bff-92ab-8719b21c990d.jpg","CS_01D_e7502e0e-4536-4909-b7f3-c0b7f93b2d67.jpg","CS_02_f2f03823-5799-4d8d-be07-a369c4d7da04.jpg","CS_02B_251599eb-bec1-40cc-9a44-a0a80ab24769.jpg","CS_03_77f8f15f-61a2-4155-9651-6576cafb68ef.jpg","CS_04_c4f1fbd5-64ac-445c-92bd-85db70aac8de.jpg"]
        },
        "frido-cloud-comfort-slippers": {
          "Soft Peach": ["CCS-01_5df3ddce-28c2-46e8-9ab1-7164cd5ee242.jpg","CCS-01A_134d5e93-930f-4d1d-9237-4b1da3816d77.jpg","CCS-01B_b7093b74-8feb-477d-aabf-a3b282c1a60c.jpg","CCS-01C_cd092df7-98b7-4c58-b8ff-912c6d9e0a29.jpg","CCS-01D_22552186-8c68-4687-9596-56833dca5b38.jpg","CCS-02_62c6f7b7-23b8-49bb-87da-7641d7fe9e92.jpg","CCS-03_a9fd1ce4-47e1-4e5b-ace3-6bd280d58e3c.jpg","CCS-04_f3427249-42da-492e-83d6-9daf42ddc7e3.jpg"]
        },
        // Cloudy Grey and Olive Green are properly alt-tagged here (13 photos each) and are
        // deliberately absent below — Shopify already wins for them. The five colours listed
        // got only ONE tagged photo each, so their sets come from the untagged upload runs.
        // Each run was matched to a colour by comparing it against that colour's one
        // correctly tagged photo, not by assuming run order matches the option order.
        "frido-mens-comfort-dual-strap-sandals": {
          "Classic Black": ["01_64ff53ca-5352-417e-8d50-b6f7d1a05d72.jpg","06_47a6214e-006d-427e-8b3d-08fb70c810ca.jpg","02_8e97b6c9-5abd-4f8f-9825-6650d6dc8388.jpg","07_bedb6c8e-e8d3-432a-8a69-b0475030532b.jpg","01D_649106ef-2bc7-46f0-9cd6-35e69b1b46ef.jpg","08_a48a4a21-1ff5-4e99-8144-8eeaf03af260.jpg","09_91416b33-76dc-423f-8715-22533c168c7c.jpg","01B_aa99f9ee-0bb9-4f09-a1ed-936ac0aeca85.jpg"],
          "Denim Blue": ["01D_4d907c26-e790-4333-bd0c-9844893f1089.jpg","01C_9ad1c0fd-4b8f-40e7-86da-8c1409196eea.jpg","DS-07_3748e44f-16f5-4ce5-98e6-9e671a8844f2.jpg","DS-01_19834958-7329-4566-971c-0ba1fcdf6a6c.jpg","DS-03_fdb48f9f-3b4e-4ebc-9e70-e7a8e101abad.jpg","DS-08_a5c2cfa8-35ca-4b07-8022-f086b781eab2.jpg","01_d62ec35e-41d5-4dd3-814a-175b972c07a7.jpg","DS-06_4b964635-5b72-4e7c-abea-42bb74b47971.jpg"],
          "Warm Brown": ["01_c306d81b-3fda-4501-954c-3c39d43dbac6.jpg","04_146c8373-81e1-4ef9-90aa-46653b5033a5.jpg","11_4796c659-dcc9-4885-a4f0-76a5c5d1e564.jpg","01C_f8ea6269-cf39-4f4c-8c46-1f4198eb8677.jpg","09_454e9683-4a50-4e3c-ab92-9d9022ed479d.jpg","10_a4b55af6-5249-4504-aa38-bf6795263376.jpg","07_3bbd132f-a6d6-4231-b53a-f8db63cadfdc.jpg","01A_87dbce24-1ee6-4085-a725-92762d6c632f.jpg"],
          "Army Grey": ["DS-02_3f7cda0c-eecb-4d82-a812-28e42ddbf2c8.jpg","01D_18614c91-d372-47d6-9335-80a01234b503.jpg","DS-06_d5c2f67e-ff32-4467-a050-e81fc9ab9845.jpg","01C_d7f68649-6d48-45a2-b167-357ac18636d3.jpg","DS-08_1c627842-ad38-4d1e-a603-a1ac4b6188de.jpg","DS-04_07cd7a20-61ad-421f-abf6-5e2552557f79.jpg","01_889740ee-464b-4ad5-a157-914da465f62c.jpg","DS-07_c60b9843-95eb-4203-94ab-ee7cee771e81.jpg"],
          "Camel Brown": ["01D_453bf17d-7fe2-49bb-bf9a-5a4c72dd8d4e.jpg","DS-02_d23032df-e5df-41cb-8814-3dd8f2fed6dc.jpg","DS-07_d43257ae-d785-46eb-bc29-d118596ad4d3.jpg","01_001ff85a-46c5-4b00-ae3b-1ab193e61acc.jpg","DS-04_6c90d55f-e6aa-47fc-afe7-9625795157df.jpg","DS-06_9fac3555-57cb-4402-a89a-764abb7bb02f.jpg","DS-08_8ba3c9c9-8bd7-4ac6-9094-5eaf21d99a3f.jpg","DS-01_916485ee-7239-4ac3-b4c2-e783713d638a.jpg"]
        },
        "frido-mens-cloud-comfort-sandal": {
          "Chestnut Brown": ["CCM-01_ecfb0f96-e51d-4cb7-8180-dc2965b3751b.jpg","CCM-01B_90e1d567-4b90-4f4c-a86d-d794602b320b.jpg","CCM-01C_e5f95341-e6ea-4ae8-bede-a096c65c2179.jpg","CCM-01A_2be3e300-a20e-47da-adfe-5b6267f6ef81.jpg","CCM-01Dpsd.jpg","CCM-04_0f493dd2-9c11-41d7-b478-cb37390eb215.jpg","CCM-05_d539dd8b-9198-4bf5-ba9d-cefd81b6a06e.jpg","CCM-06_bc6ed782-4f2d-4134-8c83-fbb0cf793e81.jpg"],
          "Olive Green": ["CCM-01_ba8f2e91-5ed3-406a-8456-dc7f128d5913.jpg","CCM-01B_8a2b7e94-708b-4620-a01a-4267b229e883.jpg","CCM-01C_15527322-0399-4c12-bb77-497eedc7d4c0.jpg","CCM-01A_4d4a4c84-da5f-4c31-bdc3-45978afee3c9.jpg","CCM-01D_fb51d54d-bd22-4e05-9dec-90fa50a93bef.jpg","CCM-04_007865c9-4e30-4047-8565-7457c5b11bb2.jpg","CCM-05_dfcef4fb-b7bc-4e47-9427-ffdd29287423.jpg","CCM-06_d8ca5d83-993d-419b-894f-444f5983b2c2.jpg"]
        },
        "frido-orthopedic-heel-pad-pro-insole": {
          "Beige": ["HPP-01-beige.jpg","HPP-02-copy-0.jpg","HPP-03B-copy-0.jpg","HPP-04-copy-0.jpg","HPP-05-copy-0.jpg","HPP-06-copy-0.jpg","HPP-07-copy-0.jpg","HPP-08-copy-0.jpg"],
          "Grey": ["HPP-01.jpg","HPP-02.jpg","HPP-03B.jpg","HPP-04.jpg","HPP-05.jpg","HPP-06.jpg","HPP-07.jpg","HPP-08.jpg"]
        },
        "frido-orthotics-heel-protector": {
          "Green": ["01_13751138-9e38-4ed6-8b96-e78d8f7cb973.jpg","HP-01_8a638bb7-6190-4c72-8aa2-6a7950b6a211.jpg","HP-02_1130132f-4268-469f-9ff7-254fd8cf3245.jpg","HP-03_6c7c2be6-2693-4c81-ae63-52d903de0555.jpg","HP-04_8be3954f-ded7-40eb-b83f-cc6f5c11f6d3.jpg","HP-05_548a0a45-2121-4249-9eb7-958a1cdf6303.jpg","HP-07_49f60846-4950-4055-b51e-f4f4a223eeda.jpg","HP-08.jpg"],
          "Black": ["01-copy-0_86c1bd3e-8980-4744-bb89-72c3974fc17e.jpg","HP-01-copy-0.jpg","HP-02-copy-0.jpg","HP-03-copy-0.jpg","HP-04.jpg","HP-05-copy-0.jpg","HP-07-copy-0.jpg","HP-08-copy-0.jpg"]
        },
        "frido-orthotics-toe-ring-sandals": {
          "Black": ["MS-01_f6649676-9d6d-4c73-a001-ea88f7445553.jpg","MS-01B_06c4ee9b-2bf9-400c-bed2-7d05e020b91a.jpg","MS-01C_37e53fe3-19f3-4613-b357-4bb4bc6a2d4e.jpg","MS-01D_927b182d-395d-47fd-94dc-80940ecd1505.jpg","MS-02_4c16ccfa-5b46-4500-b143-99b03798ca82.jpg","MS-03_ad1170d9-9fee-411b-bf43-f11a76eea7b6.jpg","MS-04_ed3a1d8b-14f5-46de-bdc0-1a01be285ccc.jpg","MS-05_f00b5476-10c4-4998-8a6d-2d6bcdfba5e6.jpg"],
          "Brown": ["MS-01_ffe80cba-2c75-43e4-b68c-602c1b86ccc5.jpg","MS-01B_b05fd996-76c7-446e-b6fd-7cc5f0bbd70a.jpg","MS-01C_f5a5e593-79d5-46a0-b36a-049fd4c70bf5.jpg","MS-01D_93f397ad-d988-426c-90b3-9b3c2f473083.jpg","MS-02_8954981f-c547-48e5-b195-a0423b1741b0.jpg","MS-03_6f79fcbb-3b74-4f42-b61e-af0fbff2b6cf.jpg","MS-04_32bd6a2e-67c5-40d1-87c9-4d212c87ec52.jpg","MS-05_0a069940-39ac-45e2-9282-da0e04215c98.jpg"]
        },
        "frido-puneri-arch-comfort-sandal": {
          "Classic Brown": ["CCPC-00A_bb9b1feb-f0ae-4f39-b55a-e6c8adcbcf1f.jpg","CCPC-00B_df60c412-e377-449d-b04d-fbe9c67ddebd.jpg","CCPC-00C_262dc365-7ba7-45e9-8dda-d6044bc85a0e.jpg","CCPC-00D_c2c1390b-e3c6-4820-8d3b-d0425cda43ba.jpg","CCPC-00E_5df386e3-a244-43a4-827e-6bfde86d3a11.jpg","CCPC-01_d651a236-07b4-472b-bbb4-f298a75562fb.jpg","CCPC-02_9c026098-df5f-490d-877a-2cb5ba4b4b3a.jpg","CCPC-03_2fbf6ada-c5a1-4091-9246-7acf27a980d8.jpg"]
        },
        "frido-puneri-chappal-men": {
          "Black": ["PC-01_ef4f6100-4f33-462d-8794-fcecf6adbb5b.jpg","PC-01B_512785c2-668d-436d-ac4f-f3f453a54e4c.jpg","PC-01C_6f523732-cb93-4687-ae96-2050af31932c.jpg","PC-01D_0e5a496e-6752-4b7c-8004-170fcd20c2b1.jpg","PC-01E_f25e4fd4-a037-4a93-a838-c07b82ebaf9c.jpg","PC-02_eb018788-ff82-4f27-9b26-2ee3f2e4b29b.jpg","PC-03_a8a96822-a5fa-47b8-8ac2-d82842a5c1c4.jpg","PC-04_9237b02f-a74a-406b-a6ad-2720ca7246e0.jpg"],
          "Olive": ["PC_01A_6cbe5615-0694-4141-89aa-1fd3c3573d63.jpg","PC_01B_I_b36a20f0-a4ef-4fa5-acdd-9e50f7505379.jpg","PC_01C_ef3b747f-1700-4df7-9ad7-5251393c1719.jpg","PC_01D_479ed977-67c8-4952-a66d-b2e4893c1f1f.jpg","PC_01E_25142dc3-d6ec-41d9-8ff2-288dc27d2434.jpg","PC_02_d94dad09-36e7-4b59-93de-24bbbcf85536.jpg","PC_03_0d0669d9-aa12-473a-a980-819888e4f91b.jpg","PC_04_f4b05379-f03c-43a8-bab1-2e775e89f193.jpg"]
        },
        // The capture for this product had picked up two files that are not product
        // photos at all — a Snapmint payment banner and a generic foot icon — so every
        // colour ended its carousel on a payment logo. SGI-02..06 are beige-tinted
        // shots, which is why Transparent must NOT borrow them: the catalogue holds
        // only the two genuinely transparent photos below (hero + retail pack).
        "frido-silicone-gel-insole": {
          "Beige": ["SGI-01.jpg","SGI-02.jpg","SGI-03.jpg","SGI-04.jpg","SGI-05.jpg","SGI-06.jpg"],
          "Grey": ["SGI-01_1.jpg","SGI-02-copy-0.jpg","SGI-03-copy-0.jpg","SGI-04-copy-0.jpg","SGI-05-copy-0.jpg","SGI-06-copy-0.jpg"],
          "Transparent": ["SGI-01_9a0426ec-b55a-402b-8dc8-fb4298553a49.jpg"]
        },
        "frido-womens-cloud-comfort-sandal-toeless": {
          "Tan": ["WS-01_8355e471-082a-4b88-808d-13818bc6177d.jpg","WS-01A_6285865a-51de-445a-afa0-f78832c8ca98.jpg","WS-01B_0b8c212c-0a29-48ea-98d6-84a40957ea82.jpg","WS-01C_55a1e3fd-c07b-456d-b789-273f23311fb1.jpg","WS-01D_072c262f-fbf0-4f05-b0de-a139ec81c7c7.jpg","WS-02_39e32c88-a1db-4e26-b53c-9ad4d3843253.jpg","WS-02B_889f21ec-992a-46ca-bc12-aab628fac7c9.jpg","WS-03_0d15944e-b17f-44ea-af65-d52d2f86296b.jpg"],
          "Dark Silver": ["WS-01_953a7019-b185-4e07-8ea6-d04c4e19ce95.jpg","WS-01A_e687b64e-c4e6-45a2-a329-b482fdaf2a1a.jpg","WS-01B_f49095a6-87be-4f1b-8f4c-f08bc1af52da.jpg","WS-01C_adb9996d-ff05-45a6-b801-6ef6f58dec77.jpg","WS-01D_7dc6d4f6-b671-444d-a3c0-926a84a975e6.jpg","WS-02_94a4751f-5a52-472f-aa3c-76a05221427d.jpg","WS-02B_78e620eb-9e2a-4482-a5d9-8add432f837a.jpg","WS-03_2fe20d8e-bad1-49f8-9420-9f99e9cbc227.jpg"],
          // Lavender is deliberately absent: its photos exist only inside an upload run that
          // also holds the brown and black sandals, so there is no way to separate them
          // without risking another colour's shoe. It keeps its own hero until tagged.
          "Taupe": ["WS-06_62c31a9f-f7a6-42d2-955d-baadedc9af51.jpg","WS-04_7c8036d9-2cc1-49c9-88e4-99e602b3dd2c.jpg","WS-05_f2c95d3e-95a3-4439-96e3-7e63577b5a6f.jpg","WS-03_c0d9c6d0-ff3a-41fe-af2d-c211a276fa0b.jpg","WS-07_b19804c0-9bba-4a90-9189-06e7fc05c2d2.jpg","WS-11_0c70f557-5cd6-4620-b4a6-8fffb6a577ab.jpg","WS-01D_1830a854-7d62-4bec-837e-05cba380815e.jpg","WS-01_8287c991-9950-4ff3-8270-29f533821789.jpg"],
          "Black": ["WS-04_32577868-8b7e-4cbb-9a26-067fc28538eb.jpg","WS-02B_eed33187-6ccd-4a90-8af0-5331fc22fc1f.jpg","WS-01D_06143288-8ecc-495c-a8a3-b394cdae9b6b.jpg","WS-03_b49ab213-01f7-4c41-be3f-b8bdb8fed454.jpg","WS-01_abe8fb00-22bd-4af2-b4f5-4965a24adcaa.jpg","WS-07_da380cc7-6bb5-4adf-bdae-74b29337d0aa.jpg","WS-02_ecd0272b-69a3-4f4b-b8cf-9b8310ca915a.jpg","WS-05_2.jpg"],
          "Peach": ["WS-01A_47560fc4-8805-47a3-9444-41a149a704a7.jpg","WS-01C_e6c1d9b5-4cfc-4737-bf15-36437c732085.jpg","WS-07_a911170f-5a6b-48b8-bf31-24eff96afd2c.jpg","WS-02B_42072d3e-8fe1-4209-9b1a-47bc641a9115.jpg","WS-11_f6e27768-4245-4f33-a1af-fea20786e76d.jpg","WS-10_b97110cb-6cc1-4acb-a680-6f7612a283fc.jpg","WS-06_586622c3-2eee-4fa0-af5a-6dca6491f324.jpg","WS-08_b341a34e-a2c6-492e-8cf2-476c92e706e6.jpg"]
        },
        "frido-womens-cloud-comfort-shoes-slip-ons": {
          "Black": ["AS-00A_f451e497-e7ac-48bf-a8f7-6b2be2ea01c9.jpg","AS-00B_57f835a7-5eb9-43ba-85b9-7b7f34dd0b4c.jpg","AS-00D_9cf4ab98-36e4-43fe-92d6-8c092a73f704.jpg","AS-00E_db280368-2068-4d39-a5fc-ded02f370536.jpg","AS-01_7f5bb253-fed9-4f15-a821-97860184f1b1.jpg","AS-01B_fe5fed19-c4b5-49c1-bd6e-aec751c9a840.jpg","AS-02_ab355b9d-d621-4155-960b-778d794219c7.jpg","AS-03_864692ce-bca5-4054-8e2e-c645a25be4d2.jpg"],
          "White": ["AS-00A_43be17a7-fca6-42b8-a6ca-11f254fb2f90.jpg","AS-00B_28e81d69-947a-4351-bc49-de59d836cf71.jpg","AS-00D_9459b74e-08bc-43a9-8256-7619d47f4792.jpg","AS-00E_2.jpg","AS-01_333c63a8-ccfc-4309-baf9-a02d13e9fdfd.jpg","AS-01B_f9d0d589-9bca-4484-a039-d76651324cd7.jpg","AS-02_7f2ec6cc-ec01-475a-ae37-315e0df89ee7.jpg","AS-03_a97e5455-6979-4871-bf0d-4b9aa847ed54.jpg"],
          "Lavender": ["AS-00A_41b71d68-e9db-4379-9867-b6b94366ddc2.jpg","AS-00B_ff1b9d91-67a1-473d-b5b8-9c50a2123e0d.jpg","AS-00D_78d409b7-e49c-4806-8b65-477c058cbedc.jpg","AS-00E_2208ba6b-89ef-46ea-93f0-8f27efdc4b7c.jpg","AS-01_bf4f3d5c-94e3-450c-8d11-851ca8168950.jpg","AS-01B_e4479b53-5f3d-4d06-8b85-cd48ec59b36a.jpg","AS-02_808a6639-2e79-4e91-af34-1c6d9cecd0ee.jpg","AS-03_b897ae16-051c-4e5f-9da7-3c77918eff18.jpg"],
          "Pink": ["AS-00A_8922b8b0-9643-4b15-a79f-15d56d9279a3.jpg","AS-00B_deda9d81-b493-42b0-ac7e-9a5facfd2172.jpg","AS-00D_13ab1d66-567b-4d95-be54-ca6126a2155e.jpg","AS-00E_6b5ec78b-3b04-4873-911b-ba438f4b02a3.jpg","AS-01_5f1356f0-38ca-4ad6-9274-453bf22a3048.jpg","AS-01B_0bcc0218-dae5-47cf-94e3-86767d123dbf.jpg","AS-02_0f1933df-5502-40cc-b9bf-4e1b6aee1608.jpg","AS-03_2f57c74f-e31d-4ad3-ad28-d803135a8c81.jpg"]
        },
        "frido-womens-ethnic-comfort-flat-sandal": {
          "Satin Gold": ["EF-01A_ffcf9389-001c-46d0-a6d9-0c867df1161d.jpg","EF-01B_efdb4040-051b-4674-ad34-b59a9a27cad6.jpg","EF-01C_7cf09150-bfe7-473f-890e-f1cf51e7a854.jpg","EF-01D_5335cb81-632e-4899-be0e-37e145a58a25.jpg","EF-02_31b2ae49-de98-4bca-a1ae-8fc70d53e11f.jpg","EF-03_6147bd9c-fd8b-4bb0-90a8-793e7e201f11.jpg","EF-04_1202248f-d974-4dc8-9a0c-abf61bf93d3f.jpg","EF-05_a3d7625f-5b75-4d18-a7fb-7e2e38661ffd.jpg"],
          "Pastel Multi": ["EF-01A_7f750f80-f0db-42d2-a6e1-53080d5df4f7.jpg","EF-01B_39c04118-f30e-402c-a47c-010d781d0c53.jpg","EF-01C_1.jpg","EF-01D_035add3e-99ef-4115-876d-9e7839544187.jpg","EF-02_e6d77168-c2e4-452d-9f14-09a9dcb59187.jpg","EF-03_804d1ea5-a308-48ad-8730-626437b487ee.jpg","EF-04_252b9e50-ee61-4dc5-a10a-abe170f9d29d.jpg","EF-05_9f677331-fdd1-461d-a8c5-fd9e4cd97c37.jpg"],
          "Rose Pink": ["EF-01A_4b7a0bbc-53ea-4cba-8d19-af34b5c3538d.jpg","EF-01B_bc832656-b307-4d61-a69c-ee66a648d22e.jpg","EF-01C_032e81fc-ac97-4375-8f38-2c1c24609cec.jpg","EF-01D_9992b4b6-1e9b-47c6-a33e-8a3cb41560cc.jpg","EF-02_774f587c-fe90-4fa9-a756-0a90c812361e.jpg","EF-03_3d32b997-ef55-4149-b55b-08cc2cfcff6e.jpg","EF-04_1de9a9bd-97ef-4b23-a96e-4b5a7d021d76.jpg","EF-05_e268de24-1cac-4d92-90b7-8a9273e84057.jpg"],
          "Mocca Mousse": ["EF-01A_55add399-0142-4005-8cee-7abc404e21be.jpg","EF-01B_7d9b66e1-3d2e-4a04-a9d2-d5a516a36cc1.jpg","EF-01C_e5e4783e-93ac-46bc-8483-ce184ab59925.jpg","EF-01D_52e26928-75eb-4159-8f5b-7e8e6a23a8da.jpg","EF-02_f966643c-3eae-4d66-bdea-d35d968775fb.jpg","EF-03_92eac97e-02f3-4eeb-aeb1-9236c85aa9dc.jpg","EF-04_16b0db9e-c648-45bf-a121-94ad285f423d.jpg","EF-05_10d46da7-0128-45b8-967b-dc881db12d3b.jpg"]
        }
      };
      function colorsFor(p){
        if (p && p.name && PRODUCT_COLORS[p.name] && PRODUCT_COLORS[p.name].length) return PRODUCT_COLORS[p.name];
        if (p && p.__shopifyColors && p.__shopifyColors.length) return p.__shopifyColors;
        if (window.FfShopify) {
          window.FfShopify.annotateProduct(p);
          var live = window.FfShopify.colorsForProduct(p, PRODUCT_COLORS, null);
          if (live && live.length) return live;
        }
        if (p && p.sizeType) return FALLBACK_COLORS;
        return [];
      }
      // Resolve the best variant ID given product name, chosen color index, and size.
      // Priority: live Shopify match → color+size map → size-only map → base vid.
      function resolveVariant(p, colorIdx, size){
        if (window.FfShopify) {
          var liveVid = window.FfShopify.resolveVariant(p, colorIdx, size, PRODUCT_COLORS, FALLBACK_COLORS);
          if (liveVid) return liveVid;
        }
        var cols = colorsFor(p);
        if (cols.length && colorIdx != null && cols[colorIdx] && cols[colorIdx].variants && size && cols[colorIdx].variants[size]){
          return cols[colorIdx].variants[size];
        }
        var sv = variantForSize(p.name, size);
        if (sv) return sv;
        return p.vid || "";
      }
    
      // ── PRODUCT DETAILS (for the "View details" pop-up) ─────────────
      // Per-product rich content, keyed by product name:
      //   images   - array of gallery image URLs (first is the main shot)
      //   description - paragraph string
      //   details  - object of label → value pairs (Brand, Type, Material, ...)
      // FILL THESE IN per product. Anything omitted falls back gracefully:
      // images → the product's single img; description → its tag line; details → price/rating.
      // Template:
      //   "Frido Comfort Formal Shoes": {
      //     images: ["https://.../1.jpg", "https://.../2.jpg"],
      //     description: "Lightweight comfort formal shoes built for long office hours...",
      //     details: { Brand: "Frido", Type: "Formal shoes", Material: "Genuine leather", Origin: "India" }
      //   },
      var PRODUCT_DETAILS = {
      };
      function detailsFor(p){
        var d = (p && p.name && PRODUCT_DETAILS[p.name]) ? PRODUCT_DETAILS[p.name] : {};
        var images = (d.images && d.images.length) ? d.images.slice(0) : [];
        // No curated gallery? Build one from the live per-colour images (one real
        // product shot per colour) so the details view shows every variant.
        if (!images.length){
          var cols = colorsFor(p) || [];
          for (var i = 0; i < cols.length; i++){
            if (cols[i].img && images.indexOf(cols[i].img) < 0) images.push(cols[i].img);
          }
        }
        if (!images.length && p && p.img) images = [p.img];
        var description = d.description || p.tag || "";
        var details = d.details || {};
        return { images: images, description: description, details: details };
      }
    
      var QUESTIONS = [
        { id: "location", q: "Where do you feel pain/discomfort most often?", help: "Tap the area that bothers you most.", opts: [
          { label: "Heel", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Heel_ff507ccc-1639-43fc-8d80-a3a6c36084da.png?v=1781518663" alt="" loading="lazy">', sig: { plantar: 3, heel: 3 } },
          { label: "Arch / midfoot", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Arch_midfoot.png?v=1781518663" alt="" loading="lazy">', sig: { flat: 4, high: 4, plantar: 1 } },
          { label: "Ball of foot", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Ball_of_foot_d5c3a48e-cec5-4f70-a76f-06ece1c76ed8.png?v=1781518662" alt="" loading="lazy">', sig: { meta: 5 } },
          { label: "Toes", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Toes.png?v=1781518663" alt="" loading="lazy">', sig: { bunion: 5, meta: 1, high: 1 } },
          { label: "Entire foot", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Entire_foot.png?v=1781518662" alt="" loading="lazy">', sig: { fatigue: 5 } },
          { label: "Not sure", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frame_1_7ac5d2a1-f77f-495d-8ca8-4e1ac77049e1.png?v=1781525336" alt="" loading="lazy">', sig: { general: 1 } }
        ]},
        { id: "feel", q: "How would you describe the discomfort?", help: "Pick the closest match.", opts: [
          { label: "Sharp pain", sub: "Sudden, stabbing, often on first steps", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Sharp_pain.png?v=1781588366" alt="" loading="lazy">', sig: { plantar: 7 } },
          { label: "Burning sensation", sub: "Hot, prickly, usually under the toes or ball of foot", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Burning_sensation.png?v=1781588365" alt="" loading="lazy">', sig: { meta: 3, high: 1, bunion: 1 } },
          { label: "Constant aching pain", sub: "Dull & consistent, builds through the day", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Constant_aching_pain.png?v=1781588366" alt="" loading="lazy">', sig: { heel: 2, flat: 1 } },
          { label: "Foot fatigue", sub: "Heavy, worn-out, after long hours on your feet", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Foot_fatigue.png?v=1781588366" alt="" loading="lazy">', sig: { fatigue: 5, flat: 1 } },
          { label: "Numbness or tingling", sub: "Pins-and-needles or loss of feeling", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Numbness_or_tingling.png?v=1781588366" alt="" loading="lazy">', sig: { meta: 2, high: 2, bunion: 2, general: 2 } },
          { label: "Knee or lower-leg pain", sub: "Aches up from the foot, often from poor arch support", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Group_1_5.png?v=1781689645" alt="" loading="lazy">', sig: { flat: 4, fatigue: 1 } },
          { label: "Not sure", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frame_1_7ac5d2a1-f77f-495d-8ca8-4e1ac77049e1.png?v=1781525336" alt="" loading="lazy">', sig: { general: 1 } }
        ]},
        { id: "diagnosed", q: "Have you ever been diagnosed with any of the following foot conditions?", help: "Select all that apply.", multi: true, opts: [
          { label: "Plantar Fasciitis", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/plantar_fascitis_2.png?v=1781504786" alt="" loading="lazy">', sig: { plantar: 8 } },
          { label: "Heel Spur", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Heel_Spur.png?v=1781504851" alt="" loading="lazy">', sig: { heel: 5, plantar: 2 } },
          { label: "Flat Feet", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Flat_Feet_f0eb8100-5f1d-4f02-8ed0-6e1883eb4ac2.png?v=1781504851" alt="" loading="lazy">', sig: { flat: 6 } },
          { label: "High Arches", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/High_Arches.png?v=1781504851" alt="" loading="lazy">', sig: { high: 6 } },
          { label: "Bunions", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Bunions_7d3616ba-54db-44a2-a34f-11664dbb7c71.png?v=1781504851" alt="" loading="lazy">', sig: { bunion: 8 }, addon: "bunion", width: "wide" },
          { label: "Metatarsalgia (Ball of Foot Pain)", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Metatarsalgia_Ball_of_Foot_Pain.png?v=1781504851" alt="" loading="lazy">', sig: { meta: 8 } },
          { label: "Achilles Tendonitis", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Achilles_Tendonitis.png?v=1781504851" alt="" loading="lazy">', sig: { heel: 3, plantar: 2 } },
          { label: "Not sure / None of the above", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frame_1_7ac5d2a1-f77f-495d-8ca8-4e1ac77049e1.png?v=1781525336" alt="" loading="lazy">', sig: {} }
        ]},
        { id: "arch", q: "What's your arch like?", help: "Not sure? Wet-footprint test: a full print = flat, a thin strip = high.", helpImg: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_27_1.png?v=1781593128", opts: [
          { label: "Flat (full footprint)", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/flat_feet_5958cc1d-2600-45d8-9ff5-05f17a7b6008.png?v=1781593122" alt="" loading="lazy">', sig: { flat: 5, plantar: 4, heel: 2, fatigue: 3 } },
          { label: "Normal", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/normal.png?v=1781593122" alt="" loading="lazy">', sig: { fatigue: 1 } },
          { label: "High (narrow footprint)", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/high_arch.png?v=1781593123" alt="" loading="lazy">', sig: { high: 5, meta: 3, heel: 1, fatigue: 2 } },
          { label: "Not sure", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frame_1_7ac5d2a1-f77f-495d-8ca8-4e1ac77049e1.png?v=1781525336" alt="" loading="lazy">', sig: {} }
        ]},
        { id: "gender", q: "What's your gender?", help: "So we match the right styles and fit.", opts: [
          { label: "Female", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Female.png?v=1781518700" alt="" loading="lazy">', sig: {}, gender: "women" },
          { label: "Male", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Male.png?v=1781518700" alt="" loading="lazy">', sig: {}, gender: "men" }
        ]},
        { id: "activity", q: "Which activities best describe your daily routine?", help: "Select all that apply.", multi: true, opts: [
          { label: "Long hours on my feet all day", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frame_1_e2df7250-754b-467d-ae7a-3c8077f4955e.png?v=1781854263" alt="" loading="lazy">', sig: { fatigue: 5, plantar: 2, heel: 2 }, ctx: "work" },
          { label: "Daily walking and errands", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Daily_walking_1b673b76-d2a2-466a-8fba-e0ae56bcddd9.png?v=1781522974" alt="" loading="lazy">', sig: { heel: 1, flat: 2, high: 2, fatigue: 3 }, ctx: "walk" },
          { label: "Running, gym, or sports", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Running_gym_or_sports_35a2f961-a668-46a7-bb3d-b9068b6f6c2f.png?v=1781523220" alt="" loading="lazy">', sig: { plantar: 3, heel: 2, meta: 4 }, ctx: "active" },
          { label: "Relaxing at home", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Relaxing_at_home_2b34a31c-7ee5-4577-b549-28629fc33db8.png?v=1781522979" alt="" loading="lazy">', sig: { fatigue: 1 }, ctx: "casual" }
        ]},
        { id: "timing", q: "When is your foot pain or discomfort at its worst?", help: "Pick the closest match.", opts: [
          { label: "First few steps in the morning", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/First_few_steps_in_the_morning.png?v=1781602170" alt="" loading="lazy">', sig: { plantar: 4, heel: 2 } },
          { label: "After standing for long periods", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frame_1_e2df7250-754b-467d-ae7a-3c8077f4955e.png?v=1781854263" alt="" loading="lazy">', sig: { fatigue: 3, heel: 2, flat: 2, high: 2 } },
          { label: "After walking long distances", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frame_4_ded5544e-8242-45bc-bcc9-3ef93c310999.png?v=1781854262" alt="" loading="lazy">', sig: { fatigue: 3, flat: 2, meta: 2, high: 2 } },
          { label: "During exercise or sports", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/During_exercise_or_sports_1.png?v=1781602170" alt="" loading="lazy">', sig: { meta: 3, plantar: 2 } },
          { label: "By the end of the day", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frame_3_7acde17c-ba77-45e5-b534-0f534a70b728.png?v=1781854262" alt="" loading="lazy">', sig: { fatigue: 4, flat: 2, heel: 2, high: 2 } },
          { label: "All the time", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frame_2_7a860256-d6b1-4abc-8360-b00cf10a87ad.png?v=1781854262" alt="" loading="lazy">', sig: { fatigue: 4, heel: 2, general: 4 } },
          { label: "I don't experience pain, just tired feet", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/I_don_t_experience_pain_just_tired_feet_1.png?v=1781602171" alt="" loading="lazy">', sig: { fatigue: 6 } }
        ]},
        { id: "footwear", q: "What type of footwear do you wear most often?", help: "Footwear is often the root cause of recurring foot discomfort.", opts: [
          { label: "Sneakers", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/sneakers_1_1.png?v=1781597098" alt="" loading="lazy">', sig: {} },
          { label: "Sports Shoes", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Sports_Shoes.png?v=1781588335" alt="" loading="lazy">', sig: { plantar: 1, meta: 1 } },
          { label: "Formal Shoes", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Formal_Shoes.png?v=1781588335" alt="" loading="lazy">', sig: { meta: 2, heel: 1, fatigue: 1 } },
          { label: "Flats", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Flats.png?v=1781588335" alt="" loading="lazy">', sig: { plantar: 2, flat: 2 } },
          { label: "Sandals / Slippers", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Sandals_Slippers.png?v=1781588335" alt="" loading="lazy">', sig: { fatigue: 1, plantar: 3, flat: 1, high: 1 } },
          { label: "Heels", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Heels.png?v=1781588335" alt="" loading="lazy">', sig: { meta: 4, bunion: 3, fatigue: 2 } },
          { label: "Safety Shoes / Work Boots", icon: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Safety_Shoes_Work_Boots.png?v=1781588335" alt="" loading="lazy">', sig: { fatigue: 4, heel: 2 } }
        ]}
      ];
    
      var CTX_LABEL = { work: "long hours on your feet", walk: "daily walking", active: "exercise & sports", casual: "relaxing at home", ethnic: "festive wear" };
      var DISCOUNT = 0.15;
    
      var step = 0, answers = {}, kit = { shoe: true, insole: true, support: true };
      var userName = "";
      var SESSION_KEY = "ff_footfinder_session";

      function persistSession(prefUsed){
        try {
          sessionStorage.setItem(SESSION_KEY, JSON.stringify({
            version: 1,
            completed: true,
            answers: answers,
            userName: userName,
            prefOverride: prefUsed || "",
            record: {
              sessionId: RECORD.sessionId,
              startedAt: RECORD.startedAt,
              completedAt: RECORD.completedAt,
              name: RECORD.name,
              phone: RECORD.phone,
              lead: RECORD.lead,
              answers: RECORD.answers,
              result: RECORD.result,
              recommended: RECORD.recommended
            }
          }));
        } catch (e) {}
      }

      function clearSession(){
        try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
      }

      function restoreSession(){
        try {
          var raw = sessionStorage.getItem(SESSION_KEY);
          if (!raw) return false;
          var data = JSON.parse(raw);
          if (!data || !data.completed || !data.answers) return false;
          answers = data.answers;
          userName = data.userName || "";
          if (data.record){
            var rec = data.record;
            if (rec.sessionId) RECORD.sessionId = rec.sessionId;
            if (rec.startedAt) RECORD.startedAt = rec.startedAt;
            if (rec.completedAt) RECORD.completedAt = rec.completedAt;
            RECORD.name = rec.name || null;
            RECORD.phone = rec.phone || null;
            RECORD.lead = rec.lead || null;
            RECORD.answers = rec.answers || {};
            RECORD.result = rec.result || null;
            RECORD.recommended = rec.recommended || null;
          }
          elIntro.style.display = "none";
          if (elNameScreen) elNameScreen.style.display = "none";
          if (elGate) elGate.style.display = "none";
          elQuiz.style.display = "none";
          var pref = data.prefOverride || undefined;
          showResult(pref, { restore: true });
          track("session_restored", { condition: RECORD.result && RECORD.result.condition });
          return true;
        } catch (e) { return false; }
      }
    
      // capture the optional first name (trim, title-case the first letter, strip odd chars)
      function captureName(){
        var el = document.getElementById("ff-name-input");
        if (!el) return;
        var v = (el.value || "").trim().replace(/[^a-zA-Z\u00C0-\u024F\s'-]/g, "").slice(0, 24);
        if (v){ userName = v.charAt(0).toUpperCase() + v.slice(1); }
        RECORD.name = userName || null;
      }
      // returns ", Priya" style suffix, or "" if no name — for natural injection
      function nameSuffix(){ return userName ? (", " + userName) : ""; }
    
      var elIntro = document.getElementById("ff-intro");
      var elQuiz = document.getElementById("ff-quiz");
      var elResult = document.getElementById("ff-result");
      var elMount = document.getElementById("ff-q-mount");
      var elBar = document.getElementById("ff-bar-fill");
      var elCount = document.getElementById("ff-step-count");
    
      // build the embedded Q1 starter from the same QUESTIONS data (no duplication)
      function renderStarter(){
        var grid = document.getElementById("ff-starter-grid");
        if (!grid) return;
        var q1 = QUESTIONS[0];
        var h = "";
        for (var i = 0; i < q1.opts.length; i++){
          h += '<button class="ff-starter-opt" data-i="' + i + '"><span class="ff-starter-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span><span class="ff-starter-text">' + q1.opts[i].label + '</span><span class="ff-starter-ico">' + q1.opts[i].icon + '</span></button>';
        }
        grid.innerHTML = h;
        var btns = grid.querySelectorAll(".ff-starter-opt");
        for (var b = 0; b < btns.length; b++){
          btns[b].addEventListener("click", function(){
            var idx = parseInt(this.getAttribute("data-i"), 10);
            // record Q1 answer, then go through the name interstitial before Q2
            answers[QUESTIONS[0].id] = idx;
            RECORD.answers[QUESTIONS[0].id] = { question: QUESTIONS[0].q, label: QUESTIONS[0].opts[idx].label, index: idx };
            track("quiz_answer", { question: QUESTIONS[0].id, step: 1, choice: QUESTIONS[0].opts[idx].label, via: "hero" });
            clearSession();
            showNameInterstitial(1);
          });
        }
      }
      // Allow the footprint visual ("We help with") to start the quiz with Q1 pre-selected
      window.__startFromZone = function(idx){
        if (typeof idx !== "number") return;
        answers[QUESTIONS[0].id] = idx;
        RECORD.answers[QUESTIONS[0].id] = { question: QUESTIONS[0].q, label: QUESTIONS[0].opts[idx].label, index: idx };
        track("quiz_answer", { question: QUESTIONS[0].id, step: 1, choice: QUESTIONS[0].opts[idx].label, via: "helps_foot" });
        clearSession();
        showNameInterstitial(1);
      };
    
      // ── name interstitial (sits between the first tap and Q2) ──
      var elNameScreen = document.getElementById("ff-name-screen");
      var pendingFromStep = 0;
      function showNameInterstitial(fromStep){
        pendingFromStep = fromStep || 0;
        if (userName){ beginQuiz(pendingFromStep); return; } // already named, skip
        track("name_interstitial_shown", { fromStep: pendingFromStep });
        elIntro.style.display = "none"; elNameScreen.style.display = "flex"; window.scrollTo(0,0);
        var input = document.getElementById("ff-name-screen-input");
        if (input){ setTimeout(function(){ input.focus(); }, 80); }
      }
      (function wireNameScreen(){
        var input = document.getElementById("ff-name-screen-input");
        var phone = document.getElementById("ff-name-screen-phone");
        var err = document.getElementById("ff-name-phone-err");
        if (phone){
          phone.addEventListener("input", function(){
            this.value = this.value.replace(/[^0-9]/g, "").slice(0, 10);
            if (err) err.classList.remove("show");
          });
        }
        function captureFromScreen(){
          if (input){
            var v = (input.value || "").trim().replace(/[^a-zA-Z\u00C0-\u024F\s'-]/g, "").slice(0, 24);
            if (v){ userName = v.charAt(0).toUpperCase() + v.slice(1); RECORD.name = userName; }
          }
          if (phone){
            // Only store a REAL number. This runs on the skip path too, so a half-typed
            // "98" must not be recorded as a contact (it would then satisfy the gate
            // and we'd end up with an unusable lead instead of a good one).
            var num = (phone.value || "").replace(/[^0-9]/g, "");
            if (num.length === 10 && !/^[0-5]/.test(num)){ RECORD.phone = "+91" + num; }
          }
        }
        function phoneIsValidOrEmpty(){
          if (!phone) return true;
          var num = (phone.value || "").replace(/[^0-9]/g, "");
          if (!num) return true; // empty is fine — both fields are optional
          return num.length === 10 && !/^[0-5]/.test(num);
        }
        function proceed(skipped){
          if (!skipped && !phoneIsValidOrEmpty()){
            if (err) err.classList.add("show");
            if (phone) phone.focus();
            return;
          }
          // Capture on BOTH paths. "Skip this" used to throw away a number the shopper had
          // already typed, so the mandatory gate then demanded it a second time — the exact
          // opposite of "ask once". A number on screen is a number given.
          captureFromScreen();
          var hasName = !!userName, hasPhone = !!RECORD.phone;
          track(skipped ? "name_screen_skipped" : "name_screen_captured", { hasName: hasName, hasPhone: hasPhone });
          if (hasPhone) submitLead({ name: userName || null, phone: RECORD.phone });
          elNameScreen.style.display = "none";
          beginQuiz(pendingFromStep);
        }
        var cont = document.getElementById("ff-name-continue");
        if (cont) cont.addEventListener("click", function(){ proceed(false); });
        var skip = document.getElementById("ff-name-skip");
        if (skip) skip.addEventListener("click", function(){ proceed(true); });
        if (input){
          input.addEventListener("keydown", function(e){ if (e.key === "Enter"){ e.preventDefault(); if (phone) phone.focus(); else proceed(false); } });
        }
        if (phone){
          phone.addEventListener("keydown", function(e){ if (e.key === "Enter"){ e.preventDefault(); proceed(false); } });
        }
      })();
    
      function beginQuiz(fromStep){
        if (!RECORD.startedAt){ track("quiz_start", { via: fromStep > 0 ? "hero_q1" : "button", named: !!userName }); RECORD.startedAt = new Date().toISOString(); }
        elIntro.style.display = "none"; elQuiz.style.display = "block"; step = fromStep || 0; renderQ(); window.scrollTo(0,0);
      }
    
      document.getElementById("ff-start").addEventListener("click", function(){ clearSession(); showNameInterstitial(0); });
      (function wireStickyStart(){
        var btn = document.getElementById("ff-sticky-start");
        if (btn) btn.addEventListener("click", function(){ showNameInterstitial(0); });
      })();
      document.getElementById("ff-back").addEventListener("click", function(){
        if (step > 0) { step--; renderQ(); } else { elQuiz.style.display = "none"; elIntro.style.display = "block"; (ffRoot || document.documentElement).classList.remove("ff-in-quiz"); }
      });
      // exit button: confirm then return to intro, clearing quiz state
      (function wireExit(){
        var exitBtn = document.getElementById("ff-exit");
        if (!exitBtn) return;
        var armed = false, timer = null;
        var originalText = exitBtn.querySelector("span") ? exitBtn.querySelector("span").textContent : "Exit";
        exitBtn.addEventListener("click", function(){
          if (!armed){
            armed = true;
            var span = exitBtn.querySelector("span");
            if (span) span.textContent = "Sure?";
            exitBtn.classList.add("ff-exit--armed");
            if (timer) clearTimeout(timer);
            timer = setTimeout(function(){
              armed = false;
              if (span) span.textContent = originalText;
              exitBtn.classList.remove("ff-exit--armed");
            }, 3000);
            return;
          }
          // confirmed exit: clear quiz state, return to intro
          armed = false;
          if (timer) clearTimeout(timer);
          var span = exitBtn.querySelector("span");
          if (span) span.textContent = originalText;
          exitBtn.classList.remove("ff-exit--armed");
          track("quiz_exit", { atStep: step + 1 });
          step = 0; answers = {};
          elQuiz.style.display = "none"; elIntro.style.display = "block";
          (ffRoot || document.documentElement).classList.remove("ff-in-quiz");
          window.scrollTo(0, 0);
        });
      })();
      // name interstitial back: return to intro
      (function wireNameBack(){
        var nameBack = document.getElementById("ff-name-back");
        if (!nameBack) return;
        nameBack.addEventListener("click", function(){
          track("name_screen_back", {});
          elNameScreen.style.display = "none"; elIntro.style.display = "block"; window.scrollTo(0, 0);
        });
      })();
    
      function renderQ(){
        var qq = QUESTIONS[step];
        var pct = Math.round((step / QUESTIONS.length) * 100);
        elBar.style.width = pct + "%";
        elCount.textContent = (step + 1) + " / " + QUESTIONS.length;
        var html = '<div class="ff-q">';
        var mid = Math.floor(QUESTIONS.length / 2);
        html += '<div class="ff-q-num">Question ' + (step + 1) + '</div>';
        // medium personalization: address the user by name in the question text at two key moments —
        // right after the name capture (step 1) and at the halfway mark.
        var questionText = qq.q;
        if (userName && step === 1){ questionText = "Thanks, " + userName + ". " + qq.q; }
        else if (userName && step === mid){ questionText = "You're doing great, " + userName + ". " + qq.q; }
        html += '<h2>' + questionText + '</h2><p class="help">' + qq.help + '</p>';
        if (qq.helpImg) { html += '<img src="' + qq.helpImg + '" alt="" loading="lazy" style="width:68%;border-radius:12px;margin:0 auto 16px;display:block;">'; }
        html += '<div class="ff-options' + (qq.id === "location" ? " ff-options-stacked" : "") + '">';
        var isMulti = !!qq.multi;
        var selectedSet = {};
        if (isMulti && Array.isArray(answers[qq.id])){
          for (var k = 0; k < answers[qq.id].length; k++){ selectedSet[answers[qq.id][k]] = true; }
        }
        for (var i = 0; i < qq.opts.length; i++){
          var o = qq.opts[i];
          var isSelected = isMulti ? !!selectedSet[i] : (answers[qq.id] === i);
          var sel = isSelected ? " sel" : "";
          html += '<button class="ff-opt' + sel + '" data-i="' + i + '">';
          html += '<span class="ff-check">' + ICON.check + '</span>';
          html += '<span class="ff-opt-label"><span class="ff-opt-lead">' + o.label + '</span>';
          if (o.sub) html += '<span class="ff-opt-sub">' + o.sub + '</span>';
          html += '</span>';
          html += '<span class="ff-ico">' + o.icon + '</span>';
          html += '</button>';
        }
        html += '</div>';
        if (isMulti){
          var hasAny = Array.isArray(answers[qq.id]) && answers[qq.id].length > 0;
          var countN = hasAny ? answers[qq.id].length : 0;
          // spacer so the last option isn't hidden behind the sticky bar
          html += '<div class="ff-q-multi-pad" aria-hidden="true"></div>';
          html += '<div class="ff-multi-bar' + (hasAny ? ' ff-multi-bar--ready' : '') + '" id="ff-multi-bar">';
          html += '<span class="ff-multi-count" id="ff-multi-count">' + countN + ' selected</span>';
          html += '<button class="ff-cta ff-multi-continue" id="ff-multi-continue"' + (hasAny ? '' : ' disabled') + '>Continue';
          html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
          html += '</button>';
          html += '</div>';
        }
        html += '</div>';
        elMount.innerHTML = html;
        var btns = elMount.querySelectorAll(".ff-opt");
        for (var b = 0; b < btns.length; b++){
          btns[b].addEventListener("click", function(){
            if (isMulti){ toggleMulti(parseInt(this.getAttribute("data-i"), 10)); }
            else { pick(parseInt(this.getAttribute("data-i"), 10)); }
          });
        }
        if (isMulti){
          var contBtn = document.getElementById("ff-multi-continue");
          if (contBtn) contBtn.addEventListener("click", function(){ advanceMulti(); });
        }
        (ffRoot || document.documentElement).classList.add("ff-in-quiz");
      }
    
      function pick(idx){
        var qq = QUESTIONS[step];
        answers[qq.id] = idx;
        // store answer in plain language for the data record
        RECORD.answers[qq.id] = { question: qq.q, label: qq.opts[idx].label, index: idx };
        track("quiz_answer", { question: qq.id, step: step + 1, choice: qq.opts[idx].label });
        var btns = elMount.querySelectorAll(".ff-opt");
        for (var b = 0; b < btns.length; b++){ btns[b].classList.remove("sel"); }
        if (btns[idx]) btns[idx].classList.add("sel");
        setTimeout(function(){
          if (step < QUESTIONS.length - 1){ step++; renderQ(); window.scrollTo(0,0); } else { showGate(); }
        }, 260);
      }
    
      function toggleMulti(idx){
        var qq = QUESTIONS[step];
        if (!Array.isArray(answers[qq.id])) answers[qq.id] = [];
        var arr = answers[qq.id];
        var pos = arr.indexOf(idx);
        if (pos >= 0){ arr.splice(pos, 1); } else { arr.push(idx); }
        // visual toggle
        var btns = elMount.querySelectorAll(".ff-opt");
        if (btns[idx]) btns[idx].classList.toggle("sel", arr.indexOf(idx) >= 0);
        // sticky bar: count + ready state + button enable
        var bar = document.getElementById("ff-multi-bar");
        var countEl = document.getElementById("ff-multi-count");
        var contBtn = document.getElementById("ff-multi-continue");
        if (countEl) countEl.textContent = arr.length + " selected";
        if (bar) bar.classList.toggle("ff-multi-bar--ready", arr.length > 0);
        if (contBtn){
          if (arr.length > 0) contBtn.removeAttribute("disabled");
          else contBtn.setAttribute("disabled", "");
        }
      }
    
      function advanceMulti(){
        var qq = QUESTIONS[step];
        var arr = answers[qq.id] || [];
        if (arr.length === 0) return;
        // record the array of labels
        var labels = arr.map(function(i){ return qq.opts[i].label; });
        RECORD.answers[qq.id] = { question: qq.q, labels: labels, indices: arr.slice() };
        track("quiz_answer_multi", { question: qq.id, step: step + 1, choices: labels });
        if (step < QUESTIONS.length - 1){ step++; renderQ(); window.scrollTo(0,0); } else { showGate(); }
      }
    
      // ── lead gate (skippable phone capture before results) ──
      var elGate = document.getElementById("ff-gate");
      function showGate(){
        // If we've already captured the phone at the interstitial, skip the gate entirely
        if (RECORD.phone){
          track("lead_gate_auto_skipped", { reason: "phone_captured_upfront" });
          showResult();
          return;
        }
        var t = document.getElementById("ff-gate-title");
        if (t){ t.textContent = userName ? (userName + ", your match is ready!") : "Your match is ready!"; }
        // hide the name input at the gate if we already captured a name earlier
        var nameField = document.getElementById("ff-name-input");
        if (nameField && userName){ nameField.style.display = "none"; }
        track("lead_gate_shown", {});
        elQuiz.style.display = "none"; elGate.style.display = "flex"; window.scrollTo(0,0);
        (ffRoot || document.documentElement).classList.remove("ff-in-quiz");
      }
      function proceedToResult(){ elGate.style.display = "none"; showResult(); }
      (function wireGate(){
        var phoneEl = document.getElementById("ff-phone-input");
        var errEl = document.getElementById("ff-gate-err");
        if (phoneEl){
          phoneEl.addEventListener("input", function(){
            this.value = this.value.replace(/[^0-9]/g, "").slice(0, 10);
            if (errEl) errEl.classList.remove("show");
          });
        }
        var submit = document.getElementById("ff-gate-submit");
        if (submit){
          submit.addEventListener("click", function(){
            captureName();
            var num = (phoneEl.value || "").replace(/[^0-9]/g, "");
            // Indian mobile numbers are 10 digits starting 6-9
            if (num.length !== 10 || /^[0-5]/.test(num)){
              if (errEl) errEl.classList.add("show");
              phoneEl.focus();
              return;
            }
            RECORD.phone = "+91" + num;
            track("lead_captured", { hasName: !!userName });
            submitLead({ name: userName || null, phone: "+91" + num });
            proceedToResult();
          });
        }
        // Pre-diagnosis gate is MANDATORY — phone required before results.
        // (Skip button + handler intentionally removed.)
      })();
    
      // ── lead destination ──
      // Sends a captured lead to your backend / CRM. Currently a stub that funnels
      // through the existing analytics. DROP YOUR ENDPOINT HERE — for example:
      //   fetch("https://your-endpoint", { method:"POST",
      //     headers:{"Content-Type":"application/json"}, body: JSON.stringify(lead) });
      // Works with a Google Sheet webhook, Klaviyo, Shopify, or the WhatsApp API.
      // Same contact must not be reported twice. Both the optional first screen and the
      // mandatory gate call this, and the first screen now also fires on "Skip this" —
      // without a guard one shopper could land in the sheet as two leads.
      var lastLeadSig = "";
      function submitLead(lead){
        try {
          var sig = ((lead && lead.phone) || "") + "|" + ((lead && lead.name) || "");
          if (sig === lastLeadSig) return;
          lastLeadSig = sig;
          RECORD.lead = lead;
          sendData(RECORD, "lead_captured");
          // Expose the captured contact so the abandoned-cart tracker can attach it
          // to the cart snapshot, and (re)start its idle watch now that we have a phone.
          window.__ffContact = { phone: RECORD.phone || (lead && lead.phone) || "", name: RECORD.name || (lead && lead.name) || "", sessionId: RECORD.sessionId };
          if (window.FfAbandon && window.FfAbandon.onContact) window.FfAbandon.onContact();
          // TODO: POST `lead` (and/or RECORD) to your chosen endpoint here.
        } catch (e) {}
      }
    
      function scoreAnswers(){
        var scores = { plantar: 0, heel: 0, flat: 0, high: 0, fatigue: 0, meta: 0, bunion: 0, general: 0 };
        var ctx = "walk", width = "regular", gender = "men", pref = "";
        var overrideCondition = null;
        var addons = {};
        // ctx priority: when multiple activities are selected, pick the highest-priority context.
        // Higher number = higher priority (more support needed).
        var CTX_PRIORITY = { active: 4, work: 3, walk: 2, ethnic: 1, casual: 0 };
        var ctxScore = -1;
        for (var s = 0; s < QUESTIONS.length; s++){
          var qq = QUESTIONS[s]; var a = answers[qq.id];
          if (a === undefined || a === null) continue;
          // multi-select: a is an array of indices
          var indices = Array.isArray(a) ? a : [a];
          for (var ii = 0; ii < indices.length; ii++){
            var o = qq.opts[indices[ii]];
            if (!o) continue;
            if (o.sig) { for (var k in o.sig){ if (scores.hasOwnProperty(k)) scores[k] += o.sig[k]; } }
            if (o.ctx && CTX_PRIORITY[o.ctx] !== undefined && CTX_PRIORITY[o.ctx] > ctxScore){
              ctx = o.ctx;
              ctxScore = CTX_PRIORITY[o.ctx];
            }
            if (o.width) width = o.width;
            if (o.gender) gender = o.gender;
            if (o.pref !== undefined) pref = o.pref;
            if (o.override && !overrideCondition) overrideCondition = o.override;
            if (o.addon) addons[o.addon] = true;
          }
        }
        // ── HARD RULE ──────────────────────────────────────────────────────────────
        // If the user selects BOTH "Flat Feet" (diagnosed) AND "Flat (full footprint)" (arch),
        // the diagnosis is always Flat Feet, regardless of any other selections.
        (function(){
          function isSelected(qid, labelStarts){
            var a = answers[qid];
            if (a === undefined || a === null) return false;
            var idxs = Array.isArray(a) ? a : [a];
            var q = null;
            for (var qi = 0; qi < QUESTIONS.length; qi++){ if (QUESTIONS[qi].id === qid){ q = QUESTIONS[qi]; break; } }
            if (!q) return false;
            for (var n = 0; n < idxs.length; n++){
              var opt = q.opts[idxs[n]];
              if (opt && opt.label && opt.label.toLowerCase().indexOf(labelStarts) === 0) return true;
            }
            return false;
          }
          if (isSelected("diagnosed", "flat feet") && isSelected("arch", "flat")){
            overrideCondition = "flat";
          }
        })();

        var top;
        if (overrideCondition && scores.hasOwnProperty(overrideCondition)){
          // user told us they have a confirmed condition; trust them
          top = overrideCondition;
        } else {
          top = "general"; var topVal = 0;
          for (var c in scores){ if (scores[c] > topVal){ topVal = scores[c]; top = c; } }
        }
        return { condition: top, ctx: ctx, width: width, gender: gender, pref: pref, addons: addons, scores: scores };
      }
    
      function fmt(n){ return n.toLocaleString("en-IN"); }
      // Returns up to N secondary conditions ranked by score, expressed as % of the primary's score.
      // Excludes the primary, excludes conditions below the threshold (default 40%).
      function secondaryConditions(scores, primaryKey, opts){
        opts = opts || {};
        var threshold = opts.threshold || 0.25;
        var max = opts.max || 2;
        var primaryScore = scores[primaryKey] || 0;
        if (primaryScore <= 0) return [];
        var items = [];
        for (var k in scores){
          if (k === primaryKey) continue;
          var pct = scores[k] / primaryScore;
          if (pct >= threshold){
            // cap at 99% so an override-pinned primary doesn't yield secondaries above 100%
            if (pct > 0.99) pct = 0.99;
            items.push({ key: k, pct: pct, score: scores[k] });
          }
        }
        items.sort(function(a, b){ return b.score - a.score; });
        return items.slice(0, max);
      }
    
      function stars(r){ var full = Math.round(parseFloat(r)); var s = ""; for (var i=0;i<5;i++){ s += i<full ? "★" : "☆"; } return s; }
    
      function renderStats(){
        var h = '<div class="ff-stats-strip">';
        h += '<div class="ff-stats-card"><div class="ff-stats-left"><div class="ff-stats-num">2 Lakh+</div><div class="ff-stats-sub">Customers</div></div><div class="ff-stats-ico ff-stats-ico--red">&#10084;</div></div>';
        h += '<div class="ff-stats-card"><div class="ff-stats-left"><div class="ff-stats-num">4.8</div><div class="ff-stats-sub">Avg. rating</div></div><div class="ff-stats-ico ff-stats-ico--yel">&#9733;</div></div>';
        h += '<div class="ff-stats-card"><div class="ff-stats-left"><div class="ff-stats-num">94%</div><div class="ff-stats-sub">Saw results</div></div><div class="ff-stats-ico ff-stats-ico--grn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="8 12 11 15 16 9"/></svg></div></div>';
        h += '</div>';
        return h;
      }
    
      function renderStories(){
        var el = document.getElementById("ff-stories-static");
        if (!el) return "";
        var html = el.outerHTML;
        html = html.replace(' style="display:none;"', "");
        html = html.replace(' id="ff-stories-static"', "");
        // Tag the result-page clone so it can get its own spacing (extra top gap) without
        // affecting the homepage instance.
        html = html.replace('class="ff-stories-section"', 'class="ff-stories-section ff-stories-section--result"');
        return html;
      }
    
      var FAQ_COMMON = [
        { q: "How long does it take to feel relief?", a: "Most customers notice a difference within 7\u201310 days of consistent use. For chronic conditions like plantar fasciitis or flat feet, full relief typically comes within 3\u20134 weeks." },
        { q: "Frido products seem expensive \u2014 are they worth it?", a: "Fair question. A single physio session in India costs \u20b9800\u20131,500 and gives you relief for a day. A Frido insole at \u20b91,499 works every day for 12\u201318 months \u2014 that\u2019s under \u20b94 per day. Our footwear is built on an orthopedic last with cushioning most brands only put in shoes twice the price. Over 2 lakh customers and a 4.8 rating suggest the results speak for themselves. And if it doesn\u2019t work for you, we have a 7-day easy exchange." },
        { q: "Can I use the insole in any shoe?", a: "Yes. Frido insoles are trim-to-fit and work in most closed shoes, sneakers, and formal footwear. Remove the existing insole first for best fit." },
        { q: "What\u2019s your return policy?", a: "We offer a 7-day easy exchange on all footwear and insoles. If the product isn\u2019t right for you, contact us on WhatsApp and we\u2019ll sort it out." },
        { q: "Is this recommended by doctors?", a: "Frido products are designed with orthopedic and podiatric inputs. Many physiotherapists and ortho specialists recommend our insoles as a first-line comfort solution." },
        { q: "Can I wear these all day?", a: "Absolutely. Our insoles and footwear are built for all-day wear. Start with a few hours if your feet are adjusting to arch support, then build up." }
      ];
      var FAQ_BY_CONDITION = {
        plantar:  [{ q: "Why does my heel hurt most in the morning?", a: "That\u2019s classic plantar fasciitis. Overnight the fascia tightens; first steps stretch it suddenly. A deep heel cup with arch support reduces that morning spike significantly." }],
        heel:     [{ q: "Are heel pads the same as insoles?", a: "No. Heel pads target the heel pad only, while full-length insoles support the entire foot. For heel spur pain, a combination of both works best." }],
        flat:     [{ q: "Do flat feet get worse without support?", a: "Over time, unsupported flat feet can cause knee and lower-back pain from overpronation. A rigid arch insole corrects alignment before secondary issues develop." }],
        high:     [{ q: "High arches \u2014 do I need softer or firmer insoles?", a: "Softer, cushioned insoles. High arches absorb less shock naturally, so extra cushioning at the ball and heel prevents stress fractures and fatigue." }],
        fatigue:  [{ q: "Why do my feet ache by afternoon even in comfortable shoes?", a: "Most casual shoes lack midfoot support. A memory foam insole with arch support redistributes pressure and dramatically cuts end-of-day fatigue." }],
        meta:     [{ q: "What is metatarsalgia and can insoles help?", a: "Metatarsalgia is ball-of-foot pain from excess pressure on the metatarsal bones. A metatarsal pad insole lifts and spreads that load \u2014 most users feel relief within days." }],
        bunion:   [{ q: "Will a bunion corrector straighten my toe permanently?", a: "Correctors realign the toe during wear and slow progression. For permanent correction, surgery is the only option \u2014 but a corrector plus wide-toe footwear relieves daily pain very effectively." }],
        general:  [{ q: "I don\u2019t have a specific condition. How do I pick the right insole?", a: "Start with a cushioned memory foam insole for all-day comfort. If you stand 4+ hours daily, add light arch support. The quiz result above matches you to your ideal combination." }]
      };
    
      function renderFAQ(condition) {
        var faqs = (FAQ_BY_CONDITION[condition] || []).concat(FAQ_COMMON);
        var h = '<section class="ff-faq-section">';
        h += '<h2 class="ff-faq-title">Frequently Asked Questions</h2>';
        h += '<p class="ff-faq-sub">Everything you need to know before you buy. Still unsure? Our support team is a message away.</p>';
        for (var fi = 0; fi < faqs.length; fi++) {
          h += '<div class="ff-faq-item" data-faq="' + fi + '">';
          h += '<button type="button" class="ff-faq-q">';
          h += '<span>' + faqs[fi].q + '</span>';
          h += '<span class="ff-faq-chevron"><svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="#1A1A1A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
          h += '</button>';
          h += '<div class="ff-faq-a">' + faqs[fi].a + '</div>';
          h += '</div>';
        }
        h += '</section>';
        return h;
      }
    
      function showResult(prefOverride, opts){
        opts = opts || {};
        var r = scoreAnswers();
        var cond = CATALOG[r.condition];
        var set = cond[r.gender] || cond.men;
        var prefForShoe = (prefOverride !== undefined) ? prefOverride : r.pref;
        // Default hero = the curated CATALOG shoe (guarantees the displayed footwear matches its
        // category tab). Only when the user explicitly picks a footwear type (pref) do we run the
        // scorer to swap in a best-match product of that category.
        var heroShoe;
        if (prefForShoe){
          heroShoe = pickShoe(r.condition, r.ctx, r.gender, prefForShoe);
          if (!heroShoe) heroShoe = set.shoe;
        } else {
          heroShoe = set.shoe;
        }
        // Resolve hero footwear type from the SHOES catalog (set.shoe P() objects don't carry .t).
        var heroType = heroShoe.t;
        if (!heroType){
          for (var hi = 0; hi < SHOES.length; hi++){ if (SHOES[hi].p === heroShoe || SHOES[hi].p.name === heroShoe.name){ heroType = SHOES[hi].t; break; } }
        }
        var heroFwType = (heroType === "sandal") ? "sandal" : ((heroType === "slipper" || heroType === "chappal") ? "slipper" : "closed");
        var items = [
          { key: "shoe", role: "Recommended footwear", section: "footwear", footwearType: heroFwType, locked: true, p: heroShoe },
          { key: "insole", role: "Matched insole", section: "insole", locked: false, p: set.insole }
        ];
        // Bunion is the only condition with a true orthotic (the Bunion Corrector). For every other
        // condition the third item is a second insole, shown under the Insole section.
        if (r.condition === "bunion"){
          items.push({ key: "support", role: "Relief add-on", section: "orthotic", locked: false, p: set.support });
        } else {
          items.push({ key: "support", role: "Added insole", section: "insole", locked: false, p: set.support });
        }
        // Bunion Corrector only appears when bunion is the primary result (it's the kit's
        // `support` item from the bunion CATALOG entry). It is never added as a secondary addon.
        if (!opts.restore){
          track("quiz_complete", { condition: r.condition, gender: r.gender, ctx: r.ctx, width: r.width });
        }

        // ── populate the full data record ──
        if (!opts.restore){ RECORD.completedAt = new Date().toISOString(); }
        RECORD.result = {
          condition: r.condition,
          conditionLabel: cond.label,
          gender: r.gender,
          activity: r.ctx,
          activityLabel: CTX_LABEL[r.ctx],
          width: r.width
        };
        try { window.__ffResult = RECORD.result; } catch (e) {}
        RECORD.recommended = {
          shoe: heroShoe.name,
          insole: set.insole.name,
          support: set.support.name
        };
        if (!opts.restore){ sendData(RECORD, "quiz_complete"); }
        var prefUsed = (prefOverride !== undefined) ? prefOverride : r.pref;
        persistSession(prefUsed);
    
        var widthNote = (r.width === "wide") ? " · roomy fit" : "";
        var hero = heroShoe;
        var heroOff = Math.round((1 - hero.price / hero.mrp) * 100);
        // determine active filter from hero shoe's category — match by name since set.shoe (CATALOG)
        // is a different object than the SHOES array entries.
        var heroShoeRow = null;
        for (var si = 0; si < SHOES.length; si++){ if (SHOES[si].p === hero || SHOES[si].p.name === hero.name){ heroShoeRow = SHOES[si]; break; } }
        var activeFilter = heroShoeRow ? heroShoeRow.t : "closed";
        if (activeFilter === "chappal") activeFilter = "slipper"; // collapse chappal under slipper
    
        var html = '<div class="ff-fade">';
        var heading = userName ? ("Hi " + userName + ", Here\u2019s What We Found.") : "Here\u2019s What We Found.";
        var primaryIcon = CONDITION_ICONS[r.condition] || ICON.general;

        // ════ COMBINED REPORT BLOCK (single blue gradient) ════
        var ms = getMatchStrength(r.condition);
        var chips = getAnswerChips();
        var causes = CAUSES_BY_COND[r.condition] || CAUSES_BY_COND.general;

        html += '<div class="ff-rep ff-rep--blue ff-rep--combined">';

        // block header — name in title, name-free eyebrow
        var reportTitle = userName ? (userName + "\u2019s Foot Health Report") : "Your Foot Health Report";
        html += '<div class="ff-rep-eyebrow">Your results are in</div>';
        html += '<h2 class="ff-rep-maintitle">' + reportTitle + '</h2>';
        html += '<p class="ff-rep-sub">Based on your answers, here\u2019s what we found and why.</p>';

        // ── sub-part: Your diagnosis (FIRST) ──
        html += '<div class="ff-rep-part">';
        html += '<div class="ff-rep-part-label">Your diagnosis</div>';
        html += '<div class="ff-rep-found">';
        html += '<span class="ff-rep-found-ico">' + primaryIcon + '</span>';
        html += '<div class="ff-rep-found-text">';
        html += '<span class="ff-rep-found-name">' + cond.label + '</span>';
        if (cond.oneLine) html += '<span class="ff-rep-found-desc">' + cond.oneLine + '</span>';
        html += '</div>';
        html += '</div>';
        html += '</div>';  // /ff-rep-part (diagnosis)

        // ── sub-part: Based on what you told us (SECOND) ──
        if (chips.length){
          html += '<div class="ff-rep-part">';
          html += '<div class="ff-rep-part-label">Based on what you told us</div>';
          html += '<div class="ff-rep-chips">';
          for (var ci = 0; ci < chips.length; ci++){ html += '<span class="ff-rep-chip">' + chips[ci] + '</span>'; }
          html += '</div>';
          html += '</div>';
        }

        // ── sub-part: Why this happens (THIRD) ──
        html += '<div class="ff-rep-part">';
        html += '<div class="ff-rep-part-label">Why this happens</div>';
        html += '<div class="ff-rep-causes">';
        for (var cz = 0; cz < causes.length; cz++){
          var cu = causes[cz];
          html += '<div class="ff-rep-cause">';
          html += '<span class="ff-rep-cause-ico">' + causeIcon(cu.icon) + '</span>';
          html += '<div class="ff-rep-cause-text"><span class="ff-rep-cause-title">' + cu.title + '</span><span class="ff-rep-cause-body">' + cu.body + '</span></div>';
          html += '</div>';
        }
        html += '</div>';
        html += '</div>';

        html += '</div>';  // /ff-rep--combined


        // ── shared social-proof adoption % (illustrative; placeholders) ──
        // STRICT RULE: indoor % must always be higher than outdoor % per condition.
        var FF_INDOOR_PCT = { plantar:84, flat:86, heel:81, high:80, fatigue:78, meta:79, bunion:77, general:76 };
        var FF_OUTDOOR_PCT_RAW = { plantar:71, heel:69, flat:74, high:67, fatigue:66, meta:64, bunion:62, general:68 };
        function ffOutdoorPct(condKey){
          var indoor = FF_INDOOR_PCT[condKey] || 80;
          var outdoor = FF_OUTDOOR_PCT_RAW[condKey] || 67;
          // enforce outdoor strictly below indoor
          return Math.min(outdoor, indoor - 1);
        }

        // ════════════════════════════════════════════════════════════════════
        // VERSION A — "Your [Condition] Kit": multi-select rich cards + one CTA
        // 3 selectable cards (shoe+free insole, sandal, slipper), each with a
        // default variant pill; one combined CTA adds all selected items.
        // ════════════════════════════════════════════════════════════════════
        (function(){
          var condLabel = (cond.label || "foot pain").toLowerCase();
          var pct = FF_INDOOR_PCT[r.condition] || 80;
          var ARCH_CONDS = { plantar:1, flat:1, heel:1, high:1 };
          var archFirst = !!ARCH_CONDS[r.condition];

          // ---- product data ----
          var arch = P("Frido Cloud Comfort Arch Support Slippers", "Built-in arch support", 949, 1999, "51352664867097", ICON.insole, "4.6", "1.1k", "https://myfrido.com/products/frido-cloud-comfort-arch-support-slippers", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/B-CCASS-01_daacff8c-5694-47b1-81b6-3f541e8e0653.jpg?v=1770619699");
          var plush = P("Frido Cloud Comfort Slippers", "Soft, Plush cushioning", 849, 1499, "51223190274329", ICON.insole, "4.6", "1.1k", "https://myfrido.com/products/frido-cloud-comfort-slippers", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/CCS-01_5df3ddce-28c2-46e8-9ab1-7164cd5ee242.jpg?v=1758444340");
          var kitSlipper = archFirst ? arch : plush;
          var kitShoe = pickShoe(r.condition, r.ctx, r.gender, "closed");
          var kitSandal = pickShoe(r.condition, r.ctx, r.gender, "sandal");

          var INSOLE_BY_COND = {
            plantar: P("Frido Plantar Fasciitis Pain Relief Ortho Insoles", "Deep heel cup for plantar relief", 1499, 2499, "50656187613465", ICON.insole, "4.6", "1.2k", "https://myfrido.com/products/frido-plantar-fasciitis-pain-relief-ortho-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Primary_Small_-_PLI.webp?v=1783507476"),
            heel:    P("Frido Orthopedic Heel Pad Pro Insole", "Gel heel cushioning for heel pain", 599, 699, "50720461717785", ICON.support, "4.5", "980", "https://myfrido.com/products/frido-orthopedic-heel-pad-pro-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/HPP-01-beige.jpg?v=1745922369"),
            flat:    P("Frido Arch Support Insoles", "Semi-rigid arch correction for flat feet", 999, 2799, "45508768596249", ICON.insole, "4.6", "1.1k", "https://myfrido.com/products/frido-arch-support-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Arch_correction_Insole_rigid.jpg?v=1724683439"),
            high:    P("Frido Arch Support Insoles", "Semi-rigid arch support for high arches", 999, 2799, "45508768596249", ICON.insole, "4.6", "1.1k", "https://myfrido.com/products/frido-arch-support-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Arch_correction_Insole_rigid.jpg?v=1724683439"),
            fatigue: P("Frido Gel Max Comfort Insole", "All-day soft support", 699, 1599, "50668529058073", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-gel-max-comfort-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/0-GMI-LI-Small_8945baa9-c165-465b-8889-93455ffb0537.jpg?v=1744875791"),
            meta:    P("Frido Gel Max Comfort Insole", "Plush cushioning for the ball of the foot", 699, 1599, "50668529058073", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-gel-max-comfort-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/0-GMI-LI-Small_8945baa9-c165-465b-8889-93455ffb0537.jpg?v=1744875791"),
            bunion:  P("Frido Gel Max Comfort Insole", "Shock-absorbing gel layer", 699, 1599, "50668529058073", ICON.support, "4.5", "1.7k", "https://myfrido.com/products/frido-gel-max-comfort-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/0-GMI-LI-Small_8945baa9-c165-465b-8889-93455ffb0537.jpg?v=1744875791"),
            general: P("Frido Gel Max Comfort Insole", "Soft full-foot support", 699, 1599, "50668529058073", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-gel-max-comfort-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/0-GMI-LI-Small_8945baa9-c165-465b-8889-93455ffb0537.jpg?v=1744875791")
          };
          var kitInsole = INSOLE_BY_COND[r.condition] || INSOLE_BY_COND.general;
          // Resolve against Shopify BEFORE anything renders. The entries above carry a
          // hardcoded photo/price, and only the bundle row and cart were being annotated —
          // so the "comes free" strip under each shoe showed a different picture of the same
          // insole (for flat/high arches, a visibly different one: Arch_correction_Insole_rigid
          // vs Shopify's Beginners_Flat_Feet_Insole). Annotating here means the strip, the
          // bundle row, the cart and the data-ffb-ins-* attributes all read one object.
          try { if (window.FfShopify) window.FfShopify.annotateProduct(kitInsole); } catch (e) {}
          // Expose the diagnosed free insole so seedFreeGift puts the SAME product in
          // the cart that the bundle shows as the free gift (single source of truth).
          try { window.__ffFreeGiftInsole = kitInsole; } catch (e) {}

          // data-attr helper for the select/sheet flow (reused by wireKit)
          function dataAttrs(p, role){
            return ' data-kit-name="' + (p.name||"") + '" data-kit-tag="' + (p.tag||"") + '" data-kit-price="' + (p.price||0) + '" data-kit-mrp="' + (p.mrp||p.price||0) + '" data-kit-vid="' + (p.vid||"") + '" data-kit-url="' + (p.url||"") + '" data-kit-img="' + (p.img||"") + '" data-kit-role="' + role + '"';
          }
          function offTag(p){ return (p.mrp && p.mrp > p.price) ? '<span class="ff-kit-off">' + Math.round((1 - p.price/p.mrp)*100) + '% OFF</span>' : ''; }
          function ctxTag(kind){
            if (kind === "indoor") return '<span class="ff-kit-ctx ff-kit-ctx--in">Indoor</span>';
            return '<span class="ff-kit-ctx ff-kit-ctx--out">Outdoor</span>';
          }
          function variantPill(role){
            return '<span class="ff-kit-variant" data-kit-variant-for="' + role + '"><span class="ff-kit-variant-txt">Select size</span><span class="ff-kit-variant-change">Change</span></span>';
          }
          function priceHtml(p){
            var now = '<span class="ff-kit-price">\u20b9' + fmt(p.price) + '</span>';
            var mrp = (p.mrp && p.mrp > p.price) ? '<span class="ff-kit-mrp">\u20b9' + fmt(p.mrp) + '</span>' : '';
            return '<span class="ff-kit-priceline">' + now + mrp + '</span>';
          }

          // ── option lists per category (ranked for this condition/gender/activity) ──
          var allClosed = pickShoes(r.condition, r.ctx, r.gender, "closed");
          var shoeList = allClosed.slice(0, 4);
          var SANDAL_ONLY = (r.gender === "women")
            ? ["Frido Women's Cloud Comfort Sandal", "Frido Women's Cloud Comfort Sandal - Toeless"]
            : ["Frido Men's Comfort Dual Strap Sandals", "Frido Men's Cloud Comfort Sandal"];
          var sandalPoolAll = pickShoes(r.condition, r.ctx, r.gender, "sandal");
          var sandalList = [];
          for (var so = 0; so < SANDAL_ONLY.length; so++){
            for (var sp = 0; sp < sandalPoolAll.length; sp++){
              if (sandalPoolAll[sp].name === SANDAL_ONLY[so]){ sandalList.push(sandalPoolAll[sp]); break; }
            }
          }
          if (!sandalList.length) sandalList = sandalPoolAll.slice(0, 2);
          var slipperList = pickShoes(r.condition, r.ctx, r.gender, "slipper").slice(0, 4);

          // ── feature chips: small inline-SVG icons + label, derived from product copy ──
          var FEAT_SVG = {
            cushion: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 16c-2 0-3-1.5-3-3.5S4 9 7 9c1-3 4-4 6-4s4.5 1 5 4c2 0 4 1 4 3.5S20 16 18 16z"/></svg>',
            arch: ICON.arch,
            drop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 16h16"/><path d="M7 16v-3M17 16v-3"/></svg>',
            light: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20s6-2 10-6 6-10 6-10-6 0-10 4-6 12-6 12z"/><path d="M9 15a2 2 0 0 0-2 2"/></svg>',
            breathe: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8h11a3 3 0 1 0-3-3"/><path d="M3 12h15a3 3 0 1 1-3 3"/><path d="M3 16h7"/></svg>',
            allday: ICON.hourglass,
            grip: ICON.support,
            roomy: ICON.wide,
            shock: ICON.bolt
          };
          function chip(key, label){ return '<span class="ffb-chip">' + (iconMark(key) || FEAT_SVG[key] || '') + label + '</span>'; }
          function featuresFor(p, type){
            var s = ((p.name || "") + " " + (p.tag || "")).toLowerCase();
            var out = [];
            function add(k, l){ if (out.length < 3){ for (var i=0;i<out.length;i++){ if (out[i].l === l) return; } out.push({ k:k, l:l }); } }
            if (/arch|orthotic/.test(s)) add("arch", "Arch support");
            if (/cushion|plush|soft|cloud|memory/.test(s)) add("cushion", "Cushioned");
            if (/light|active|walking/.test(s)) add("light", "Lightweight");
            if (/roomy|wide|dual strap/.test(s)) add("roomy", "Roomy fit");
            if (/breathable|open|toeless|toe ring|v-strap/.test(s)) add("breathe", "Breathable");
            if (/rigid|firm|stable|structure|formal/.test(s)) add("grip", "Firm support");
            // type defaults to guarantee >=2 chips
            if (type === "closed"){ add("cushion", "Cushioned"); add("allday", "All-day"); }
            else if (type === "sandal"){ add("breathe", "Breathable"); add("arch", "Arch support"); }
            else { add("cushion", "Cushioned"); add("arch", "Arch support"); }
            var h = "";
            for (var i = 0; i < out.length; i++) h += chip(out[i].k, out[i].l);
            return h;
          }

          // ── option card (1:1 image, chips, variant pill, select state) ──
          function optCard(p, role, type, selected, withFreeInsole){
            var h = '<div class="ffb-card' + (selected ? ' is-selected' : '') + '" data-ffb-role="' + role + '" data-ffb-type="' + type + '"';
            h += ' data-ffb-name="' + (p.name||"") + '" data-ffb-tag="' + (p.tag||"") + '" data-ffb-price="' + (p.price||0) + '" data-ffb-mrp="' + (p.mrp||p.price||0) + '" data-ffb-vid="' + (p.vid||"") + '" data-ffb-url="' + (p.url||"") + '" data-ffb-img="' + (p.img||"") + '">';
            h += '<span class="ffb-card-check">' + ICON.check + '</span>';
            h += '<div class="ffb-card-img"><img src="' + p.img + '" alt="' + p.name + '" loading="lazy">' + (withFreeInsole ? '<span class="ffb-free">+ FREE insole</span>' : '') + '</div>';
            h += '<div class="ffb-card-name">' + p.name.replace("Frido ", "") + '</div>';
            h += '<div class="ffb-card-priceline"><span class="ffb-card-price">\u20b9' + fmt(p.price) + '</span>' + ((p.mrp && p.mrp > p.price) ? '<span class="ffb-card-mrp">\u20b9' + fmt(p.mrp) + '</span>' : '') + '</div>';
            h += '<div class="ffb-chips">' + featuresFor(p, type) + '</div>';
            h += '<div class="ffb-card-foot"><span class="ffb-variant" data-ffb-variant-for="' + role + '"><span class="ffb-variant-txt">Select size</span><span class="ffb-variant-change">Change</span></span></div>';
            h += '</div>';
            return h;
          }
          function optRow(list, prefix, type, preselectFirst, freeInsole){
            var h = '<div class="ffb-row">';
            for (var i = 0; i < list.length; i++){
              h += optCard(list[i], prefix + i, type, (preselectFirst && i === 0), freeInsole);
            }
            h += '</div>';
            return h;
          }

          // featured-pick layout: one option (+ insole for shoes) up top, the rest collapsed below
          function dataAttrsFfb(p, role, type){
            return ' data-ffb-role="' + role + '" data-ffb-type="' + type + '" data-ffb-name="' + (p.name||"") + '" data-ffb-tag="' + (p.tag||"") + '" data-ffb-price="' + (p.price||0) + '" data-ffb-mrp="' + (p.mrp||p.price||0) + '" data-ffb-vid="' + (p.vid||"") + '" data-ffb-url="' + (p.url||"") + '" data-ffb-img="' + (p.img||"") + '"';
          }
          function priceLine(p){
            return '<div class="ffb-card-priceline"><span class="ffb-card-price">\u20b9' + fmt(p.price) + '</span>' + ((p.mrp && p.mrp > p.price) ? '<span class="ffb-card-mrp">\u20b9' + fmt(p.mrp) + '</span>' : '') + '</div>';
          }
          function variantPillFfb(role){
            return '<span class="ffb-variant" data-ffb-variant-for="' + role + '"><span class="ffb-variant-txt">Select size</span><span class="ffb-variant-change">Change</span></span>';
          }
          function carouselDots(n){
            if (n <= 1) return '';
            var h = '<div class="ffb-cx-dots">';
            for (var ci = 0; ci < n; ci++) h += '<span class="ffb-cx-dot' + (ci === 0 ? ' is-on' : '') + '"></span>';
            h += '</div>';
            return h;
          }
          function featCard(p, role, type, selected, tag){
            var off = (p.mrp && p.mrp > p.price) ? Math.round((1 - p.price / p.mrp) * 100) : 0;
            var h = '<div class="ffb-card ffb-card--feat' + (selected ? ' is-selected' : '') + '"' + dataAttrsFfb(p, role, type) + '>';
            h += '<span class="ffb-card-check">' + ICON.check + '</span>';
            if (tag) h += '<span class="ffb-card-tag">' + tag + '</span>';
            h += '<div class="ffb-card-img"><img src="' + p.img + '" alt="' + p.name + '" loading="lazy"></div>';
            h += '<div class="ffb-card-body">';
            h += '<div class="ffb-card-name">' + p.name.replace("Frido ", "") + '</div>';
            var featCols = colorsFor(p);
            if (featCols && featCols.length){
              h += '<div class="ffb-card-swatches">';
              for (var fci = 0; fci < featCols.length; fci++){
                var fsw = featCols[fci].swatch || "";
                var fswStyle = (fsw.indexOf("#") === 0) ? ('background:' + fsw + ';') : ('background-image:url(' + fsw + ');');
                h += '<span class="ffb-sw" title="' + featCols[fci].name + '" style="' + fswStyle + '"></span>';
              }
              h += '</div>';
            }
            h += '<div class="ffb-card-priceline"><span class="ffb-card-price">\u20b9' + fmt(p.price) + '</span>';
            if (p.mrp && p.mrp > p.price){
              h += '<span class="ffb-card-mrp">\u20b9' + fmt(p.mrp) + '</span>';
              if (off > 0) h += '<span class="ffb-card-off">' + off + '% OFF</span>';
            }
            h += '</div>';
            h += '<div class="ffb-card-foot"><button type="button" class="ffb-variant ffb-atc" data-ffb-variant-for="' + role + '"><span class="ffb-variant-txt">ADD TO CART</span><span class="ffb-variant-change" style="display:none;">Change</span></button></div>';
            h += '</div>';
            h += '</div>';
            return h;
          }
          function miniCard(p, role, type){
            var h = '<div class="ffb-card ffb-card--mini"' + dataAttrsFfb(p, role, type) + '>';
            h += '<span class="ffb-card-check">' + ICON.check + '</span>';
            h += '<div class="ffb-card-img"><img src="' + p.img + '" alt="' + p.name + '" loading="lazy"></div>';
            h += '<div class="ffb-card-name">' + p.name.replace("Frido ", "") + '</div>';
            h += priceLine(p);
            h += '<span class="ffb-added">\u2713 Added to your bundle</span>';
            h += '</div>';
            return h;
          }
          // featured (index 0) + collapsible "more" — used for sandals & slippers (no insole)
          function catSection(list, prefix, type, preselectFirst, moreLabel){
            var h = '<div class="ffb-shoe-carousel' + (type === "slipper" || type === "sandal" ? ' ffb-carousel--left' : '') + '">';
            for (var i = 0; i < list.length; i++){
              h += '<div class="ffb-carousel-item">' + featCard(list[i], prefix + i, type, false) + '</div>';
            }
            h += '</div>';
            return h;
          }
          // the free insole, shown as its own card under the shoe (size only, marked free)
          function insoleCard(p){
            var h = '<div class="ffb-insole-card">';
            h += '<div class="ffb-prod">';
            h += '<div class="ffb-prod-img"><img src="' + p.img + '" alt="' + p.name + '" loading="lazy"><span class="ffb-free">FREE</span></div>';
            h += '<div class="ffb-prod-main">';
            h += '<div class="ffb-insole-tag">Included free with your shoe</div>';
            h += '<div class="ffb-card-name">' + p.name.replace("Frido ", "") + '</div>';
            h += '<div class="ffb-insole-price"><span class="ffb-insole-now">Free</span><span class="ffb-card-mrp">\u20b9' + fmt(p.mrp||0) + '</span></div>';
            h += '<div class="ffb-card-foot">' + variantPillFfb("insole") + '</div>';
            h += '</div></div>';
            h += '</div>';
            return h;
          }
          // occasion bucketing for closed shoes (one tab per occasion)
          var OCC_LABELS = { casual:"Casual", daily:"Daily", formal:"Formal", walking:"Walking" };
          var OCC_HINT = { daily:"Lace-ups and slip-ons, daily wear", casual:"Sneakers, Easygoing daily looks", formal:"Office, events", walking:"Long walks, standing" };
          var OCC_ICON = {
            daily:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.4 1.4M17.6 17.6L19 19M19 5l-1.4 1.4M6.4 17.6L5 19"/></svg>',
            casual:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h13v5a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9z"/><path d="M17 10h2.2a2.4 2.4 0 0 1 0 4.8H17"/><path d="M8 5.5c0-1 .8-1 .8-2M11.5 5.5c0-1 .8-1 .8-2"/></svg>',
            formal:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="11" rx="2"/><path d="M9 8V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/><path d="M3 13h18"/></svg>',
            walking: '<img src="https://cdn.shopify.com/s/files/1/0553/0419/2034/files/icons8-walking-96.png?v=1783409037" alt="" loading="lazy" style="width:24px;height:24px;object-fit:contain;display:block;">'
          };
          var OCC_ORDER = ["daily", "casual", "formal", "walking"];
          function occOf(p){
            var n = (p.name || "").toLowerCase();
            if (/walking shoe/.test(n)) return "walking";
            if (/casual sneaker/.test(n)) return "casual";
            if (/formal/.test(n)) return "formal";
            return "daily";
          }

          // ── "How this helps" + trust strip + FAQ (shown below each step's nav) ──
          var HELP_ROWS = {
            closed:  [["cushion","Forefoot cushioning","Spreads pressure off the ball of your foot."],["arch","Arch support","Restores the arch so the forefoot carries less load."],["shock","Shock absorption","Softens each step before it reaches the bone."]],
            sandal:  [["breathe","Open + breathable","Cool, supportive cover for warm days and errands."],["arch","Built-in arch","Keeps the arch supported even in an open sandal."],["roomy","Roomy toe-box","Room across the forefoot \u2014 no squeeze on the joint."]],
            slipper: [["cushion","Plush cushioning","A soft landing for every step at home."],["arch","Indoor arch support","Most support is lost barefoot \u2014 this keeps it going."],["grip","Non-slip sole","Stable footing on hard indoor floors."]]
          };
          var FAQS = [
            ["How does the free insole work?","Add any shoe and we include a matching insole free \u2014 it trims to size and sits inside your shoe."],
            ["Not sure of your size?","Pick your usual UK size. Between sizes? Size up \u2014 and you have 7 days to exchange."],
            ["What if it doesn\u2019t work for me?","Try it for 7 days. If it\u2019s not right, exchange or return it \u2014 simple."]
          ];
          var ICON_CASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.4"/></svg>';
          var ICON_BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>';
          var ICON_FWD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:17px;height:17px;vertical-align:-3px;margin-left:7px;"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
          // Provided icon images (replace inline SVGs where a match exists; bolt = shock)
          var ICON_IMG = {
            grip:     "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Non-slip_grip.png?v=1782819290",
            roomy:    "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Roomy_toe-box.png?v=1782819290",
            cushion:  "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Cushioning.png?v=1782819290",
            arch:     "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Arch_support_9a9931a7-cc02-4305-81f1-47efcd5d96f8.png?v=1782819289",
            shock:    "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Shock.png?v=1782819289",
            bolt:     "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Shock.png?v=1782819289",
            breathe:  "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Breathable_e75562f9-4f77-4663-94e7-aa2f329598ed.png?v=1782819290",
            insole:   "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Free_Sole.png?v=1782819290",
            cod:      "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/COD_5512fe73-d442-48cb-a267-8062bd258e96.png?v=1782819289",
            exchange: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/7_Day_exchange.png?v=1782819289",
            ball:     "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Deep_heel_cup.png?v=1782901626",
            heel:     "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Gel_heel_cushioning.png?v=1782901626",
            allday:   "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/All-day_comfort.png?v=1782901626",
            support:  "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Motion_control.png?v=1782901625"
          };
          function iconMark(key){ return ICON_IMG[key] ? '<img src="' + ICON_IMG[key] + '" alt="" loading="lazy">' : null; }
          function helpBlock(type, condPhrase){
            var rows = HELP_ROWS[type] || HELP_ROWS.closed;
            var h = '<div class="ffb-help">';
            h += '<div class="ffb-help-eyebrow">How this helps your ' + (condPhrase || "").toLowerCase() + '</div>';
            h += '<div class="ffb-help-rows">';
            for (var i = 0; i < rows.length; i++){
              var ic = iconMark(rows[i][0]) || FEAT_SVG[rows[i][0]] || ICON[rows[i][0]] || ICON.support;
              h += '<div class="ffb-help-row"><span class="ffb-help-ico">' + ic + '</span><div><div class="ffb-help-t">' + rows[i][1] + '</div><div class="ffb-help-b">' + rows[i][2] + '</div></div></div>';
            }
            h += '</div>';
            h += '<div class="ffb-help-eyebrow ffb-help-eyebrow--faq">Common questions</div>';
            h += '<div class="ffb-faq">';
            for (var f = 0; f < FAQS.length; f++){
              h += '<div class="ffb-faq-item"><button type="button" class="ffb-faq-q" data-ffb-faq><span>' + FAQS[f][0] + '</span><span class="ffb-faq-caret">\u25be</span></button><div class="ffb-faq-a">' + FAQS[f][1] + '</div></div>';
            }
            h += '</div>';
            h += '</div>';
            return h;
          }

          // ════════ SCIENCE BRIDGE (per condition) ════════
          var SCIENCE = {
            plantar: { zone:"heel", intro:"Plantar fasciitis is strain where the arch band meets the heel, and it shows up as the hot zone below. The right support shortens that pull and spreads the load.", rows:[["arch","Arch support cradles the fascia","Holding the arch stops the heel-to-toe band from over-stretching with every step."],["heel","Load moves off the sore heel","A deep heel cup centres the fat pad so weight spreads around the painful point."],["bolt","Peak pressure drops","Shock absorption softens heel-strike before the load reaches the fascia."]] },
            heel: { zone:"heel", intro:"Heel pain is repeated impact bruising the fat pad under your heel bone, seen as the hot zone below. Cushioning and support move that load away from the heel.", rows:[["ball","Gel cushioning under the heel","A shock layer sits right under the heel bone where the impact lands."],["arch","Load shares along the foot","Arch support spreads weight forward instead of dumping it on the heel."],["bolt","Peak pressure drops","Impact is soaked up at heel-strike before it travels up the leg."]] },
            flat: { zone:"arch", intro:"A collapsed arch dumps your weight onto the heel and inner edge, shown as the hot zones below. The right support props the arch back up, so the same load spreads across the whole foot.", rows:[["arch","Arch support holds the arch up","The foot stops rolling inward, so it isn\u2019t dumping weight on the inner edge."],["support","Weight spreads across the footbed","With the arch supported, the load covers the whole foot instead of piling on one spot."],["cushion","Peak pressure drops","Cushioning soaks up what\u2019s left, so the sore spot you feel eases."]] },
            high: { zone:"ball", intro:"A high arch under-loads the middle of the foot, so pressure piles onto the heel and ball, as the hot zones below show. Filling the arch spreads that load out.", rows:[["arch","Arch support fills the gap","A contoured insole fills the hollow under a high arch so the midfoot shares the load."],["cushion","Weight spreads off heel and ball","With the middle carrying its share, less piles onto the two contact points."],["bolt","Peak pressure drops","Extra cushioning absorbs impact, so the heel and ball stop taking the brunt."]] },
            fatigue: { zone:"whole", intro:"All-day aching is your feet taking peak load for hours, shown as the warm zones below. Support shares that load so it never builds up.", rows:[["cushion","Cushioning takes the daily load","Plush support reduces the pressure your soles absorb hour after hour."],["arch","Weight spreads across the foot","Arch support shares the load so muscles tire more slowly."],["allday","Pressure stays low all day","Support holds up from morning to night, so aching doesn\u2019t build."]] },
            meta: { zone:"forefoot", intro:"Metatarsalgia is peak pressure building under the long bones of your forefoot, seen as the hot zone below. A pad and arch support spread it away.", rows:[["cushion","A pad lifts behind the ball","Weight is carried just behind the sore metatarsal heads, not on them."],["arch","Load spreads across the forefoot","Rebuilding the transverse arch splits the splayed bones so one point isn\u2019t overloaded."],["bolt","Peak pressure drops","Less force reaches the forefoot at push-off, so the burning eases."]] },
            bunion: { zone:"forefoot", intro:"Bunions flare when a tight toe-box and pressure across the big-toe joint concentrate load there, as the hot zone below shows. Room and support ease it.", rows:[["roomy","A roomy toe-box frees the joint","The big-toe joint gets space instead of being squeezed sideways."],["cushion","Weight spreads off the joint","A soft footbed cushions the ball so pressure isn\u2019t focused on the bump."],["arch","Peak pressure drops","Arch support improves alignment, easing the strain across the joint."]] },
            general: { zone:"whole", intro:"Without support, weight concentrates in a few spots, shown below. The right footwear spreads the load evenly and cushions every step.", rows:[["cushion","Cushioning takes the load","Support reduces the pressure your soles absorb all day."],["arch","Weight spreads across the foot","Arch support keeps the foot aligned so the load is shared."],["bolt","Peak pressure drops","Shock absorption softens impact, so less travels up the leg."]] }
          };
          var ZONE_CAP = { heel:"the heel", arch:"heel and inner arch", ball:"heel and ball", forefoot:"the forefoot", whole:"the foot" };
          var sci = SCIENCE[r.condition] || SCIENCE.general;
          function footSVG(zone, after){
            var sfx = after ? "b" : "a";
            var BASE = "#E7E4DB", RED = "226,75,74", ORG = "239,159,39", GRN = "150,200,110";
            function rad(id, rgb){
              return "<radialGradient id='" + id + "' cx='50%' cy='50%' r='50%'>"
                + "<stop offset='0%' stop-color='rgba(" + rgb + ",0.95)'/>"
                + "<stop offset='58%' stop-color='rgba(" + rgb + ",0.62)'/>"
                + "<stop offset='100%' stop-color='rgba(" + rgb + ",0)'/></radialGradient>";
            }
            var SOLE = "M35 141 C46 141 52 134 52 124 C52 114 49 107 49 98 C49 88 51 80 55 71 C59 61 59 53 51 48 C45 44 40 45 35 45 C30 45 25 44 19 48 C11 53 11 61 15 71 C19 80 25 87 25 98 C25 110 23 117 22 125 C22 134 24 141 35 141 Z";
            var TOES = "<ellipse cx='20' cy='33' rx='6.6' ry='7.8' fill='" + BASE + "'/><ellipse cx='32' cy='26' rx='4.8' ry='6' fill='" + BASE + "'/><ellipse cx='42' cy='25' rx='4.2' ry='5.4' fill='" + BASE + "'/><ellipse cx='51' cy='27' rx='3.6' ry='4.7' fill='" + BASE + "'/><ellipse cx='58' cy='32' rx='3.1' ry='4' fill='" + BASE + "'/>";
            var TOESC = "<ellipse cx='20' cy='33' rx='6.6' ry='7.8'/><ellipse cx='32' cy='26' rx='4.8' ry='6'/><ellipse cx='42' cy='25' rx='4.2' ry='5.4'/><ellipse cx='51' cy='27' rx='3.6' ry='4.7'/><ellipse cx='58' cy='32' rx='3.1' ry='4'/>";
            function blob(cx, cy, grad, rx, ry){ return "<ellipse cx='" + cx + "' cy='" + cy + "' rx='" + rx + "' ry='" + ry + "' fill='url(#" + grad + ")'/>"; }
            var hx = 35, hy = 119, ax = 30, ay = 93, bx = 37, by = 62;
            var L = "";
            if (!after){
              if (zone === "heel") L += blob(hx, hy, "hi" + sfx, 19, 21);
              else if (zone === "arch") L += blob(ax, ay, "hi" + sfx, 17, 21);
              else if (zone === "ball" || zone === "forefoot") L += blob(bx, by, "hi" + sfx, 21, 16);
              else L += blob(bx, by, "hi" + sfx, 21, 16) + blob(hx, hy, "hi" + sfx, 19, 21);
            } else {
              if (zone === "heel") L += blob(hx, hy, "md" + sfx, 19, 21) + blob(ax, ay, "lo" + sfx, 16, 20);
              else if (zone === "arch") L += blob(ax, ay, "md" + sfx, 17, 21) + blob(bx, by, "lo" + sfx, 19, 14) + blob(hx, hy, "lo" + sfx, 16, 17);
              else if (zone === "ball" || zone === "forefoot") L += blob(bx, by, "md" + sfx, 21, 16) + blob(ax, ay, "lo" + sfx, 16, 20);
              else L += blob(bx, by, "md" + sfx, 21, 16) + blob(hx, hy, "md" + sfx, 19, 21) + blob(ax, ay, "lo" + sfx, 15, 19);
            }
            var s = "<svg viewBox='0 0 72 150' role='img' aria-label='foot pressure map'>";
            s += "<defs>" + rad("hi" + sfx, RED) + rad("md" + sfx, ORG) + rad("lo" + sfx, GRN);
            s += "<clipPath id='clip" + sfx + "'><path d='" + SOLE + "'/>" + TOESC + "</clipPath></defs>";
            s += "<path d='" + SOLE + "' fill='" + BASE + "'/>" + TOES;
            s += "<g clip-path='url(#clip" + sfx + "')>" + L + "</g>";
            s += "</svg>";
            return s;
          }

          var SCI_IMG = {
            plantar: { b:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Planter_Fasciitis_Before.png?v=1783412017", a:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Planter_Fasciitis_After.png?v=1783412017" },
            heel:    { b:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Heel_Pain_Before_eb0816d5-beaf-42fc-aa15-43df55344437.png?v=1783412017", a:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Heel_Pain_After_f9b11ce9-da83-4562-8cb6-6424cffb570e.png?v=1783412017" },
            flat:    { b:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Flat_Feet_Before_a2c61e21-b28a-4ea2-8702-7b96eb98f3b3.png?v=1783412016", a:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Flat_Feet_After_1928368d-3fc4-4bb8-80d1-6dc89a6d066c.png?v=1783412017" },
            high:    { b:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/HIgh_Arch_Before_8a38760a-cb45-4b24-a5f6-7866dc54135d.png?v=1783412017", a:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/HIgh_Arch_After_a4c53180-7c74-40be-a470-8f03220bd046.png?v=1783412017" },
            fatigue: { b:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Foot_Fatigue_Before_91ab174c-3f24-43b2-af08-8a0749dd7121.png?v=1783412017", a:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Foot_Fatigue_After_895d357c-cb7b-4cc4-9966-435b4c672fbb.png?v=1783412016" },
            meta:    { b:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Ball_Of_Foot_Before_3600aa8d-50a1-40b4-89a7-82d335b52212.png?v=1783412017", a:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Ball_Of_Foot_After_ba67d406-6a50-4c1d-9868-badb47beffa4.png?v=1783412017" },
            bunion:  { b:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Bunions_Before.png?v=1783412017", a:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Bunions_After.png?v=1783412017" },
            general: { b:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/General_Before_436f2566-50cc-4844-9e02-948d9b9ead9b.png?v=1783412017", a:"https://cdn.shopify.com/s/files/1/0553/0419/2034/files/General_After_5d747492-0cb6-4be0-8d34-2b0bfab94eef.png?v=1783412017" }
          };
          var sciImg = SCI_IMG[r.condition] || SCI_IMG.general;

          var html2 = '<section class="ffb-sci">';
          html2 += '<div class="ffb-sci-eyebrow">' + ICON.spark + 'The science</div>';
          html2 += '<div class="ffb-sci-title">How The Right Footwear And Insole Fixes ' + cond.label + '</div>';
          html2 += '<p class="ffb-sci-intro">' + sci.intro + '</p>';
          html2 += '<div class="ffb-sci-map">';
          html2 += '<div class="ffb-foot"><div class="ffb-foot-box"><img src="' + sciImg.b + '" alt="Without support" loading="lazy"></div><div class="ffb-foot-cap">Flat shoe</div><div class="ffb-foot-sub">Load on ' + (ZONE_CAP[sci.zone] || "the foot") + '</div></div>';
          html2 += '<div class="ffb-sci-arrow">' + ICON.cycle + '</div>';
          html2 += '<div class="ffb-foot"><div class="ffb-foot-box"><img src="' + sciImg.a + '" alt="With Frido" loading="lazy"></div><div class="ffb-foot-cap is-after">With Frido</div><div class="ffb-foot-sub">Load spread evenly</div></div>';
          html2 += '<div class="ffb-legend ffb-legend--scale" role="img" aria-label="Maximum pressure scale, 0 to 400 kilopascals"><div class="ffb-scale-cap">Maximum pressure (kPa)</div><div class="ffb-scale-bar"></div><div class="ffb-scale-ticks"><span>400</span><span>200</span><span>0</span></div></div>';
          html2 += '</div>';
          html2 += '<div class="ffb-sci-why">Why the shoe changes the pressure</div>';
          html2 += '<div class="ffb-sci-rows">';
          for (var sciI = 0; sciI < sci.rows.length; sciI++){
            var rw = sci.rows[sciI];
            html2 += '<div class="ffb-sci-row"><span class="ffb-sci-row-ico">' + (iconMark(rw[0]) || ICON[rw[0]] || FEAT_SVG[rw[0]] || ICON.support) + '</span><div><div class="ffb-sci-row-t">' + rw[1] + '</div><div class="ffb-sci-row-b">' + rw[2] + '</div></div></div>';
          }
          html2 += '</div>';
          html2 += '<div class="ffb-sci-cred">' + ICON.support + '<span>Designed with podiatry principles, tuned on plantar-pressure mats*</span></div>';
          html2 += '<div class="ffb-sci-foot">*Illustrative pressure model based on in-house testing. Individual results vary.</div>';
          html2 += '</section>';

          // ════════ GUIDED KIT BUILDER ════════
          html2 += '<section class="ffb-wrap" id="ffb-wrap" data-ffb-ins-name="' + (kitInsole.name||"") + '" data-ffb-ins-tag="' + (kitInsole.tag||"") + '" data-ffb-ins-mrp="' + (kitInsole.mrp||0) + '" data-ffb-ins-vid="' + (kitInsole.vid||"") + '" data-ffb-ins-url="' + (kitInsole.url||"") + '" data-ffb-ins-img="' + (kitInsole.img||"") + '">';
          html2 += '<div class="ffb-head"><span class="ffb-title">Build Your ' + cond.label + ' Relief Bundle</span><span class="ffb-sub">Pick your footwear and get a free ' + condLabel + ' insole.</span></div>';
          html2 += '<div class="ffb-stage">';

          // -- entry --
          html2 += '<div class="ffb-screen is-active" data-ffb-screen="entry">';
          html2 += '<div class="ffb-entry">';
          html2 += '<div class="ffb-entry-ico">' + ICON.spark + '</div>';
          html2 += '<div class="ffb-entry-title">Let\u2019s build your relief bundle</div>';
          html2 += '<div class="ffb-entry-hook">Pick your pairs. We\u2019ll add a free insole to keep every step comfortable.</div>';
          html2 += '<div class="ffb-cue">3 quick steps</div>';
          html2 += '<button type="button" class="ffb-btn" id="ffb-start">Start now</button>';
          html2 += '</div>';
          html2 += '<a href="tel:+919096417888" class="ffb-expert" data-ffb-expert>' + ICON.support + 'Still not sure? Talk to a foot expert</a>';
          html2 += '</div>';

          // ===== STEP 1 · Outdoors: shoes (occasion tabs) + free insole =====
          html2 += '<div class="ffb-screen" data-ffb-screen="step1">';
          function msRow(cur){
            var mSteps = ["Shoes", "Sandals", "Slippers"];
            var mh = '<div class="ffb-mstep">';
            for (var mi = 0; mi < 3; mi++){
              if (mi > 0) mh += '<div class="ffb-mstep-line' + ((mi + 1) <= cur ? ' is-done' : '') + '"></div>';
              var mSt = (mi + 1 < cur) ? ' is-done' : ((mi + 1 === cur) ? ' is-active' : '');
              mh += '<div class="ffb-mstep-node' + mSt + '" data-ffb-goto="step' + (mi + 1) + '" role="button" tabindex="0"><span class="ffb-mstep-dot">' + ((mi + 1 < cur) ? '\u2713' : (mi + 1)) + '</span><span class="ffb-mstep-label">' + mSteps[mi] + '</span></div>';
            }
            return mh + '</div>';
          }
          html2 += '<div class="ffb-prog"><span class="ffb-prog-label"><span class="ffb-step-n">Step 1 of 3</span><span class="ffb-prog-t">Pick your shoes</span></span></div>';
          html2 += msRow(1);
          html2 += '<div class="ffb-step-card">';
          if (allClosed.length){
            // bucket closed shoes by occasion, keeping each shoe's global index for a stable role
            var occMap = {};
            for (var ci2 = 0; ci2 < allClosed.length; ci2++){
              var ok = occOf(allClosed[ci2]);
              (occMap[ok] = occMap[ok] || []).push({ p: allClosed[ci2], gidx: ci2 });
            }
            var occKeys = [];
            for (var oi = 0; oi < OCC_ORDER.length; oi++){ if (occMap[OCC_ORDER[oi]] && occMap[OCC_ORDER[oi]].length) occKeys.push(OCC_ORDER[oi]); }
            var defaultOcc = ""; // nothing chosen yet — cards stay hidden until the user picks an occasion
            // tabs
            html2 += '<div class="ffb-filter" id="ffb-filter">';
            html2 += '<div class="ffb-occ-q">What do you need shoes for?</div>';
            html2 += '<div class="ffb-tabs">';
            for (oi = 0; oi < occKeys.length; oi++){
              html2 += '<button type="button" class="ffb-tab' + (occKeys[oi] === defaultOcc ? ' is-active' : '') + '" data-ffb-occ="' + occKeys[oi] + '"><span class="ffb-tab-ico">' + (OCC_ICON[occKeys[oi]] || '') + '</span><span class="ffb-tab-label">' + OCC_LABELS[occKeys[oi]] + '</span><span class="ffb-tab-hint">' + (OCC_HINT[occKeys[oi]] || '') + '</span></button>';
            }
            html2 += '</div></div>';
            // Each occasion renders its shoes as a horizontal carousel; every shoe card is
            // paired with a display-only free-insole card. The real free insole auto-attaches
            // to the chosen shoe and auto-sizes to it (see syncInsoleSize).
            var insolePairCard = function(ins){
              var ph = '<div class="ffb-cx-insole">';
              ph += '<span class="ffb-cx-insole-img"><img src="' + (ins.img||"") + '" alt="' + (ins.name||"") + '" loading="lazy"></span>';
              ph += '<span class="ffb-cx-insole-txt"><span class="ffb-cx-insole-t">' + (ins.name||"").replace("Frido ", "") + '</span><span class="ffb-cx-insole-sub">Comes free \u00b7 size auto-matched to your shoe</span></span>';
              ph += '<span class="ffb-cx-free">Free</span>';
              ph += '</div>';
              return ph;
            };
            html2 += '<div class="ffb-occ" data-ffb-occ-panel="all" style="display:none;">';
            html2 += '<div class="ffb-shoe-carousel" id="ffb-shoe-carousel">';
            for (oi = 0; oi < occKeys.length; oi++){
              var grp = occMap[occKeys[oi]];
              for (var gj = 0; gj < grp.length; gj++){
                html2 += '<div class="ffb-carousel-item" data-occ="' + occKeys[oi] + '">';
                html2 += featCard(grp[gj].p, "shoe" + grp[gj].gidx, "closed", false, OCC_LABELS[occKeys[oi]] || "");
                html2 += insolePairCard(kitInsole);
                html2 += '</div>';
              }
            }
            html2 += '</div>';
            html2 += '</div>';
          }
          html2 += '<div class="ffb-nav ffb-nav--row"><button type="button" class="ffb-navbtn ffb-navbtn--skip" data-ffb-skip="step1">Skip</button><button type="button" class="ffb-navbtn ffb-navbtn--next" id="ffb-s1-cta"><span class="ffb-s1a">Continue</span><span class="ffb-s1b" style="display:none;">Continue to sandals</span>' + ICON_FWD + '</button></div>';
          html2 += '</div>';
          html2 += '</div>';

          // ===== STEP 2 · Outdoors: sandals (no insole) =====
          html2 += '<div class="ffb-screen" data-ffb-screen="step2">';
          html2 += '<div class="ffb-prog"><span class="ffb-prog-label"><span class="ffb-step-n">Step 2 of 3</span><span class="ffb-prog-t">Need a supportive sandal too?</span></span></div>';
          html2 += msRow(2);
          html2 += '<div class="ffb-step-card">';
          if (sandalList.length){
            html2 += catSection(sandalList, "sandal", "sandal", false, "More sandals");
          } else {
            html2 += '<div class="ffb-helps">No sandal styles for this profile \u2014 you can skip ahead.</div>';
          }
          html2 += '<div class="ffb-nav ffb-nav--row"><button type="button" class="ffb-navbtn ffb-navbtn--skip" data-ffb-skip="step2">Skip</button><button type="button" class="ffb-navbtn ffb-navbtn--next" data-ffb-next="step3">Continue to slippers' + ICON_FWD + '</button></div>';
          html2 += '</div>';
          html2 += '</div>';

          // ===== STEP 3 · Indoors: slippers =====
          html2 += '<div class="ffb-screen" data-ffb-screen="step3">';
          html2 += '<div class="ffb-prog"><span class="ffb-prog-label"><span class="ffb-step-n">Step 3 of 3</span><span class="ffb-prog-t">Complete your bundle with supportive house slippers?</span></span></div>';
          html2 += msRow(3);
          html2 += '<div class="ffb-step-card">';
          if (slipperList.length){
            html2 += '<div class="ffb-proof-pill">' + pct + '% with ' + condLabel + ' chose this support*</div>';
            html2 += catSection(slipperList, "slipper", "slipper", false, "More slippers");
          } else {
            html2 += '<div class="ffb-helps">No indoor styles for this profile \u2014 you can still build your bundle below.</div>';
          }
          html2 += '<div class="ffb-skip--btn"><button type="button" class="ffb-navbtn ffb-navbtn--skip" data-ffb-skip="step3">Skip \u2014 I don\u2019t need indoor support</button></div>';
          html2 += '</div>';
          html2 += '</div>';

          html2 += '</div>'; // /ffb-stage

          // -- running kit + sticky build CTA (shown once builder starts) --
          html2 += '<div class="ffb-foot-bar" id="ffb-bar" style="display:none;">';
          html2 += '<div class="ffb-trust ffb-trust--bar">';
          html2 += '<span class="ffb-trust-i">' + (iconMark("exchange") || ICON.cycle) + '7-day exchange</span>';
          html2 += '<span class="ffb-trust-i"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 17.27l6.18 3.73-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>Rated 4.6/5</span>';
          html2 += '<span class="ffb-trust-i">' + (iconMark("cod") || ICON_CASH) + 'Cash on delivery</span>';
          html2 += '</div>';
          html2 += '<div class="ffb-kit-head"><span class="ffb-kit-head-t" id="ffb-count">Your bundle</span><span class="ffb-sum-save" id="ffb-save"></span></div>';
          html2 += '<div class="ffb-warn" id="ffb-warn" role="status" style="display:none;"></div>';
          html2 += '<div class="ffb-kit-list" id="ffb-list"></div>';
          // Once the step picker has collapsed away this is the only route back to it,
          // so the shopper can re-add anything they deleted from the bundle.
          html2 += '<button type="button" class="ffb-edit" id="ffb-edit" style="display:none;"><span class="ffb-edit-plus">+</span>Add more items</button>';
          html2 += '<div class="ffb-kit-total" id="ffb-total" style="display:none;"></div>';
          html2 += '<button type="button" class="ffb-btn" id="ffb-build">BUY NOW</button>';
          html2 += '<a href="tel:+919096417888" class="ffb-expert" data-ffb-expert>' + ICON.support + 'Still not sure? Talk to a foot expert</a>';
          html2 += '</div>';
          html2 += '</section>'; // /ffb-wrap

          // sticky checkout bar — appears while browsing the builder
          html2 += '<div class="ffb-sticky" id="ffb-sticky" style="display:none;"><div class="ffb-sticky-inner">';
          html2 += '<div class="ffb-sticky-info"><div class="ffb-sticky-count" id="ffb-sticky-count"></div><div class="ffb-sticky-price"><span class="ffb-sticky-total" id="ffb-sticky-total"></span><span class="ffb-sticky-mrp" id="ffb-sticky-mrp"></span><span class="ffb-sticky-save" id="ffb-sticky-save"></span></div></div>';
          html2 += '<button type="button" class="ffb-sticky-btn" id="ffb-sticky-btn">ADD TO CART</button>';
          html2 += '</div></div>';

          // sticky "jump to bundle" CTA — visible while reading the report/science, scrolls down to the builder
          html2 += '<div class="ffb-jump" id="ffb-jump"><button type="button" class="ffb-jump-btn" id="ffb-jump-btn">Build Your ' + cond.label + ' Relief Bundle<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></button></div>';

          // reviews carousel injected below the builder
          html2 += '__FF_REVIEWS__';

          html += html2;
        })();

        // ── Customer reviews carousel (rendered, then injected into the kit panel) ──
        (function(){
          var REVIEWS_BY_COND = {
            plantar: [
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_38.png?v=1781774197", name: "Priya Deshmukh", quote: "My plantar fasciitis flares the second I step barefoot at home. These arch-support slippers keep my heel cushioned all day \u2014 the morning pain has really eased.", tags: ["Arch Support Slippers", "Plantar Fasciitis Insole"] },
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_47.png?v=1781778651", name: "Suresh Pillai", quote: "First few steps out of bed used to be agony. Wearing these around the house keeps the fascia supported, so mornings hurt far less now.", tags: ["Arch Support Slippers"] },
              { textOnly: true, name: "Ritika Bose", quote: "I work from home and the hard floor was killing my heels. The deep arch cup on these slippers took the strain off my plantar fasciitis completely.", tags: ["Arch Support Slippers", "Heel Cup"] },
              { textOnly: true, name: "Gaurav Sinha", quote: "Plantar fasciitis made standing in the kitchen torture. A week in these slippers and that sharp first-step pain has genuinely calmed down.", tags: ["Arch Support Slippers"] },
              { textOnly: true, name: "Aarti Ranganathan", quote: "I walk 4km every morning and my heel would ache for hours afterwards. Three weeks in these walking shoes and I finish my route without that burning under the heel.", tags: ["Active Walking Shoes"] },
              { textOnly: true, name: "Vishal Chauhan", quote: "Slid these into my office shoes and the deep heel cup does exactly what it claims. That first-step pain in the morning has dropped from an 8 to about a 2.", tags: ["Plantar Fasciitis Insole"] },
              { textOnly: true, name: "Nandini Krishnan", quote: "I teach and I'm on my feet six hours a day. The gel heel pad takes the sting out of standing on hard classroom floors. I'm not limping to my car anymore.", tags: ["Orthopedic Heel Pad Pro"] },
              { textOnly: true, name: "Zubin Mistry", quote: "Bought the walking shoes and the plantar insole together. The combination is what did it. Firm arch plus a cushioned heel means the fascia isn't pulling with every step.", tags: ["Active Walking Shoes", "Plantar Fasciitis Insole"] }
            ],
            heel: [
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_37.png?v=1781774197", name: "Sandeep Reddy", quote: "Heel pain on hard floors made me dread standing in the kitchen. The cushioned heel on these slippers absorbs every step now \u2014 such a relief.", tags: ["Arch Support Slippers", "Heel Protector"] },
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/2_534f806f-05de-44fa-84af-a66448b1e56c.jpg?v=1781776946", name: "Manish Gupta", quote: "My heel would throb after a few hours barefoot. These slippers have a soft heel pad that cushions each step \u2014 the ache is mostly gone.", tags: ["Arch Support Slippers"] },
              { textOnly: true, name: "Farah Sheikh", quote: "Sharp heel pain every evening was my normal. Switched to these at home and the padding under the heel made a real difference within a week.", tags: ["Arch Support Slippers", "Heel Pad"] },
              { textOnly: true, name: "Deepak Rawat", quote: "The heel pain that flared on tiles is so much better now. These cushion the heel exactly where it used to hurt the most.", tags: ["Arch Support Slippers"] },
              { textOnly: true, name: "Prakash Bhandari", quote: "My heel throbbed after every shift on the shop floor. The gel pocket under the heel absorbs the impact, and three weeks in the constant ache has faded.", tags: ["Dual Gel Insoles"] },
              { textOnly: true, name: "Swati Naik", quote: "Wore these sandals for a full day of shopping expecting the usual heel pain by lunch. It never came. The soft landing under the heel makes a real difference.", tags: ["Cloud Comfort Sandal"] },
              { textOnly: true, name: "Kabir Dutta", quote: "The heel protector is the one I actually notice. It cups the heel and stays put in my shoe, and the sharp pain on tiles is basically gone.", tags: ["Orthotics Heel Protector"] },
              { textOnly: true, name: "Shalini Prabhu", quote: "Hard marble floors at home were the worst part of my day. Adding the gel insole to my house shoes cushioned the heel enough that I can potter around the kitchen again.", tags: ["Dual Gel Insoles", "Heel Protector"] }
            ],
            flat: [
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_36.png?v=1781774197", name: "Neha Agarwal", quote: "With flat feet, going barefoot at home left my arches and knees aching by evening. The arch support in these slippers finally gives my feet something to rest on.", tags: ["Arch Support Slippers", "Semi-Rigid Insoles"] },
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/3_82a10c0b-d61a-49fe-b6ff-140f623664a0.jpg?v=1781776946", name: "Devansh Rao", quote: "Flat feet meant zero arch support whenever I took my shoes off. These slippers fill that gap at home \u2014 my arches and lower back feel far better.", tags: ["Arch Support Slippers"] },
              { textOnly: true, name: "Pooja Hegde", quote: "I overpronate badly with flat feet. The firm arch in these keeps my feet aligned even indoors, so the end-of-day ache is gone.", tags: ["Arch Support Slippers", "Arch Insole"] },
              { textOnly: true, name: "Sahil Kapadia", quote: "My flat feet used to roll inward without support. These slippers hold my arch even at home, and my knees stopped aching by night.", tags: ["Arch Support Slippers"] },
              { textOnly: true, name: "Nitin Ahuja", quote: "Flat feet meant my ankles rolled inward in every pair I owned. These lace-ups have a stable base that keeps me straight, and my knees have stopped aching by evening.", tags: ["Cloud Comfort Shoes - Lace Ups"] },
              { textOnly: true, name: "Revathi Subramanian", quote: "Finally, sandals with a real arch built in. I can wear them for a full day out and my arches don't feel like they've collapsed by the end of it.", tags: ["Arch Comfort Sandals"] },
              { textOnly: true, name: "Pallavi Ghosh", quote: "The rigid arch felt strange for two days, then it clicked. My feet aren't rolling inward anymore and the strain up my shins has eased a lot.", tags: ["Arch Support Insoles (Rigid)"] },
              { textOnly: true, name: "Ajay Thakur", quote: "Got the whole combo instead of picking one piece. Having proper support in my work shoes and at home is what actually fixed the lower-back ache I'd blamed on my chair for years.", tags: ["Ultimate Flat Feet Combo"] }
            ],
            high: [
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_44.png?v=1781778322", name: "Aditya Kapoor", quote: "High arches mean my feet tire fast without cushioning. These slippers add padding at the heel and ball \u2014 no more sore feet after a day on bare floors.", tags: ["Arch Support Slippers", "Cushion Insole"] },
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/slipper_4.jpg?v=1781774262", name: "Tara Menon", quote: "My high arches need shock absorption most shoes don't give. These cushioned slippers soak it up at home \u2014 my feet finally feel rested.", tags: ["Arch Support Slippers"] },
              { textOnly: true, name: "Yash Bhatia", quote: "Pressure used to build up on my heel and ball because of my high arches. The extra padding in these slippers spreads it out beautifully.", tags: ["Arch Support Slippers", "Cushion Insole"] },
              { textOnly: true, name: "Ishaan Roy", quote: "High arches make hard floors brutal. These slippers cushion both the heel and forefoot, so I can pad around the house pain-free now.", tags: ["Arch Support Slippers"] },
              { textOnly: true, name: "Siddharth Bhalla", quote: "High arches mean all my weight lands on the heel and the ball. These slip-ons cushion both ends, so I can stand through a whole day of client meetings now.", tags: ["Cloud Comfort Shoes - Slip Ons"] },
              { textOnly: true, name: "Ira Chandran", quote: "This insole actually fills the gap under my arch, which no regular insole ever did. The pressure spots under my forefoot have settled right down.", tags: ["Max Comfort Arch Cushion Insoles"] },
              { textOnly: true, name: "Varun Sethi", quote: "My arches never touched the shoe, so everything hammered the heel. The gel insole spreads the load and my feet aren't sore after a long day on site.", tags: ["Gel Max Comfort Insole"] },
              { textOnly: true, name: "Preeti Wadhwa", quote: "Wore the slip-ons with the arch cushion insole on a Goa trip and walked far more than usual. My feet didn't complain once. The shock absorption is the difference.", tags: ["Cloud Comfort Shoes - Slip Ons", "Arch Cushion Insole"] }
            ],
            fatigue: [
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_42.png?v=1781778322", name: "Rahul Iyer", quote: "On my feet all day at work, then chores at home \u2014 my feet were always aching. Slipping into these Cloud Comfort slippers is when the fatigue finally stops.", tags: ["Cloud Comfort Slippers", "Memory Foam Insole"] },
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_40.png?v=1781774237", name: "Sonia Kohli", quote: "By evening my feet felt like lead. These cushioned slippers gave me that soft landing at home \u2014 the tired, achy feeling has eased a lot.", tags: ["Cloud Comfort Slippers"] },
              { textOnly: true, name: "Imran Qureshi", quote: "Standing on hard floors all evening wrecked my feet. The memory-foam feel of these slippers is the comfort my tired feet were missing.", tags: ["Cloud Comfort Slippers", "Memory Foam Insole"] },
              { textOnly: true, name: "Meghna Das", quote: "After a long day my feet would just give up. Slipping into these is instant relief \u2014 soft, cushioned, and my soles stop aching.", tags: ["Cloud Comfort Slippers"] },
              { textOnly: true, name: "Naveen Shetty", quote: "Retail job, ten-hour shifts, feet like bricks by closing. Put these memory foam insoles in my work shoes and I've stopped counting down the minutes.", tags: ["Max Comfort Memory Foam Insole"] },
              { textOnly: true, name: "Ritu Bansal", quote: "The moment I get home these go on. My feet stop aching almost immediately. It's the cushioning I didn't realise I was missing.", tags: ["Cloud Comfort Slippers"] },
              { textOnly: true, name: "Sameer Ali", quote: "I'm in and out of the car all day for work. The gel pro insoles keep my soles from getting that hot, tired burn by mid-afternoon.", tags: ["Dual Gel Pro Insoles"] },
              { textOnly: true, name: "Jyoti Rathod", quote: "Insoles in my work shoes, slippers at home, so my feet get support for the whole day now. That end-of-day heaviness has genuinely gone.", tags: ["Memory Foam Insole", "Cloud Comfort Slippers"] }
            ],
            meta: [
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_43.png?v=1781778321", name: "Kavya Nair", quote: "The ball of my foot would burn on hard tiles. These soft Cloud Comfort slippers spread the pressure so well that walking around the house feels normal again.", tags: ["Cloud Comfort Slippers", "Metatarsal Pad"] },
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/slipper.jpg?v=1781774263", name: "Arnav Sengupta", quote: "Metatarsalgia made the front of my foot ache constantly. The cushioning in these slippers takes the load off the ball of my foot \u2014 huge relief.", tags: ["Cloud Comfort Slippers"] },
              { textOnly: true, name: "Lakshmi Iyer", quote: "Sharp pain under my toes whenever I stood too long. These plush slippers cushion exactly where it hurt, so I can be on my feet at home again.", tags: ["Cloud Comfort Slippers", "Forefoot Cushion"] },
              { textOnly: true, name: "Tarun Joshi", quote: "Ball-of-foot pain made hard floors unbearable. The soft padding in these spreads the pressure so the burning feeling is finally gone.", tags: ["Cloud Comfort Slippers"] },
              { textOnly: true, name: "Ashwin Raghavan", quote: "The ball of my foot burned in every sandal I tried. These have enough padding under the forefoot that I can wear them all evening without that hot spot.", tags: ["Comfort Dual Strap Sandals"] },
              { textOnly: true, name: "Kirti Shah", quote: "Metatarsalgia made standing at the counter miserable. The gel insole takes the pressure off the ball of my foot, and the burning is mostly gone.", tags: ["Silicone Gel Insole"] },
              { textOnly: true, name: "Mohit Vyas", quote: "The pain right under my toes was worst in formal shoes. These memory foam insoles spread the load and I got through a full wedding day on my feet.", tags: ["Max Comfort Memory Foam Insole"] },
              { textOnly: true, name: "Shreya Kamath", quote: "Dual strap sandals with a gel insole inside is my combination. The forefoot pressure that used to build up after an hour simply doesn't now.", tags: ["Comfort Dual Strap Sandals", "Silicone Gel Insole"] }
            ],
            bunion: [
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_48.png?v=1781778650", name: "Anjali Verma", quote: "Most slippers rubbed my bunion painfully. These are roomy and soft \u2014 no pressure on the joint even after hours on my feet at home.", tags: ["Cloud Comfort Slippers", "Bunion Corrector"] },
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/slipper_2.jpg?v=1781774263", name: "Harpreet Kaur", quote: "Anything narrow would irritate my bunion instantly. The wide, soft fit of these slippers means zero rubbing \u2014 my toes finally have room.", tags: ["Cloud Comfort Slippers"] },
              { textOnly: true, name: "Nikhil Saxena", quote: "My bunion ached the moment I put on tight house slippers. These are gentle and spacious, so there's no pressure on the joint anymore.", tags: ["Cloud Comfort Slippers", "Wide Fit"] },
              { textOnly: true, name: "Reshma Patel", quote: "Every other slipper pressed right on my bunion. These have such a roomy toe box that I can wear them all day with no soreness.", tags: ["Cloud Comfort Slippers"] },
              { textOnly: true, name: "Bhavna Trivedi", quote: "The corrector doesn't work miracles overnight, but wearing it at home has taken the daily soreness out of the joint. My toe sits straighter through the evening.", tags: ["Orthotics Bunion Corrector"] },
              { textOnly: true, name: "Rajat Oberoi", quote: "Every strap I owned pressed right on the bunion. The toe ring design holds the sandal without touching the joint at all. No rubbing for the first time in years.", tags: ["Orthotics Toe Ring Sandals"] },
              { textOnly: true, name: "Fatima Ansari", quote: "Wide shoes helped, but the memory foam insole is what stopped the ache underneath. Together they've made walking normal again.", tags: ["Max Comfort Memory Foam Insole"] },
              { textOnly: true, name: "Girish Pai", quote: "Sandals during the day, corrector in the evening. The combination has taken the throb out of my bunion after work.", tags: ["Orthotics Toe Ring Sandals", "Bunion Corrector"] }
            ],
            general: [
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/New_Project_-_Arcads_image_asset_49.png?v=1781778650", name: "Vivek Malhotra", quote: "Comfiest thing I wear at home now. My feet feel supported and cushioned from my morning coffee right through to evening chores.", tags: ["Cloud Comfort Slippers", "Comfort Insole"] },
              { img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/579eff51-064a-4bc7-9c38-9d61f4f9065a.png?v=1781781946", name: "Ananya Pillai", quote: "I just wanted something soft and supportive for everyday home wear. These deliver \u2014 my feet stay comfortable no matter how long I'm up.", tags: ["Cloud Comfort Slippers"] },
              { textOnly: true, name: "Rohit Khanna", quote: "Honestly didn't expect much from slippers, but these are a daily-wear upgrade. Cushioned, supportive, and my feet never feel tired now.", tags: ["Cloud Comfort Slippers", "Comfort Insole"] },
              { textOnly: true, name: "Sneha Pawar", quote: "Wear these from morning to night around the house. They're soft without being flat, and my feet feel genuinely looked after.", tags: ["Cloud Comfort Slippers"] },
              { textOnly: true, name: "Tanvi Bhatt", quote: "No specific problem, I just wanted shoes that don't wreck my feet. These are the first pair I can wear morning to night without thinking about them.", tags: ["Cloud Comfort Shoes - Slip Ons"] },
              { textOnly: true, name: "Alok Mishra", quote: "Dropped these into my old sneakers and it was like getting a new pair. Softer landing, and my feet aren't tired after the commute.", tags: ["Max Comfort Memory Foam Insole"] },
              { textOnly: true, name: "Rhea Dsouza", quote: "I stand about five hours a day. The gel insoles took the edge off completely. No more dull ache in my soles by evening.", tags: ["Dual Gel Pro Insoles"] },
              { textOnly: true, name: "Karthik Balan", quote: "Bought the slip-ons and added the memory foam insole. Most comfortable my feet have been at work in years, and worth every rupee.", tags: ["Cloud Comfort Shoes - Slip Ons", "Memory Foam Insole"] }
            ]
          };
          var revSet = REVIEWS_BY_COND[r.condition] || REVIEWS_BY_COND.general;
          var revTitle = 'How others with ' + (cond.label || 'foot pain').toLowerCase() + ' found relief';
          // slipper the reviewer is holding — arch vs normal, matching the condition's slipper rule
          var REV_ARCH_CONDS = { plantar: 1, flat: 1, high: 1, fatigue: 1, meta: 1 };
          var revSlipName = REV_ARCH_CONDS[r.condition] ? "Frido Arch Cloud Comfort Slippers" : "Frido Cloud Comfort Slippers";
          var revSlipUrl = "https://myfrido.com/products/frido-cloud-comfort-slippers?variant=51223190274329";
          var revH = '<section class="ff-slipreview"><h3 class="ff-slipreview-title">' + revTitle + '</h3><div class="ff-slipreview-row">';
          for (var rs = 0; rs < revSet.length; rs++){
            var rev = revSet[rs];
            revH += '<div class="ff-slipreview-card' + (rev.textOnly ? ' ff-slipreview-card--text' : '') + '">';
            if (!rev.textOnly){
              if (rev.img){
                revH += '<div class="ff-slipreview-img"><img src="' + rev.img + '" alt="' + rev.name + '" loading="lazy"></div>';
              } else {
                revH += '<div class="ff-slipreview-img ff-slipreview-img--ph"></div>';
              }
            }
            revH += '<div class="ff-slipreview-body">';
            revH += '<div class="ff-slipreview-meta">Condition: ' + cond.label + '</div>';
            revH += '<div class="ff-slipreview-stars">\u2605\u2605\u2605\u2605\u2605</div>';
            revH += '<p class="ff-slipreview-quote">' + rev.quote + '</p>';
            revH += '<div class="ff-slipreview-name">' + rev.name + ' <span class="ff-slipreview-tick">\u2713</span></div>';
            if (!rev.textOnly && rev.img){
              revH += '<a class="ff-slipreview-prod" href="' + revSlipUrl + '" target="_blank" rel="noopener">' + revSlipName + '</a>';
            }
            revH += '</div></div>';
          }
          revH += '</div></section>';
          html = html.replace('__FF_REVIEWS__', revH);
        })();

        // milestones used by renderBundle()
        // The \u20b9500 / \u20b91,000 "coupon" rewards were front-end-only promises with nothing
        // backing them at checkout, so they're removed for launch. Only Free Shipping
        // (a real shipping benefit, not a cart-price discount) remains. If the store has
        // NO free-shipping threshold, drop this entry too and hide the bar.
        var milestones = [
          { threshold: 500, label: "Free Shipping", short: "Free Shipping" }
        ];

        html += '<div id="ff-bundle-carousels"></div>';


        // cart drawer removed — hidden holder keeps the bundle mounts alive so the
        // in-page builder (setupBundle / Buy Now) still wires up; nothing is shown.
        html += '<div id="ff-cart-holder" style="display:none;" aria-hidden="true">';
        html += '<div id="ff-bundle-body"></div>';
        html += '<div id="ff-drawer-carousels"></div>';
        html += '<div id="ff-bundle-bar-mount"></div>';
        html += '</div>';

        // ── variant bottom-sheet (single instance, mounted at result-page level) ──
        html += renderStats();
        html += renderStories();
        html += renderFAQ(r.condition);
        html += '<button type="button" class="ff-retake" id="ff-retake">' + (ICON.refresh || '') + 'Retake quiz</button>';
        html += '<div class="ff-sheet-overlay" id="ff-sheet-overlay"></div>';
        html += '<div class="ff-sheet" id="ff-sheet" role="dialog" aria-modal="true">';
        html += '<div class="ff-sheet-handle"></div>';
        html += '<div class="ff-sheet-head"><div class="ff-sheet-title" id="ff-sheet-title"></div><button type="button" class="ff-sheet-close" id="ff-sheet-close" aria-label="Close">' + ICON.close + '</button></div>';
        html += '<div class="ff-sheet-body" id="ff-sheet-body"></div>';
        html += '<button type="button" class="ff-sheet-confirm" id="ff-sheet-confirm" disabled>Confirm</button>';
        html += '</div>';
    
    
        html += '</div>'; // close .ff-fade
    
        elQuiz.style.display = "none"; elResult.style.display = "block"; elResult.innerHTML = html; window.scrollTo(0,0);
        // Relocate the variant sheet + its overlay to <body> so no transformed
        // ancestor (our .ff-fade fade-in, or an injected scroll-motion transform)
        // turns its position:fixed into ancestor-relative and mis-places it.
        (function relocateSheet(){
          var all = document.querySelectorAll("#ff-sheet, #ff-sheet-overlay");
          for (var i = 0; i < all.length; i++){ if (!elResult.contains(all[i])) all[i].parentNode.removeChild(all[i]); }
          var ov = elResult.querySelector("#ff-sheet-overlay"); if (ov) document.body.appendChild(ov);
          var sh = elResult.querySelector("#ff-sheet"); if (sh) document.body.appendChild(sh);
        })();
        var appWrap = document.getElementById("ff-app");
        if (appWrap) appWrap.classList.add("ff-wrap--result");
        // Cart FAB visibility is managed by FfCart (shows when the cart has items).
        if (window.FfCart) window.FfCart.refresh();
        (ffRoot || document.documentElement).classList.remove("ff-in-quiz");
    
        // ── live bundle render + delete + add-to-cart ──
        var syncKitBarSticky = null;
        (function setupBundle(){
          var bodyEl = document.getElementById("ff-bundle-body");
          var barMountEl = document.getElementById("ff-bundle-bar-mount");
          var carouselsMountEl = document.getElementById("ff-bundle-carousels");
          var drawerCarouselsMountEl = document.getElementById("ff-drawer-carousels");
          if (!bodyEl || !barMountEl) return;
          // Cart starts EMPTY. `items` holds the recommended products (hero shoe + 2 insoles);
          // nothing is in the cart until the user adds (slippers, carousels, recommendation cards).
          var liveItems = [];
          var recommendedItems = items.slice();
          var removedItems = []; // populated on delete; cleared on re-add
          var fwCarouselFilter = activeFilter; // smart-match category for the "More Footwear" carousel
          var SAVED_PCT = 0.15; // legacy flat value; bundle discount is now tiered by item count
          // Bundle reward tiers DISABLED for launch: the 5/10/15% was front-end-only
          // and nothing applies it at GoKwik checkout, so it would make the displayed
          // price lower than what's charged. Forced to 0 so displayed = charged.
          // (Real MRP→sale savings still show via compare-at prices below.)
          function bundlePctForCount(n){ return 0; }
          var BUNDLE_TIERS = [5, 10, 15]; // % off shown on the milestone bar (1, 2, 3 products)
          var ffbBundlePct = 0; // current fractional discount, kept in sync by renderSummary()
          var refreshKit = function(){}; // reassigned by wireKit(); paint() calls it to sync kit pills + summary
          var kitFootwearItems = function(){ return []; }; // reassigned by wireKit(); lists the shoe/sandal/slipper items
          // Pull the UK size number out of any size label ("6 UK (EU40)", "UK 6", "3 UK (36 EU)", "6" -> 6).
          function ffbUkNum(s){ var m = String(s == null ? "" : s).match(/\d+/); return m ? parseInt(m[0], 10) : null; }

          // UK size out of a size label OR a full cart variant_title ("Black / 5 UK (EU38)").
          // Anchored on the literal "UK" so the EU number can never be read as the size.
          // The old approach stripped every non-digit and concatenated what was left, so
          // "5 UK (EU38)" became 538 — outside every insole range (S 6-8, L 9-12), which
          // sent the nearest-range fallback to L and shipped a 9-12 UK insole to a UK5 foot.
          // Only products labelled without an EU number (e.g. "UK5") happened to work.
          function ffbUkFromLabel(s){
            var str = String(s == null ? "" : s);
            var m = str.match(/(\d+)\s*UK/i) || str.match(/UK\s*(\d+)/i);
            if (m) return parseInt(m[1], 10);
            m = str.match(/\d+/);
            return m ? parseInt(m[0], 10) : NaN;
          }

          // liveItems IS the Buy Now payload (checkoutNow reads it), while the visible
          // bundle list is driven by the kit builder's own `selected` flags. Deselecting a
          // card used to leave a ghost in liveItems, so the next Buy Now silently re-added
          // an item the shopper had already removed. Every deselect drops it here.
          function dropFromLive(item){
            if (!item) return;
            for (var i = liveItems.length - 1; i >= 0; i--){
              if (liveItems[i] === item || (liveItems[i] && liveItems[i].key === item.key)) liveItems.splice(i, 1);
            }
          }
    
          // ── per-item variant state ──
          // vState[key] = { color: idx|null, size: str|null }
          var vState = {};
          function ensureVState(key){ if (!vState[key]) vState[key] = { color: null, size: null }; }
          for (var vi = 0; vi < liveItems.length; vi++) ensureVState(liveItems[vi].key);
    
          function vNeeds(it){
            if (window.FfShopify) window.FfShopify.annotateProduct(it.p);
            var hasShopifyColors = !!(it.p && it.p.__shopifyColors && it.p.__shopifyColors.length);
            var needColor = (it.section === "footwear") || hasShopifyColors;
            var needSize = sizesFor(it.p).length > 0;
            return { color: needColor, size: needSize };
          }
          function vReady(it){
            var n = vNeeds(it); var s = vState[it.key]; if (!s) return false;
            if (n.size && !s.size) return false;
            if (n.color && s.color == null) return false;
            return true;
          }
          function vLabel(it){
            var n = vNeeds(it); var s = vState[it.key] || {}; var bits = [];
            if (n.size && s.size) bits.push("Size " + s.size);
            if (n.color && s.color != null){ var c = colorsFor(it.p)[s.color]; if (c) bits.push(c.name); }
            return bits.join(" \u00b7 ");
          }
          function vVariantId(it){
            if (window.FfShopify) window.FfShopify.annotateProduct(it.p);
            if (!vState[it.key]) return it.p.vid || "";
            return resolveVariant(it.p, vState[it.key].color, vState[it.key].size);
          }
          function vPlaceholder(it){
            var n = vNeeds(it);
            if (n.size && n.color) return "Select size & color";
            if (n.size) return "Select size";
            if (n.color) return "Select color";
            return "";
          }
    
          // ── sheet wiring (sheet DOM mounted once at result-page level) ──
          var sheetEl = document.getElementById("ff-sheet");
          var sheetOverlay = document.getElementById("ff-sheet-overlay");
          var sheetBody = document.getElementById("ff-sheet-body");
          var sheetTitle = document.getElementById("ff-sheet-title");
          var sheetConfirm = document.getElementById("ff-sheet-confirm");
          var sheetItem = null;
          var draft = { color: null, size: null };
    
          function openSheet(it){
            sheetItem = it;
            ensureVState(it.key);
            draft = { color: vState[it.key].color, size: vState[it.key].size };
            var n = vNeeds(it);
            sheetTitle.textContent = it.p.name;
            var h = "";
            // Gallery — supports multiple images with arrows.
            // Sourced ENTIRELY from Shopify — no hardcoded per-product images.
            // When a colour is selected we show that colour's own variant image (Shopify
            // maps colour → variant image, so it is always the right photo). With no
            // colour option, fall back to the product's full Shopify image list.
            // Max product photos in the sheet (the size chart is inserted separately).
            // Shopify products here carry up to ~250 images — lifestyle, detail and
            // every colour — so the full list must never go straight into the gallery.
            var GALLERY_MAX = 8;
            // NOTE: the old GAL_ALIASES / galColorTokens filename matcher lived here and is
            // deliberately gone. It inferred a photo's colour from its filename, which fails
            // whenever Shopify names files CS_01.jpg — the gallery then fell back to the whole
            // product list and showed other colours' shoes. Colour→image now comes from
            // Shopify itself (variant links + image alt), resolved in the bootstrap snippet.
            // Two URLs can be the same picture: Shopify appends a _<uuid> to the filename
            // when a file is re-uploaded, which this catalogue does once per colour. Keying
            // on the filename with that uuid stripped collapses those byte-identical copies.
            function galKey(u){
              var f = String(u || "").split("?")[0].split("/").pop().toLowerCase();
              return f.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.[a-z0-9]+$)/, "");
            }
            function galDedupe(arr){
              var seen = {}, out = [];
              for (var i = 0; i < arr.length && out.length < GALLERY_MAX; i++){
                var u = arr[i]; if (!u) continue;
                var k = galKey(u); if (seen[k]) continue;
                seen[k] = 1; out.push(u);
              }
              return out;
            }
            function galleryFromShopify(colorObj){
              var all = (it.p.__shopifyImages && it.p.__shopifyImages.length) ? it.p.__shopifyImages : [];
              if (colorObj){
                // Shopify's own mapping, resolved server-side: the variant's image plus the
                // photos labelled for this colour. Nothing else — the leftover images are
                // NOT colour-neutral, so padding with them is what put a lavender shoe under
                // "BLACK" and filled the carousel with repeats of the wrong shoe.
                var g = (it.p.__shopifyGallery && it.p.__shopifyGallery[colorObj.name]) || [];
                // Top up from the set captured for this colour off Frido's own PDP. Shopify
                // still LEADS — its images are concatenated first and galDedupe keeps the
                // first occurrence — so this only ever fills the empty slots behind them,
                // and every entry is retired the moment the images are labelled in admin.
                // Padding (rather than only replacing when Shopify has <=1) matters because
                // a partial alt-tagging pass leaves colours with 2-4 images, which used to
                // sit at 3 slides while a verified 8-photo set went unused.
                var pdpSet = FF_PDP_GALLERY[it.p.__shopifyHandle || ""];
                var files = pdpSet && pdpSet[colorObj.name];
                if (files && files.length){
                  var mapped = files.map(function(f){ return FF_CDN + f + "?width=900"; });
                  g = g.length ? g.concat(mapped) : mapped;
                }
                var out = galDedupe([colorObj.img].concat(g));
                if (out.length) return out;
                // Nothing mapped for this colour at all — its own photo beats a wrong one.
                return galDedupe([colorObj.img || it.p.__shopifyImg || it.p.img]);
              }
              // No colour option at all (insoles etc.) — a capped set of the product photos.
              var imgs = galDedupe(all);
              if (!imgs.length && it.p.__shopifyImg) imgs.push(it.p.__shopifyImg);
              if (!imgs.length && it.p.img) imgs.push(it.p.img);
              return imgs;
            }
            var setSheetGallery = null;
            var sheetGalleryGoTo = null;
            var SIZE_CHART_URL = "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/size_chart_46ea9a6a-aad2-49b9-afbe-fd77f386a008.webp?v=1781681614";
            var sizeChartIdx = -1;
            // Resolve the opening colour BEFORE building the gallery, so the photo and
            // the colour label always agree (previously the gallery was built from an
            // arbitrary colour while the label showed the selected one).
            var initCols = n.color ? colorsFor(it.p) : [];
            // Gender-sized products (heel pad, gel insole): the quiz already asked, so open
            // on that gender — and on a colour that actually stocks it. Beige has no
            // Women's and Grey has no Men's, so plain colour-0 would open sold out.
            (function preselectGender(){
              if (!n.size || draft.size) return;
              var gd = ffGenderSize(it.p);
              if (!gd) return;
              draft.size = gd;
              if (!n.color || draft.color != null || !initCols.length) return;
              var stock = window.FfShopify && window.FfShopify.sizeInStock;
              for (var gi2 = 0; gi2 < initCols.length; gi2++){
                if (!stock || stock(it.p, initCols[gi2].name, gd)){ draft.color = gi2; return; }
              }
            })();
            if (n.color && initCols.length && draft.color == null) draft.color = 0;
            var galleryImgs = galleryFromShopify(draft.color != null ? initCols[draft.color] : null);
            galleryImgs = galleryImgs.slice(0);
            // Size chart goes LAST (only when this product needs a size) — it used to be
            // forced to slide 4, which pushed the shopper's remaining product photos behind
            // a reference diagram mid-carousel. Gender-sized products are excluded: the
            // chart is a UK/US/EUR footwear grid, meaningless next to a Women / Men choice.
            var wantsSizeChart = n.size && !!SIZE_CHART_URL && !ffIsGenderSizeAxis(it.p);
            if (wantsSizeChart){
              sizeChartIdx = galleryImgs.length;
              galleryImgs.push(SIZE_CHART_URL);
            }
            function gallerySlideHTML(arr, chartIdx){
              var s = "";
              for (var gsi = 0; gsi < arr.length; gsi++){
                var isChart = (gsi === chartIdx);
                s += '<div class="ff-sheet-gallery-slide' + (isChart ? ' ff-sheet-gallery-slide--chart' : '') + '"><img class="ff-sheet-gallery-img" src="' + arr[gsi] + '" alt="' + (isChart ? 'Size chart' : it.p.name) + '" loading="lazy"></div>';
              }
              return s;
            }
            if (galleryImgs.length){
              h += '<div class="ff-sheet-gallery" id="ff-sheet-gallery">';
              h += '<div class="ff-sheet-gallery-track" id="ff-sheet-gallery-track">' + gallerySlideHTML(galleryImgs, sizeChartIdx) + '</div>';
              if (galleryImgs.length > 1){
                h += '<button type="button" class="ff-gallery-arrow ff-gallery-arrow--prev" id="ff-gallery-prev" aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>';
                h += '<button type="button" class="ff-gallery-arrow ff-gallery-arrow--next" id="ff-gallery-next" aria-label="Next image"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>';
                h += '<div class="ff-gallery-dots" id="ff-gallery-dots">';
                for (var gi = 0; gi < galleryImgs.length; gi++){ h += '<span class="ff-gallery-dot' + (gi === 0 ? ' is-on' : '') + '" data-gi="' + gi + '"></span>'; }
                h += '</div>';
              }
              h += '</div>';
            }
            if (n.color){
              var cols = colorsFor(it.p);
              h += '<div class="ff-sheet-section">';
              h += '<div class="ff-sheet-label">Color<span id="ff-sheet-color-name"></span></div>';
              h += '<div class="ff-color-grid" id="ff-sheet-colors">';
              for (var ci = 0; ci < cols.length; ci++){
                // Modal swatches show the colour's variant PHOTO (hex only if none).
                var sw = cols[ci].img || cols[ci].swatch || "";
                var swStyle = (sw.indexOf("#") === 0) ? ('background:' + sw + ';') : ('background-image:url(' + sw + '); background-size:cover;');
                h += '<button type="button" class="ff-color-opt" data-ci="' + ci + '" title="' + cols[ci].name + '" style="' + swStyle + '"></button>';
              }
              h += '</div></div>';
            }
            if (n.size){
              var szs = sizesFor(it.p);
              var sizeUnit = (szs.length && /^\d+$/.test(String(szs[0]))) ? "UK" : "";
              h += '<div class="ff-sheet-section">';
              // The "Size chart" link only makes sense when the chart is in the gallery.
              h += '<div class="ff-sheet-label ff-sheet-label--row">Size' + (sizeUnit ? ' <span class="ff-sheet-unit">' + sizeUnit + '</span>' : '') +
                   (wantsSizeChart ? '<button type="button" class="ff-size-chart-btn" id="ff-size-chart-btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M9 4v16"/></svg> Size chart</button>' : '') + '</div>';
              h += '<div class="ff-size-grid" id="ff-sheet-sizes">';
              for (var si = 0; si < szs.length; si++){
                h += '<button type="button" class="ff-size-opt" data-size="' + szs[si] + '">' + szs[si] + '</button>';
              }
              // availability is painted after render (it depends on the selected colour)
              h += '</div>';
              h += '</div>';
            }
            sheetBody.innerHTML = h;
    
            // wire colors
            var sCols = sheetBody.querySelectorAll("#ff-sheet-colors .ff-color-opt");
            function paintColor(){
              for (var k = 0; k < sCols.length; k++) sCols[k].classList.toggle("sel", k === draft.color);
              var nm = document.getElementById("ff-sheet-color-name");
              var cArr = colorsFor(it.p);
              if (nm && draft.color != null){ var c = cArr[draft.color]; nm.textContent = c ? (" \u00b7 " + c.name) : ""; }
              // Swap the gallery to the selected colour's Shopify variant image.
              var cur = (draft.color != null) ? cArr[draft.color] : null;
              if (cur){
                var pcGal = galleryFromShopify(cur);
                if (setSheetGallery && pcGal.length) setSheetGallery(pcGal);
                else {
                  var track0 = document.getElementById("ff-sheet-gallery-track");
                  var gimg = track0 ? track0.querySelector(".ff-sheet-gallery-slide:first-child .ff-sheet-gallery-img") : null;
                  if (gimg && cur.img) gimg.src = cur.img;
                }
              }
            }
            for (var sc = 0; sc < sCols.length; sc++){
              (function(idx){ sCols[idx].addEventListener("click", function(){ draft.color = idx; paintColor(); applyGenderDefault(); paintSizeStock(); paintSize(); refreshConfirm(); }); })(sc);
            }
            if (sCols.length && draft.color == null) draft.color = 0;
            paintColor();
    
            // wire sizes
            var sSizes = sheetBody.querySelectorAll("#ff-sheet-sizes .ff-size-opt");
            // Grey out sizes Shopify reports as sold out. Re-run whenever the colour
            // changes, since stock is per colour+size variant.
            function paintSizeStock(){
              if (!window.FfShopify || !window.FfShopify.sizeInStock) return;
              var cA = colorsFor(it.p);
              var cName = (draft.color != null && cA[draft.color]) ? cA[draft.color].name : null;
              for (var k = 0; k < sSizes.length; k++){
                var lbl = sSizes[k].getAttribute("data-size");
                var oos = !window.FfShopify.sizeInStock(it.p, cName, lbl);
                sSizes[k].classList.toggle("is-oos", oos);
                sSizes[k].disabled = oos;
                if (oos){
                  sSizes[k].setAttribute("aria-disabled", "true");
                  sSizes[k].title = "Out of stock";
                  if (draft.size === lbl) draft.size = null; // never leave a sold-out size selected
                } else {
                  sSizes[k].removeAttribute("aria-disabled");
                  sSizes[k].removeAttribute("title");
                }
              }
            }
            function paintSize(){
              for (var k = 0; k < sSizes.length; k++) sSizes[k].classList.toggle("sel", sSizes[k].getAttribute("data-size") === draft.size);
            }
            for (var ss = 0; ss < sSizes.length; ss++){
              sSizes[ss].addEventListener("click", function(){ draft.size = this.getAttribute("data-size"); paintSize(); refreshConfirm(); });
            }
            // Gender-sized products (heel pad, gel insole) open on the quiz's own answer.
            // Runs before paintSizeStock so a sold-out gender still gets cleared.
            function applyGenderDefault(){
              if (!n.size || draft.size) return;
              var gd = ffGenderSize(it.p);
              if (gd) draft.size = gd;
            }
            applyGenderDefault();
            paintSizeStock();
            paintSize();
            refreshConfirm();
    
            // wire gallery: horizontal scroll strip with arrows + dots
            (function(){
              var track = document.getElementById("ff-sheet-gallery-track");
              var dotsWrap = document.getElementById("ff-gallery-dots");
              if (!track) return;
              var gIdx = 0;
              function slides(){ return track.querySelectorAll(".ff-sheet-gallery-slide"); }
              function scrollToIdx(i){
                var sl = slides();
                if (!sl.length) return;
                gIdx = Math.max(0, Math.min(sl.length - 1, i));
                var el = sl[gIdx];
                if (el){ try { track.scrollTo({ left: el.offsetLeft, behavior: "smooth" }); } catch (e){ track.scrollLeft = el.offsetLeft; } }
                paintDots();
              }
              function paintDots(){
                if (!dotsWrap) return;
                var gDots = dotsWrap.querySelectorAll(".ff-gallery-dot");
                for (var d = 0; d < gDots.length; d++) gDots[d].classList.toggle("is-on", d === gIdx);
              }
              function nearestIdx(){
                var sl = slides(); if (!sl.length) return 0;
                var best = 0, bestD = Infinity;
                for (var i = 0; i < sl.length; i++){ var dd = Math.abs(sl[i].offsetLeft - track.scrollLeft); if (dd < bestD){ bestD = dd; best = i; } }
                return best;
              }
              var scrollRaf = null;
              track.addEventListener("scroll", function(){
                if (scrollRaf) return;
                scrollRaf = window.requestAnimationFrame(function(){ scrollRaf = null; gIdx = nearestIdx(); paintDots(); });
              });
              function rebuildDots(){
                if (!dotsWrap) return;
                var hh = "", c = slides().length;
                for (var gi = 0; gi < c; gi++){ hh += '<span class="ff-gallery-dot' + (gi === 0 ? ' is-on' : '') + '" data-gi="' + gi + '"></span>'; }
                dotsWrap.innerHTML = hh;
                var gDots = dotsWrap.querySelectorAll(".ff-gallery-dot");
                for (var d2 = 0; d2 < gDots.length; d2++){ (function(ix){ gDots[ix].addEventListener("click", function(){ scrollToIdx(ix); }); })(d2); }
              }
              var prev = document.getElementById("ff-gallery-prev");
              var next = document.getElementById("ff-gallery-next");
              if (prev) prev.addEventListener("click", function(){ scrollToIdx(gIdx - 1); });
              if (next) next.addEventListener("click", function(){ scrollToIdx(gIdx + 1); });
              sheetGalleryGoTo = scrollToIdx;
              setSheetGallery = function(arr){
                var newArr = arr.slice(0);
                if (wantsSizeChart){ sizeChartIdx = newArr.length; newArr.push(SIZE_CHART_URL); } // last slide
                else { sizeChartIdx = -1; }
                galleryImgs = newArr;
                track.innerHTML = gallerySlideHTML(newArr, sizeChartIdx);
                gIdx = 0;
                track.scrollLeft = 0;
                rebuildDots();
              };
            })();

            // Re-run now that setSheetGallery exists — it is assigned inside the IIFE
            // above, which runs AFTER the first paintColor() call, so without this the
            // opening colour's gallery swap was silently skipped.
            paintColor();

            // wire size chart button — scrolls the gallery horizontally to the size-chart slide
            var szChartBtn = document.getElementById("ff-size-chart-btn");
            if (szChartBtn){
              szChartBtn.addEventListener("click", function(){
                if (sizeChartIdx < 0 || !sheetGalleryGoTo) return;
                var g = document.getElementById("ff-sheet-gallery");
                if (g && g.scrollIntoView){ try { g.scrollIntoView({ behavior: "smooth", block: "nearest" }); } catch (e){} }
                sheetGalleryGoTo(sizeChartIdx);
                track("size_chart_view", {});
              });
            }
    
            refreshConfirm(); // sets the label (incl. "Out of stock") and disabled state
            sheetOverlay.classList.add("show");
            sheetEl.classList.add("show");
            ffLockScroll(true);
          }
          function refreshConfirm(){
            if (!sheetItem) return;
            var n = vNeeds(sheetItem);
            var ok = (!n.size || draft.size) && (!n.color || draft.color != null);
            // Sold-out check: if the whole product has no stock, or the chosen
            // colour+size variant is unavailable, say so instead of offering an add
            // that would fail silently.
            var oos = false;
            if (window.FfShopify){
              if (window.FfShopify.productInStock && !window.FfShopify.productInStock(sheetItem.p)) oos = true;
              if (!oos && ok && window.FfShopify.sizeInStock){
                var cA = colorsFor(sheetItem.p);
                var cName = (draft.color != null && cA[draft.color]) ? cA[draft.color].name : null;
                if (draft.size && !window.FfShopify.sizeInStock(sheetItem.p, cName, draft.size)) oos = true;
              }
            }
            sheetConfirm.disabled = !ok || oos;
            sheetConfirm.classList.toggle("is-oos", oos);
            sheetConfirm.textContent = oos ? "Out of stock" : (sheetItem.pendingAdd ? "Add to cart" : "Confirm");
          }
          function closeSheet(){
            sheetOverlay.classList.remove("show");
            sheetEl.classList.remove("show");
            ffLockScroll(false);
            sheetItem = null;
          }
          // wire once (sheet stays in DOM across paints)
          sheetOverlay.addEventListener("click", closeSheet);
          document.getElementById("ff-sheet-close").addEventListener("click", closeSheet);
          sheetConfirm.addEventListener("click", function(){
            if (!sheetItem) return;
            ensureVState(sheetItem.key);
            var priorSize = vState[sheetItem.key].size; // size before this confirm (for first-time detection)
            vState[sheetItem.key].color = draft.color;
            vState[sheetItem.key].size = draft.size;

            // The free insole normally auto-follows the shoe size (syncInsoleSize + the
            // cart's __ffComputeInsoleNeeds). A manual pick here LOCKS it: flag the state so
            // syncInsoleSize stops re-matching, and publish the chosen variant so the cart's
            // gift-sync seeds that exact variant instead of the size-matched one.
            if (sheetItem.free && draft.size){
              vState[sheetItem.key].userSet = true;
              var mvid = vVariantId(sheetItem);
              window.__ffManualInsoleVid = mvid ? String(mvid) : "";
            }

            // First size chosen anywhere → suggest it for the other footwear (fills empty sizes only,
            // mapped by UK number since each product labels sizes differently). Later edits stay independent.
            if (draft.size && !priorSize){
              var sibs = kitFootwearItems();
              var anyOtherSized = false;
              for (var pf = 0; pf < sibs.length; pf++){
                var sib = sibs[pf];
                if (!sib || sib.key === sheetItem.key) continue;
                if (vState[sib.key] && vState[sib.key].size){ anyOtherSized = true; break; }
              }
              if (!anyOtherSized){
                var targetUk = ffbUkNum(draft.size);
                if (targetUk != null){
                  for (var pf2 = 0; pf2 < sibs.length; pf2++){
                    var sib2 = sibs[pf2];
                    if (!sib2 || sib2.key === sheetItem.key || sib2.section !== "footwear") continue;
                    ensureVState(sib2.key);
                    if (vState[sib2.key].size) continue; // never overwrite an existing choice
                    var slist = sizesFor(sib2.p);
                    for (var si2 = 0; si2 < slist.length; si2++){
                      if (ffbUkNum(slist[si2]) === targetUk){ vState[sib2.key].size = slist[si2]; break; }
                    }
                  }
                }
              }
            }
            // Pending add (a "More X" carousel product or a slipper add) → add it
            // straight to the real Shopify cart and open the drawer. Deferred via
            // setTimeout so it runs after closeSheet() below restores the scroll-lock.
            if (sheetItem.pendingAdd){
              sheetItem.pendingAdd = false;
              var addVid = vVariantId(sheetItem);
              if (addVid && window.FfCart){
                track("carousel_add_to_cart", { name: sheetItem.p.name, size: draft.size, color: draft.color });
                setTimeout(function(){ window.FfCart.addAndOpen([{ id: addVid, qty: 1 }]); }, 0);
              }
            }
            track("variant_selected", { item: sheetItem.key, size: draft.size, color: draft.color });
            closeSheet();
            paint();
          });
    
          function totalOf(arr){ var s = 0; for (var i = 0; i < arr.length; i++) s += arr[i].p.price; return s; }
          function finalOf(t){ return Math.round(t * (1 - ffbBundlePct)); }
    
          function milestoneState(t){
            var unlocked = 0;
            for (var i = 0; i < milestones.length; i++) if (t >= milestones[i].threshold) unlocked++;
            var title, fillPct;
            var denom = milestones.length - 1;
            if (unlocked === 0){
              title = "Almost there! Just <strong>\u20b9" + fmt(milestones[0].threshold - t) + " more</strong> for Free Shipping";
            } else if (unlocked === milestones.length){
              var allName = (milestones.length === 1) ? (milestones[0].short || milestones[0].label) : ("all " + milestones.length + " rewards");
              title = "Congrats! You\u2019ve unlocked <strong>" + allName + "</strong> \ud83c\udf89";
            } else {
              var unlockedName = milestones[unlocked - 1].short || milestones[unlocked - 1].label;
              title = "Congrats! You\u2019ve unlocked a <strong>" + unlockedName + "</strong> \ud83c\udf89";
            }
            // fill (denom<=0 means a single milestone: fill straight toward its threshold)
            if (unlocked === milestones.length) fillPct = 100;
            else if (denom <= 0) fillPct = Math.min((t / milestones[0].threshold) * 100, 100);
            else if (unlocked === 0) fillPct = Math.min((t / milestones[0].threshold) * (100 / denom / 2), 100 / denom - 4);
            else {
              var seg = 100 / denom;
              var prev = milestones[unlocked - 1].threshold;
              var next = milestones[unlocked].threshold;
              var prog = (t - prev) / (next - prev);
              fillPct = ((unlocked - 1) * seg) + (prog * seg);
            }
            return { title: title, fillPct: fillPct, unlocked: unlocked };
          }
    
          function renderMilestone(t){
            var s = milestoneState(t);
            var h = '<div class="ff-ms">';
            h += '<div class="ff-ms-title">' + s.title + '</div>';
            h += '<div class="ff-ms-track">';
            h += '<div class="ff-ms-line"></div>';
            h += '<div class="ff-ms-line-fill" style="width:' + s.fillPct + '%"></div>';
            for (var mi = 0; mi < milestones.length; mi++){
              var on = t >= milestones[mi].threshold;
              var pos = (milestones.length > 1) ? (mi / (milestones.length - 1)) * 100 : 50;
              var align = "";
              if (mi === 0) align = " ff-ms-checkpoint--first";
              else if (mi === milestones.length - 1) align = " ff-ms-checkpoint--last";
              h += '<div class="ff-ms-checkpoint' + (on ? " is-unlocked" : "") + align + '" style="left:' + pos + '%">';
              h += '<div class="ff-ms-dot">' + (on ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' : '') + '</div>';
              h += '<div class="ff-ms-label">' + milestones[mi].label + '</div>';
              h += '</div>';
            }
            h += '</div></div>';
            return h;
          }
    
          // Footwear-type tab options
          var fwTabs = [
            { type: "closed",  label: "Shoes",    img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frido_Cloud_comfort_Shoes_Lace-ups_-Navy_6c1e8774-e176-4e2a-b342-58c68b524fed.png?v=1781265247" },
            { type: "sandal",  label: "Sandals",  img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Cloud_Comfort_Sandal_Chestnut_Brown.png?v=1781265331" },
            { type: "slipper", label: "Slippers", img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Cloud_Comfort_Slippers_Olive_Green.png?v=1781265200" }
          ];
    
          function indexOfItem(arr, key){
            for (var i = 0; i < arr.length; i++) if (arr[i] === key || (arr[i] && arr[i].key === key)) return i;
            return -1;
          }
          function hasFootwearType(type){
            for (var i = 0; i < liveItems.length; i++){
              if (liveItems[i].section === "footwear" && liveItems[i].footwearType === type) return true;
            }
            return false;
          }
          function nextFootwearKey(){
            // unique key per added footwear so deletes can target them
            var n = 0;
            for (var i = 0; i < liveItems.length; i++) if (liveItems[i].section === "footwear") n++;
            return "shoe_" + (Date.now() + n);
          }
          function addFootwearByType(type){
            if (hasFootwearType(type)) return false;
            var pickPref = (type === "slipper") ? "slipper" : type;
            var picked = pickShoe(r.condition, r.ctx, r.gender, pickPref);
            if (!picked) return false;
            var newKey = nextFootwearKey();
            liveItems.push({
              key: newKey,
              role: "Recommended footwear",
              section: "footwear",
              footwearType: type,
              locked: false,
              p: picked
            });
            ensureVState(newKey);
            track("bundle_footwear_added", { type: type });
            return true;
          }
    
          function renderRow(idx){
            var item = liveItems[idx];
            var it = item.p;
            var needs = vNeeds(item);
            var ready = vReady(item);
            var hasOpts = needs.size || needs.color;
            var h = '<div class="ff-kit-row' + (!ready && hasOpts ? " is-incomplete" : "") + '" data-idx="' + idx + '" data-key="' + item.key + '">';
            h += '<div class="ff-kit-row-img">' + (it.img ? '<img src="' + it.img + '" alt="' + it.name + '" loading="lazy">' : it.icon) + '</div>';
            h += '<div class="ff-kit-row-body">';
            h += '<div class="ff-kit-row-name">' + it.name + '</div>';
            if (it.tag) h += '<div class="ff-kit-row-tag">' + it.tag + '</div>';
            h += '<div class="ff-kit-row-price">';
            h += '<span class="ff-kit-row-now">\u20b9' + fmt(it.price) + '</span>';
            if (it.mrp && it.mrp > it.price) h += '<span class="ff-kit-row-was">\u20b9' + fmt(it.mrp) + '</span>';
            h += '</div>';
            if (hasOpts){
              var pillLabel = ready ? vLabel(item) : vPlaceholder(item);
              h += '<button type="button" class="ff-kit-row-variant' + (ready ? " is-ready" : "") + '" data-idx="' + idx + '">';
              h += '<span class="ff-kit-row-variant-text">' + pillLabel + '</span>';
              h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
              h += '</button>';
            }
            h += '</div>';
            h += '<button type="button" class="ff-kit-row-del" data-idx="' + idx + '" aria-label="Remove ' + it.name + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg></button>';
            h += '</div>';
            return h;
          }
    
          function renderFootwearTabs(){
            var h = '<div class="ff-kit-fwtabs">';
            for (var ti = 0; ti < fwTabs.length; ti++){
              var tab = fwTabs[ti];
              var added = hasFootwearType(tab.type);
              h += '<button class="ff-kit-fwtab' + (added ? " is-added" : "") + '" data-fwtype="' + tab.type + '" type="button">';
              h += '<span class="ff-kit-fwtab-ico"><img src="' + tab.img + '" alt="" loading="lazy"></span>';
              h += '<span class="ff-kit-fwtab-label">' + tab.label + '</span>';
              if (added){
                h += '<span class="ff-kit-fwtab-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
              } else {
                h += '<span class="ff-kit-fwtab-plus">+</span>';
              }
              h += '</button>';
            }
            h += '</div>';
            return h;
          }
    
          function renderSection(sectionId, label, includeTabs){
            // collect indices of items belonging to this section
            var idxList = [];
            for (var i = 0; i < liveItems.length; i++) if (liveItems[i].section === sectionId) idxList.push(i);
    
            var h = '<div class="ff-kit-sec" data-sec="' + sectionId + '">';
            h += '<div class="ff-kit-sec-label">' + label + '</div>';
            if (includeTabs) h += renderFootwearTabs();
            if (idxList.length === 0){
              if (sectionId === "footwear"){
                h += '<div class="ff-kit-sec-empty">No footwear selected. Pick a category above to add one.</div>';
              } else {
                h += '<div class="ff-kit-sec-empty">Not in your bundle.</div>';
              }
            } else {
              for (var k = 0; k < idxList.length; k++) h += renderRow(idxList[k]);
            }
            h += '</div>';
            return h;
          }
    
          function renderBody(){
            var t = totalOf(liveItems);
            var h = renderMilestone(t);
    
            h += '<div class="ff-kit-review">';
            h += '<div class="ff-kit-review-head"><div class="ff-kit-review-h"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg> Review Your Order</div><div class="ff-kit-review-count">' + liveItems.length + ' Item' + (liveItems.length === 1 ? '' : 's') + '</div></div>';
    
            if (liveItems.length === 0){
              h += '<div class="ff-kit-empty"><div class="ff-kit-empty-msg">Your cart is empty.</div></div>';
            } else {
              h += renderSection("footwear", "Footwear", false);
              h += renderSection("insole", "Insole", false);
              var hasOrthotic = false;
              for (var oi = 0; oi < liveItems.length; oi++){ if (liveItems[oi].section === "orthotic"){ hasOrthotic = true; break; } }
              if (hasOrthotic) h += renderSection("orthotic", "Orthotic", false);
            }
            h += '</div>';
            return h;
          }
    
          function renderBar(){
            var t = totalOf(liveItems);
            var final = finalOf(t);
            var saved = t - final;
            if (liveItems.length === 0){ return ''; }
            var svgSaved = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><line x1="9.5" y1="14.5" x2="14.5" y2="9.5"/><circle cx="9.4" cy="9.4" r="1"/><circle cx="14.6" cy="14.6" r="1"/></svg>';
            var svgTruck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1.5" y="6" width="12" height="9.5" rx="1"/><path d="M13.5 9h3.8l3.2 3.2v3.3h-7z"/><circle cx="6" cy="17.3" r="1.6"/><circle cx="16.5" cy="17.3" r="1.6"/></svg>';
            var svgReturn = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12a8 8 0 1 0 2.6-5.9"/><polyline points="3.5 4.5 3.5 9 8 9"/></svg>';
            var h = '<div class="ff-cobar">';
            // total price row
            h += '<div class="ff-cobar-top">';
            h += '<span class="ff-cobar-label">Total Price</span>';
            if (saved > 0){
              h += '<span class="ff-cobar-saved"><span class="ff-cobar-saved-ico">' + svgSaved + '</span>\u20b9' + fmt(saved) + ' applied!</span>';
            }
            h += '<span class="ff-cobar-total">\u20b9' + fmt(final) + '</span>';
            h += '</div>';
            // checkout button (id + ff-kit-bar-btn class kept for existing wiring / loading state)
            h += '<button class="ff-kit-bar-btn ff-cobar-btn" id="ff-kit-bar-btn" type="button">Proceed to Checkout</button>';
            // trust badges
            h += '<div class="ff-cobar-trust">';
            h += '<span class="ff-cobar-trust-item">' + svgTruck + 'Hassle Free Shipping</span>';
            h += '<span class="ff-cobar-trust-item">' + svgReturn + '7-Days Return &amp; Exchange*</span>';
            h += '</div>';
            h += '</div>';
            return h;
          }
    
          function wireDeletes(){
            var btns = bodyEl.querySelectorAll(".ff-kit-row-del");
            for (var i = 0; i < btns.length; i++){
              btns[i].addEventListener("click", function(){
                var idx = parseInt(this.getAttribute("data-idx"), 10);
                if (isNaN(idx) || !liveItems[idx]) return;
                var removed = liveItems[idx];
                liveItems.splice(idx, 1);
                // push to removedItems for re-add carousel (deduped by product name)
                var dup = false;
                for (var d = 0; d < removedItems.length; d++) if (removedItems[d].p.name === removed.p.name){ dup = true; break; }
                if (!dup) removedItems.push(removed);
                track("bundle_item_removed", { key: removed.key, remaining: liveItems.length });
                paint();
              });
            }
            var resetBtn = bodyEl.querySelector("#ff-kit-reset");
            if (resetBtn){
              resetBtn.addEventListener("click", function(){
                liveItems = items.slice();
                removedItems = [];
                // reset variant state for original items only
                vState = {};
                for (var rv = 0; rv < liveItems.length; rv++) ensureVState(liveItems[rv].key);
                track("bundle_reset", {});
                paint();
              });
            }
            var tabs = bodyEl.querySelectorAll(".ff-kit-fwtab");
            for (var ti = 0; ti < tabs.length; ti++){
              tabs[ti].addEventListener("click", function(){
                if (this.classList.contains("is-added")) return; // already in bundle
                var type = this.getAttribute("data-fwtype");
                if (!type) return;
                if (addFootwearByType(type)) paint();
              });
            }
            // variant select pills
            var vBtns = bodyEl.querySelectorAll(".ff-kit-row-variant");
            for (var vbi = 0; vbi < vBtns.length; vbi++){
              vBtns[vbi].addEventListener("click", function(){
                var idx = parseInt(this.getAttribute("data-idx"), 10);
                if (isNaN(idx) || !liveItems[idx]) return;
                openSheet(liveItems[idx]);
              });
            }
          }
    
          // ── Buy Now checkout: validate every line has a variant, then redirect straight
          //    to the myfrido.com cart permalink. (Drawer + Gokwik express path removed.)
          function checkoutNow(uiBtn){
            var missing = -1;
            for (var i = 0; i < liveItems.length; i++){
              if (!vReady(liveItems[i])){ missing = i; break; }
            }
            if (missing >= 0){
              openSheet(liveItems[missing]);
              track("bundle_cart_blocked_variant", { idx: missing, key: liveItems[missing].key });
              return;
            }
            function setLoading(on){
              if (!uiBtn) return;
              uiBtn.classList.toggle("is-loading", !!on);
              uiBtn.disabled = !!on;
            }
            var ensureCatalog = window.FfShopify
              ? window.FfShopify.prefetchProducts(collectCatalogProducts())
              : Promise.resolve();
            setLoading(true);
            ensureCatalog.then(function(){
              var lineItems = [];
              var fullCents = 0;
              // The free insole is NOT pushed into lineItems — it carries the _free_gift
              // property and its quantity is derived from the shoes. FfCart.syncGifts()
              // (called after the add) seeds one insole per shoe unit, size-matched.
              for (var v2 = 0; v2 < liveItems.length; v2++){
                if (liveItems[v2].free) continue; // free insole is handled via FfCart.syncGifts
                if (window.FfShopify) window.FfShopify.annotateProduct(liveItems[v2].p);
                var vid = vVariantId(liveItems[v2]);
                if (!vid){ setLoading(false); openSheet(liveItems[v2]); return; }
                lineItems.push({ id: vid, qty: 1, properties: liveItems[v2].free ? { _ff_source: "frido-footwear-quiz", _free_gift: "true" } : { _ff_source: "frido-footwear-quiz" } });
                if (window.FfShopify) fullCents += window.FfShopify.variantPriceCents(liveItems[v2].p, vid);
                else fullCents += (liveItems[v2].p.price || 0) * 100;
              }
              var finalPrice = finalOf(totalOf(liveItems));
              var disamCents = fullCents - (finalPrice * 100);
              if (disamCents < 0) disamCents = 0;

              // Add only what the cart is actually missing. Buy Now is "put my bundle in
              // the cart", not "add one more of everything" — pressing it twice, or
              // pressing it again after adding a second product, used to stack duplicates.
              // FfCart keeps __ffLastCart current after every cart op, so this costs no
              // extra request. Free-gift insoles are excluded (syncGifts owns those).
              var cartNow = window.__ffLastCart;
              var have = {};
              if (cartNow && cartNow.items){
                for (var ci = 0; ci < cartNow.items.length; ci++){
                  var cit = cartNow.items[ci];
                  var cgp = cit.properties;
                  if (cgp && (cgp._free_gift === "true" || cgp._free_gift === true)) continue;
                  var ck = String(cit.variant_id);
                  have[ck] = (have[ck] || 0) + (cit.quantity || 1);
                }
              }
              var toAdd = [];
              for (var ai = 0; ai < lineItems.length; ai++){
                var ak = String(lineItems[ai].id);
                if ((have[ak] || 0) > 0){ have[ak] -= 1; continue; }  // already in the cart
                toAdd.push(lineItems[ai]);
              }

              track("bundle_add_to_cart", {
                condition: r.condition,
                items: liveItems.length,
                added: toAdd.length,
                vids: lineItems.map(function (x) { return x.id; }).join(",")
              });
              sendData(RECORD, "bundle_add_to_cart");

              // Native cart: add to the same-origin Shopify cart and slide in the drawer.
              // addAndOpen calls FfCart.syncGifts() itself once the shoes land, seeding
              // one free insole per shoe unit — so nothing extra to do for the gift here.
              // Nothing missing → just show the cart (and let syncGifts settle the insoles).
              if (!toAdd.length){
                setLoading(false);
                window.FfCart.open();   // slides the drawer + one read to repaint it
                return;
              }
              window.FfCart.addAndOpen(toAdd).then(function(){ setLoading(false); }, function(){ setLoading(false); });
            });
          }

          function wireCart(){
            var btn = document.getElementById("ff-kit-bar-btn");
            if (!btn) return;
            btn.addEventListener("click", function(){
              // strict validation: find first item missing variant
              var missing = -1;
              for (var i = 0; i < liveItems.length; i++){
                if (!vReady(liveItems[i])){ missing = i; break; }
              }
              if (missing >= 0){
                var row = bodyEl.querySelector('.ff-kit-row[data-idx="' + missing + '"]');
                if (row){
                  row.classList.remove("shake"); void row.offsetWidth; row.classList.add("shake");
                  row.scrollIntoView({ behavior: "smooth", block: "center" });
                }
                openSheet(liveItems[missing]);
                track("bundle_cart_blocked_variant", { idx: missing, key: liveItems[missing].key });
                return;
              }

              var ensureCatalog = window.FfShopify
                ? window.FfShopify.prefetchProducts(collectCatalogProducts())
                : Promise.resolve();

              ensureCatalog.then(function(){
                var lineItems = [];
                var fullCents = 0;
                for (var v2 = 0; v2 < liveItems.length; v2++){
                  if (liveItems[v2].free) continue; // free insole is seeded separately as a free-gift line
                  if (window.FfShopify) window.FfShopify.annotateProduct(liveItems[v2].p);
                  var vid = vVariantId(liveItems[v2]);
                  if (!vid){
                    openSheet(liveItems[v2]);
                    return;
                  }
                  lineItems.push({ id: vid, qty: 1, properties: liveItems[v2].free ? { _ff_source: "frido-footwear-quiz", _free_gift: "true" } : { _ff_source: "frido-footwear-quiz" } });
                  if (window.FfShopify) {
                    fullCents += window.FfShopify.variantPriceCents(liveItems[v2].p, vid);
                  } else {
                    fullCents += (liveItems[v2].p.price || 0) * 100;
                  }
                }

                var fullPrice = totalOf(liveItems);
                var finalPrice = finalOf(fullPrice);
                var saleCents = finalPrice * 100;
                var disamCents = fullCents - saleCents;
                if (disamCents < 0) disamCents = 0;

                track("bundle_add_to_cart", {
                  condition: r.condition,
                  items: liveItems.length,
                  vids: lineItems.map(function (x) { return x.id; }).join(",")
                });
                sendData(RECORD, "bundle_add_to_cart");

                // Native cart: add to the same-origin Shopify cart and slide in the
                // drawer. (Checkout is deferred — "Proceed to Checkout" in the drawer
                // is the single checkout entry point, to be routed to GoKwik later.)
                window.FfCart.addAndOpen(lineItems);
              });
            });
          }
    
          // ── alternative-product carousels (Removed / More Footwear / More Insoles / More Support) ──
          function isInBundle(productName){
            for (var i = 0; i < liveItems.length; i++) if (liveItems[i].p.name === productName) return true;
            return false;
          }
          function getMoreFootwear(){
            // Filter by the carousel's active category tab; exclude items already in bundle
            var all = pickShoes(r.condition, r.ctx, r.gender, fwCarouselFilter);
            var out = [];
            for (var i = 0; i < all.length; i++){ if (!isInBundle(all[i].name)) out.push(all[i]); }
            return out.slice(0, 10);
          }
          function getMoreInsoles(){
            // Fixed curated list shown on every result, in this exact order.
            // Skip any that are already in the bundle to avoid duplication.
            var fixed = [
              P("Frido Max Comfort Memory Hi-Per Foam Insole", "Soft full-foot support", 1099, 1799, "", ICON.insole, "4.6", "2.2k", "https://myfrido.com/products/frido-max-comfort-memory-hi-per-foam-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/MFI-02.jpg?v=1719343958"),
              P("Frido Dual Gel Pro Insoles", "Shock-absorbing gel layer", 1199, 1999, "", ICON.support, "4.5", "1.7k", "https://myfrido.com/products/frido-dual-gel-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/DualGelInsole-L1-Small-2024_badb6c9e-7b37-4454-beb3-c381f9fa7d98.jpg?v=1758534908"),
              P("Frido Orthopedic Heel Pad Pro Insole", "Gel heel cushioning for heel pain", 599, 699, "", ICON.support, "4.5", "980", "https://myfrido.com/products/frido-orthopedic-heel-pad-pro-insole", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/HPP-01-beige.jpg?v=1745922369"),
              P("Frido Arch Sports Insole", "Active arch support · sweat-proof", 699, 1299, "49444552769817", ICON.insole, "4.6", "1.1k", "https://myfrido.com/products/frido-arch-sports-insoles", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/LS-2.jpg?v=1738400353")
            ];
            // Ultimate Flat Feet Combo shown first, ONLY for plantar fasciitis results.
            if (r.condition === "plantar"){
              fixed.unshift(P("Frido Ultimate Flat Feet Combo", "3-insole arch correction set", 2599, 7697, "", ICON.insole, "4.6", "740", "https://myfrido.com/products/ultimate-flat-feet-combo", "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Ultimate_Flat_Feet_Combo_abf375c8-ba6f-4532-af35-9ec7a6df76d8.png?v=1770808437"));
            }
            var pool = [];
            for (var i = 0; i < fixed.length; i++){
              if (!isInBundle(fixed[i].name)) pool.push(fixed[i]);
            }
            return pool;
          }
          function getMoreSupport(){
            var pool = [];
            for (var k in CATALOG){
              if (!CATALOG.hasOwnProperty(k)) continue;
              var c = CATALOG[k];
              var set2 = c[r.gender] || c.men;
              if (set2 && set2.support && !isInBundle(set2.support.name)){
                // Bunion Corrector is bundle-only — never surface it in More Support.
                if (set2.support.name === "Frido Orthotics Bunion Corrector") continue;
                var dup = false;
                for (var d = 0; d < pool.length; d++) if (pool[d].name === set2.support.name){ dup = true; break; }
                if (!dup) pool.push(set2.support);
              }
            }
            return pool.slice(0, 10);
          }
    
          function renderCard(p, ctaStyle, dataAttr){
            var off = (p.mrp && p.mrp > p.price) ? Math.round((1 - p.price / p.mrp) * 100) : 0;
            var h = '<div class="ff-carousel-card" ' + dataAttr + '>';
            h += '<div class="ff-carousel-card-img">' + (p.img ? '<img src="' + p.img + '" alt="' + p.name + '" loading="lazy">' : p.icon) + '</div>';
            h += '<div class="ff-carousel-card-name">' + p.name + '</div>';
            // Colour circles (hex) \u2014 same treatment as the step cards; the modal shows
            // the actual variant photos. Insoles/no-colour products render nothing.
            var cCols = colorsFor(p);
            if (cCols && cCols.length){
              h += '<div class="ff-carousel-card-sw">';
              for (var cci = 0; cci < cCols.length; cci++){
                var csw = cCols[cci].swatch || "";
                var cswStyle = (csw.indexOf("#") === 0) ? ('background:' + csw + ';') : ('background-image:url(' + csw + '); background-size:cover;');
                h += '<span class="ff-sw-dot" title="' + cCols[cci].name + '" style="' + cswStyle + '"></span>';
              }
              h += '</div>';
            }
            h += '<div class="ff-carousel-card-price"><span class="ff-carousel-card-now">\u20b9' + fmt(p.price) + '</span>';
            if (p.mrp && p.mrp > p.price) h += '<span class="ff-carousel-card-was">\u20b9' + fmt(p.mrp) + '</span>';
            h += '</div>';
            h += '<button type="button" class="ff-carousel-card-cta ff-carousel-card-cta--' + ctaStyle + '" ' + dataAttr + '>Add to cart</button>';
            h += '</div>';
            return h;
          }
    
          function renderCarousel(title, products, ctaStyle, attrPrefix){
            if (!products.length) return '';
            var h = '<section class="ff-carousel">';
            h += '<h3 class="ff-carousel-title">' + title + '</h3>';
            h += '<div class="ff-carousel-row">';
            for (var i = 0; i < products.length; i++){
              h += renderCard(products[i], ctaStyle, 'data-prod-name="' + products[i].name + '" data-source="' + attrPrefix + '"');
            }
            h += '</div></section>';
            return h;
          }
    
          function renderFwCarouselTabs(){
            // Filter tabs for the "More Footwear" carousel — Shoes/Sandals/Slippers
            var tabs = [
              { type: "closed",  label: "Shoes",    img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Frido_Cloud_comfort_Shoes_Lace-ups_-Navy_6c1e8774-e176-4e2a-b342-58c68b524fed.png?v=1781265247" },
              { type: "sandal",  label: "Sandals",  img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Cloud_Comfort_Sandal_Chestnut_Brown.png?v=1781265331" },
              { type: "slipper", label: "Slippers", img: "https://cdn.shopify.com/s/files/1/0553/0419/2034/files/Cloud_Comfort_Slippers_Olive_Green.png?v=1781265200" }
            ];
            var h = '<div class="ff-carousel-fwtabs">';
            for (var i = 0; i < tabs.length; i++){
              var t = tabs[i];
              var sel = (t.type === fwCarouselFilter) ? " is-selected" : "";
              h += '<button class="ff-carousel-fwtab' + sel + '" data-fwfilter="' + t.type + '" type="button">';
              h += '<span class="ff-carousel-fwtab-ico"><img src="' + t.img + '" alt="" loading="lazy"></span>';
              h += '<span class="ff-carousel-fwtab-label">' + t.label + '</span>';
              h += '</button>';
            }
            h += '</div>';
            return h;
          }
    
          function renderCarousels(){
            if (!carouselsMountEl) return '';
            var h = '';
            // also-bought cross-sell (heel & bunion only) — on the result page
            h += renderAlsoBought();
            // Removed (conditional)
            if (removedItems.length){
              var removedProducts = removedItems.map(function(it){ return it.p; });
              h += renderCarousel("Removed from your bundle", removedProducts, "yellow", "removed");
            }
            // More Footwear — with filter tabs above the card row
            var fwProducts = getMoreFootwear();
            h += '<section class="ff-carousel">';
            h += '<h3 class="ff-carousel-title">More Footwear For You</h3>';
            h += renderFwCarouselTabs();
            if (fwProducts.length){
              h += '<div class="ff-carousel-row">';
              for (var fpi = 0; fpi < fwProducts.length; fpi++){
                h += renderCard(fwProducts[fpi], "yellow", 'data-prod-name="' + fwProducts[fpi].name + '" data-source="footwear"');
              }
              h += '</div>';
            } else {
              h += '<div class="ff-carousel-empty">No additional footwear in this category.</div>';
            }
            h += '</section>';
            h += renderCarousel("More Insoles For You", getMoreInsoles(), "yellow", "insole");
            return h;
          }
    
          function findProductByName(name){
            // Look in SHOES, all CATALOG insoles/supports, and removedItems
            for (var i = 0; i < SHOES.length; i++) if (SHOES[i].p && SHOES[i].p.name === name) return SHOES[i].p;
            for (var k in CATALOG){
              if (!CATALOG.hasOwnProperty(k)) continue;
              var c = CATALOG[k];
              var set2 = c[r.gender] || c.men;
              if (set2){
                if (set2.insole && set2.insole.name === name) return set2.insole;
                if (set2.support && set2.support.name === name) return set2.support;
              }
            }
            for (var ri = 0; ri < removedItems.length; ri++) if (removedItems[ri].p.name === name) return removedItems[ri].p;
            return null;
          }
    
          function sectionForProduct(p, source){
            // Use source hint first; fall back to product traits
            if (source === "footwear" || source === "removed") {
              if (p.t === "sandal" || p.t === "slipper" || p.t === "chappal" || p.t === "closed") return "footwear";
            }
            if (source === "insole") return "insole";
            if (source === "support") return "orthotic";
            // fallback
            if (p.t) return "footwear";
            return "insole";
          }
          function footwearTypeFor(p){
            if (p.t === "sandal") return "sandal";
            if (p.t === "slipper" || p.t === "chappal") return "slipper";
            return "closed";
          }
    
          function wireCarousels(){
            if (!carouselsMountEl) return;
            // footwear filter tabs above More Footwear carousel
            var fwTabBtns = carouselsMountEl.querySelectorAll(".ff-carousel-fwtab");
            for (var fti = 0; fti < fwTabBtns.length; fti++){
              fwTabBtns[fti].addEventListener("click", function(){
                var t = this.getAttribute("data-fwfilter");
                if (!t || t === fwCarouselFilter) return;
                fwCarouselFilter = t;
                track("carousel_fw_filter", { type: t });
                paint();
              });
            }
            var btns = carouselsMountEl.querySelectorAll(".ff-carousel-card-cta");
            for (var i = 0; i < btns.length; i++){
              btns[i].addEventListener("click", function(){
                var name = this.getAttribute("data-prod-name");
                var source = this.getAttribute("data-source");
                // add a curated "Recommended for you" item by its key (keeps role/section/variant intent)
                if (source === "recommended"){
                  var recKey = this.getAttribute("data-rec-key");
                  for (var rk = 0; rk < recommendedItems.length; rk++){
                    if (recommendedItems[rk].key === recKey){
                      var already = false;
                      for (var al = 0; al < liveItems.length; al++){ if (liveItems[al].p && liveItems[al].p.name === recommendedItems[rk].p.name){ already = true; break; } }
                      if (!already){
                        liveItems.push(recommendedItems[rk]);
                        ensureVState(recommendedItems[rk].key);
                        track("recommended_added", { key: recKey, name: recommendedItems[rk].p.name });
                        paint();
                      }
                      return;
                    }
                  }
                  return;
                }
                if (!name) return;
                // re-add from "removed" section: restore original item shape if it exists
                if (source === "removed"){
                  var foundIdx = -1;
                  for (var ri = 0; ri < removedItems.length; ri++) if (removedItems[ri].p.name === name){ foundIdx = ri; break; }
                  if (foundIdx >= 0){
                    var item = removedItems[foundIdx];
                    removedItems.splice(foundIdx, 1);
                    liveItems.push(item);
                    ensureVState(item.key);
                    track("bundle_item_readded", { key: item.key, name: name });
                    paint();
                    return;
                  }
                }
                // add new item from "More X" carousel — open the variant sheet first (colour/size
                // for footwear, size for insoles); the actual add happens on sheet confirm.
                var prod = findProductByName(name);
                if (!prod) return;
                // if already in cart, just open the sheet on the existing item
                for (var ce = 0; ce < liveItems.length; ce++){
                  if (liveItems[ce].p && liveItems[ce].p.name === name){ openSheet(liveItems[ce]); return; }
                }
                var sec = sectionForProduct(prod, source);
                var newKey;
                var newItem = { p: prod, section: sec, locked: false };
                if (sec === "footwear"){
                  newKey = "shoe_" + Date.now();
                  newItem.key = newKey;
                  newItem.role = "Recommended footwear";
                  newItem.footwearType = footwearTypeFor(prod);
                } else if (sec === "insole"){
                  newKey = "insole_" + Date.now();
                  newItem.key = newKey;
                  newItem.role = "Matched insole";
                } else {
                  newKey = "support_" + Date.now();
                  newItem.key = newKey;
                  newItem.role = "Relief add-on";
                }
                newItem.pendingAdd = true;   // sheet confirm will push it into the cart
                ensureVState(newKey);
                track("bundle_carousel_open_sheet", { source: source, name: name });
                openSheet(newItem);
              });
            }
          }
    
          function updateCartCount(){
            // The header badge reflects the real Shopify cart and is owned by FfCart
            // (updated on its own add/seed/change ops), so local bundle changes don't
            // touch it — they only update the in-page bundle summary bar.
            renderPageCart();
          }

          function renderPageCart(){
            var el = document.getElementById("ff-pagecart");
            if (!el) return;
            var n = liveItems.length;
            var t = totalOf(liveItems);
            var finalP = finalOf(t);
            var ms = milestoneState(t);
            var h = "";
            if (n > 0 && ms.unlocked > 0){
              var unlockedLabel = milestones[ms.unlocked - 1].short || milestones[ms.unlocked - 1].label;
              h += '<div class="ff-kit-bar-ms ff-kit-bar-ms--on">';
              h += '<span class="ff-kit-bar-ms-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
              h += '<span class="ff-kit-bar-ms-txt"><strong>' + unlockedLabel + '</strong> is unlocked</span>';
              h += '</div>';
            } else {
              var togo = milestones[0].threshold - t;
              h += '<div class="ff-kit-bar-ms">';
              if (n > 0) h += '<span class="ff-kit-bar-ms-txt">Add <strong>\u20b9' + fmt(togo) + '</strong> more to unlock Free Shipping</span>';
              else h += '<span class="ff-kit-bar-ms-txt">Add items to unlock Free Shipping</span>';
              h += '</div>';
            }
            h += '<button type="button" class="ff-kit-bar-cart" id="ff-pagecart-open">';
            h += '<div class="ff-kit-bar-prices">';
            h += '<div class="ff-kit-bar-count">' + n + ' Item' + (n === 1 ? '' : 's') + '</div>';
            if (n > 0){
              h += '<div class="ff-kit-bar-final"><span class="ff-kit-bar-was">\u20b9' + fmt(t) + '</span><span class="ff-kit-bar-now">\u20b9' + fmt(finalP) + '</span></div>';
            }
            h += '</div>';
            h += '<span class="ff-kit-bar-btn">View cart</span>';
            h += '</button>';
            el.innerHTML = h;
            var openBtn = document.getElementById("ff-pagecart-open");
            if (openBtn) openBtn.addEventListener("click", function(){ if (window.__ffOpenCart) window.__ffOpenCart(); });
          }

          // ── "X% of people with <condition> also bought" — heel & bunion only ──
          function alsoBoughtFor(condKey){
            var set = CATALOG[condKey] && (CATALOG[condKey][r.gender] || CATALOG[condKey].men);
            if (!set || !set.support) return null;
            if (condKey === "heel")   return { pct: 67, label: "Heel Pain", p: set.support };
            if (condKey === "bunion") return { pct: 62, label: "Bunion",    p: set.support };
            return null;
          }
          function renderAlsoBought(){
            var ab = alsoBoughtFor(r.condition);
            if (!ab) return '';
            var h = '<section class="ff-carousel ff-alsobought">';
            h += '<h3 class="ff-carousel-title ff-ab-title"><span class="ff-ab-pct">' + ab.pct + '%</span> of people with ' + ab.label + ' also bought</h3>';
            h += '<div class="ff-carousel-row">';
            h += renderCard(ab.p, "yellow", 'data-prod-name="' + ab.p.name + '" data-source="support"');
            h += '</div>';
            h += '</section>';
            return h;
          }

          function renderDrawerCarousels(){
            if (!drawerCarouselsMountEl) return '';
            var h = '<div style="margin-top:24px;">';


            // ── More Footwear For You ──
            var fwProducts = getMoreFootwear();
            h += '<section class="ff-carousel">';
            h += '<h3 class="ff-carousel-title">More Footwear For You</h3>';
            h += renderFwCarouselTabs();
            if (fwProducts.length){
              h += '<div class="ff-carousel-row">';
              for (var fpi = 0; fpi < fwProducts.length; fpi++){
                h += renderCard(fwProducts[fpi], "yellow", 'data-prod-name="' + fwProducts[fpi].name + '" data-source="footwear"');
              }
              h += '</div>';
            } else {
              h += '<div class="ff-carousel-empty">No additional footwear in this category.</div>';
            }
            h += '</section>';

            // ── More Insoles For You ──
            var insProducts = getMoreInsoles();
            if (insProducts.length){
              h += '<section class="ff-carousel" style="margin-top:24px;">';
              h += '<h3 class="ff-carousel-title">More Insoles For You</h3>';
              h += '<div class="ff-carousel-row">';
              for (var ipi = 0; ipi < insProducts.length; ipi++){
                h += renderCard(insProducts[ipi], "yellow", 'data-prod-name="' + insProducts[ipi].name + '" data-source="insole"');
              }
              h += '</div>';
              h += '</section>';
            }

            h += '</div>';
            return h;
          }

          function wireDrawerCarousels(){
            if (!drawerCarouselsMountEl) return;
            var fwTabBtns = drawerCarouselsMountEl.querySelectorAll(".ff-carousel-fwtab");
            for (var fti = 0; fti < fwTabBtns.length; fti++){
              fwTabBtns[fti].addEventListener("click", function(){
                var t = this.getAttribute("data-fwfilter");
                if (!t || t === fwCarouselFilter) return;
                fwCarouselFilter = t;
                track("drawer_carousel_fw_filter", { type: t });
                paint();
              });
            }
            var btns = drawerCarouselsMountEl.querySelectorAll(".ff-carousel-card-cta");
            for (var i = 0; i < btns.length; i++){
              btns[i].addEventListener("click", function(){
                var name = this.getAttribute("data-prod-name");
                var source = this.getAttribute("data-source");
                if (!name) return;
                var prod = findProductByName(name);
                if (!prod) return;
                for (var ce = 0; ce < liveItems.length; ce++){
                  if (liveItems[ce].p && liveItems[ce].p.name === name){ openSheet(liveItems[ce]); return; }
                }
                var sec = sectionForProduct(prod, source);
                var newKey = "shoe_" + Date.now();
                var newItem = { p: prod, section: sec, locked: false, key: newKey, role: "Recommended footwear", footwearType: footwearTypeFor(prod) };
                newItem.pendingAdd = true;
                ensureVState(newKey);
                track("drawer_carousel_open_sheet", { source: source, name: name });
                openSheet(newItem);
              });
            }
          }

          function paint(){
            bodyEl.innerHTML = renderBody();
            barMountEl.innerHTML = renderBar();
            if (carouselsMountEl) carouselsMountEl.innerHTML = renderCarousels();
            if (drawerCarouselsMountEl) drawerCarouselsMountEl.innerHTML = renderDrawerCarousels();
            updateCartCount();
            wireDeletes();
            wireCart();
            wireCarousels();
            wireDrawerCarousels();
            if (syncKitBarSticky) syncKitBarSticky();
            refreshKit();
          }
    
          paint();

          // ── Free insole = one per shoe ─────────────────────────────────────
          // The store backs this with a Buy-X-Get-Y CODE (buy a shoe → get an insole
          // free), so the cart must hold one free-gift insole per shoe UNIT. We expose
          // window.__ffComputeInsoleNeeds(cart) — from the live cart it returns the map
          // { insoleVariantId: qty } the cart should hold. FfCart.syncGifts() reconciles
          // to it after every cart change and clears insoles when the last shoe is gone.
          (function installInsoleNeeds(){
            try {
              // Handles that count as a shoe (t:"closed") — mirrors the discount's Buy
              // collection (frido-footwear-quiz-shoes). Derived from the quiz catalogue
              // so it stays in sync; sandals/slippers deliberately excluded.
              var SHOE_HANDLES = {};
              for (var si = 0; si < SHOES.length; si++){
                if (SHOES[si].t !== "closed") continue;
                var hh = (window.FfShopify && window.FfShopify.handleFromUrl) ? window.FfShopify.handleFromUrl(SHOES[si].p.url) : "";
                if (hh) SHOE_HANDLES[hh] = true;
              }
              var HANDLE_BY_COND = {
                plantar: "frido-plantar-fasciitis-pain-relief-ortho-insoles",
                heel:    "frido-orthopedic-heel-pad-pro-insole",
                flat:    "frido-arch-support-insole",
                high:    "frido-arch-support-insole",
                fatigue: "frido-gel-max-comfort-insole",
                meta:    "frido-gel-max-comfort-insole",
                bunion:  "frido-gel-max-comfort-insole",
                general: "frido-gel-max-comfort-insole"
              };
              // The diagnosed insole's live record (+ a hardcoded fallback variant), by
              // the same candidate priority the bundle uses.
              function resolveInsole(){
                var boot = window.__FF_SHOPIFY_BOOTSTRAP || {};
                var cond = (window.__ffResult && window.__ffResult.condition) || "general";
                var candidates = [];
                if (window.__ffFreeGiftInsole && window.__ffFreeGiftInsole.url && window.FfShopify && window.FfShopify.handleFromUrl){
                  var dh = window.FfShopify.handleFromUrl(window.__ffFreeGiftInsole.url); if (dh) candidates.push(dh);
                }
                if (HANDLE_BY_COND[cond]) candidates.push(HANDLE_BY_COND[cond]);
                candidates.push("frido-arch-support-rigid-insole");
                var rec = null;
                for (var ci = 0; ci < candidates.length; ci++){ var r2 = boot[candidates[ci]]; if (r2 && r2.variants && r2.variants.length){ rec = r2; break; } }
                var fbVid = (window.__ffFreeGiftInsole && window.__ffFreeGiftInsole.vid) ? String(window.__ffFreeGiftInsole.vid) : "";
                return { rec: rec, fbVid: fbVid };
              }
              // Pick the insole variant whose size range covers the shoe size (insoles are
              // sized as ranges S 6-8 / L 9-12), preferring an in-stock one. Falls back to
              // the nearest available range, then the hardcoded variant.
              // Some insoles are sold per GENDER rather than per UK size (Heel Pad Pro is
              // Colour × Gender, no size option). With no size to match on, the picker fell
              // through to "first available variant" — and because the women's beige pad is
              // out of stock, every shopper including women was sent the MEN'S pad. Narrow to
              // the diagnosed gender first and let the colourway fall out of availability.
              function insoleVariantPool(rec){
                var vs = (rec && rec.variants) || [];
                var opts = (rec && rec.options) || [];
                var gPos = 0;
                for (var oi = 0; oi < opts.length; oi++){
                  if (/gender/i.test(opts[oi].name || "")) gPos = opts[oi].position || (oi + 1);
                }
                if (!gPos) return vs;
                var want = String((window.__ffResult && window.__ffResult.gender) || "").toLowerCase();
                if (want !== "men" && want !== "women") return vs;
                var matched = [];
                for (var i = 0; i < vs.length; i++){
                  var v = vs[i];
                  var val = gPos === 1 ? v.option1 : (gPos === 2 ? v.option2 : v.option3);
                  // indexOf(...) === 0, not a substring test: "women".indexOf("men") is 2,
                  // so a loose check would hand every woman the men's variant again.
                  if (v.available && String(val || "").toLowerCase().indexOf(want) === 0) matched.push(v);
                }
                return matched.length ? matched : vs;   // nothing in stock for that gender → any
              }
              function insoleVidForSize(rec, fbVid, sizeLabel){
                var vs = insoleVariantPool(rec);
                if (!vs.length) return fbVid;
                var target = ffbUkFromLabel(sizeLabel);
                var firstAvail = "", best = "", bestDist = 1e9;
                for (var i = 0; i < vs.length; i++){
                  var v = vs[i];
                  if (v.available && !firstAvail) firstAvail = String(v.id);
                  if (isNaN(target)) continue;
                  var nums = [v.option1, v.option2, v.option3].join(" ").match(/\d+/g);
                  if (!nums || !nums.length) continue;
                  var lo = parseInt(nums[0], 10), hi = nums.length > 1 ? parseInt(nums[1], 10) : lo;
                  if (target >= lo && target <= hi && v.available) return String(v.id);
                  var dist = target < lo ? (lo - target) : (target - hi);
                  if (v.available && dist < bestDist){ bestDist = dist; best = String(v.id); }
                }
                return best || firstAvail || String(vs[0].id) || fbVid;
              }
              window.__ffComputeInsoleNeeds = function(cart){
                var need = {};
                try {
                  if (!cart || !cart.items) return need;
                  var ins = resolveInsole();
                  if (!ins.rec && !ins.fbVid) return need;
                  // If the shopper manually chose an insole size in the bundle, honour that
                  // exact variant for every earned insole instead of size-matching per shoe.
                  var manual = String(window.__ffManualInsoleVid || "").trim();
                  for (var i = 0; i < cart.items.length; i++){
                    var it = cart.items[i];
                    var gp = it.properties;
                    if (gp && (gp._free_gift === "true" || gp._free_gift === true)) continue; // insoles don't earn insoles
                    if (!SHOE_HANDLES[it.handle]) continue;                                    // shoes only
                    var size = (it.variant_title && it.variant_title !== "Default Title") ? it.variant_title : "";
                    var vid = manual || insoleVidForSize(ins.rec, ins.fbVid, size);
                    if (vid){ need[vid] = (need[vid] || 0) + (it.quantity || 1); }
                  }
                } catch (e) {}
                return need;
              };
            } catch (e) {}
          })();
          // Reconcile now (covers a returning cart that already has shoes from a prior visit).
          if (window.FfCart && window.FfCart.syncGifts) window.FfCart.syncGifts();

          // ── cart drawer open / close ──
          (function wireCartDrawer(){
            var fab = document.getElementById("ff-cart-fab");
            var overlay = document.getElementById("ff-cart-overlay");
            var drawer = document.getElementById("ff-cart-drawer");
            var closeBtn = document.getElementById("ff-cart-drawer-close");
            function openCart(){ if (drawer){ drawer.classList.add("open"); overlay.classList.add("show"); document.body.style.overflow = "hidden"; } }
            function closeCart(){ if (drawer){ drawer.classList.remove("open"); overlay.classList.remove("show"); document.body.style.overflow = ""; } }
            if (fab) fab.addEventListener("click", openCart);
            if (overlay) overlay.addEventListener("click", closeCart);
            if (closeBtn) closeBtn.addEventListener("click", closeCart);
            window.__ffOpenCart = openCart;
          })();

          // ── indoor slipper "Add to cart" → push into the bundle as footwear ──
          (function wireSlippers(){
            // Build (or find existing) a cart item for a slipper button.
            function slipItemFor(btn){
              var name = btn.getAttribute("data-slip-name");
              for (var j = 0; j < liveItems.length; j++){
                if (liveItems[j].p && liveItems[j].p.name === name) return liveItems[j];
              }
              var prod = P(name, btn.getAttribute("data-slip-tag"),
                parseInt(btn.getAttribute("data-slip-price"), 10),
                parseInt(btn.getAttribute("data-slip-mrp"), 10),
                btn.getAttribute("data-slip-vid"), ICON.shoe, "4.7", "1k",
                btn.getAttribute("data-slip-url"), btn.getAttribute("data-slip-img"));
              var newKey = "slip_" + Date.now();
              var item = { key: newKey, role: "Indoor slippers", section: "footwear", footwearType: "slipper", locked: false, p: prod };
              return item;
            }
            function isInCart(name){
              for (var j = 0; j < liveItems.length; j++){ if (liveItems[j].p && liveItems[j].p.name === name) return true; }
              return false;
            }

            // "Add to cart" → open the variant sheet first (gallery / colour / size).
            // The actual add happens when the user confirms inside the sheet.
            var btns = elResult.querySelectorAll(".ff-slip-add");
            for (var i = 0; i < btns.length; i++){
              btns[i].addEventListener("click", function(){
                var name = this.getAttribute("data-slip-name");
                var item;
                if (isInCart(name)){
                  for (var j = 0; j < liveItems.length; j++){ if (liveItems[j].p && liveItems[j].p.name === name){ item = liveItems[j]; break; } }
                } else {
                  item = slipItemFor(this);   // built but NOT yet in liveItems
                  item.pendingAdd = true;     // sheet confirm will push it into the cart
                  ensureVState(item.key);
                }
                openSheet(item);
              });
            }
          })();

          // ── Guided kit builder wiring (stepper + multi-select + skip + variant sheet + build CTA).
          // Lives inside setupBundle so it uses the LIVE liveItems / openSheet / vState / paint.
          (function wireKit(){
            if (!elResult) return;
            var wrap = elResult.querySelector(".ffb-wrap");
            if (!wrap) return;

            function inCartByName(name){
              for (var j = 0; j < liveItems.length; j++){ if (liveItems[j].p && liveItems[j].p.name === name) return true; }
              return false;
            }
            function prodFromCard(card){
              return P(
                card.getAttribute("data-ffb-name"),
                card.getAttribute("data-ffb-tag"),
                parseInt(card.getAttribute("data-ffb-price"), 10) || 0,
                parseInt(card.getAttribute("data-ffb-mrp"), 10) || 0,
                card.getAttribute("data-ffb-vid"),
                ICON.shoe, "4.7", "1k",
                card.getAttribute("data-ffb-url"),
                card.getAttribute("data-ffb-img")
              );
            }
            function typeOfRole(role){ return role.replace(/[0-9]+$/, ""); }

            var roleMeta = {
              shoe:    { section: "footwear", footwearType: "shoe",    role: "Recommended footwear" },
              sandal:  { section: "footwear", footwearType: "sandal",  role: "Recommended footwear" },
              slipper: { section: "footwear", footwearType: "slipper", role: "Indoor slippers" }
            };

            // build kit-state per option card
            var kit = {}; // role -> { card, item, selected, baseType }
            var cards = wrap.querySelectorAll(".ffb-card");
            for (var c = 0; c < cards.length; c++){
              var role = cards[c].getAttribute("data-ffb-role");
              if (!role) continue;
              var baseType = typeOfRole(role);
              var meta = roleMeta[baseType] || roleMeta.shoe;
              var prod = prodFromCard(cards[c]);
              var item = { key: "ffb_" + role, role: meta.role, section: meta.section, footwearType: meta.footwearType, locked: false, p: prod };
              ensureVState(item.key);
              kit[role] = { card: cards[c], item: item, selected: cards[c].classList.contains("is-selected"), baseType: baseType };
            }
            kitFootwearItems = function(){ var a = []; for (var kk in kit){ if (kit.hasOwnProperty(kk)) a.push(kit[kk].item); } return a; };

            // one free insole (price 0), added when any shoe is in the kit — data read off the builder element
            var freeInsole = null;
            (function(){
              var fp = P(
                wrap.getAttribute("data-ffb-ins-name"),
                wrap.getAttribute("data-ffb-ins-tag"),
                0,
                parseInt(wrap.getAttribute("data-ffb-ins-mrp"), 10) || 0,
                wrap.getAttribute("data-ffb-ins-vid"),
                ICON.insole, "4.6", "1k",
                wrap.getAttribute("data-ffb-ins-url"),
                wrap.getAttribute("data-ffb-ins-img")
              );
              freeInsole = { key: "ffb_freeinsole", role: "Free insole", section: "insole", locked: false, free: true, p: fp };
              ensureVState(freeInsole.key);
            })();

            // insole card pill (the insole isn't a selectable .ffb-card; its pill just sets size)
            var insolePill = wrap.querySelector('.ffb-variant[data-ffb-variant-for="insole"]');
            if (insolePill){
              insolePill.addEventListener("click", function(ev){ ev.stopPropagation(); freeInsole.pendingAdd = false; openSheet(freeInsole); });
            }

            function giveDefaultColor(item){ var n = vNeeds(item); if (n.color && vState[item.key].color == null) vState[item.key].color = 0; }
            for (var rk in kit){ if (kit.hasOwnProperty(rk) && kit[rk].selected) giveDefaultColor(kit[rk].item); }

            // Number of selected shoes — each earns its own free insole.
            function selectedShoeCount(){
              var n = 0;
              for (var k in kit){ if (kit.hasOwnProperty(k) && kit[k].baseType === "shoe" && kit[k].selected) n++; }
              return n;
            }
            function anyShoeSelected(){
              for (var k in kit){ if (kit.hasOwnProperty(k) && kit[k].baseType === "shoe" && kit[k].selected) return true; }
              return false;
            }
            function selectedItems(){
              var order = [];
              for (var k in kit){ if (kit.hasOwnProperty(k)) order.push(k); }
              order.sort();
              var arr = [];
              for (var i = 0; i < order.length; i++){ if (kit[order[i]].selected) arr.push(kit[order[i]].item); }
              return arr;
            }

            function renderPills(){
              var pills = wrap.querySelectorAll(".ffb-variant");
              for (var i = 0; i < pills.length; i++){
                var role = pills[i].getAttribute("data-ffb-variant-for");
                if (!kit[role]) continue;
                var txt = pills[i].querySelector(".ffb-variant-txt");
                // Product-level stock: a product with no available variant shows
                // OUT OF STOCK instead of an add that would fail silently.
                var pOos = !!(window.FfShopify && window.FfShopify.productInStock && !window.FfShopify.productInStock(kit[role].item.p));
                pills[i].classList.toggle("is-oos", pOos);
                pills[i].disabled = pOos;
                if (txt) txt.textContent = pOos ? "OUT OF STOCK" : (vReady(kit[role].item) ? vLabel(kit[role].item) : (pills[i].classList.contains("ffb-atc") ? "ADD TO CART" : (vPlaceholder(kit[role].item) || "Select size")));
                var chg = pills[i].querySelector(".ffb-variant-change");
                if (chg && pills[i].classList.contains("ffb-atc")) chg.style.display = vReady(kit[role].item) ? "" : "none";
              }
              if (insolePill){ var it = insolePill.querySelector(".ffb-variant-txt"); if (it) it.textContent = vReady(freeInsole) ? vLabel(freeInsole) : (vPlaceholder(freeInsole) || "Select size"); }
            }

            var ffbPrevKeys = {}, ffbPrevTotal = 0;
            var stickyHasItems = false, stickyNeeds = false;
            function updateSticky(){
              var sticky = document.getElementById("ffb-sticky");
              if (!sticky) return;
              sticky.style.display = "none"; return; // retired: bundle bar + step CTAs are the only actions
              if (!stickyHasItems){ sticky.style.display = "none"; return; }
              var wrapEl = document.getElementById("ffb-wrap");
              var buildBtn2 = document.getElementById("ffb-build");
              var vh = window.innerHeight || document.documentElement.clientHeight || 0;
              var show = false;
              if (wrapEl && vh && wrapEl.getBoundingClientRect){
                var wr = wrapEl.getBoundingClientRect();
                var entered = wr.top < vh * 0.5;   // user has scrolled down to the builder
                var stillOn = wr.bottom > 90;       // builder still on screen
                var buildVisible = false;
                if (buildBtn2 && buildBtn2.getBoundingClientRect){ var br = buildBtn2.getBoundingClientRect(); buildVisible = (br.top < vh - 16 && br.bottom > 0); }
                show = entered && stillOn && !buildVisible;
              }
              sticky.style.display = show ? "block" : "none";
            }
            // show the "jump to bundle" CTA while the builder is still below the fold; hide once it scrolls into view
            function updateJump(){
              var jump = document.getElementById("ffb-jump");
              if (!jump) return;
              var wrapEl = document.getElementById("ffb-wrap");
              var resEl = document.getElementById("ff-result");
              var vh = window.innerHeight || document.documentElement.clientHeight || 0;
              var show = false;
              if (wrapEl && resEl && vh && resEl.style.display !== "none" && wrapEl.getBoundingClientRect){
                var wr = wrapEl.getBoundingClientRect();
                show = wr.top > vh * 0.62;
              }
              if (show) jump.classList.add("is-visible"); else jump.classList.remove("is-visible");
            }
            function renderSummary(){
              var sel = selectedItems();
              var count = sel.length;
              var now = 0;
              for (var i = 0; i < sel.length; i++) now += (sel[i].p.price || 0);
              var shoeCount = selectedShoeCount();       // one free insole per shoe
              var shoeSel = shoeCount > 0;
              var insMrp = shoeCount * (freeInsole.p.mrp || 0); // total insole value saved
              var totalItems = count + shoeCount;

              // ── bundle reward: tiered discount by number of products (1=5%, 2=10%, 3=15%) ──
              var bundlePct = bundlePctForCount(count);
              ffbBundlePct = bundlePct; // keep checkout (finalOf) in sync with what's shown
              var nowAfter = Math.round(now * (1 - bundlePct));

              // ── selected-items list (each shoe/sandal/slipper deletable; insole is free + tied to shoes) ──
              function lineHTML(it, deletable, free, sizeOverride){
                var ready = vReady(it);
                var varTxt = sizeOverride ? ("Size " + sizeOverride)
                  : (ready ? vLabel(it) : (vPlaceholder(it) || "Select size"));
                // Show the CHOSEN colour's photo, the way the cart drawer does. p.img is the
                // product's featured image, so an Aqua pick was still showing the maroon hero.
                var thumb = it.p.img || "";
                var tSt = vState[it.key];
                if (tSt && tSt.color != null){
                  var tCols = colorsFor(it.p);
                  if (tCols && tCols[tSt.color] && tCols[tSt.color].img) thumb = tCols[tSt.color].img;
                }
                var h = '<div class="ffb-li' + (free ? ' ffb-li--free' : '') + '" data-key="' + it.key + '">';
                h += '<div class="ffb-li-thumb"><img src="' + thumb + '" alt="" loading="lazy">' + (free ? '<span class="ffb-li-free">FREE</span>' : '') + '</div>';
                h += '<div class="ffb-li-info"><div class="ffb-li-name">' + (it.p.name||"").replace("Frido ", "") + '</div>';
                h += '<span class="ffb-li-pill"><span class="ffb-li-pill-txt">' + varTxt + '</span><span class="ffb-li-pill-change">Change</span></span></div>';
                h += '<div class="ffb-li-price' + (free ? ' free' : '') + '">' + (free ? "Free" : ("\u20b9" + fmt(it.p.price||0))) + '</div>';
                if (deletable) h += '<button type="button" class="ffb-li-del" data-del="' + it.key + '" aria-label="Remove">' + ICON.close + '</button>';
                h += '</div>';
                return h;
              }
              var listEl = document.getElementById("ffb-list");
              if (listEl){
                if (count === 0){
                  listEl.innerHTML = '<div class="ffb-kit-empty">Pick a shoe or sandal above to start your bundle.</div>';
                } else {
                  var lh = "";
                  for (var li = 0; li < sel.length; li++) lh += lineHTML(sel[li], true, false);
                  // Each earned insole is size-matched to ITS OWN shoe, exactly as the cart
                  // does it. Rendering one shared vState size here made the bundle advertise
                  // a size the cart would never hold as soon as two shoes differed.
                  var insSizes = insoleSizesForSelection();
                  for (var fi2 = 0; fi2 < shoeCount; fi2++) lh += lineHTML(freeInsole, false, true, insSizes[fi2]);
                  listEl.innerHTML = lh;
                }
              }

              var warnEl2 = document.getElementById("ffb-warn");
              if (warnEl2 && count > 0) warnEl2.style.display = "none";
              var elCount = document.getElementById("ffb-count");
              var elSave = document.getElementById("ffb-save");
              var elTotal = document.getElementById("ffb-total");
              var elBuild = document.getElementById("ffb-build");
              if (elCount) elCount.textContent = (totalItems === 0) ? "Your bundle" : ("Your bundle \u00b7 " + totalItems + (totalItems === 1 ? " item" : " items"));
              if (elSave) elSave.textContent = (shoeSel && insMrp > 0) ? ((shoeCount === 1 ? "insole free" : shoeCount + " insoles free") + " \u00b7 save \u20b9" + fmt(insMrp)) : "";
              if (elTotal){
                if (count === 0){ elTotal.style.display = "none"; }
                else {
                  var mrpSum = 0;
                  for (var mt2 = 0; mt2 < sel.length; mt2++){ mrpSum += (sel[mt2].p.mrp || sel[mt2].p.price || 0); }
                  if (shoeSel) mrpSum += shoeCount * (freeInsole.p.mrp || 0);
                  var saved2 = mrpSum - nowAfter;
                  elTotal.style.display = "block";
                  var th = '<div class="ffb-total-row"><span>Total</span><span class="ffb-total-amt">\u20b9' + fmt(nowAfter) + (mrpSum > nowAfter ? ' <span class="ffb-total-mrp">\u20b9' + fmt(mrpSum) + '</span>' : '') + '</span></div>';
                  if (saved2 > 0) th += '<div class="ffb-total-saved">You save \u20b9' + fmt(saved2) + (bundlePct > 0 ? ' \u00b7 ' + Math.round(bundlePct * 100) + '% bundle discount' : '') + '</div>';
                  elTotal.innerHTML = th;
                }
              }
              if (elBuild){
                elBuild.disabled = (count === 0);
                elBuild.textContent = (count === 0) ? "Pick at least one item" : "BUY NOW";
              }

              // insole card reflects shoe selection (locked until a shoe is chosen)
              var insCard = wrap.querySelector(".ffb-insole-card");
              if (insCard) insCard.classList.toggle("is-active", shoeSel);

              // sticky checkout bar contents + nudge state
              var mrpTotal = 0;
              for (var mt = 0; mt < sel.length; mt++){ mrpTotal += (sel[mt].p.mrp || sel[mt].p.price || 0); }
              if (shoeSel) mrpTotal += shoeCount * (freeInsole.p.mrp || 0);
              var needsVar = false;
              for (var nv = 0; nv < sel.length; nv++){ if (!vReady(sel[nv])){ needsVar = true; break; } }
              if (!needsVar && shoeSel && !vReady(freeInsole)) needsVar = true;
              stickyHasItems = (count > 0);
              stickyNeeds = needsVar;
              var sCount = document.getElementById("ffb-sticky-count");
              var sTotal = document.getElementById("ffb-sticky-total");
              var sMrp = document.getElementById("ffb-sticky-mrp");
              var sSave = document.getElementById("ffb-sticky-save");
              var sBtn = document.getElementById("ffb-sticky-btn");
              if (sCount) sCount.textContent = totalItems + (totalItems === 1 ? " item" : " items");
              if (sTotal) sTotal.textContent = "\u20b9" + fmt(nowAfter);
              if (sMrp) sMrp.textContent = (mrpTotal > nowAfter) ? ("\u20b9" + fmt(mrpTotal)) : "";
              if (sSave) sSave.textContent = (mrpTotal > nowAfter) ? ("Save \u20b9" + fmt(mrpTotal - nowAfter)) : "";
              if (sBtn){ sBtn.textContent = "ADD TO CART"; sBtn.classList.remove("is-nudge"); }
              updateSticky();

              // show items landing in the kit below: flash new rows + pulse the count
              var curKeys = {};
              for (var ck = 0; ck < sel.length; ck++) curKeys[sel[ck].key] = true;
              if (shoeSel) curKeys[freeInsole.key] = true;
              if (listEl){
                for (var nk in curKeys){
                  if (curKeys.hasOwnProperty(nk) && !ffbPrevKeys[nk]){
                    var row = listEl.querySelector('[data-key="' + nk + '"]');
                    if (row){ row.classList.remove("ffb-li--new"); void row.offsetWidth; row.classList.add("ffb-li--new"); }
                  }
                }
              }
              if (elCount && totalItems > ffbPrevTotal){
                elCount.classList.remove("ffb-count-pulse"); void elCount.offsetWidth; elCount.classList.add("ffb-count-pulse");
                var activeScr = wrap.querySelector(".ffb-screen.is-active");
                var onStep3 = activeScr && activeScr.getAttribute("data-ffb-screen") === "step3";
                if (onStep3){
                  var barEl = document.getElementById("ffb-bar");
                  if (barEl && barEl.getBoundingClientRect){
                    var rect = barEl.getBoundingClientRect();
                    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
                    if (vh && rect.top > vh - 40){
                      try { barEl.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e){}
                    }
                  }
                }
              }
              ffbPrevKeys = curKeys;
              ffbPrevTotal = totalItems;
            }

            // paint() calls this after every re-render (variant confirm, cart delete, etc.)
            function matchInsoleSize(insoleP, shoeSize){
              var szs = sizesFor(insoleP);
              if (!szs || !szs.length) return null;
              // Same UK-anchored parse the cart uses, so the two can't disagree.
              var target = ffbUkFromLabel(shoeSize);
              if (isNaN(target)) return null;
              var best = null, bestDist = 1e9;
              for (var i = 0; i < szs.length; i++){
                var nums = String(szs[i]).match(/\d+/g);
                if (!nums || !nums.length) continue;
                var lo = parseInt(nums[0], 10);
                var hi = nums.length > 1 ? parseInt(nums[1], 10) : lo;
                if (target >= lo && target <= hi) return szs[i];
                var dist = target < lo ? (lo - target) : (target - hi);
                if (dist < bestDist){ bestDist = dist; best = szs[i]; }
              }
              return best;
            }
            function primaryShoeSize(){
              var order = [];
              for (var k in kit){ if (kit.hasOwnProperty(k)) order.push(k); }
              order.sort();
              for (var i = 0; i < order.length; i++){
                var e = kit[order[i]];
                if (e.selected && e.baseType === "shoe"){
                  var s = vState[e.item.key];
                  if (s && s.size) return s.size;
                }
              }
              return null;
            }
            // One entry per selected shoe: the insole size THAT shoe earns. This is the
            // bundle-side mirror of the cart's __ffComputeInsoleNeeds — same per-shoe
            // matching, same manual-override rule — so the two lists always agree.
            // Returns null for a shoe whose size isn't chosen yet (row falls back to the
            // normal placeholder).
            function insoleSizesForSelection(){
              var out = [];
              if (!freeInsole) return out;
              ensureVState(freeInsole.key);
              var manual = vState[freeInsole.key].userSet ? vState[freeInsole.key].size : null;
              var order = [];
              for (var k in kit){ if (kit.hasOwnProperty(k)) order.push(k); }
              order.sort();
              for (var i = 0; i < order.length; i++){
                var e = kit[order[i]];
                if (!e.selected || e.baseType !== "shoe") continue;
                if (manual){ out.push(manual); continue; }
                var s = vState[e.item.key] && vState[e.item.key].size;
                out.push(s ? matchInsoleSize(freeInsole.p, s) : null);
              }
              return out;
            }
            // Free insole size follows the chosen shoe size by default. Once the shopper
            // manually picks a size in the sheet (userSet), we stop re-matching and keep it.
            function syncInsoleSize(){
              if (!freeInsole) return;
              ensureVState(freeInsole.key);
              if (vState[freeInsole.key].userSet) return; // manual pick — respect it
              var iN = vNeeds(freeInsole);
              if (!iN.size) return;
              var ss = primaryShoeSize();
              if (!ss) return;
              var m = matchInsoleSize(freeInsole.p, ss);
              if (!m) return;
              ensureVState(freeInsole.key);
              vState[freeInsole.key].size = m;
              if (iN.color && vState[freeInsole.key].color == null) vState[freeInsole.key].color = 0;
            }
            refreshKit = function(){ syncInsoleSize(); renderPills(); renderSummary(); };

            // card tap toggles selection. Delegated on the wrapper so infinity-loop clones
            // (created later by setupShoeCarousel, and sharing their original's role) are also
            // clickable; selection state is mirrored onto every card that shares the role.
            function cardsForRole(role){ return wrap.querySelectorAll('.ffb-card[data-ffb-role="' + role + '"]'); }
            // Slippers are the final step. Selecting one green-ticks the Slippers node
            // and drops the shopper onto the finished bundle below.
            function completeSlippersStep(){
              var scr3 = wrap.querySelector('[data-ffb-screen="step3"]');
              if (scr3){
                var node = scr3.querySelector('.ffb-mstep-node[data-ffb-goto="step3"]');
                if (node){
                  node.classList.remove("is-active"); node.classList.add("is-done");
                  var dot = node.querySelector(".ffb-mstep-dot"); if (dot) dot.textContent = "✓";
                }
                var lines = scr3.querySelectorAll(".ffb-mstep-line");
                if (lines.length) lines[lines.length - 1].classList.add("is-done");
              }
              // Defer the scroll so it runs after any variant sheet that ADD-TO-CART opens.
              setTimeout(function(){
                var bar = document.getElementById("ffb-bar");
                if (bar && bar.scrollIntoView){ try { bar.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (e){} }
              }, 260);
            }
            // Drop the Slippers ✓ back to "3" once the last slipper leaves the bundle,
            // so the marker never claims something the shopper has removed.
            function uncompleteSlippersStep(){
              var scr3 = wrap.querySelector('[data-ffb-screen="step3"]');
              if (!scr3) return;
              var node = scr3.querySelector('.ffb-mstep-node[data-ffb-goto="step3"]');
              if (!node) return;
              node.classList.remove("is-done");
              var activeScr = wrap.querySelector(".ffb-screen.is-active");
              node.classList.toggle("is-active", !!(activeScr && activeScr.getAttribute("data-ffb-screen") === "step3"));
              var dot = node.querySelector(".ffb-mstep-dot"); if (dot) dot.textContent = "3";
            }
            function setCardSelected(role, sel){
              if (!kit[role]) return;
              kit[role].selected = sel;
              // Removing from the bundle must also remove from the Buy Now payload.
              if (!sel) dropFromLive(kit[role].item);
              var same = cardsForRole(role);
              for (var q = 0; q < same.length; q++) same[q].classList.toggle("is-selected", sel);
              if (sel) giveDefaultColor(kit[role].item);
              renderSummary();
              if (kit[role].baseType === "slipper"){
                if (sel) completeSlippersStep();
                else if (!hasSelectionOfType("slipper")) uncompleteSlippersStep();
              }
            }
            wrap.addEventListener("click", function(ev){
              var t = ev.target, pill = null, card = null;
              while (t && t !== wrap){
                if (t.getAttribute && t.getAttribute("data-ffb-variant-for")){ pill = t; break; }
                if (t.getAttribute && t.getAttribute("data-ffb-role") && String(t.className || "").indexOf("ffb-card") >= 0){ card = t; break; }
                t = t.parentNode;
              }
              if (pill){
                // Real pills stopPropagation and are wired directly; only clone pills reach here.
                var prole = pill.getAttribute("data-ffb-variant-for");
                if (!kit[prole]) return;
                if (!kit[prole].selected) setCardSelected(prole, true);
                kit[prole].item.pendingAdd = false;
                openSheet(kit[prole].item);
                renderSummary();
                return;
              }
              if (!card) return;
              var role = card.getAttribute("data-ffb-role");
              if (!kit[role]) return;
              setCardSelected(role, !kit[role].selected);
            });

            // variant pill / Change → open the sheet (stores variant; Build CTA does the add)
            var pills = wrap.querySelectorAll(".ffb-variant");
            for (var pi = 0; pi < pills.length; pi++){
              pills[pi].addEventListener("click", function(ev){
                ev.stopPropagation();
                var role = this.getAttribute("data-ffb-variant-for");
                if (!kit[role]) return;
                if (!kit[role].selected){ setCardSelected(role, true); }
                kit[role].item.pendingAdd = false;
                openSheet(kit[role].item);
                renderSummary();
              });
            }

            // "More [category]" toggles — reveal/hide the collapsed alternatives
            var moreToggles = wrap.querySelectorAll(".ffb-more-toggle");
            for (var mt = 0; mt < moreToggles.length; mt++){
              moreToggles[mt].addEventListener("click", function(){
                var key = this.getAttribute("data-ffb-more");
                var listEl = wrap.querySelector('.ffb-more[data-ffb-more-list="' + key + '"]');
                if (!listEl) return;
                var isOpen = listEl.style.display !== "none";
                listEl.style.display = isOpen ? "none" : "block";
                this.classList.toggle("is-open", !isOpen);
              });
            }

            // ── occasion tabs — Step 1 has two phases: pick a filter, then reveal shoes ──
            var occTabs = wrap.querySelectorAll(".ffb-tab");
            var s1Phase = 1, s1Occ = "";
            function firstOcc(){ return occTabs.length ? occTabs[0].getAttribute("data-ffb-occ") : "daily"; }
            function setActiveTab(occ){
              for (var i = 0; i < occTabs.length; i++){ occTabs[i].classList.toggle("is-active", occTabs[i].getAttribute("data-ffb-occ") === occ); }
            }
            function showOcc(occ){
              setActiveTab(occ);
              var panels = wrap.querySelectorAll(".ffb-occ");
              for (var p2 = 0; p2 < panels.length; p2++){ panels[p2].style.display = "block"; }
              var flt = document.getElementById("ffb-filter");
              if (flt) flt.classList.add("is-chosen");
              scrollCarouselToOcc(occ);
            }
            function centerItem(item, smooth){
              if (!item || !item.scrollIntoView) return;
              var fn = function(){ try { item.scrollIntoView({ behavior: smooth ? "smooth" : "auto", inline: "center", block: "nearest" }); } catch (e) {} };
              if (window.requestAnimationFrame) requestAnimationFrame(fn); else fn();
            }
            // True while a programmatic tab-scroll is animating — suppresses the scroll
            // handler's tab-sync so a left-aligned card isn't immediately re-synced to
            // whatever lands in the centre.
            var carProgScroll = false;
            // Align a card's LEFT edge to the carousel's left content edge (after its
            // padding), so clicking a tab lands its first product as the first card on
            // the left rather than scrolling it to the centre.
            function alignItemLeft(item, smooth){
              var car = document.getElementById("ffb-shoe-carousel");
              if (!car || !item) return;
              var fn = function(){
                try {
                  var cr = car.getBoundingClientRect(), tr = item.getBoundingClientRect();
                  var pad = parseFloat((window.getComputedStyle ? getComputedStyle(car).paddingLeft : "0")) || 0;
                  var left = car.scrollLeft + (tr.left - cr.left) - pad;
                  carProgScroll = true;
                  if (car.scrollTo) car.scrollTo({ left: left, behavior: smooth ? "smooth" : "auto" }); else car.scrollLeft = left;
                  setTimeout(function(){ carProgScroll = false; }, 500);
                } catch (e) { carProgScroll = false; }
              };
              if (window.requestAnimationFrame) requestAnimationFrame(fn); else fn();
            }
            function scrollCarouselToOcc(occ){
              var car = document.getElementById("ffb-shoe-carousel");
              if (!car) return;
              var target = car.querySelector('.ffb-carousel-item:not([data-ffb-clone])[data-occ="' + occ + '"]');
              if (target) alignItemLeft(target, true);
            }
            function revealShoes(occ){
              s1Occ = occ;
              showOcc(occ);
              s1Phase = 2;
              var la = document.querySelector(".ffb-s1a"), lb = document.querySelector(".ffb-s1b");
              if (la) la.style.display = "none"; if (lb) lb.style.display = "inline";
              track("kit_builder_shoes_reveal", { occasion: occ });
            }
            // Default preselected tag = Daily (falls back to first tab if Daily is absent).
            function defaultOccTag(){
              for (var dt = 0; dt < occTabs.length; dt++){ if (occTabs[dt].getAttribute("data-ffb-occ") === "daily") return "daily"; }
              return firstOcc();
            }
            s1Occ = defaultOccTag();
            for (var ot = 0; ot < occTabs.length; ot++){
              occTabs[ot].addEventListener("click", function(){
                var occ = this.getAttribute("data-ffb-occ");
                track("kit_builder_occ", { occasion: occ });
                if (s1Phase === 2){ s1Occ = occ; showOcc(occ); }
                else { revealShoes(occ); }
              });
            }
            var s1cta = document.getElementById("ffb-s1-cta");
            if (s1cta) s1cta.addEventListener("click", function(){
              if (s1Phase === 1){
                revealShoes(s1Occ || defaultOccTag());
              } else {
                track("kit_builder_next", { to: "step2" });
                showScreen("step2");
              }
            });
            function wireCarouselDots(){
              var cars = wrap.querySelectorAll(".ffb-shoe-carousel");
              for (var ci = 0; ci < cars.length; ci++){
                (function(car){
                  var sib = car.nextElementSibling;
                  var dots = (sib && sib.className && String(sib.className).indexOf("ffb-cx-dots") >= 0) ? sib : null;
                  if (!dots) return;
                  var dotEls = dots.querySelectorAll(".ffb-cx-dot");
                  car.addEventListener("scroll", function(){
                    var items = car.querySelectorAll(".ffb-carousel-item");
                    if (!items.length) return;
                    var iw = items[0].offsetWidth + 12;
                    var idx = iw > 0 ? Math.round(car.scrollLeft / iw) : 0;
                    if (idx < 0) idx = 0;
                    if (idx > dotEls.length - 1) idx = dotEls.length - 1;
                    for (var k = 0; k < dotEls.length; k++) dotEls[k].classList.toggle("is-on", k === idx);
                  });
                })(cars[ci]);
              }
            }
            wireCarouselDots();
            // Shoe carousel: center-snap, pill follows the CENTER card, infinity loop via edge clones.
            function setupShoeCarousel(){
              var car = document.getElementById("ffb-shoe-carousel");
              if (!car) return;
              function markClone(n){ n.setAttribute("data-ffb-clone", "1"); n.setAttribute("aria-hidden", "true"); }
              var reals = car.querySelectorAll(".ffb-carousel-item");
              if (reals.length >= 2){
                var firstReal = reals[0], lastReal = reals[reals.length - 1];
                var cs = lastReal.cloneNode(true), ce = firstReal.cloneNode(true);
                markClone(cs); markClone(ce);
                car.insertBefore(cs, firstReal);
                car.appendChild(ce);
              }
              function nearestCenter(){
                var items = car.querySelectorAll(".ffb-carousel-item");
                if (!items.length) return null;
                var vc = car.scrollLeft + car.clientWidth / 2, best = null, bestD = Infinity;
                for (var i = 0; i < items.length; i++){
                  var c = items[i].offsetLeft + items[i].offsetWidth / 2, dd = Math.abs(c - vc);
                  if (dd < bestD){ bestD = dd; best = items[i]; }
                }
                return best;
              }
              function updatePill(){ var it = nearestCenter(); var occ = it && it.getAttribute("data-occ"); if (occ) setActiveTab(occ); }
              var settle;
              car.addEventListener("scroll", function(){
                if (carProgScroll) return; // don't re-sync the tab during a programmatic tab-scroll
                updatePill();
                clearTimeout(settle);
                settle = setTimeout(function(){
                  var it = nearestCenter();
                  if (!it || !it.getAttribute("data-ffb-clone")) return;
                  var all = car.querySelectorAll(".ffb-carousel-item");
                  var rr = car.querySelectorAll('.ffb-carousel-item:not([data-ffb-clone])');
                  if (!rr.length) return;
                  centerItem((it === all[0]) ? rr[rr.length - 1] : rr[0], false);
                }, 130);
              });
            }
            setupShoeCarousel();

            // ── stepper navigation ──
            var screens = wrap.querySelectorAll(".ffb-screen");
            // Slide the step picker away once the shopper is done choosing.
            function collapseSteps(){
              var stage = wrap.querySelector(".ffb-stage");
              if (!stage || stage.classList.contains("is-collapsed")) return;
              var warnEl = document.getElementById("ffb-warn");
              if (warnEl) warnEl.style.display = "none";
              // lock in the current height so the transition has something to animate from
              stage.style.maxHeight = stage.scrollHeight + "px";
              // force reflow so the browser registers the start value before we shrink
              void stage.offsetHeight;
              stage.classList.add("is-collapsing");
              stage.style.maxHeight = "0px";
              window.setTimeout(function(){
                stage.classList.remove("is-collapsing");
                stage.classList.add("is-collapsed");
                stage.style.display = "none";
                stage.style.maxHeight = "";
                syncEditBtn();
                var bar = document.getElementById("ffb-bar");
                if (bar && bar.scrollIntoView){ try { bar.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (e){} }
              }, 420);
              track("kit_builder_steps_collapsed", {});
            }
            // Reverse of collapseSteps. Without this the picker — and with it the
            // Shoes/Sandals/Slippers markers and every product carousel — is gone for
            // good, so a deleted item can never be picked again.
            function stepsCollapsed(){
              var stage = wrap.querySelector(".ffb-stage");
              return !!(stage && stage.classList.contains("is-collapsed"));
            }
            function expandSteps(stepName){
              var stage = wrap.querySelector(".ffb-stage");
              if (!stage) return;
              var reopening = stage.classList.contains("is-collapsed");
              if (reopening){
                stage.classList.remove("is-collapsed");
                stage.style.display = "";
              }
              // Switch screens first so the grow animation measures the height of the
              // step we're actually landing on, not whichever one was last active.
              if (stepName) showScreen(stepName);
              if (reopening){
                var full = stage.scrollHeight;
                stage.style.maxHeight = "0px";
                void stage.offsetHeight;              // register the start value before growing
                stage.style.maxHeight = full + "px";
                window.setTimeout(function(){ stage.style.maxHeight = ""; }, 440);
                track("kit_builder_steps_reopened", { to: stepName || "" });
              }
              syncEditBtn();
            }
            function hasSelectionOfType(t){
              for (var k in kit){ if (kit.hasOwnProperty(k) && kit[k].baseType === t && kit[k].selected) return true; }
              return false;
            }
            // Land the shopper on the first category they haven't picked from yet.
            function firstOpenStep(){
              if (!hasSelectionOfType("shoe")) return "step1";
              if (!hasSelectionOfType("sandal")) return "step2";
              if (!hasSelectionOfType("slipper")) return "step3";
              return "step1";
            }
            var editBtnEl = document.getElementById("ffb-edit");
            function syncEditBtn(){
              if (editBtnEl) editBtnEl.style.display = stepsCollapsed() ? "flex" : "none";
            }
            if (editBtnEl){
              editBtnEl.addEventListener("click", function(){
                track("kit_builder_edit", {});
                expandSteps(firstOpenStep());
              });
            }
            function showBundleWarning(){
              var el = document.getElementById("ffb-warn");
              if (!el) return;
              el.innerHTML = ICON.lock + '<span>Add at least one item to your bundle to claim your free insole.</span>';
              el.style.display = "flex";
              if (el.scrollIntoView){ try { el.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e){} }
              track("kit_builder_skip_empty", {});
            }
            function showScreen(name){
              for (var i = 0; i < screens.length; i++){
                screens[i].classList.toggle("is-active", screens[i].getAttribute("data-ffb-screen") === name);
              }
              var bar = document.getElementById("ffb-bar");
              if (bar) bar.style.display = (name === "entry") ? "none" : "block";
              // Center the first card of this step's carousel (same centered look as shoes).
              var activeScr = wrap.querySelector('.ffb-screen.is-active');
              var car2 = activeScr ? activeScr.querySelector(".ffb-shoe-carousel") : null;
              if (car2 && car2.className.indexOf("ffb-carousel--left") < 0){
                var it2 = car2.querySelector('.ffb-carousel-item:not([data-ffb-clone])');
                if (it2 && it2.scrollIntoView){ try { it2.scrollIntoView({ behavior: "auto", inline: "center", block: "nearest" }); } catch (e2) {} }
              }
              var target = activeScr ? (activeScr.querySelector(".ffb-prog") || activeScr) : wrap;
              try { target.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (e){}
            }
            function deselectStep(stepName){
              var map = { step1: "shoe", step2: "sandal", step3: "slipper" };
              var t = map[stepName];
              for (var k in kit){ if (kit.hasOwnProperty(k) && kit[k].baseType === t){ setCardSelected(k, false); } }
            }            var startBtn = document.getElementById("ffb-start");
            if (startBtn) startBtn.addEventListener("click", function(){ track("kit_builder_start", {}); showScreen("step1"); renderSummary(); });
            var nextEls = wrap.querySelectorAll("[data-ffb-next]");
            for (var ni = 0; ni < nextEls.length; ni++){
              nextEls[ni].addEventListener("click", function(){ var tgt = this.getAttribute("data-ffb-next"); track("kit_builder_next", { to: tgt }); showScreen(tgt); });
            }
            var backEls = wrap.querySelectorAll("[data-ffb-back]");
            for (var bi = 0; bi < backEls.length; bi++){
              backEls[bi].addEventListener("click", function(){ showScreen(this.getAttribute("data-ffb-back") || "step1"); });
            }
            var skipEls = wrap.querySelectorAll("[data-ffb-skip]");
            for (var si = 0; si < skipEls.length; si++){
              skipEls[si].addEventListener("click", function(){
                var which = this.getAttribute("data-ffb-skip");
                deselectStep(which);
                track("kit_builder_skip", { step: which });
                if (which === "step1") showScreen("step2");
                else if (which === "step2") showScreen("step3");
                else {
                  // Last skip. With something in the bundle there is nothing left to
                  // choose, so collapse the picker away and leave the trust strip +
                  // bundle. With an empty bundle, collapsing would strand the shopper
                  // with no way to earn the free insole — so keep it open and say why.
                  renderSummary();
                  if (selectedItems().length > 0) collapseSteps();
                  else showBundleWarning();
                }
              });
            }
            // clickable Shoes / Sandals / Slippers stepper — jump straight to a step
            var stepNodes = wrap.querySelectorAll("[data-ffb-goto]");
            function gotoStepFromNode(node){
              var tgt = node.getAttribute("data-ffb-goto");
              if (!tgt) return;
              track("kit_builder_step_nav", { to: tgt });
              showScreen(tgt);
            }
            for (var sn = 0; sn < stepNodes.length; sn++){
              stepNodes[sn].addEventListener("click", function(){ gotoStepFromNode(this); });
              stepNodes[sn].addEventListener("keydown", function(ev){
                if (ev.key === "Enter" || ev.key === " " || ev.keyCode === 13 || ev.keyCode === 32){ ev.preventDefault(); gotoStepFromNode(this); }
              });
            }

            // expert links — placeholder until the live endpoint is ready
            var expertEls = wrap.querySelectorAll("[data-ffb-expert]");
            for (var ei = 0; ei < expertEls.length; ei++){
              expertEls[ei].addEventListener("click", function(){ track("kit_builder_expert_click", {}); });
            }

            // FAQ accordion (each "How this helps" block)
            var faqBtns = wrap.querySelectorAll("[data-ffb-faq]");
            for (var fq = 0; fq < faqBtns.length; fq++){
              faqBtns[fq].addEventListener("click", function(){
                var item = this.parentNode;
                if (item && item.classList) item.classList.toggle("open");
              });
            }

            // ── build CTA → validate variants (incl. free insole size) → push to liveItems → open cart ──
            var buildBtn = document.getElementById("ffb-build");
            if (buildBtn){
              buildBtn.addEventListener("click", function(){
                var sel = selectedItems();
                if (!sel.length) return;
                for (var i = 0; i < sel.length; i++){
                  if (!vReady(sel[i])){ sel[i].pendingAdd = false; openSheet(sel[i]); return; }
                }
                // the free insole comes with any shoe — its size auto-follows the shoe size
                syncInsoleSize();
                if (anyShoeSelected() && !vReady(freeInsole)){ freeInsole.pendingAdd = false; openSheet(freeInsole); return; }
                // Rebuild the payload from the CURRENT selection instead of appending to it.
                // Appending + an "is it already there?" test against liveItems meant a
                // removed item (absent from liveItems, still stale elsewhere) looked like a
                // new addition, so deleted products kept reappearing in the cart. The
                // selection is the single source of truth for what Buy Now sends.
                liveItems.length = 0;
                for (var j = 0; j < sel.length; j++){ ensureVState(sel[j].key); liveItems.push(sel[j]); }
                if (anyShoeSelected()){ ensureVState(freeInsole.key); liveItems.push(freeInsole); }
                track("kit_built", { count: liveItems.length });
                checkoutNow(buildBtn);
              });
            }

            // sticky bar: button delegates to Build (which nudges for size/colour or adds to cart)
            function nudgePills(){
              var listEl2 = document.getElementById("ffb-list");
              if (!listEl2) return;
              var sel2 = selectedItems();
              var keys = [];
              for (var i = 0; i < sel2.length; i++){ if (!vReady(sel2[i])) keys.push(sel2[i].key); }
              if (anyShoeSelected() && !vReady(freeInsole)) keys.push(freeInsole.key);
              setTimeout(function(){
                for (var k = 0; k < keys.length; k++){
                  var row = listEl2.querySelector('[data-key="' + keys[k] + '"]');
                  if (row){ var pill = row.querySelector(".ffb-li-pill"); if (pill){ pill.classList.remove("ffb-nudge"); void pill.offsetWidth; pill.classList.add("ffb-nudge"); } }
                }
              }, 360);
            }
            var stickyBtnEl = document.getElementById("ffb-sticky-btn");
            if (stickyBtnEl) stickyBtnEl.addEventListener("click", function(){
              track("kit_sticky_cta", { needs: stickyNeeds });
              var barEl = document.getElementById("ffb-bar");
              if (barEl && barEl.scrollIntoView){ try { barEl.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e){} }
              if (stickyNeeds){ nudgePills(); }
            });
            var jumpBtnEl = document.getElementById("ffb-jump-btn");
            if (jumpBtnEl) jumpBtnEl.addEventListener("click", function(){
              track("result_jump_to_bundle", {});
              var wrapEl2 = document.getElementById("ffb-wrap");
              if (wrapEl2 && wrapEl2.scrollIntoView){ try { wrapEl2.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (e){} }
            });
            var stickyRaf = null;
            function onStickyScroll(){ if (stickyRaf) return; stickyRaf = window.requestAnimationFrame(function(){ stickyRaf = null; updateSticky(); updateJump(); }); }
            window.addEventListener("scroll", onStickyScroll, true);
            window.addEventListener("resize", onStickyScroll);
            updateJump();

            // ── kit list: delete removes an item; tapping a row opens its size/colour sheet ──
            function itemByKey(key){
              if (key === freeInsole.key) return freeInsole;
              for (var k in kit){ if (kit.hasOwnProperty(k) && kit[k].item.key === key) return kit[k].item; }
              return null;
            }
            function roleByKey(key){
              for (var k in kit){ if (kit.hasOwnProperty(k) && kit[k].item.key === key) return k; }
              return null;
            }
            var listWrap = document.getElementById("ffb-list");
            if (listWrap){
              listWrap.addEventListener("click", function(ev){
                var t = ev.target;
                var delEl = t;
                while (delEl && delEl !== listWrap){ if (delEl.getAttribute && delEl.getAttribute("data-del")) break; delEl = delEl.parentNode; }
                if (delEl && delEl !== listWrap && delEl.getAttribute("data-del")){
                  var dk = delEl.getAttribute("data-del");
                  var drole = roleByKey(dk);
                  if (drole){
                    // setCardSelected (not a direct flag flip) so the carousel's
                    // infinity-loop clones drop their tick too, and re-tapping the card works.
                    setCardSelected(drole, false);
                    track("kit_item_removed", { role: drole });
                    // An empty bundle with the picker collapsed strands the shopper —
                    // bring the steps back so they can choose again. If the picker is
                    // still open, leave them where they are.
                    if (!selectedItems().length && stepsCollapsed()) expandSteps(firstOpenStep());
                  }
                  return;
                }
                var rowEl = t;
                while (rowEl && rowEl !== listWrap){ if (rowEl.getAttribute && rowEl.getAttribute("data-key")) break; rowEl = rowEl.parentNode; }
                if (rowEl && rowEl !== listWrap && rowEl.getAttribute("data-key")){
                  var it = itemByKey(rowEl.getAttribute("data-key"));
                  if (it){ it.pendingAdd = false; openSheet(it); }
                }
              });
            }

            // Deleting a line in the cart drawer must also un-tick it in the bundle.
            // Otherwise the card stays selected, the bundle still lists it, and the very
            // next Buy Now puts it straight back — which reads as the cart re-adding
            // something the shopper just deleted. Gift insoles are excluded (FfCart.syncGifts
            // owns those and re-derives them from the shoes in the cart).
            // showResult() re-runs on a category-tab change, which rebuilds this whole
            // closure. Drop the previous handler first — a document-level listener
            // survives elResult.innerHTML being replaced, so it would otherwise stack up
            // and act on a stale `kit`.
            if (window.__ffCartRemovedHandler){
              document.removeEventListener("ff:cart-line-removed", window.__ffCartRemovedHandler);
            }
            window.__ffCartRemovedHandler = function(ev){
              var vid = ev && ev.detail && ev.detail.variantId;
              if (!vid) return;
              var hit = null;
              for (var k in kit){
                if (!kit.hasOwnProperty(k) || !kit[k].selected) continue;
                if (String(vVariantId(kit[k].item)) === String(vid)){ hit = k; break; }
              }
              if (!hit) return;
              setCardSelected(hit, false);   // also drops it from liveItems (the Buy Now payload)
              track("kit_item_removed_from_cart", { role: hit });
              // Deliberately NOT reopening the step picker here: showScreen() scrolls, and
              // the shopper is looking at the cart drawer, so the page would jump behind it.
              // The "Add more items" button is already showing for when they close the drawer.
            };
            document.addEventListener("ff:cart-line-removed", window.__ffCartRemovedHandler);

            syncEditBtn();
            refreshKit();
          })();
        })();
        // The hero card always shows the smart-match category; category override now lives in the bundle section.)
    
        // ── bundle category tabs: tap a tab to re-pick the bundle's footwear category ──
        (function wireBundleCatTabs(){
          var tabs = elResult.querySelectorAll(".ff-bundle-cat-tab");
          for (var i = 0; i < tabs.length; i++){
            tabs[i].addEventListener("click", function(){
              var newPref = this.getAttribute("data-pref");
              if (!newPref) return;
              track("bundle_cat_change", { from: prefForShoe, to: newPref });
              showResult(newPref);
            });
          }
        })();
    
        // ── FAQ accordion ──
        (function wireFAQ(){
          var items = elResult.querySelectorAll(".ff-faq-item");
          for (var i = 0; i < items.length; i++){
            (function(item){
              var btn = item.querySelector(".ff-faq-q");
              if (!btn) return;
              btn.addEventListener("click", function(){
                var isOpen = item.classList.contains("open");
                // close all
                for (var j = 0; j < items.length; j++) items[j].classList.remove("open");
                if (!isOpen) item.classList.add("open");
              });
            })(items[i]);
          }
        })();
    
        // ── Retake quiz: reset state and return to the start ──
        (function wireRetake(){
          var rt = document.getElementById("ff-retake");
          if (!rt) return;
          rt.addEventListener("click", function(){
            answers = {}; step = 0; kit = { shoe: true, insole: true, support: true };
            elResult.style.display = "none"; elResult.innerHTML = "";
            elIntro.style.display = "block";
            (ffRoot || document.documentElement).classList.remove("ff-in-quiz");
            track("quiz_retake", {});
            window.scrollTo(0, 0);
          });
        })();
    
        // ── Sticky page cart bar: show/hide on scroll past the diagnosis hero ──
        (function wireStickyBar(){
          var trigger = elResult.querySelector(".ff-diag-hero");
          if (!trigger) return;
          function check(){
            var bar = document.getElementById("ff-pagecart");
            if (!bar) return;
            var show = trigger.getBoundingClientRect().bottom < 0;
            bar.classList.toggle("show", show);
          }
          syncKitBarSticky = check;
          window.addEventListener("scroll", check, { passive: true });
          check();
        })();
    
        // (Dead-code zone: all the handlers below target markup we removed — wireAltCards,
        // variant-sheet handlers, retake, bundle bar, renderKit. Skipped via if(false) so the
        // page doesn't crash. Will be properly removed once the new sections are built.)
        if (false) {
    
        // ── alternative product carousel: tap a card or its add-to-cart to open the product ──
        (function wireAltCards(){
          var altBtns = elResult.querySelectorAll(".ff-alt-cart");
          for (var i = 0; i < altBtns.length; i++){
            altBtns[i].addEventListener("click", function(ev){
              ev.stopPropagation();
              var idx = parseInt(this.getAttribute("data-alt-idx"), 10);
              var p = alternatives[idx]; if (!p) return;
              track("result_alt_add_to_cart", { product: p.name });
              if (p.url) { window.open(p.url, "_blank"); }
              else { track("result_alt_no_url", { product: p.name }); }
            });
          }
          var altCards = elResult.querySelectorAll(".ff-alt-card");
          for (var j = 0; j < altCards.length; j++){
            altCards[j].addEventListener("click", function(){
              var idx = parseInt(this.getAttribute("data-alt-idx"), 10);
              var p = alternatives[idx]; if (!p) return;
              track("result_alt_view", { product: p.name });
              if (p.url) { window.open(p.url, "_blank"); }
            });
          }
        })();
    
        // ── per-product variant state ──
        // variantState[key] = { color: idx|null, size: str|null }
        var variantState = {};
        for (var vi = 0; vi < items.length; vi++){ variantState[items[vi].key] = { color: null, size: null }; }
    
        // which options does an item need?
        function itemNeeds(it){
          var needColor = (it.key === "shoe");
          var needSize = sizesFor(it.p).length > 0;
          return { color: needColor, size: needSize };
        }
        // is an item's variant fully chosen?
        function itemReady(it){
          var n = itemNeeds(it); var s = variantState[it.key];
          if (n.size && !s.size) return false;
          if (n.color && s.color == null) return false;
          return true;
        }
        // short label for the chosen variant, e.g. "Size 8 · Olive"
        function variantLabel(it){
          var n = itemNeeds(it); var s = variantState[it.key]; var bits = [];
          if (n.size && s.size) bits.push("Size " + s.size);
          if (n.color && s.color != null){ var c = colorsFor(it.p)[s.color]; if (c) bits.push(c.name); }
          return bits.join(" \u00b7 ");
        }
        // resolve the variant ID for an item given its current selection
        function itemVariant(it){
          return resolveVariant(it.p, variantState[it.key].color, variantState[it.key].size);
        }
    
        // ── bottom sheet ──
        var sheet = document.getElementById("ff-sheet");
        var overlay = document.getElementById("ff-sheet-overlay");
        var sheetBody = document.getElementById("ff-sheet-body");
        var sheetTitle = document.getElementById("ff-sheet-title");
        var sheetConfirm = document.getElementById("ff-sheet-confirm");
        var sheetItem = null;        // item currently being edited
        var draft = { color: null, size: null };
    
        function openSheet(it){
          sheetItem = it;
          draft = { color: variantState[it.key].color, size: variantState[it.key].size };
          var n = itemNeeds(it);
          sheetTitle.textContent = it.p.name;
          var h = "";
          if (n.size){
            var szs = sizesFor(it.p);
            h += '<div class="ff-sheet-section">';
            h += '<div class="ff-sheet-label">Size <span class="ff-sheet-unit">UK</span></div>';
            h += '<div class="ff-size-grid" id="ff-sheet-sizes">';
            for (var si = 0; si < szs.length; si++){
              h += '<button type="button" class="ff-size-opt" data-size="' + szs[si] + '">' + szs[si] + '</button>';
            }
            h += '</div></div>';
          }
          if (n.color){
            var cols = colorsFor(it.p);
            h += '<div class="ff-sheet-section">';
            h += '<div class="ff-sheet-label">Color<span id="ff-sheet-color-name"></span></div>';
            h += '<div class="ff-color-grid" id="ff-sheet-colors">';
            for (var ci = 0; ci < cols.length; ci++){
              // Modal swatches show the colour's variant PHOTO (hex only if none).
              var sw = cols[ci].img || cols[ci].swatch || "";
              var swStyle = (sw.indexOf("#") === 0) ? ('background:' + sw + ';') : ('background-image:url(' + sw + '); background-size:cover;');
              h += '<button type="button" class="ff-color-opt" data-ci="' + ci + '" title="' + cols[ci].name + '" style="' + swStyle + '"></button>';
            }
            h += '</div></div>';
          }
          sheetBody.innerHTML = h;
    
          // color handlers (also swap the hero photo live if this is the shoe)
          var scolors = sheetBody.querySelectorAll("#ff-sheet-colors .ff-color-opt");
          function paintColor(){
            for (var k = 0; k < scolors.length; k++){ scolors[k].classList.toggle("sel", k === draft.color); }
            var nm = document.getElementById("ff-sheet-color-name");
            if (nm && draft.color != null){ var c = colorsFor(it.p)[draft.color]; nm.textContent = c ? (" \u00b7 " + c.name) : ""; }
            if (it.key === "shoe" && draft.color != null){
              var c2 = colorsFor(it.p)[draft.color];
              var imgWrap = document.getElementById("ff-hero-img");
              if (imgWrap && c2 && c2.img){ imgWrap.innerHTML = '<img src="' + c2.img + '" alt="' + it.p.name + '" loading="lazy">'; }
            }
          }
          for (var sc = 0; sc < scolors.length; sc++){
            (function(idx){ scolors[idx].addEventListener("click", function(){ draft.color = idx; paintColor(); refreshConfirm(); }); })(sc);
          }
          if (scolors.length){ if (draft.color == null) draft.color = 0; paintColor(); }
    
          // size handlers
          var ssizes = sheetBody.querySelectorAll("#ff-sheet-sizes .ff-size-opt");
          function paintSize(){
            for (var k = 0; k < ssizes.length; k++){ ssizes[k].classList.toggle("sel", ssizes[k].getAttribute("data-size") === draft.size); }
          }
          for (var ss = 0; ss < ssizes.length; ss++){
            ssizes[ss].addEventListener("click", function(){ draft.size = this.getAttribute("data-size"); paintSize(); refreshConfirm(); });
          }
          // Gender-sized products open on the quiz's own answer (see ffGenderSize).
          if (n.size && !draft.size){ var gd0 = ffGenderSize(it.p); if (gd0) draft.size = gd0; }
          paintSize();
          refreshConfirm();
    
          overlay.classList.add("show");
          sheet.classList.add("show");
          ffLockScroll(true);
        }
        function refreshConfirm(){
          var n = itemNeeds(sheetItem);
          var ok = (!n.size || draft.size) && (!n.color || draft.color != null);
          sheetConfirm.disabled = !ok;
        }
        function closeSheet(){
          overlay.classList.remove("show");
          sheet.classList.remove("show");
          ffLockScroll(false);
          sheetItem = null;
        }
        overlay.addEventListener("click", closeSheet);
        document.getElementById("ff-sheet-close").addEventListener("click", closeSheet);
        sheetConfirm.addEventListener("click", function(){
          if (!sheetItem) return;
          variantState[sheetItem.key].color = draft.color;
          variantState[sheetItem.key].size = draft.size;
          track("variant_selected", { item: sheetItem.key, size: draft.size, color: draft.color });
          closeSheet();
          repaintKit();
        });
        // expose opener for kit cards
        window.__ffOpenSheet = openSheet;
    
        // ── details bottom sheet ──
        var detSheet = document.getElementById("ff-det-sheet");
        var detOverlay = document.getElementById("ff-det-overlay");
        var detBody = document.getElementById("ff-det-body");
        var detTitle = document.getElementById("ff-det-title");
        function openDetails(it){
          var d = detailsFor(it.p);
          detTitle.textContent = it.p.name;
          var h = "";
          // gallery
          var main = d.images.length ? d.images[0] : (it.p.img || "");
          h += '<div class="ff-det-gallery">';
          h += '<div class="ff-det-main" id="ff-det-main">' + (main ? '<img src="' + main + '" alt="' + it.p.name + '">' : it.p.icon) + '</div>';
          if (d.images.length > 1){
            h += '<div class="ff-det-thumbs" id="ff-det-thumbs">';
            for (var gi = 0; gi < d.images.length; gi++){
              h += '<button type="button" class="ff-det-thumb ' + (gi === 0 ? "sel" : "") + '" data-img="' + d.images[gi] + '"><img src="' + d.images[gi] + '" alt="" loading="lazy"></button>';
            }
            h += '</div>';
          }
          h += '</div>';
          // price
          var off = Math.round((1 - it.p.price / it.p.mrp) * 100);
          h += '<div class="ff-det-price"><span class="ff-det-now">\u20b9' + fmt(it.p.price) + '</span><span class="ff-det-was">\u20b9' + fmt(it.p.mrp) + '</span><span class="ff-det-off">' + off + '% OFF</span></div>';
          // color swatches (footwear only)
          if (it.key === "shoe"){
            var cols = colorsFor(it.p);
            if (cols.length){
              h += '<div class="ff-det-section"><div class="ff-sheet-label">Colors</div><div class="ff-color-grid">';
              for (var ci = 0; ci < cols.length; ci++){
                // Modal swatches show the colour's variant PHOTO (hex only if none).
                var sw = cols[ci].img || cols[ci].swatch || "";
                var swStyle = (sw.indexOf("#") === 0) ? ('background:' + sw + ';') : ('background-image:url(' + sw + '); background-size:cover;');
                h += '<span class="ff-color-opt static" title="' + cols[ci].name + '" style="' + swStyle + '"></span>';
              }
              h += '</div></div>';
            }
          }
          // description
          if (d.description){
            h += '<div class="ff-det-section"><div class="ff-sheet-label">Description</div><p class="ff-det-desc">' + d.description + '</p></div>';
          }
          // collapsible product details
          var keys = [];
          for (var dk in d.details){ if (d.details.hasOwnProperty(dk)) keys.push(dk); }
          // fallback details if none supplied
          if (!keys.length){
            d.details = { Rating: it.p.rating + " (" + it.p.reviews + " reviews)", Returns: "7-day easy returns", Delivery: "Cash on delivery available" };
            keys = ["Rating", "Returns", "Delivery"];
          }
          h += '<div class="ff-det-section"><button type="button" class="ff-det-toggle" id="ff-det-toggle">Product details<span class="ff-det-chev" id="ff-det-chev">' + ICON.chev + '</span></button>';
          h += '<div class="ff-det-rows" id="ff-det-rows">';
          for (var ki = 0; ki < keys.length; ki++){
            h += '<div class="ff-det-row"><span class="ff-det-k">' + keys[ki] + '</span><span class="ff-det-v">' + d.details[keys[ki]] + '</span></div>';
          }
          h += '</div></div>';
    
          detBody.innerHTML = h;
    
          // thumbnail switching
          var thumbs = detBody.querySelectorAll(".ff-det-thumb");
          for (var tb = 0; tb < thumbs.length; tb++){
            thumbs[tb].addEventListener("click", function(){
              var src = this.getAttribute("data-img");
              var mainWrap = document.getElementById("ff-det-main");
              if (mainWrap){ mainWrap.innerHTML = '<img src="' + src + '" alt="' + it.p.name + '">'; }
              for (var q = 0; q < thumbs.length; q++){ thumbs[q].classList.remove("sel"); }
              this.classList.add("sel");
            });
          }
          // details dropdown toggle (open by default)
          var rows = document.getElementById("ff-det-rows");
          var chev = document.getElementById("ff-det-chev");
          var tog = document.getElementById("ff-det-toggle");
          if (tog){
            tog.addEventListener("click", function(){
              var open = rows.classList.toggle("open");
              if (chev) chev.classList.toggle("up", open);
            });
            rows.classList.add("open"); if (chev) chev.classList.add("up");
          }
    
          track("view_details", { item: it.key });
          detOverlay.classList.add("show");
          detSheet.classList.add("show");
          ffLockScroll(true);
        }
        function closeDetails(){
          detOverlay.classList.remove("show");
          detSheet.classList.remove("show");
          ffLockScroll(false);
        }
        detOverlay.addEventListener("click", closeDetails);
        document.getElementById("ff-det-close").addEventListener("click", closeDetails);
        window.__ffOpenDetails = openDetails;
    
        // now that variant state + sheet are ready, render the kit cards
        renderKit(items);
    
        document.getElementById("ff-retake").addEventListener("click", function(){
          answers = {}; step = 0; kit = { shoe: true, insole: true, support: true };
          elResult.style.display = "none"; elResult.innerHTML = ""; elIntro.style.display = "block"; track("quiz_retake", {});
          var hc = document.getElementById("ff-cart-fab");
          if (hc) hc.style.display = "none";
        });
    
        document.getElementById("ff-bundle-btn").addEventListener("click", function(e){
          e.preventDefault();
          var chosen = items.filter(function(it){ return kit[it.key]; });
          // find the first kept item still missing a required variant
          var missing = null;
          for (var m = 0; m < chosen.length; m++){ if (!itemReady(chosen[m])){ missing = chosen[m]; break; } }
          if (missing){
            var card = document.querySelector('.ff-card[data-k="' + missing.key + '"]');
            if (card){
              card.classList.remove("shake"); void card.offsetWidth; card.classList.add("shake");
              card.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            openSheet(missing);
            return;
          }
          var vids = chosen.map(function(it){ return itemVariant(it) || it.p.vid; }).filter(Boolean);
          var full = 0; for (var i = 0; i < chosen.length; i++){ full += chosen[i].p.price; }
          var cnt = chosen.length;
          var rate = cnt >= 3 ? 0.15 : (cnt === 2 ? 0.10 : 0);
          var finalPrice = Math.round(full * (1 - rate));
          RECORD.kit = { shoe: kit.shoe, insole: kit.insole, support: kit.support };
          RECORD.variants = {};
          for (var v2 = 0; v2 < chosen.length; v2++){
            RECORD.variants[chosen[v2].key] = { size: variantState[chosen[v2].key].size, color: variantLabel(chosen[v2]) || null };
          }
          RECORD.bundle = { itemsKept: cnt, fullPrice: full, finalPrice: finalPrice, saved: full - finalPrice, discountRate: rate };
          track("add_kit_to_cart", { condition: r.condition, items: chosen.length, vids: vids.join(",") });
          sendData(RECORD, "add_kit_to_cart");
          if (vids.length){
            window.FfCart.addAndOpen(vids.map(function(v){ return { id: v, qty: 1 }; }));
          } else {
            var withUrl = chosen.filter(function(it){ return it.p.url; });
            if (withUrl.length){ window.open(withUrl[0].p.url, "_blank"); }
            else { alert("Add real variant IDs to enable one-click bundle checkout."); }
          }
        });
    
    
        function renderKit(items){
          var list = document.getElementById("ff-kit-list");
          function paint(){
            var h = "";
            for (var i = 0; i < items.length; i++){
              var it = items[i]; var on = kit[it.key];
              var needs = itemNeeds(it);
              var hasOpts = needs.size || needs.color;
              h += '<div class="ff-card ' + (on ? "on" : "off") + '" data-k="' + it.key + '">';
              h += '<div class="ff-check-box" data-toggle="' + it.key + '">' + ICON.check + '</div>';
              h += '<div class="ff-card-img">' + (it.p.img ? '<img src="' + it.p.img + '" alt="' + it.p.name + '" loading="lazy">' : it.p.icon) + '</div>';
              h += '<div class="ff-card-body"><div class="ff-card-role">' + it.role + '</div>';
              h += '<div class="ff-card-name">' + it.p.name + '</div><div class="ff-card-tag">' + it.p.tag + '</div>';
              h += '<div class="ff-card-actions">';
              if (hasOpts){
                var ready = itemReady(it);
                var lbl = ready ? variantLabel(it) : ((it.key === "shoe" && needs.color) ? "Select size & color" : "Select size");
                h += '<button type="button" class="ff-variant-pill ' + (ready ? "set" : "") + '" data-opts="' + it.key + '">' + (ready ? (ICON.check + ' ') : "") + lbl + '</button>';
              }
              h += '<button type="button" class="ff-details-link" data-det="' + it.key + '">View details</button>';
              h += '</div>';
              h += '</div>';
              h += '<div class="ff-card-right"><div class="ff-card-price">\u20b9' + fmt(it.p.price) + '</div>';
              h += '<div class="ff-card-mrp">\u20b9' + fmt(it.p.mrp) + '</div>';
              h += '</div></div>';
            }
            list.innerHTML = h;
            // checkbox toggles keep/remove
            var boxes = list.querySelectorAll(".ff-check-box");
            for (var b = 0; b < boxes.length; b++){
              boxes[b].addEventListener("click", function(e){
                e.stopPropagation();
                var k = this.getAttribute("data-toggle"); kit[k] = !kit[k];
                track("kit_toggle", { item: k, on: kit[k] }); paint(); updateBundle();
              });
            }
            // variant pill opens the sheet
            var pills = list.querySelectorAll(".ff-variant-pill");
            for (var pp = 0; pp < pills.length; pp++){
              pills[pp].addEventListener("click", function(e){
                e.stopPropagation();
                var k = this.getAttribute("data-opts");
                var it2 = null; for (var z = 0; z < items.length; z++){ if (items[z].key === k) it2 = items[z]; }
                if (it2 && window.__ffOpenSheet) window.__ffOpenSheet(it2);
              });
            }
            // "View details" opens the details sheet
            var dls = list.querySelectorAll(".ff-details-link");
            for (var dl = 0; dl < dls.length; dl++){
              dls[dl].addEventListener("click", function(e){
                e.stopPropagation();
                var k = this.getAttribute("data-det");
                var it3 = null; for (var z2 = 0; z2 < items.length; z2++){ if (items[z2].key === k) it3 = items[z2]; }
                if (it3 && window.__ffOpenDetails) window.__ffOpenDetails(it3);
              });
            }
          }
          window.repaintKit = paint;
          function updateBundle(){
            var chosen = items.filter(function(it){ return kit[it.key]; });
            var full = 0, count = chosen.length;
            for (var i = 0; i < chosen.length; i++){ full += chosen[i].p.price; }
            // bundle % discount DISABLED for launch (unbacked at checkout) — see bundlePctForCount.
            var rate = 0;
            var nowPrice = Math.round(full * (1 - rate));
            var saved = full - nowPrice;
            var btn = document.getElementById("ff-bundle-btn");
            var mile = document.getElementById("ff-milestone");
            if (count === 0){
              if (mile){ mile.className = "ff-milestone"; mile.innerHTML = ""; }
              document.getElementById("ff-bundle-label").textContent = "No items selected";
              document.getElementById("ff-bundle-prices").innerHTML = '<span class="ff-bundle-now">\u20b90</span>';
              if (btn){ btn.style.opacity = "0.4"; btn.style.pointerEvents = "none"; }
              return;
            }
            if (btn){ btn.style.opacity = ""; btn.style.pointerEvents = ""; }
            // progressive milestone: current reward + next nudge
            // The 10%/15% "unlock" nudges are gone with the bundle discount - nothing
            // backs them at checkout, so promising them would misstate the price.
            if (mile){ mile.className = "ff-milestone"; mile.innerHTML = ""; }
            document.getElementById("ff-bundle-label").textContent = (count === 3) ? "Complete Relief Bundle \u00b7 3 items" : (count + " item" + (count !== 1 ? "s" : "") + " selected");
            var pr = '<span class="ff-bundle-now">\u20b9' + fmt(nowPrice) + '</span>';
            if (saved > 0){ pr += '<span class="ff-bundle-was">\u20b9' + fmt(full) + '</span><span class="ff-bundle-save">Save \u20b9' + fmt(saved) + '</span>'; }
            document.getElementById("ff-bundle-prices").innerHTML = pr;
          }
          paint(); updateBundle();
        }
        } // end if(false) dead-code wrapper
      }
    
      // init embedded Q1 starter on the intro; restore completed quiz from this tab session
      renderStarter();
      restoreSession();
    
      // Toggle .ff-past-intro on #ff-root whenever the intro section becomes hidden.
      // Used by the sticky bottom CTA + help floater to know when to step aside.
      (function watchIntroVisibility(){
        if (!elIntro) return;
        function sync(){
          var hidden = (elIntro.style.display === "none");
          (ffRoot || document.documentElement).classList.toggle("ff-past-intro", hidden);
        }
        sync(); // initial pass
        var mo = new MutationObserver(sync);
        mo.observe(elIntro, { attributes: true, attributeFilter: ["style"] });
      })();
    
      // Reveal the sticky bottom CTA only when the hero CTA has scrolled out of view.
      // Uses IntersectionObserver — when hero CTA is intersecting the viewport, sticky is hidden.
      (function watchHeroCtaVisibility(){
        var heroCta = document.getElementById("ff-start");
        if (!heroCta || typeof IntersectionObserver === "undefined") return;
        var io = new IntersectionObserver(function(entries){
          for (var i = 0; i < entries.length; i++){
            var visible = entries[i].isIntersecting;
            (ffRoot || document.documentElement).classList.toggle("ff-sticky-visible", !visible);
          }
        }, { threshold: 0, rootMargin: "0px 0px -20px 0px" });
        io.observe(heroCta);
      })();
    
    })();
    
    // ── help floater (icon crossfade + expand panel) ──
    (function helpFloater(){
      var fab = document.getElementById("ff-help-fab");
      var panel = document.getElementById("ff-help-panel");
      var closeBtn = document.getElementById("ff-help-close");
      if (!fab || !panel) return;
    
      function openPanel(){
        panel.classList.add("open");
        fab.setAttribute("aria-expanded", "true");
      }
      function closePanel(){
        panel.classList.remove("open");
        fab.setAttribute("aria-expanded", "false");
      }
      fab.addEventListener("click", function(e){
        e.stopPropagation();
        if (panel.classList.contains("open")) closePanel(); else openPanel();
      });
      if (closeBtn) closeBtn.addEventListener("click", function(e){ e.stopPropagation(); closePanel(); });
      // close on outside click
      document.addEventListener("click", function(e){
        if (!panel.classList.contains("open")) return;
        if (panel.contains(e.target) || fab.contains(e.target)) return;
        closePanel();
      });
      // close on Esc
      document.addEventListener("keydown", function(e){ if (e.key === "Escape") closePanel(); });
    
      // alternate the icon every 2s (drives a CSS keyframe trigger via a data attr)
      var which = 0;
      setInterval(function(){
        which = which ? 0 : 1;
        fab.setAttribute("data-icon", which ? "wa" : "video");
      }, 2000);
      fab.setAttribute("data-icon", "video");
    })();
    
    // ── review carousel dot navigation ──
    // (conditions section uses native horizontal scroll — no JS needed)
    
    (function reviewCarousels(){
      var dots = document.querySelectorAll(".ff-review-dot");
      for (var i = 0; i < dots.length; i++){
        dots[i].addEventListener("click", function(){
          var idx = this.getAttribute("data-i");
          var hero = this.parentElement && this.parentElement.parentElement;
          if (hero) hero.setAttribute("data-active", idx);
        });
      }
    })();
    // ── "We help with" footprint hotspots ──
    (function helpsFoot(){
      var ZONE_INDEX = { heel: 0, arch: 1, ball: 2 };
      function trigger(zone){
        var idx = ZONE_INDEX[zone];
        if (idx == null) return;
        // record Q1 answer and start the name interstitial → quiz
        var q1 = (window.__QUESTIONS_REF || null);
        var rec = (window.__RECORD_REF || null);
        if (window.__startFromZone){ window.__startFromZone(idx); }
      }
      var nodes = document.querySelectorAll(".ff-helps-row, .ff-foot-hot");
      for (var i = 0; i < nodes.length; i++){
        nodes[i].style.cursor = "pointer";
        nodes[i].addEventListener("click", function(){
          var z = this.getAttribute("data-zone");
          trigger(z);
        });
      }
    })();

/* ══════════════════════════════════════════════════════════════════════════
   FfCart — same-origin AJAX cart + sliding drawer (native theme)
   Replaces the old permalink-redirect. Add-to-cart POSTs to /cart/add.js on the
   CURRENT origin, then renders + slides in the drawer. Checkout is deferred
   (GoKwik lands in checkout() later); "Proceed to Checkout" uses standard
   same-origin /checkout for now so the cart is functional end-to-end.
   ══════════════════════════════════════════════════════════════════════════ */
(function FfCartModule(){
  "use strict";
  function money(cents){ var r = Math.round((cents || 0) / 100); return "₹" + r.toLocaleString("en-IN"); }
  // Shopify's failure text contains the product title (quotes and all), so it must be
  // escaped before it goes anywhere near innerHTML.
  function esc(s){
    return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
      return c === "&" ? "&amp;" : c === "<" ? "&lt;" : c === ">" ? "&gt;" : "&quot;";
    });
  }
  function isGift(it){
    var gp = it && it.properties;
    return !!(gp && (gp._free_gift === "true" || gp._free_gift === true));
  }
  var mountRoot, overlay, drawer, bodyEl, footEl, fab, badge, mounted = false;
  // Reason the last add failed, so the drawer can say WHY instead of "try again".
  var lastAddError = null;
  // Latest cart we painted (server truth OR an optimistic projection of it). Every
  // qty tap renders off this immediately, so the drawer never waits on the network.
  var lastCart = null;
  var checkingOut = false;
  // Mutations the shopper has asked for that the server hasn't caught up with yet.
  // While this is > 0 the optimistic projection is AHEAD of every server response in
  // flight, so painting one of those responses would resurrect a line the shopper has
  // already deleted (it reappears, then vanishes when the next response lands). Only
  // the write that drains the queue is allowed to paint.
  var pendingWrites = 0;
  function endWrite(){ if (pendingWrites > 0) pendingWrites--; }
  // Shopify serialises cart writes per session anyway, so queue ours rather than
  // letting rapid taps race and land out of order.
  var opQueue = Promise.resolve();
  function enqueue(fn){
    var run = opQueue.then(fn, fn);
    opQueue = run.then(function(){ return null; }, function(){ return null; });
    return run;
  }

  function ensureMounted(){
    if (mounted) return;
    mountRoot = document.body;
    overlay = document.getElementById("ff-cart-overlay");
    if (!overlay){ overlay = document.createElement("div"); overlay.id = "ff-cart-overlay"; overlay.className = "ff-cart-overlay"; mountRoot.appendChild(overlay); }
    drawer = document.getElementById("ff-cart-drawer");
    if (!drawer){
      drawer = document.createElement("aside");
      drawer.id = "ff-cart-drawer"; drawer.className = "ff-cart-drawer";
      drawer.setAttribute("role", "dialog"); drawer.setAttribute("aria-label", "Your cart");
      drawer.innerHTML =
        '<div class="ff-cart-drawer-head"><span class="ff-cart-drawer-title">Your Cart</span>' +
        '<button type="button" class="ff-cart-drawer-close" id="ff-cart-drawer-close" aria-label="Close cart">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>' +
        '<div class="ff-cart-drawer-scroll" id="ff-cart-body"></div>' +
        '<div class="ff-cart-drawer-foot" id="ff-cart-foot"></div>';
      mountRoot.appendChild(drawer);
    }
    bodyEl = document.getElementById("ff-cart-body");
    footEl = document.getElementById("ff-cart-foot");
    fab = document.getElementById("ff-cart-fab");
    badge = document.getElementById("ff-cart-fab-badge");
    overlay.addEventListener("click", close);
    var cb = document.getElementById("ff-cart-drawer-close");
    if (cb) cb.addEventListener("click", close);
    if (fab) fab.addEventListener("click", function(e){ e.preventDefault(); openAndRefresh(); });
    // Delegated once. render() rewrites the list on every paint (including the optimistic
    // one on each tap), so per-button listeners would be rebound constantly.
    if (bodyEl) bodyEl.addEventListener("click", onBodyClick);
    mounted = true;
  }

  function onBodyClick(ev){
    var t = ev.target;
    while (t && t !== bodyEl && !(t.getAttribute && t.getAttribute("data-key"))) t = t.parentNode;
    if (!t || t === bodyEl || !t.getAttribute) return;
    var key = t.getAttribute("data-key");
    var qty = parseInt(t.getAttribute("data-qty"), 10);
    if (!key || isNaN(qty)) return;
    changeQty(key, qty);
  }

  function open(){ ensureMounted(); drawer.classList.add("open"); overlay.classList.add("show"); document.body.style.overflow = "hidden"; }
  function close(){ if (!drawer) return; drawer.classList.remove("open"); overlay.classList.remove("show"); document.body.style.overflow = ""; }

  function cartGet(){ return fetch("/cart.js?ff=" + (new Date().getTime()), { headers: { Accept: "application/json" }, credentials: "same-origin", cache: "no-store" }).then(function(r){ return r.json(); }); }
  function cartAdd(items){ return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin", body: JSON.stringify({ items: items }) }).then(function(r){ if (!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); }); }
  function cartChange(key, qty){ return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin", body: JSON.stringify({ id: key, quantity: qty }) }).then(function(r){ return r.json(); }); }

  function normalize(items){
    return (items || []).map(function(it){
      if (it && typeof it === "object" && it.id != null){ return { id: it.id, quantity: it.qty || it.quantity || 1, properties: it.properties || { _ff_source: "frido-footwear-quiz" } }; }
      return { id: it, quantity: 1, properties: { _ff_source: "frido-footwear-quiz" } };
    }).filter(function(x){ return x.id; });
  }

  function updateBadge(count){
    if (!fab) fab = document.getElementById("ff-cart-fab");
    if (!badge) badge = document.getElementById("ff-cart-fab-badge");
    if (fab) fab.style.display = "inline-flex"; // always-visible header cart button
    if (badge){ badge.textContent = count; badge.style.display = count > 0 ? "flex" : "none"; }
  }

  function render(cart, optimistic){
    ensureMounted();
    lastCart = cart;
    updateBadge(cart.item_count || 0);
    // Keep the latest cart available to the abandoned-cart tracker + refresh its idle watch.
    // Optimistic paints are a local projection, not server truth — don't report them as the
    // cart snapshot; the reconciled render a beat later does that.
    if (!optimistic){
      try { window.__ffLastCart = cart; if (window.FfAbandon && window.FfAbandon.onCartChange) window.FfAbandon.onCartChange(); } catch (e) {}
    }
    if (!cart.items || !cart.items.length){
      bodyEl.innerHTML = '<div class="ff-cart-empty">Your cart is empty.</div>';
      footEl.innerHTML = "";
      return cart;
    }
    var h = "";
    var mrpSum = 0; // sum of compare-at (MRP) line totals, for the savings line
    var pricer = (window.FfShopify && window.FfShopify.variantPricingCents) ? window.FfShopify.variantPricingCents : null;
    // A gift insole reads at FULL price until the BXGY code is on the cart session, and
    // at ₹0 after — and the code is only applied on the checkout tap. That made the same
    // cart show ₹699 or ₹0 depending on whether the shopper had already tried checkout.
    // Gift lines are always shown as Free, and `giftUnbilled` is what the cart still
    // charges for them, so the subtotal below reflects the same promise either way.
    var giftUnbilled = 0;
    for (var gu = 0; gu < cart.items.length; gu++){
      if (isGift(cart.items[gu])) giftUnbilled += (cart.items[gu].final_line_price || 0);
    }
    for (var i = 0; i < cart.items.length; i++){
      var it = cart.items[i];
      var gift = isGift(it);
      var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, "_120x$1$2") : "";
      var pr = pricer ? pricer(it.variant_id) : null;
      var mrpLine = (pr && pr.cmp) ? pr.cmp * it.quantity : 0;
      // A free gift's "was" price is its own selling price when there's no compare-at,
      // otherwise the strike-through would be missing and it'd just look like ₹0.
      if (gift && !mrpLine) mrpLine = (it.original_line_price || it.line_price || it.final_line_price || 0);
      var shownLine = gift ? 0 : it.final_line_price;
      mrpSum += (mrpLine > shownLine) ? mrpLine : shownLine;
      h += '<div class="ff-cart-item">';
      h += '<div class="ff-cart-item-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>';
      h += '<div class="ff-cart-item-main">';
      h += '<div class="ff-cart-item-title">' + it.product_title + '</div>';
      if (it.variant_title && it.variant_title !== "Default Title"){ h += '<div class="ff-cart-item-variant">' + it.variant_title + '</div>'; }
      h += '<div class="ff-cart-item-row">';
      h += '<div class="ff-cart-qty"><button type="button" class="ff-cart-qtybtn" data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" class="ff-cart-qtybtn" data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '">+</button></div>';
      h += '<span class="ff-cart-item-price' + (gift ? ' ff-cart-item-price--free' : '') + '">' + (gift ? "Free" : money(shownLine));
      if (mrpLine > shownLine){ h += '<span class="ff-cart-item-mrp">' + money(mrpLine) + '</span>'; }
      h += '</span>';
      h += '</div></div>';
      h += '<button type="button" class="ff-cart-item-remove" data-key="' + it.key + '" data-qty="0" aria-label="Remove item">×</button>';
      h += '</div>';
    }
    bodyEl.innerHTML = h;
    // Subtotal net of anything the cart still bills for the free insoles, so it matches
    // the "Free" lines above whether or not the BXGY code has been applied yet.
    var shownTotal = Math.max(0, (cart.total_price || 0) - giftUnbilled);
    var saved = mrpSum - shownTotal;
    // Trust marker: reassure the shopper whenever a free-gift insole is present
    // (syncGifts only seeds one when a shoe is in the cart, so its presence already
    // means the discount applies).
    var freeUnits = 0;
    for (var g = 0; g < cart.items.length; g++){
      if (isGift(cart.items[g])) freeUnits += (cart.items[g].quantity || 1);
    }
    var giftNote = (freeUnits > 0)
      ? '<div class="ff-cart-giftnote"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
        '<span>' + (freeUnits === 1 ? 'Your insole is free' : 'Your ' + freeUnits + ' insoles are free') + ' — discount applied at checkout</span></div>'
      : '';

    footEl.innerHTML =
      (saved > 0 ? '<div class="ff-cart-savings"><span>You save</span><span class="ff-cart-savings-val">' + money(saved) + '</span></div>' : '') +
      '<div class="ff-cart-subtotal"><span>Subtotal</span><span class="ff-cart-subtotal-val">' + money(shownTotal) + '</span></div>' +
      giftNote +
      '<button type="button" class="ff-cta ff-cart-checkout" id="ff-cart-checkout">Proceed to Checkout</button>';
    // Qty / remove taps are handled by the delegated listener wired in ensureMounted().
    var co = document.getElementById("ff-cart-checkout");
    if (co){
      co.addEventListener("click", checkout);
      // footEl is rebuilt on every paint, so a checkout already in flight has to
      // re-apply its own busy state to the fresh button.
      if (checkingOut){ co.disabled = true; co.classList.add("is-loading"); co.textContent = "Preparing checkout…"; }
    }
    return cart;
  }

  // Project a qty change onto the cart we already hold so the drawer updates on tap
  // instead of after the round trip. Corrected by the server render that follows.
  function projectQty(cart, key, qty){
    if (!cart || !cart.items) return null;
    var out = {
      items: [], total_price: 0, item_count: 0,
      discount_codes: cart.discount_codes,
      cart_level_discount_applications: cart.cart_level_discount_applications
    };
    var found = false;
    for (var i = 0; i < cart.items.length; i++){
      var it = cart.items[i];
      var isTarget = (it.key === key);
      if (isTarget) found = true;
      var q = isTarget ? qty : it.quantity;
      if (q <= 0) continue;
      var unit = (it.final_price != null) ? it.final_price : (it.price || 0);
      var copy = {};
      for (var k in it){ if (it.hasOwnProperty(k)) copy[k] = it[k]; }
      copy.quantity = q;
      copy.final_line_price = unit * q;
      copy.line_price = ((it.price != null) ? it.price : unit) * q;
      copy.original_line_price = ((it.original_price != null) ? it.original_price : unit) * q;
      out.items.push(copy);
      out.total_price += copy.final_line_price;
      out.item_count += q;
    }
    return found ? out : null;
  }

  // A quiz-sourced line deleted here must also leave the bundle, or the next Buy Now
  // re-adds it. Gift insoles are skipped — syncGifts re-derives those from the shoes.
  function announceRemoval(cart, key){
    if (!cart || !cart.items) return;
    for (var i = 0; i < cart.items.length; i++){
      if (cart.items[i].key !== key) continue;
      var it = cart.items[i];
      var gp = it.properties;
      if (gp && (gp._free_gift === "true" || gp._free_gift === true)) return;
      try {
        document.dispatchEvent(new CustomEvent("ff:cart-line-removed", {
          detail: { variantId: String(it.variant_id), handle: it.handle, title: it.product_title }
        }));
      } catch (e) {}
      return;
    }
  }

  function changeQty(key, qty){
    var before = lastCart;
    var projected = projectQty(before, key, qty);
    if (projected) render(projected, true);          // instant feedback
    if (qty <= 0) announceRemoval(before, key);
    pendingWrites++;
    return enqueue(function(){
      // Promise.resolve() first so a synchronous throw becomes a rejection the handler
      // below can see — otherwise endWrite() is skipped and pendingWrites stays stuck
      // above zero, silently freezing every future repaint.
      return Promise.resolve().then(function(){ return cartChange(key, qty); }).then(function(cart){
        // Drop our claim BEFORE reconciling, so the write that empties the queue is the
        // one that paints server truth; earlier ones stay silent.
        endWrite();
        // /cart/change.js returns the whole updated cart — reuse it instead of re-fetching.
        return syncGifts(cart && cart.item_count != null ? cart : null);
      }, function(){ endWrite(); return refresh(); });
    });
  }

  var refreshSeq = 0, busy = false;
  // Only the most-recent paint wins; and never paint mid-add (busy) so a stale/empty
  // cart can't flicker over the "Adding…" state before the item lands.
  function paintCart(cart, seq){
    if (!cart || !cart.items) return cart;
    if (seq != null && seq !== refreshSeq) return cart;
    // Another tap is still queued behind this response — it is already reflected on
    // screen, and this cart predates it. Leave the optimistic view alone.
    if (pendingWrites > 0) return cart;
    if (!busy) render(cart);
    return cart;
  }
  function refresh(){
    var seq = ++refreshSeq;
    return cartGet().then(function(cart){ return paintCart(cart, seq); });
  }
  function openAndRefresh(){ open(); return refresh(); }

  function addAndOpen(items){
    var payload = normalize(items);
    if (!payload.length) return Promise.resolve(null);
    ensureMounted();
    open();
    bodyEl.innerHTML = '<div class="ff-cart-empty">Adding to your cart…</div>';
    busy = true; // suppress other refreshes from rendering mid-add
    // Queued alongside qty changes so an add can't interleave with a pending
    // remove and have the two land against each other's stale view of the cart.
    pendingWrites++;
    lastAddError = null;
    return enqueue(function(){
      // Same synchronous-throw guard as changeQty — see the note there.
      return Promise.resolve().then(function(){ return cartAdd(payload); }).catch(function(e){
        // Atomic /cart/add.js failed (e.g. one variant is sold out) — retry item-by-item
        // so the available products still land in the cart instead of failing the whole bundle.
        // Keep the reason: Shopify names the exact product and why ("… is already sold
        // out"), which is far more use to the shopper than "please try again". Stock can
        // change between page load and Buy Now, so this path is reachable in normal use.
        lastAddError = e || lastAddError;
        var chain = Promise.resolve();
        payload.forEach(function(it){
          chain = chain.then(function(){ return cartAdd([it]).catch(function(e2){ lastAddError = e2 || lastAddError; }); });
        });
        return chain;
      }).then(function(){ busy = false; endWrite(); return syncGifts(); }, function(){ busy = false; endWrite(); return refresh(); }).then(function(cart){
        var why = lastAddError && (lastAddError.description || lastAddError.message);
        if ((!cart || !cart.items || !cart.items.length) && bodyEl){
          bodyEl.innerHTML = '<div class="ff-cart-empty">' + esc(why || "Couldn’t add to cart. Please try again.") + '</div>';
        } else if (why && bodyEl){
          // Part of the bundle landed and part didn't — say which, instead of silently
          // dropping it and leaving the shopper to notice a missing line themselves.
          bodyEl.insertAdjacentHTML("afterbegin", '<div class="ff-cart-warn">' + esc(why) + '</div>');
        }
        return cart;
      });
    });
  }

  // Reconcile the cart's free-gift insole lines so there is exactly one free insole
  // per shoe UNIT, as computed by the result page (window.__ffComputeInsoleNeeds →
  // { insoleVariantId: qty }, size-matched per shoe). Adds missing, fixes quantities,
  // removes stale/duplicate/orphaned insoles (e.g. after the last shoe is removed).
  // Idempotent — only writes when the cart differs. Guard: if the result page hasn't
  // installed the computer yet, do nothing rather than wipe existing gifts.
  // `known` is a cart the caller already fetched (e.g. the /cart/change.js response), so
  // the common "nothing to reconcile" case costs ZERO extra round trips: we diff against
  // it and paint it. Only a genuine mismatch spends writes.
  function syncGifts(known){
    var seq = ++refreshSeq;
    if (typeof window.__ffComputeInsoleNeeds !== "function"){
      return known ? Promise.resolve(paintCart(known, seq)) : refresh();
    }
    function mkChange(k, q){
      return function(){
        return cartChange(k, q).then(function(c){ return (c && c.item_count != null) ? c : null; }, function(){ return null; });
      };
    }
    function mkAdd(v, q){
      return function(){
        // /cart/add.js answers with the added lines, not the cart — force a re-read after.
        return cartAdd([{ id: v, quantity: q, properties: { _ff_source: "frido-footwear-quiz", _free_gift: "true" } }])
          .then(function(){ return null; }, function(){ return null; });
      };
    }
    var first = (known && known.items) ? Promise.resolve(known) : cartGet();
    return first.then(function(cart){
      var desired = window.__ffComputeInsoleNeeds(cart) || {}; // { variantId(String): qty }
      var items = (cart && cart.items) || [];
      var ops = [];
      var seen = {};
      for (var i = 0; i < items.length; i++){
        var it = items[i];
        var gift = it.properties && (it.properties._free_gift === "true" || it.properties._free_gift === true);
        if (!gift) continue;
        var vid = String(it.variant_id);
        var want = desired[vid] || 0;
        if (want > 0 && !seen[vid]){
          seen[vid] = true;
          if (it.quantity !== want) ops.push(mkChange(it.key, want));
        } else {
          ops.push(mkChange(it.key, 0)); // unwanted / duplicate / orphan
        }
      }
      Object.keys(desired).forEach(function(vid){
        if (seen[vid] || !(desired[vid] > 0)) return;
        ops.push(mkAdd(vid, desired[vid]));
      });
      // Already correct — paint what we have and stop. No writes, no re-fetch, no timer.
      if (!ops.length) return paintCart(cart, seq);
      var chain = Promise.resolve(null);
      ops.forEach(function(op){ chain = chain.then(op); });
      return chain.then(function(last){
        if (last && last.items) return paintCart(last, seq);   // reuse the final change response
        return cartGet().then(function(c){ return paintCart(c, seq); });
      });
    }).catch(function(){ return refresh(); });
  }

  // ── Free-insole discount (single Buy-X-Get-Y code) ─────────────────────────
  // The store backs the free insole with ONE Buy-X-Get-Y CODE: buy 1 from the shoes
  // collection → get 1 from the insoles collection free, with no per-order cap so it
  // scales to N shoes → N free insoles. GoKwik does not auto-apply codes, so before
  // handing the cart to GoKwik we force-apply it via Shopify's /discount/<code>
  // endpoint (same mechanism as assets/frido-pdp-gokwik-checkout.js). The code string
  // comes from the section setting (window.__FF_FREE_INSOLE_CODE).

  // Clear any code lingering on the same-origin cart session (best-effort). Used
  // when there's no free-gift insole in the cart, so a stale insole code can't
  // discount an order that no longer contains the insole.
  function cartHasDiscount(c){
    if (!c) return false;
    if (c.discount_codes && c.discount_codes.length){
      for (var i = 0; i < c.discount_codes.length; i++){ if (c.discount_codes[i] && c.discount_codes[i].code) return true; }
    }
    if (c.cart_level_discount_applications && c.cart_level_discount_applications.length) return true;
    return false;
  }

  // Strip every code from the same-origin cart session. Two-step (JSON, then
  // form-encoded if the cart still reports a code), mirroring the proven approach in
  // assets/frido-pdp-gokwik-checkout.js — the JSON form is not always honoured.
  function clearSessionDiscount(){
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ discount: "" })
    }).catch(function(){ return null; })
      .then(function(){ return cartGet(); })
      .then(function(c){
        if (!cartHasDiscount(c)) return c;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
          credentials: "same-origin",
          body: "discount="
        }).catch(function(){ return null; }).then(function(){ return cartGet(); });
      })
      .catch(function(){ return null; });
  }

  // Codes already sitting on the cart session, lowercased.
  function appliedCodes(c){
    var out = [];
    if (c && c.discount_codes){
      for (var i = 0; i < c.discount_codes.length; i++){
        var dc = c.discount_codes[i];
        if (dc && dc.code) out.push(String(dc.code).toLowerCase());
      }
    }
    return out;
  }

  // Apply the single Buy-X-Get-Y free-insole code to the same-origin cart before GoKwik
  // reads it. Clear first so no stale code lingers, then apply once — BXGY zeroes one
  // insole per shoe on its own. Only apply when a free-gift insole is actually present.
  // Fail-safe: resolves regardless so a hiccup never blocks checkout.
  // `cart` is the one syncGifts just resolved with, so the happy path costs no extra
  // reads. Short-circuits when the session is already in the right state — the old
  // unconditional clear-then-apply spent 4-6 serial round trips on every checkout tap.
  function applyFreeInsoleCode(cart){
    var code = String(window.__FF_FREE_INSOLE_CODE || "").trim();
    var seed = (cart && cart.items) ? Promise.resolve(cart) : cartGet();
    return seed.then(function(cart){
      var items = (cart && cart.items) || [];
      var hasGift = false;
      for (var i = 0; i < items.length; i++){
        var gp = items[i].properties;
        if (gp && (gp._free_gift === "true" || gp._free_gift === true)){ hasGift = true; break; }
      }
      var applied = appliedCodes(cart);
      var lvl = !!(cart && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length);
      // Correct code already on a gift cart → nothing to do.
      if (hasGift && code && applied.length === 1 && applied[0] === code.toLowerCase()) return null;
      // No gift and no code lingering → nothing to clear.
      if (!hasGift && !applied.length && !lvl) return null;
      return clearSessionDiscount().then(function(){
        if (!code || !hasGift) return null;
        var url = "/discount/" + encodeURIComponent(code);
        // GET /discount/<code> applies the code to the same-origin cart session; GoKwik
        // then reads it. redirect:"manual" so we don't navigate to the storefront.
        return fetch(url, { method: "GET", credentials: "same-origin", redirect: "manual" })
          .catch(function(){ return fetch(url, { credentials: "same-origin" }); });
      });
    }).catch(function(){ return null; });
  }

  function goToGokwik(){
    var trigger = document.querySelector("[data-frido-pdp-gokwik-trigger] .checkout");
    if (typeof window.onCheckoutClick === "function" && trigger){ window.onCheckoutClick(trigger); return; }
    if (window.FfGokwik && typeof window.FfGokwik.whenGokwikReady === "function"){
      window.FfGokwik.whenGokwikReady(function(){
        var t = document.querySelector("[data-frido-pdp-gokwik-trigger] .checkout");
        if (typeof window.onCheckoutClick === "function" && t){ window.onCheckoutClick(t); }
        else { window.location.href = "/checkout"; }
      });
      return;
    }
    window.location.href = "/checkout"; // fallback if GoKwik is unavailable
  }

  function checkout(){
    // Proceed to GoKwik checkout on the current same-origin cart. The GoKwik SDK
    // (rendered via {% render 'gokwik' %} in layout/frido-quiz.liquid) exposes
    // window.onCheckoutClick; the hidden [data-frido-pdp-gokwik-trigger] .checkout
    // button lives in the section markup.
    // The cart is being taken to checkout — no longer an abandonment.
    try { if (window.FfAbandon && window.FfAbandon.markCheckout) window.FfAbandon.markCheckout(); } catch (e) {}
    // Reconcile insoles to the shoe count, force-apply the BXGY code, THEN open GoKwik
    // so every insole nets to ₹0 in GoKwik's summary. Never let this block checkout.
    // syncGifts resolves with the cart, which applyFreeInsoleCode reuses instead of
    // re-reading it. The button stays busy across the intervening re-paints.
    checkingOut = true;
    var btn = document.getElementById("ff-cart-checkout");
    if (btn){ btn.disabled = true; btn.classList.add("is-loading"); btn.textContent = "Preparing checkout…"; }
    function done(){
      checkingOut = false;
      // GoKwik opens a modal rather than navigating, so hand the button back.
      var b = document.getElementById("ff-cart-checkout");
      if (b){ b.disabled = false; b.classList.remove("is-loading"); b.textContent = "Proceed to Checkout"; }
      goToGokwik();
    }
    // Queued so any qty change still in flight settles before we read the cart.
    enqueue(function(){ return syncGifts(); }).then(applyFreeInsoleCode, applyFreeInsoleCode).then(done, done);
  }

  function init(){ ensureMounted(); refresh().catch(function(){}); }
  if (document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", init); } else { init(); }

  window.FfCart = { addAndOpen: addAndOpen, open: openAndRefresh, close: close, refresh: refresh, syncGifts: syncGifts };
})();

/* ═══════════════════════════════════════════════════════════
   FfAbandon — abandoned-cart capture → Google Sheet
   Sends the shopper's captured contact (phone/name from the mandatory
   lead gate) + a snapshot of the Shopify cart to a Google Apps Script
   Web App, so carts left without checking out are logged.
   Fires on page-exit (visibilitychange/pagehide via sendBeacon) and on an
   idle timeout (no interaction for N seconds). Suppressed once the shopper
   clicks Proceed to Checkout. Endpoint + idle timeout come from the section
   settings (window.__FF_ABANDON); with no endpoint set, this is a no-op.
   ═══════════════════════════════════════════════════════════ */
(function FfAbandonModule(){
  "use strict";
  var cfg = window.__FF_ABANDON || {};
  var ENDPOINT = (cfg.endpoint || "").trim();
  var IDLE_MS = Math.max(30, parseInt(cfg.idleSeconds, 10) || 90) * 1000;

  var checkoutStarted = false;
  var lastSentSig = "";
  var idleTimer = null;
  var idleThrottle = 0;

  function contact(){ return window.__ffContact || {}; }
  function cart(){ return window.__ffLastCart || null; }
  function diagnosis(){
    var r = window.__ffResult;
    return r ? (r.conditionLabel || r.condition || "") : "";
  }

  function mapItems(c){
    if (!c || !c.items) return [];
    return c.items.map(function(it){
      var free = !!(it.properties && (it.properties._free_gift === "true" || it.properties._free_gift === true));
      return {
        title: it.product_title || it.title || "",
        variant: (it.variant_title && it.variant_title !== "Default Title") ? it.variant_title : "",
        qty: it.quantity || 1,
        price: Math.round((it.final_price != null ? it.final_price : (it.price || 0)) / 100),
        sku: it.sku || "",
        vid: it.variant_id,
        free: free
      };
    });
  }

  function signature(c){
    var ct = contact();
    var parts = (c && c.items ? c.items : []).map(function(it){ return it.variant_id + "x" + it.quantity; });
    return (ct.phone || "") + "|" + parts.join(",") + "|" + (checkoutStarted ? "co" : "ab");
  }

  // Units in the cart that are NOT the free gift, so a cart holding only the
  // seeded free insole doesn't count as an abandonment.
  function billableUnits(c){
    if (!c || !c.items) return 0;
    var n = 0;
    for (var i = 0; i < c.items.length; i++){
      var it = c.items[i];
      var free = !!(it.properties && (it.properties._free_gift === "true" || it.properties._free_gift === true));
      if (!free) n += (it.quantity || 1);
    }
    return n;
  }

  function shouldSend(){
    if (!ENDPOINT) return false;
    if (!contact().phone) return false;                 // need a contact to be useful
    // Require at least one real (paid) product — the free gift alone is not an abandonment.
    return billableUnits(cart()) > 0;
  }

  function buildPayload(reason){
    var c = cart(), ct = contact();
    var items = mapItems(c);
    var billable = 0;
    for (var i = 0; i < items.length; i++){ if (!items[i].free) billable++; }
    return {
      source: "frido-footwear-quiz",
      status: checkoutStarted ? "checkout_started" : "abandoned",
      reason: reason || "",
      sessionId: ct.sessionId || "",
      phone: ct.phone || "",
      name: ct.name || "",
      diagnosis: diagnosis(),
      itemCount: c ? (c.item_count || 0) : 0,
      billableCount: billable,
      cartTotal: c ? Math.round((c.total_price || 0) / 100) : 0,
      items: items,
      page: (typeof location !== "undefined" ? location.href : ""),
      userAgent: (typeof navigator !== "undefined" ? navigator.userAgent : ""),
      clientTime: new Date().toISOString()
    };
  }

  function send(reason){
    if (!shouldSend()) return;
    var c = cart();
    var sig = signature(c);
    if (sig === lastSentSig) return;                    // dedupe identical state
    lastSentSig = sig;
    var body = JSON.stringify(buildPayload(reason));
    try {
      var sent = false;
      if (navigator && navigator.sendBeacon){
        // text/plain avoids a CORS preflight the Apps Script can't answer.
        var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
        sent = navigator.sendBeacon(ENDPOINT, blob);
      }
      if (!sent){
        fetch(ENDPOINT, { method: "POST", mode: "no-cors", keepalive: true, headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: body });
      }
    } catch (e) {}
  }

  function resetIdle(){
    if (checkoutStarted) return;
    // throttle: mousemove/scroll can fire rapidly — rearm at most ~once/sec
    var now = new Date().getTime();
    if (now - idleThrottle < 1000 && idleTimer) return;
    idleThrottle = now;
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function(){ send("idle"); }, IDLE_MS);
  }

  window.FfAbandon = {
    onContact: function(){ resetIdle(); },
    onCartChange: function(){ resetIdle(); },
    markCheckout: function(){
      checkoutStarted = true;
      if (idleTimer){ clearTimeout(idleTimer); idleTimer = null; }
      send("checkout");                                  // log the conversion signal
    },
    flush: function(reason){ send(reason || "manual"); }
  };

  if (!ENDPOINT) return;                                 // not configured — API exposed, hooks idle

  // NOTE: the `visibilitychange` → hidden trigger is intentionally DISABLED. A tab
  // switch or minimise is not treated as leaving, so a shopper who briefly switches
  // away is no longer logged as abandoned. Capture is page-close / navigate-away only.
  // Trade-off: on mobile, `pagehide`/`beforeunload` are far less reliable than
  // visibilitychange (the OS can kill a backgrounded tab without firing either), so
  // mobile abandonments will be under-captured. To restore full coverage, re-enable:
  //   document.addEventListener("visibilitychange", function(){ if (document.visibilityState === "hidden") send("exit"); });
  window.addEventListener("pagehide", function(){ send("exit"); });
  window.addEventListener("beforeunload", function(){ send("exit"); });

  var acts = ["click", "keydown", "touchstart", "scroll"];
  for (var a = 0; a < acts.length; a++){
    window.addEventListener(acts[a], function(){ resetIdle(); }, { passive: true });
  }

  // Checkout cancelled: the shopper closed the GoKwik modal without ordering, so the
  // cart is abandonable again. Without this, checkoutStarted stayed latched for the
  // rest of the page session — signature() kept returning the same "co" value, so the
  // dedupe swallowed the later exit send and a backed-out checkout never reached the
  // sheet (it was stuck as "checkout_started"). Clearing lastSentSig lets the next
  // exit/idle send through with status "abandoned".
  function rearmAfterCheckout(){
    if (!checkoutStarted) return;
    checkoutStarted = false;
    lastSentSig = "";
    resetIdle();
  }
  function bindGokwikClose(){
    try {
      if (window.gokwikSdk && typeof window.gokwikSdk.on === "function"){
        window.gokwikSdk.on("modal_closed", rearmAfterCheckout);
        return true;
      }
    } catch (e) {}
    return false;
  }
  if (!bindGokwikClose()) window.addEventListener("gokwikLoaded", function(){ bindGokwikClose(); }, { once: true });
})();
